var Jx = Object.defineProperty;
var Qx = (t, a, o) => a in t ? Jx(t, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[a] = o;
var Oe = (t, a, o) => (Qx(t, typeof a != "symbol" ? a + "" : a, o), o);
import { defineComponent as O, computed as u, openBlock as k, createElementBlock as g, normalizeClass as I, unref as l, normalizeStyle as W, renderSlot as H, createCommentVNode as L, createElementVNode as f, withKeys as sx, withModifiers as Pe, toDisplayString as U, ref as j, createTextVNode as ae, mergeProps as ce, Fragment as re, renderList as O2, withDirectives as F2, createBlock as J, resolveDynamicComponent as ve, vShow as yv, Teleport as $2, createVNode as E, Transition as se, withCtx as N, shallowRef as Yx, watch as ne, getCurrentScope as lx, onScopeDispose as hx, shallowReadonly as H2, readonly as _x, inject as fe, onMounted as xe, provide as Ee, nextTick as me, onBeforeUnmount as K2, reactive as E2, createApp as Sv, createSlots as eI, useSlots as tI, h as Ue, createStaticVNode as aI, onUnmounted as Dv, watchEffect as to, toRaw as ze, isVNode as yx, cloneVNode as oI, pushScopeId as cI, popScopeId as nI } from "vue";
const b2 = {
  primary: {
    base: "blue",
    light: "50",
    main: "500",
    dark: "600",
    hover: "550",
    border: "600",
    focus: "600"
  },
  secondary: {
    base: "gray",
    light: "200",
    main: "575",
    dark: "700",
    hover: "600",
    border: "600",
    focus: "500"
  },
  success: {
    base: "green",
    light: "50",
    main: "500",
    dark: "700",
    hover: "600",
    border: "200",
    focus: "500"
  },
  warning: {
    base: "yellow",
    light: "50",
    main: "500",
    dark: "700",
    hover: "600",
    border: "200",
    focus: "500"
  },
  danger: {
    base: "red",
    light: "50",
    main: "500",
    dark: "700",
    hover: "600",
    border: "200",
    focus: "500"
  },
  info: {
    base: "blue",
    light: "50",
    main: "450",
    dark: "600",
    hover: "500",
    border: "200",
    focus: "550"
  },
  dark: {
    base: "gray",
    light: "100",
    main: "900",
    dark: "950",
    hover: "800",
    border: "300",
    focus: "700"
  },
  light: {
    base: "gray",
    light: "50",
    main: "300",
    dark: "500",
    hover: "400",
    border: "200",
    focus: "300"
  }
}, ee = (t, a, o = {}) => {
  const { hover: c = !1, active: n = !1, focus: i = !1, disabled: d = !1 } = o;
  if (d)
    return "cstu-bg-gray-100 cstu-border-gray-200 cstu-text-gray-400 cstu-cursor-not-allowed";
  const r = b2[t];
  if (!r)
    return "";
  if (a === "text")
    return [
      `cstu-text-${r.base}-${r.main}`,
      c && `hover:cstu-text-${r.base}-${r.hover}`,
      n && `active:cstu-text-${r.base}-${r.dark}`,
      i && `focus:cstu-text-${r.base}-${r.focus}`,
      d && "cstu-opacity-50 cstu-cursor-not-allowed"
    ].filter(Boolean);
  const h = [];
  switch (a) {
    case "filled":
      h.push(`cstu-bg-${r.base}-${r.main}`), h.push("cstu-text-white"), c && h.push(`hover:cstu-bg-${r.base}-${r.hover} hover:cstu-shadow-md`), n && h.push(`active:cstu-bg-${r.base}-${r.dark}`), i && h.push(`focus:cstu-ring-${r.base}-${r.focus}/20`);
      break;
    case "light":
      h.push(`cstu-bg-${r.base}-${r.light}`), h.push(`cstu-text-${r.base}-${r.main}`), c && h.push(`hover:cstu-bg-${r.base}-250`), n && h.push(`active:cstu-bg-${r.base}-300 active:!cstu-text-white`), i && h.push(`focus:cstu-ring-${r.base}-${r.focus}/20`);
      break;
    case "outline":
      h.push("cstu-bg-white"), h.push(`cstu-text-${r.base}-${r.main}`), h.push(`cstu-border cstu-border-${r.base}-${r.main}`), t === "secondary" ? (h.pop(), h.pop(), h.push("cstu-text-gray-400"), h.push("cstu-border cstu-border-gray-400/50"), c && h.push("hover:cstu-bg-gray-400/[0.06] hover:cstu-text-gray-500"), n && h.push("active:cstu-bg-gray-250 active:cstu-text-gray-500")) : (c && h.push(`hover:cstu-bg-${r.base}-50`), n && h.push(`active:cstu-bg-${r.base}-100`)), i && h.push(`focus:cstu-ring-${r.base}-${r.focus}/20`);
      break;
    case "subtle":
      h.push(`cstu-text-${r.base}-${r.main}`), c && h.push(`hover:cstu-bg-${r.base}-50`), n && h.push(`active:cstu-bg-${r.base}-100`), i && h.push(`focus:cstu-ring-${r.base}-${r.focus}/20`);
      break;
  }
  return h.join(" ");
}, iI = (t, a) => {
  if (a === "filled")
    return "cstu-text-white";
  const o = b2[t];
  return `cstu-text-${o.base}-${o.main}`;
}, ux = (t) => {
  const a = ["cstu-shadow-sm", "cstu-transition-all cstu-duration-200"];
  switch (t) {
    case "filled":
      a.push("cstu-border-transparent");
      break;
    case "light":
      a.push("cstu-border");
      break;
    case "outline":
      a.push("cstu-border");
      break;
    case "subtle":
      a.push("cstu-shadow-none");
      break;
    case "text":
      a.push("cstu-shadow-none");
      break;
    default:
      a.push("cstu-border");
  }
  return a.join(" ");
}, rI = (t) => {
  const a = b2[t];
  return [
    "focus:cstu-outline-none",
    "focus:cstu-ring-2",
    "focus:cstu-ring-offset-0",
    `focus:cstu-ring-${a.base}-${a.focus}/20`
  ].join(" ");
}, ue = (t) => t ? ["primary", "secondary", "success", "warning", "danger", "info", "dark", "light", "initials"].includes(t) : !0, px = {
  button: {
    xs: { height: "cstu-h-[30px]", gap: "cstu-gap-[0.55rem]", padding: { x: "cstu-px-[0.67rem]", y: "cstu-py-[0.67rem]" }, text: "cstu-text-xs cstu-leading-none", icon: "cstu-w-3 cstu-h-3" },
    sm: { height: "cstu-h-[36px]", gap: "cstu-gap-[0.66rem]", padding: { x: "cstu-px-[0.8rem]", y: "cstu-py-[0.8rem]" }, text: "cstu-text-sm cstu-leading-none", icon: "cstu-w-4 cstu-h-4" },
    md: { height: "cstu-h-[40px]", gap: "cstu-gap-[0.74rem]", padding: { x: "cstu-px-[0.89rem]", y: "cstu-py-[0.89rem]" }, text: "cstu-text-base cstu-leading-none", icon: "cstu-w-5 cstu-h-5" },
    lg: { height: "cstu-h-[45px]", gap: "cstu-gap-[0.83rem]", padding: { x: "cstu-px-4", y: "cstu-py-4" }, text: "cstu-text-lg cstu-leading-none", icon: "cstu-w-6 cstu-h-6" },
    xl: { height: "cstu-h-[50px]", gap: "cstu-gap-[0.92rem]", padding: { x: "cstu-px-[1.11rem]", y: "cstu-py-[1.11rem]" }, text: "cstu-text-xl cstu-leading-none", icon: "cstu-w-7 cstu-h-7" }
  },
  badge: {
    xs: { padding: { x: "cstu-px-2", y: "cstu-py-0.5" }, text: "cstu-text-xs", icon: "cstu-w-3 cstu-h-3" },
    sm: { padding: { x: "cstu-px-2.5", y: "cstu-py-1" }, text: "cstu-text-sm", icon: "cstu-w-3.5 cstu-h-3.5" },
    md: { padding: { x: "cstu-px-3", y: "cstu-py-1.5" }, text: "cstu-text-base", icon: "cstu-w-4 cstu-h-4" },
    lg: { padding: { x: "cstu-px-4", y: "cstu-py-2" }, text: "cstu-text-lg", icon: "cstu-w-5 cstu-h-5" },
    xl: { padding: { x: "cstu-px-5", y: "cstu-py-2.5" }, text: "cstu-text-xl", icon: "cstu-w-6 cstu-h-6" }
  },
  input: {
    xs: { padding: { x: "cstu-px-2", y: "cstu-py-1" }, text: "cstu-text-xs", height: "cstu-h-7" },
    sm: { padding: { x: "cstu-px-3", y: "cstu-py-1.5" }, text: "cstu-text-sm", height: "cstu-h-8" },
    md: { padding: { x: "cstu-px-3", y: "cstu-py-2" }, text: "cstu-text-base", height: "cstu-h-10" },
    lg: { padding: { x: "cstu-px-4", y: "cstu-py-2.5" }, text: "cstu-text-lg", height: "cstu-h-11" },
    xl: { padding: { x: "cstu-px-4", y: "cstu-py-3" }, text: "cstu-text-xl", height: "cstu-h-12" }
  },
  notification: {
    xs: { padding: { x: "cstu-px-3", y: "cstu-py-2" }, text: "cstu-text-xs" },
    sm: { padding: { x: "cstu-px-4", y: "cstu-py-2.5" }, text: "cstu-text-sm" },
    md: { padding: { x: "cstu-px-4", y: "cstu-py-3" }, text: "cstu-text-base" },
    lg: { padding: { x: "cstu-px-5", y: "cstu-py-4" }, text: "cstu-text-lg" },
    xl: { padding: { x: "cstu-px-6", y: "cstu-py-5" }, text: "cstu-text-xl" }
  },
  switch: {
    xs: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-xs", height: "cstu-h-4" },
    sm: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-sm", height: "cstu-h-5" },
    md: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-base", height: "cstu-h-6" },
    lg: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-lg", height: "cstu-h-7" },
    xl: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-xl", height: "cstu-h-8" }
  },
  chip: {
    xs: { padding: { x: "cstu-px-1.5", y: "cstu-py-0.5" }, text: "cstu-text-xs", icon: "cstu-w-2.5 cstu-h-2.5" },
    sm: { padding: { x: "cstu-px-2", y: "cstu-py-1" }, text: "cstu-text-sm", icon: "cstu-w-3 cstu-h-3" },
    md: { padding: { x: "cstu-px-2.5", y: "cstu-py-1.5" }, text: "cstu-text-base", icon: "cstu-w-3.5 cstu-h-3.5" },
    lg: { padding: { x: "cstu-px-3", y: "cstu-py-2" }, text: "cstu-text-lg", icon: "cstu-w-4 cstu-h-4" },
    xl: { padding: { x: "cstu-px-3.5", y: "cstu-py-2.5" }, text: "cstu-text-xl", icon: "cstu-w-4.5 cstu-h-4.5" }
  },
  checkbox: {
    xs: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-xs", icon: "cstu-w-2 cstu-h-2" },
    sm: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-sm", icon: "cstu-w-2.5 cstu-h-2.5" },
    md: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-base", icon: "cstu-w-3 cstu-h-3" },
    lg: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-lg", icon: "cstu-w-4 cstu-h-4" },
    xl: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-xl", icon: "cstu-w-5 cstu-h-5" }
  },
  indicator: {
    xs: { padding: { x: "cstu-px-0.5", y: "cstu-py-0.5" }, text: "cstu-text-[10px]", height: "cstu-h-3.5 cstu-min-w-3.5" },
    sm: { padding: { x: "cstu-px-1", y: "cstu-py-0.5" }, text: "cstu-text-[11px]", height: "cstu-h-4 cstu-min-w-4" },
    md: { padding: { x: "cstu-px-1.5", y: "cstu-py-0.5" }, text: "cstu-text-xs", height: "cstu-h-5 cstu-min-w-5" },
    lg: { padding: { x: "cstu-px-2", y: "cstu-py-0.5" }, text: "cstu-text-xs", height: "cstu-h-6 cstu-min-w-6" },
    xl: { padding: { x: "cstu-px-2.5", y: "cstu-py-0.5" }, text: "cstu-text-sm", height: "cstu-h-7 cstu-min-w-7" }
  },
  progress: {
    xs: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-xs", height: "cstu-h-[0.125rem]" },
    sm: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-sm", height: "cstu-h-[0.1875rem]" },
    md: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-base", height: "cstu-h-[0.25rem]" },
    lg: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-sm", height: "cstu-h-[0.3125rem]" },
    xl: { padding: { x: "cstu-px-0", y: "cstu-py-0" }, text: "cstu-text-base", height: "cstu-h-[0.375rem]" }
  },
  alert: {
    xs: { padding: { x: "cstu-px-3", y: "cstu-py-2" }, text: "cstu-text-xs", icon: "cstu-w-4 cstu-h-4" },
    sm: { padding: { x: "cstu-px-3", y: "cstu-py-2.5" }, text: "cstu-text-sm", icon: "cstu-w-5 cstu-h-5" },
    md: { padding: { x: "cstu-px-4", y: "cstu-py-3" }, text: "cstu-text-base", icon: "cstu-w-5 cstu-h-5" },
    lg: { padding: { x: "cstu-px-5", y: "cstu-py-4" }, text: "cstu-text-lg", icon: "cstu-w-6 cstu-h-6" },
    xl: { padding: { x: "cstu-px-6", y: "cstu-py-5" }, text: "cstu-text-xl", icon: "cstu-w-7 cstu-h-7" }
  },
  segmentedControl: {
    xs: { gap: "cstu-gap-[8px]", padding: { x: "cstu-px-[10.5px]", y: "cstu-py-[3.5px]" }, text: "cstu-text-xs", height: "cstu-h-6" },
    sm: { gap: "cstu-gap-[9px]", padding: { x: "cstu-px-[12px]", y: "cstu-py-[4px]" }, text: "cstu-text-sm", height: "cstu-h-8" },
    md: { gap: "cstu-gap-[10px]", padding: { x: "cstu-px-[13.5px]", y: "cstu-py-[4.5px]" }, text: "cstu-text-base", height: "cstu-h-10" },
    lg: { gap: "cstu-gap-[11px]", padding: { x: "cstu-px-[15px]", y: "cstu-py-[5px]" }, text: "cstu-text-lg", height: "cstu-h-12" },
    xl: { gap: "cstu-gap-[12px]", padding: { x: "cstu-px-[16.5px]", y: "cstu-py-[5.5px]" }, text: "cstu-text-xl", height: "cstu-h-14" }
  },
  segmentedControlContainer: {
    xs: { gap: "cstu-gap-[5.25px]", padding: { x: "cstu-px-[5.25px]", y: "cstu-py-[5.25px]" } },
    sm: { gap: "cstu-gap-[6px]", padding: { x: "cstu-px-[6px]", y: "cstu-py-[6px]" } },
    md: { gap: "cstu-gap-[6.75px]", padding: { x: "cstu-px-[6.75px]", y: "cstu-py-[6.75px]" } },
    lg: { gap: "cstu-gap-[7.5px]", padding: { x: "cstu-px-[7.5px]", y: "cstu-py-[7.5px]" } },
    xl: { gap: "cstu-gap-[8.25px]", padding: { x: "cstu-px-[8.25px]", y: "cstu-py-[8.25px]" } }
  },
  dropdown: {
    xs: { padding: { x: "cstu-px-[12px]", y: "cstu-py-[7px]" }, text: "cstu-text-xs", height: void 0, icon: void 0, gap: "cstu-gap-[9px]" },
    sm: { padding: { x: "cstu-px-[12px]", y: "cstu-py-[7px]" }, text: "cstu-text-sm", height: void 0, icon: void 0, gap: "cstu-gap-[9px]" },
    md: { padding: { x: "cstu-px-[12px]", y: "cstu-py-[7px]" }, text: "cstu-text-base", height: void 0, icon: void 0, gap: "cstu-gap-[9px]" },
    lg: { padding: { x: "cstu-px-[12px]", y: "cstu-py-[7px]" }, text: "cstu-text-lg", height: void 0, icon: void 0, gap: "cstu-gap-[9px]" },
    xl: { padding: { x: "cstu-px-[12px]", y: "cstu-py-[7px]" }, text: "cstu-text-xl", height: void 0, icon: void 0, gap: "cstu-gap-[9px]" }
  }
}, Ie = (t, a) => {
  var o, c;
  if (typeof a == "string") {
    const n = px[a][t];
    return [(o = n == null ? void 0 : n.padding) == null ? void 0 : o.x, (c = n == null ? void 0 : n.padding) == null ? void 0 : c.y, n == null ? void 0 : n.text, n == null ? void 0 : n.gap].filter(Boolean).join(" ");
  }
  return a[t];
}, Tv = (t, a) => px[a][t].height || "", C2 = (t) => {
  switch (t) {
    case "xs":
      return "cstu-text-xs";
    case "sm":
      return "cstu-text-sm";
    case "md":
      return "cstu-text-base";
    case "lg":
      return "cstu-text-lg";
    case "xl":
      return "cstu-text-xl";
    default:
      return "cstu-text-base";
  }
}, dI = (t) => {
  switch (t) {
    case "xs":
      return "cstu-space-x-1";
    case "sm":
      return "cstu-space-x-2";
    case "md":
      return "cstu-space-x-3";
    case "lg":
      return "cstu-space-x-4";
    case "xl":
      return "cstu-space-x-5";
    default:
      return "cstu-space-x-3";
  }
}, S2 = (t) => {
  const a = [];
  return t.disabled && a.push("cstu-opacity-50 cstu-cursor-not-allowed cstu-pointer-events-none"), t.loading && a.push("cstu-cursor-wait"), t.active && a.push("cstu-ring-2 cstu-ring-offset-2"), t.error && a.push("cstu-border-red-300 focus:cstu-ring-red-500/20 focus:cstu-border-red-500"), t.success && a.push("cstu-border-green-300 focus:cstu-ring-green-500/20 focus:cstu-border-green-500"), a.join(" ");
}, kx = (t) => t ? "cstu-opacity-50 cstu-cursor-not-allowed cstu-pointer-events-none" : "", sI = (t) => {
  const a = [];
  return t.valid && a.push("cstu-border-green-300 focus:cstu-ring-green-500/20 focus:cstu-border-green-500"), t.invalid && a.push("cstu-border-red-300 focus:cstu-ring-red-500/20 focus:cstu-border-red-500"), t.pending && a.push("cstu-border-yellow-300 focus:cstu-ring-yellow-500/20 focus:cstu-border-yellow-500"), a.join(" ");
}, lI = (t, a = "primary") => {
  const o = [];
  return t.hover && o.push(`hover:cstu-bg-${a}-50`), t.active && o.push(`active:cstu-bg-${a}-100`), t.focus && o.push(`focus:cstu-outline-none focus:cstu-ring-2 focus:cstu-ring-${a}-500/20 focus:cstu-border-${a}-500`), o.join(" ");
}, hI = ["disabled", "type"], yI = { key: 0 }, uI = /* @__PURE__ */ f("svg", {
  class: "cstu-animate-spin cstu-h-4 cstu-w-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ f("circle", {
    class: "cstu-opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /* @__PURE__ */ f("path", {
    class: "cstu-opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1), Me = /* @__PURE__ */ O({
  __name: "Button",
  props: {
    variant: { default: "filled" },
    color: { default: "primary" },
    size: { default: "md" },
    radius: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    type: { default: "button" }
  },
  emits: {
    click: (t) => !0
  },
  setup(t, { emit: a }) {
    const o = t, c = (r) => {
      !o.disabled && !o.loading && a("click", r);
    }, n = (r) => ({
      none: "cstu-rounded-none",
      xs: "cstu-rounded",
      sm: "cstu-rounded-md",
      md: "cstu-rounded-lg",
      lg: "cstu-rounded-xl",
      xl: "cstu-rounded-2xl",
      full: "cstu-rounded-full"
    })[r] || "cstu-rounded-lg", i = u(() => {
      if (ue(o.color) || o.disabled)
        return {};
      switch (o.variant) {
        case "filled":
          return {
            backgroundColor: o.color,
            color: "white"
          };
        case "light":
          return {
            backgroundColor: `${o.color}10`,
            color: o.color
          };
        case "outline":
          return {
            borderColor: o.color,
            color: o.color
          };
        case "subtle":
          return {
            color: o.color
          };
        case "text":
          return {
            backgroundColor: "transparent",
            color: o.color,
            borderColor: "transparent"
          };
        default:
          return {};
      }
    }), d = u(() => {
      const r = "cstu-inline-flex cstu-items-center cstu-justify-center cstu-font-medium cstu-transition-all cstu-duration-200", h = ue(o.color) ? ee(o.color, o.variant, {
        hover: !0,
        active: !0,
        focus: !0
      }) : "", s = Ie(o.size, "button"), M = S2({
        disabled: o.disabled,
        loading: o.loading
      }), y = Tv(o.size, "button"), p = n(o.radius), m = !ue(o.color) && ["outline"].includes(o.variant) ? "cstu-border" : "";
      return [
        r,
        h,
        s,
        M,
        y,
        p,
        m,
        {
          "cstu-w-full": o.fullWidth,
          "cstu-cursor-pointer": !o.disabled && !o.loading,
          "cstu-border": o.variant === "outline"
        }
      ];
    });
    return (r, h) => (k(), g("button", {
      class: I(l(d)),
      style: W(l(i)),
      disabled: t.disabled || t.loading,
      type: t.type,
      onClick: c
    }, [
      H(r.$slots, "leftSection"),
      H(r.$slots, "default"),
      t.loading ? (k(), g("span", yI, [
        H(r.$slots, "loader", {}, () => [
          uI
        ])
      ])) : L("", !0),
      H(r.$slots, "rightSection")
    ], 14, hI));
  }
}), pI = (t) => {
  const a = ["cstu-relative"];
  t.fullWidth && a.push("cstu-w-full");
  const o = S2({
    disabled: t.disabled,
    error: t.error,
    required: t.required || t.withAsterisk
  });
  return o && a.push(o), a.join(" ");
}, Mx = (t, a = !1) => {
  const o = [
    "cstu-block",
    "cstu-font-medium"
  ];
  switch (a || o.push("cstu-mb-1"), t.size) {
    case "xs":
      o.push("cstu-text-xs");
      break;
    case "sm":
      o.push("cstu-text-sm");
      break;
    case "md":
      o.push("cstu-text-base");
      break;
    case "lg":
      o.push("cstu-text-lg");
      break;
    case "xl":
      o.push("cstu-text-xl");
      break;
    default:
      o.push("cstu-text-sm");
  }
  return t.error ? o.push("cstu-text-red-500") : t.disabled ? o.push("cstu-text-gray-400") : o.push("cstu-text-gray-700"), (t.required || t.withAsterisk) && o.push('after:cstu-content-["*"] after:cstu-ml-0.5 after:cstu-text-red-500'), o.join(" ");
}, kI = (t) => {
  const a = [
    "cstu-mt-1",
    "cstu-text-sm"
  ];
  return t.error ? a.push("cstu-text-red-500") : t.disabled ? a.push("cstu-text-gray-400") : a.push("cstu-text-gray-500"), a.join(" ");
}, MI = ["aria-disabled", "onKeydown"], fI = /* @__PURE__ */ f("path", {
  d: "M6.75 0.75L2.625 5.25L0.75 3.20455",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gI = [
  fI
], mI = /* @__PURE__ */ f("path", {
  d: "M6.80245 3.90741L0.697913 3.8936",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vI = [
  mI
], xI = {
  key: 2,
  class: "cstu-text-sm cstu-text-red-500 cstu-mt-0.5"
}, II = {
  name: "Checkbox"
}, yS = /* @__PURE__ */ O({
  ...II,
  props: {
    modelValue: { type: [Boolean, Array], default: !1 },
    checked: { type: Boolean, default: !1 },
    value: null,
    id: null,
    label: null,
    color: { default: "primary" },
    size: { default: "md" },
    labelPosition: { default: "right" },
    labelSize: { default: "md" },
    description: null,
    error: null,
    disabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    variant: { default: "filled" },
    labelClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(t, { emit: a }) {
    const o = t, c = u(() => o.modelValue || o.checked), n = () => {
      if (o.disabled)
        return;
      const m = !c.value;
      a("update:modelValue", m), a("change", m);
    }, i = () => {
      n();
    }, d = u(() => Mx({
      size: o.labelSize,
      disabled: o.disabled,
      error: o.error
    }, !0)), r = u(() => kI({
      color: o.color
    })), h = u(() => [
      "cstu-flex",
      "cstu-flex-col",
      o.labelPosition === "left" ? "cstu-order-first" : ""
    ]), s = {
      primary: "blue-450",
      secondary: "gray-500",
      success: "green-500",
      warning: "yellow-500",
      danger: "red-500",
      info: "blue-500",
      dark: "gray-900",
      light: "gray-300"
    }, M = u(() => [
      "cstu-inline-flex",
      "cstu-items-center",
      "cstu-justify-center",
      "cstu-cursor-pointer",
      "cstu-transition-colors",
      "cstu-duration-200",
      "cstu-ease-in-out",
      o.size === "xs" ? "cstu-h-[12px] cstu-w-[12px] cstu-rounded" : "",
      o.size === "sm" ? "cstu-h-[14px] cstu-w-[14px] cstu-rounded" : "",
      o.size === "md" ? "cstu-h-[16px] cstu-w-[16px] cstu-rounded-md" : "",
      o.size === "lg" ? "cstu-h-[18px] cstu-w-[18px] cstu-rounded-md" : "",
      o.size === "xl" ? "cstu-h-[20px] cstu-w-[20px] cstu-rounded-md" : "",
      o.disabled ? "cstu-bg-gray-200 cstu-border cstu-border-gray-200 cstu-cursor-not-allowed" : c.value || o.indeterminate ? o.variant === "outlined" ? `cstu-bg-transparent cstu-border cstu-border-${s[o.color]}` : `cstu-bg-${s[o.color]} cstu-border-${s[o.color]}` : "cstu-bg-white cstu-border cstu-border-gray-400/50"
    ]), y = u(() => [
      o.variant === "outlined" && (c.value || o.indeterminate) ? `cstu-text-${s[o.color]}` : o.disabled ? "cstu-text-gray-300" : "cstu-text-white",
      o.size === "xs" ? "cstu-h-[6px] cstu-w-[6px]" : "",
      o.size === "sm" ? "cstu-h-[7px] cstu-w-[7px]" : "",
      o.size === "md" ? "cstu-h-[8px] cstu-w-[8px]" : "",
      o.size === "lg" ? "cstu-h-[9px] cstu-w-[9px]" : "",
      o.size === "xl" ? "cstu-h-[10px] cstu-w-[10px]" : ""
    ]), p = u(() => pI({
      disabled: o.disabled,
      error: o.error
    }));
    return (m, C) => (k(), g("div", {
      class: I([l(p), "cstu-flex cstu-items-center cstu-gap-2"])
    }, [
      f("div", {
        class: I(l(M)),
        onClick: i,
        role: "checkbox",
        "aria-disabled": t.disabled,
        tabindex: "0",
        onKeydown: sx(Pe(i, ["prevent"]), ["space"])
      }, [
        l(c) && !t.indeterminate ? (k(), g("svg", {
          key: 0,
          class: I(l(y)),
          xmlns: "http://www.w3.org/2000/svg",
          width: "8",
          height: "6",
          viewBox: "0 0 8 6",
          fill: "none"
        }, gI, 2)) : L("", !0),
        t.indeterminate ? (k(), g("svg", {
          key: 1,
          class: I(l(y)),
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 8 7",
          fill: "none"
        }, vI, 2)) : L("", !0)
      ], 42, MI),
      t.label || t.description ? (k(), g("div", {
        key: 0,
        class: I(l(h))
      }, [
        t.label ? (k(), g("label", {
          key: 0,
          class: I([l(d), t.labelClass]),
          onClick: i
        }, U(t.label), 3)) : L("", !0),
        t.description ? (k(), g("div", {
          key: 1,
          class: I(l(r))
        }, U(t.description), 3)) : L("", !0),
        t.error ? (k(), g("div", xI, U(t.error), 1)) : L("", !0)
      ], 2)) : L("", !0)
    ], 2));
  }
});
function De(t) {
  return {
    none: "cstu-rounded-none",
    xs: "cstu-rounded",
    sm: "cstu-rounded-md",
    md: "cstu-rounded-lg",
    lg: "cstu-rounded-xl",
    xl: "cstu-rounded-2xl",
    full: "cstu-rounded-full"
  }[t];
}
const wI = {
  key: 0,
  class: "cstu-flex cstu-justify-between cstu-items-center cstu-mb-1"
}, CI = ["for"], LI = {
  key: 0,
  class: "cstu-text-red-500 cstu-ml-1"
}, bI = {
  key: 0,
  class: "cstu-flex cstu-items-center cstu-justify-center cstu-w-[15px] cstu-h-[15px]"
}, SI = ["id", "type", "value", "placeholder", "disabled", "required", "readonly", "pattern", "title", "maxlength"], qI = {
  key: 1,
  class: "cstu-flex cstu-items-center cstu-justify-center cstu-w-[15px] cstu-h-[15px]"
}, zI = {
  key: 1,
  class: "cstu-mt-1"
}, AI = {
  key: 2,
  class: "cstu-mt-1"
}, uS = /* @__PURE__ */ O({
  __name: "TextInput",
  props: {
    id: null,
    type: null,
    modelValue: null,
    placeholder: null,
    label: null,
    description: null,
    error: null,
    hasError: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    required: { type: Boolean },
    withAsterisk: { type: Boolean },
    showBothErrorAndDescription: { type: Boolean },
    inputProps: null,
    size: null,
    variant: null,
    radius: null,
    class: null,
    fullWidth: { type: Boolean },
    pattern: null,
    title: null,
    inputClass: null,
    maxLength: null
  },
  emits: ["update:modelValue", "focus", "blur", "change"],
  setup(t, { expose: a, emit: o }) {
    const {
      id: c,
      type: n = "text",
      modelValue: i,
      placeholder: d,
      label: r,
      description: h,
      error: s,
      hasError: M = !1,
      disabled: y = !1,
      readonly: p = !1,
      required: m = !1,
      withAsterisk: C = !1,
      showBothErrorAndDescription: z = !1,
      inputProps: w,
      size: A = "md",
      variant: b = "default",
      radius: x = "md",
      class: v,
      fullWidth: S = !1,
      pattern: V = "",
      title: Z = "",
      inputClass: K = "",
      maxLength: B = void 0
    } = t, P = `text-input-${Math.random().toString(36).substring(2, 11)}`, D = j(null), Y = {
      xs: {
        inputClass: `cstu-h-8  ${S ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-xs cstu-font-medium",
        descriptionSize: "cstu-text-xs"
      },
      sm: {
        inputClass: `cstu-h-9  ${S ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-sm cstu-font-medium",
        descriptionSize: "cstu-text-xs"
      },
      md: {
        inputClass: `cstu-h-10  ${S ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-sm cstu-font-medium",
        descriptionSize: "cstu-text-sm"
      },
      lg: {
        inputClass: `cstu-h-11  ${S ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-sm cstu-font-medium",
        descriptionSize: "cstu-text-sm"
      },
      xl: {
        inputClass: `cstu-h-12  ${S ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-base cstu-font-medium",
        descriptionSize: "cstu-text-sm"
      }
    }, oe = u(() => `${Y[A].inputClass.split(" ")[0]} cstu-transition-all cstu-duration-300`), G = u(() => Y[A].labelSize), le = u(() => Y[A].descriptionSize), he = u(() => "cstu-text-sm"), de = u(() => De(x)), q = u(() => {
      const R = {
        default: "cstu-bg-white cstu-border cstu-transition-colors cstu-duration-150 cstu-px-3",
        filled: "cstu-bg-gray-100 cstu-border cstu-border-transparent cstu-transition-colors cstu-duration-150 cstu-px-3",
        unstyled: "cstu-bg-transparent cstu-border-0"
      }, pe = F.value ? "" : b === "default" ? "cstu-border-gray-300/45" : "", Re = F.value ? "cstu-border-red-500" : "";
      return b === "unstyled" ? [R[b]] : [
        R[b],
        pe,
        Re,
        // Hover classes - only apply on hover
        F.value ? "hover:cstu-border-red-500" : "hover:cstu-border-blue-450",
        // Focus classes - only apply when focused via focus-within
        F.value ? "focus-within:cstu-border-red-500 focus-within:cstu-ring-1 focus-within:cstu-ring-red-500" : "focus-within:cstu-border-blue-450 focus-within:cstu-ring-1 focus-within:cstu-ring-blue-450"
      ];
    }), F = u(() => s !== void 0 && s !== "" || M), _ = j(!1), X = (R) => {
      _.value = !0, o("focus", R);
    }, Ge = (R) => {
      _.value = !1, o("blur", R);
    }, wv = (R) => {
      o("change", R);
    };
    return a({
      // Expose the input element itself
      input: D,
      // Expose common input methods
      focus: () => {
        var R;
        return (R = D.value) == null ? void 0 : R.focus();
      },
      blur: () => {
        var R;
        return (R = D.value) == null ? void 0 : R.blur();
      },
      select: () => {
        var R;
        return (R = D.value) == null ? void 0 : R.select();
      },
      setSelectionRange: (R, pe) => {
        var Re;
        return (Re = D.value) == null ? void 0 : Re.setSelectionRange(R, pe);
      },
      setRangeText: (R) => {
        var pe;
        return (pe = D.value) == null ? void 0 : pe.setRangeText(R);
      },
      // Expose common properties
      get value() {
        var R;
        return (R = D.value) == null ? void 0 : R.value;
      },
      set value(R) {
        D.value && R !== void 0 && (D.value.value = R);
      }
    }), (R, pe) => (k(), g("div", {
      class: I(["cstu-flex cstu-flex-col cstu-transition-all cstu-duration-300", [R.customClass, t.fullWidth ? "cstu-w-full" : "cstu-max-w-[20.5rem]"]])
    }, [
      t.label || R.$slots.label ? (k(), g("div", wI, [
        f("label", {
          for: t.id || P,
          class: I([
            "cstu-flex cstu-items-center",
            l(G)
          ])
        }, [
          H(R.$slots, "label", {}, () => [
            ae(U(t.label) + " ", 1),
            t.withAsterisk || t.required ? (k(), g("span", LI, "*")) : L("", !0)
          ])
        ], 10, CI),
        H(R.$slots, "labelIcon")
      ])) : L("", !0),
      f("div", null, [
        f("div", {
          class: I([
            "cstu-flex cstu-items-center cstu-gap-2 cstu-py-2",
            l(oe),
            l(de),
            l(q),
            {
              "cstu-opacity-50 cstu-pointer-events-none cstu-cursor-not-allowed": t.disabled
            }
          ])
        }, [
          R.$slots.leftSection ? (k(), g("div", bI, [
            H(R.$slots, "leftSection")
          ])) : L("", !0),
          f("input", ce({
            ref_key: "inputRef",
            ref: D,
            id: t.id || P,
            type: t.type,
            value: t.modelValue,
            placeholder: t.placeholder,
            disabled: t.disabled,
            required: t.required,
            readonly: t.readonly,
            pattern: t.pattern,
            title: t.title,
            maxlength: t.maxLength,
            class: [
              "cstu-flex-1 cstu-bg-transparent cstu-outline-none cstu-w-full",
              l(he),
              t.inputClass,
              {
                "cstu-text-gray-500": t.modelValue,
                "cstu-text-red-500": l(F) && !t.modelValue
              }
            ],
            onInput: pe[0] || (pe[0] = (Re) => R.$emit("update:modelValue", Re.target.value)),
            onFocus: X,
            onBlur: Ge,
            onChange: wv
          }, t.inputProps), null, 16, SI),
          R.$slots.rightSection ? (k(), g("div", qI, [
            H(R.$slots, "rightSection")
          ])) : L("", !0)
        ], 2)
      ]),
      t.description && !l(F) || R.$slots.description && !l(F) || t.showBothErrorAndDescription && t.description || t.showBothErrorAndDescription && R.$slots.description ? (k(), g("div", zI, [
        f("p", {
          class: I(["cstu-text-gray-500", l(le)])
        }, [
          H(R.$slots, "description", {}, () => [
            ae(U(t.description), 1)
          ])
        ], 2)
      ])) : L("", !0),
      l(F) && t.error || l(F) && R.$slots.error || t.showBothErrorAndDescription && t.error || t.showBothErrorAndDescription && R.$slots.error ? (k(), g("div", AI, [
        f("p", {
          class: I(["cstu-text-red-500", l(le)])
        }, [
          H(R.$slots, "error", {}, () => [
            ae(U(t.error), 1)
          ])
        ], 2)
      ])) : L("", !0)
    ], 2));
  }
}), HI = ["disabled"], PI = {
  key: 0,
  class: "w-3.5 h-3.5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, BI = /* @__PURE__ */ f("path", {
  "fill-rule": "evenodd",
  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1), VI = [
  BI
], FI = {
  key: 0,
  class: "animate-spin"
}, jI = /* @__PURE__ */ f("svg", {
  class: "w-3.5 h-3.5",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ f("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /* @__PURE__ */ f("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1), DI = [
  jI
], pS = /* @__PURE__ */ O({
  __name: "Chip",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: { default: "" },
    size: { default: "md" },
    variant: { default: "filled" },
    color: { default: "primary" },
    radius: { default: "xl" },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    withRemoveButton: { type: Boolean, default: !1 },
    withCheckIcon: { type: Boolean, default: !0 },
    checkIconPosition: { default: "left" },
    allowDeselect: { type: Boolean, default: !0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: a }) {
    const o = t, c = u(
      () => ee(o.color, o.variant)
    ), n = u(() => Ie(o.size, "chip")), i = u(
      () => S2({
        disabled: o.disabled,
        loading: o.loading
      })
    ), d = u(() => ee(o.color, o.variant)), r = u(() => h()), h = () => {
      switch (o.variant) {
        case "filled":
          return "cstu-bg-gray-300 cstu-text-gray-300";
        case "outline":
          return "cstu-bg-gray-300 cstu-text-gray-300 cstu-border-gray-300";
        case "light":
          return "cstu-bg-gray-200 cstu-text-gray-300";
        default:
          return ee(o.color, o.variant);
      }
    }, s = () => {
      o.disabled || o.loading || o.modelValue && !o.allowDeselect || a("update:modelValue", !o.modelValue);
    };
    return (M, y) => (k(), g("button", {
      class: I([
        "inline-flex items-center justify-center gap-2 rounded-full transition-colors duration-200 select-none",
        "focus:outline-none",
        l(c),
        l(n),
        l(i),
        t.modelValue ? l(d) : l(r),
        "cursor-pointer"
      ]),
      disabled: t.disabled || t.loading,
      onClick: s
    }, [
      H(M.$slots, "checkIcon", {}, () => [
        t.withCheckIcon && t.modelValue ? (k(), g("svg", PI, VI)) : L("", !0)
      ]),
      t.loading ? (k(), g("span", FI, DI)) : L("", !0),
      H(M.$slots, "label", {}, () => [
        t.label ? (k(), g("span", {
          key: 0,
          class: I(["whitespace-nowrap", t.loading ? "opacity-75" : ""])
        }, U(t.label), 3)) : L("", !0)
      ])
    ], 10, HI));
  }
}), TI = { class: "indicator-content-wrapper" }, RI = {
  key: 0,
  class: "indicator-content"
}, OI = {
  name: "Indicator"
}, $I = /* @__PURE__ */ O({
  ...OI,
  props: {
    position: { default: "top-end" },
    size: { default: "md" },
    radius: { default: "full" },
    color: { default: "danger" },
    offset: { default: 0 },
    inline: { type: Boolean, default: !1 },
    withOutline: { type: Boolean, default: !1 },
    outlineWidth: { default: 2 },
    outlineColor: { default: void 0 },
    outlineOffset: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    processing: { type: Boolean, default: !1 },
    zIndex: { default: 200 },
    label: { default: "" },
    variant: { default: "filled" },
    dot: { type: Boolean, default: !1 },
    autoContrast: { type: Boolean, default: !0 },
    customClasses: { default: "" }
  },
  setup(t) {
    const a = t, o = (p) => p ? ["primary", "secondary", "success", "warning", "danger", "info", "dark", "light"].includes(p) : !0, c = u(() => [
      a.inline ? "inline-block" : "block",
      "relative"
    ]), n = u(() => {
      if (typeof a.size == "number")
        return a.size;
      const p = {
        xs: 6,
        sm: 8,
        md: 10,
        lg: 12,
        xl: 14
      };
      return p[a.size] || p.md;
    }), i = u(() => `position-${a.position}`), d = u(() => ({
      "--indicator-z-index": `${a.zIndex}`,
      "--indicator-offset": `${a.offset}px`,
      "--indicator-outline-width": `${a.outlineWidth}px`,
      "--indicator-outline-offset": `${a.outlineOffset}px`,
      "--indicator-size": `${n.value}px`
    })), r = u(() => {
      if (!o(a.color))
        return "";
      const p = {
        filled: `${ee(a.color, "filled")} ${a.autoContrast ? "text-white dark:text-white" : ""}`,
        light: `${ee(a.color, "light")}`,
        outline: `${ee(a.color, "outline")}`
      };
      return p[a.variant] || p.filled;
    }), h = u(() => typeof a.radius == "number" ? "" : De(a.radius)), s = u(() => {
      const p = [
        a.dot ? "indicator--dot" : "",
        a.processing ? "indicator--processing" : "",
        a.withOutline ? "indicator--with-outline" : "",
        r.value,
        h.value,
        typeof a.customClasses == "string" ? a.customClasses : ""
      ];
      return Array.isArray(a.customClasses) && p.push(...a.customClasses), p.filter(Boolean);
    }), M = u(() => {
      const p = {};
      if (typeof a.radius == "number" && (p.borderRadius = `${a.radius}px`), o(a.color) || (a.variant === "filled" ? (p.backgroundColor = a.color, p.color = "white") : a.variant === "light" ? (p.backgroundColor = `${a.color}20`, p.color = a.color) : a.variant === "outline" && (p.backgroundColor = "transparent", p.color = a.color, p.border = `1px solid ${a.color}`)), a.withOutline) {
        const m = a.outlineColor || a.color;
        a.outlineOffset > 0 ? p.boxShadow = `0 0 0 ${a.outlineOffset}px white, 0 0 0 ${a.outlineOffset + a.outlineWidth}px ${y(m)}` : p.boxShadow = `0 0 0 ${a.outlineWidth}px ${y(m)}`;
      }
      return p;
    });
    function y(p) {
      if (o(p)) {
        const m = {
          primary: "#4F46E5",
          // Indigo-500
          secondary: "#6B7280",
          // Gray-500
          success: "#10B981",
          // Green-500
          warning: "#F59E0B",
          // Amber-500
          danger: "#EF4444",
          // Red-500
          info: "#3B82F6",
          // Blue-500
          dark: "#1F2937",
          // Gray-800
          light: "#F3F4F6"
          // Gray-100
        };
        return m[p] || m.primary;
      } else
        return p;
    }
    return (p, m) => (k(), g("div", {
      class: I(["indicator-root", l(c)]),
      style: W(l(d))
    }, [
      f("div", TI, [
        H(p.$slots, "default", {}, void 0, !0),
        t.disabled ? L("", !0) : (k(), g("div", {
          key: 0,
          class: I(["indicator-dot", [l(s), l(i)]]),
          style: W(l(M))
        }, [
          t.label && !t.dot ? (k(), g("span", RI, U(t.label), 1)) : L("", !0)
        ], 6))
      ])
    ], 6));
  }
});
const Rv = (t, a) => {
  const o = t.__vccOpts || t;
  for (const [c, n] of a)
    o[c] = n;
  return o;
}, kS = /* @__PURE__ */ Rv($I, [["__scopeId", "data-v-c570d29c"]]), EI = {
  key: 0,
  class: "cstu-flex cstu-justify-between cstu-mb-1"
}, UI = {
  key: 0,
  class: "cstu-text-sm cstu-font-medium cstu-text-gray-500"
}, ZI = ["aria-valuenow"], NI = {
  key: 1,
  class: "cstu-flex cstu-h-full"
}, WI = {
  key: 1,
  class: "cstu-text-sm cstu-font-medium cstu-text-gray-500 cstu-whitespace-nowrap"
}, MS = /* @__PURE__ */ O({
  __name: "Progress",
  props: {
    value: { default: 0 },
    size: { default: "md" },
    color: { default: "primary" },
    striped: { type: Boolean, default: !1 },
    animated: { type: Boolean, default: !1 },
    label: null,
    showValue: { type: Boolean, default: !1 },
    valuePosition: { default: "top" },
    radius: { default: "sm" },
    class: { default: "" },
    sections: { default: () => [] },
    minValue: { default: 0 },
    showMinValue: { type: Boolean, default: !1 },
    minValueColor: { default: "secondary" }
  },
  setup(t) {
    const a = t, o = u(() => Math.min(100, Math.max(0, a.value))), c = u(() => typeof a.color == "string" && (a.color.startsWith("#") || a.color.startsWith("rgb"))), n = u(() => c.value ? "" : ee(a.color, "filled", {
      hover: !1,
      active: !1,
      focus: !1
    })), i = u(() => typeof a.minValueColor == "string" && (a.minValueColor.startsWith("#") || a.minValueColor.startsWith("rgb"))), d = u(() => !a.minValueColor || i.value ? "" : ee(a.minValueColor, "filled", {
      hover: !1,
      active: !1,
      focus: !1
    })), r = u(() => {
      const w = {
        width: `${o.value}%`
      };
      return c.value && (w.backgroundColor = a.color), w;
    }), h = u(() => ({
      left: `${a.minValue}%`
    })), s = u(() => {
      if (!a.sections || a.sections.length === 0)
        return [];
      const w = a.sections.reduce(
        (A, b) => A + b.value,
        0
      );
      return a.sections.map((A) => {
        const b = w > 0 ? A.value / w * 100 : 0;
        return {
          ...A,
          percentage: b
        };
      });
    }), M = (w) => {
      if (typeof w.color == "string" && (w.color.startsWith("#") || w.color.startsWith("rgb")))
        return "";
      const A = w.color || a.color;
      return ee(A, "filled", {
        hover: !1,
        active: !1,
        focus: !1
      });
    }, y = (w) => {
      const A = {
        width: `${w.percentage}%`
      };
      return typeof w.color == "string" && (w.color.startsWith("#") || w.color.startsWith("rgb")) && (A.backgroundColor = w.color), A;
    }, p = u(() => De(a.radius)), m = u(() => a.class || ""), C = u(() => {
      switch (a.size) {
        case "xs":
          return "cstu-w-1";
        case "sm":
          return "cstu-w-1";
        case "md":
          return "cstu-w-1.5";
        case "lg":
          return "cstu-w-1.5";
        case "xl":
          return "cstu-w-1.5";
        default:
          return "cstu-w-1.5";
      }
    }), z = u(() => {
      let w;
      switch (a.size) {
        case "xs":
          w = 4;
          break;
        case "sm":
          w = 4;
          break;
        case "md":
          w = 8;
          break;
        case "lg":
          w = 8;
          break;
        case "xl":
          w = 8;
          break;
        default:
          w = 8;
      }
      return `${w + 4}px`;
    });
    return (w, A) => (k(), g("div", null, [
      t.label || w.$slots.label || t.showValue ? (k(), g("div", EI, [
        t.label && !w.$slots.label ? (k(), g("span", UI, U(t.label), 1)) : L("", !0),
        w.$slots.label ? H(w.$slots, "label", { key: 1 }) : L("", !0),
        t.showValue && t.valuePosition === "top" && !w.$slots.value ? (k(), g("span", {
          key: 2,
          class: I(["cstu-text-sm cstu-font-medium cstu-text-gray-500", { "flex justify-end w-full": !t.label }])
        }, U(l(o)) + "% ", 3)) : L("", !0),
        t.showValue && t.valuePosition === "top" && w.$slots.value ? H(w.$slots, "value", { key: 3 }) : L("", !0)
      ])) : L("", !0),
      f("div", {
        class: I(["cstu-relative", { "cstu-flex cstu-items-center cstu-gap-2": t.showValue && t.valuePosition === "right" }])
      }, [
        f("div", {
          class: I([
            "cstu-overflow-hidden",
            { "cstu-w-full": !(t.showValue && t.valuePosition === "right"), "cstu-flex-1": t.showValue && t.valuePosition === "right" }
          ])
        }, [
          f("div", {
            class: I([
              "cstu-relative cstu-overflow-hidden",
              l(p),
              "cstu-bg-gray-250",
              l(Tv)(t.size, "progress"),
              l(m)
            ]),
            role: "progressbar",
            "aria-valuenow": t.value,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            !t.sections || t.sections.length === 0 ? (k(), g("div", {
              key: 0,
              class: I([
                "cstu-h-full cstu-transition-all cstu-duration-300 cstu-ease-in-out",
                l(n),
                {
                  "bg-striped": t.striped && !t.animated,
                  "bg-striped animate-progress": t.animated
                }
              ]),
              style: W(l(r))
            }, null, 6)) : (k(), g("div", NI, [
              (k(!0), g(re, null, O2(l(s), (b, x) => (k(), g("div", {
                key: x,
                class: I([
                  "cstu-h-full cstu-transition-all cstu-duration-300 cstu-ease-in-out",
                  M(b),
                  {
                    "bg-striped": b.striped && !b.animated,
                    "bg-striped animate-progress": b.animated
                  }
                ]),
                style: W(y(b))
              }, null, 6))), 128))
            ]))
          ], 10, ZI)
        ], 2),
        t.showMinValue ? (k(), g("div", {
          key: 0,
          class: I(["cstu-absolute cstu-z-10", [l(C)]]),
          style: W([l(h), { top: "50%", transform: "translateX(-50%) translateY(-50%)" }])
        }, [
          H(w.$slots, "minValueMarker", {}, () => [
            f("div", {
              class: I([
                "cstu-h-full cstu-w-full cstu-rounded-sm border",
                l(d)
              ]),
              style: W([
                l(i) ? { backgroundColor: a.minValueColor } : {},
                { height: l(z) }
              ])
            }, null, 6)
          ])
        ], 6)) : L("", !0),
        t.showValue && t.valuePosition === "right" && !w.$slots.value ? (k(), g("span", WI, U(l(o)) + "% ", 1)) : L("", !0),
        t.showValue && t.valuePosition === "right" && w.$slots.value ? H(w.$slots, "value", { key: 2 }) : L("", !0)
      ], 2)
    ]));
  }
});
const GI = {
  key: 0,
  class: "flex-shrink-0"
}, XI = {
  key: 0,
  class: "flex items-center justify-between"
}, KI = {
  key: 1,
  class: "flex-shrink-0 ml-3"
}, JI = ["disabled"], QI = /* @__PURE__ */ f("span", { class: "sr-only" }, "Close", -1), YI = /* @__PURE__ */ f("svg", {
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ f("path", { d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" })
], -1), _I = [
  QI,
  YI
], fS = /* @__PURE__ */ O({
  __name: "Alert",
  props: {
    title: null,
    message: null,
    variant: { default: "outline" },
    color: { default: "primary" },
    size: { default: "md" },
    closable: { type: Boolean, default: !1 },
    onClose: null,
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: void 0 },
    invalid: { type: Boolean, default: void 0 }
  },
  emits: ["close"],
  setup(t, { emit: a }) {
    const o = t, c = (C) => C, n = u(() => ee(o.color, c(o.variant), {
      hover: !1,
      active: !1,
      focus: !1,
      disabled: o.disabled
    })), i = u(() => ux(c(o.variant))), d = u(() => iI(o.color, c(o.variant))), r = u(() => Ie(o.size, "alert")), h = u(() => C2(o.size)), s = u(() => dI(o.size)), M = u(() => S2({
      disabled: o.disabled,
      loading: o.loading
    })), y = u(() => sI({
      valid: o.valid,
      invalid: o.invalid
    })), p = u(() => lI({
      hover: !0,
      focus: !0
    }, o.color)), m = () => {
      a("close");
    };
    return (C, z) => (k(), g("div", {
      class: I([
        "relative rounded-md",
        l(i),
        l(n),
        l(r),
        l(M),
        l(y)
      ]),
      role: "alert"
    }, [
      f("div", {
        class: I(["flex items-start", [l(s)]])
      }, [
        C.$slots.icon ? (k(), g("div", GI, [
          H(C.$slots, "icon")
        ])) : L("", !0),
        f("div", {
          class: I(["flex-grow", [C.$slots.icon && "ml-3"]])
        }, [
          t.title ? (k(), g("div", XI, [
            f("h3", {
              class: I([
                "font-medium",
                l(d)
              ])
            }, U(t.title), 3)
          ])) : L("", !0),
          t.message ? (k(), g("div", {
            key: 1,
            class: I([
              "mt-1",
              t.variant === "filled" ? "text-white/90" : "text-gray-600",
              l(h)
            ])
          }, U(t.message), 3)) : L("", !0),
          H(C.$slots, "default")
        ], 2),
        t.closable ? (k(), g("div", KI, [
          f("button", {
            type: "button",
            class: I(["inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2", [
              t.variant === "filled" ? "text-white/80 hover:text-white focus:ring-white" : "text-gray-400 hover:text-gray-500 focus:ring-blue-500",
              l(p)
            ]]),
            disabled: t.disabled,
            onClick: m
          }, _I, 10, JI)
        ])) : L("", !0)
      ], 2)
    ], 2));
  }
}), ew = { class: "cstu-inline-block" }, tw = /* @__PURE__ */ O({
  __name: "OvalLoader",
  props: {
    size: { default: "md" },
    radius: { default: "100%" }
  },
  setup(t) {
    const a = t, o = {
      xs: "12px",
      sm: "16px",
      md: "24px",
      lg: "36px",
      xl: "48px"
    }, c = u(() => {
      const n = parseInt(o[a.size]);
      return `${Math.max(2, n / 12)}px`;
    });
    return (n, i) => (k(), g("span", ew, [
      f("span", {
        class: "cstu-inline-block cstu-rounded-full cstu-border-solid cstu-border-r-transparent cstu-border-current cstu-animate-[oval-spin_1.2s_linear_infinite]",
        style: W({
          width: l(o)[a.size],
          height: l(o)[a.size],
          borderWidth: l(c),
          borderRadius: a.radius || "100%"
        })
      }, null, 4)
    ]));
  }
});
const aw = /* @__PURE__ */ O({
  __name: "DotsLoader",
  props: {
    size: { default: "md" }
  },
  setup(t) {
    const a = t, o = {
      xs: "12px",
      sm: "16px",
      md: "24px",
      lg: "36px",
      xl: "48px"
    }, c = u(() => `${parseInt(o[a.size]) / 3}px`), n = u(() => `${parseInt(o[a.size]) / 6}px`);
    return (i, d) => (k(), g("span", {
      class: "cstu-inline-flex cstu-items-center",
      style: W({
        gap: l(n),
        height: l(o)[a.size]
      })
    }, [
      (k(), g(re, null, O2(3, (r) => f("span", {
        key: r,
        class: "cstu-inline-block cstu-rounded-full cstu-animate-[dots-pulse_0.8s_infinite_linear] cstu-bg-current",
        style: W({
          width: l(c),
          height: l(c),
          animationDelay: `${(r - 1) * 0.16}s`,
          opacity: 1
        })
      }, null, 4)), 64))
    ], 4));
  }
});
const ow = /* @__PURE__ */ O({
  __name: "BarsLoader",
  props: {
    size: { default: "md" }
  },
  setup(t) {
    const a = t, o = {
      xs: "12px",
      sm: "16px",
      md: "24px",
      lg: "36px",
      xl: "48px"
    }, c = u(() => `${parseInt(o[a.size]) / 6}px`);
    return (n, i) => (k(), g("span", {
      class: "cstu-inline-flex",
      style: W({
        gap: l(c),
        width: l(o)[a.size],
        height: `${parseInt(l(o)[a.size]) / 2}px`
      })
    }, [
      (k(), g(re, null, O2(3, (d) => f("span", {
        key: d,
        class: "cstu-flex-1 cstu-rounded-[2px] cstu-animate-[bars-scale_1.2s_cubic-bezier(0,0.5,0.5,1)_infinite] cstu-bg-current",
        style: W({
          animationDelay: `${(d - 1) * -0.12}s`,
          opacity: 1
        })
      }, null, 4)), 64))
    ], 4));
  }
});
const cw = /* @__PURE__ */ O({
  __name: "Loader",
  props: {
    variant: { default: "oval" },
    color: { default: "primary" },
    size: { default: "md" },
    class: null,
    loading: { type: Boolean, default: !0 },
    radius: { default: void 0 }
  },
  setup(t) {
    const a = t, o = (d) => d ? Object.keys(b2).includes(d) : !0, c = u(() => {
      if (!a.color || !o(a.color))
        return "";
      const d = a.color, r = b2[d];
      return `cstu-text-${r.base}-${r.main}`;
    }), n = u(() => !a.color || o(a.color) ? {} : { color: a.color }), i = u(() => {
      switch (a.variant) {
        case "dots":
          return aw;
        case "bars":
          return ow;
        default:
          return tw;
      }
    });
    return (d, r) => F2((k(), J(ve(l(i)), {
      class: I([
        "cstu-inline-block",
        l(c),
        a.class
      ]),
      style: W(l(n)),
      size: a.size,
      radius: a.radius
    }, null, 8, ["class", "style", "size", "radius"])), [
      [yv, a.loading]
    ]);
  }
}), nw = { class: "p-4" }, iw = {
  key: 0,
  class: "absolute top-2 right-2"
}, rw = /* @__PURE__ */ f("span", { class: "sr-only" }, "Close", -1), dw = /* @__PURE__ */ f("svg", {
  class: "h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /* @__PURE__ */ f("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1), sw = [
  rw,
  dw
], lw = {
  key: 1,
  class: "text-lg font-medium mb-2"
}, hw = { key: 2 }, gS = /* @__PURE__ */ O({
  __name: "Dialog",
  props: {
    title: null,
    content: null,
    opened: { type: Boolean },
    size: { default: "md" },
    withCloseButton: { type: Boolean, default: !0 },
    onClose: null,
    position: { default: () => ({ bottom: "20px", right: "20px" }) },
    keepMounted: { type: Boolean, default: !1 },
    zIndex: { default: 1e3 }
  },
  setup(t) {
    const a = t, o = u(() => ({
      xs: "w-[280px]",
      sm: "w-[320px]",
      md: "w-[380px]",
      lg: "w-[440px]",
      xl: "w-[520px]"
    })[a.size]);
    return (c, n) => (k(), J($2, { to: "body" }, [
      E(se, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "opacity-0 scale-95",
        "enter-to-class": "opacity-100 scale-100",
        "leave-active-class": "transition duration-200 ease-in",
        "leave-from-class": "opacity-100 scale-100",
        "leave-to-class": "opacity-0 scale-95"
      }, {
        default: N(() => [
          t.opened || t.keepMounted ? (k(), g("div", {
            key: 0,
            style: W({
              position: "fixed",
              zIndex: t.zIndex || 1e3,
              ...t.position,
              display: t.opened ? "block" : "none"
            }),
            class: "min-w-[200px]"
          }, [
            f("div", {
              class: I(["rounded-lg bg-white shadow-lg border border-gray-200", [l(o)]])
            }, [
              f("div", nw, [
                t.withCloseButton ? (k(), g("div", iw, [
                  f("button", {
                    onClick: n[0] || (n[0] = //@ts-ignore
                    (...i) => t.onClose && t.onClose(...i)),
                    class: "text-gray-400 hover:text-gray-500 focus:outline-none"
                  }, sw)
                ])) : L("", !0),
                t.title ? (k(), g("div", lw, U(t.title), 1)) : L("", !0),
                t.content ? (k(), g("div", hw, U(t.content), 1)) : L("", !0),
                H(c.$slots, "default")
              ])
            ], 2)
          ], 4)) : L("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), yw = ["top", "right", "bottom", "left"], Jv = ["start", "end"], Qv = /* @__PURE__ */ yw.reduce((t, a) => t.concat(a, a + "-" + Jv[0], a + "-" + Jv[1]), []), j2 = Math.min, L2 = Math.max, cv = Math.round, _2 = Math.floor, Ae = (t) => ({
  x: t,
  y: t
}), uw = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, pw = {
  start: "end",
  end: "start"
};
function qv(t, a, o) {
  return L2(t, j2(a, o));
}
function U2(t, a) {
  return typeof t == "function" ? t(a) : t;
}
function Te(t) {
  return t.split("-")[0];
}
function He(t) {
  return t.split("-")[1];
}
function fx(t) {
  return t === "x" ? "y" : "x";
}
function Ov(t) {
  return t === "y" ? "height" : "width";
}
function D2(t) {
  return ["top", "bottom"].includes(Te(t)) ? "y" : "x";
}
function $v(t) {
  return fx(D2(t));
}
function gx(t, a, o) {
  o === void 0 && (o = !1);
  const c = He(t), n = $v(t), i = Ov(n);
  let d = n === "x" ? c === (o ? "end" : "start") ? "right" : "left" : c === "start" ? "bottom" : "top";
  return a.reference[i] > a.floating[i] && (d = iv(d)), [d, iv(d)];
}
function kw(t) {
  const a = iv(t);
  return [nv(t), a, nv(a)];
}
function nv(t) {
  return t.replace(/start|end/g, (a) => pw[a]);
}
function Mw(t, a, o) {
  const c = ["left", "right"], n = ["right", "left"], i = ["top", "bottom"], d = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return o ? a ? n : c : a ? c : n;
    case "left":
    case "right":
      return a ? i : d;
    default:
      return [];
  }
}
function fw(t, a, o, c) {
  const n = He(t);
  let i = Mw(Te(t), o === "start", c);
  return n && (i = i.map((d) => d + "-" + n), a && (i = i.concat(i.map(nv)))), i;
}
function iv(t) {
  return t.replace(/left|right|bottom|top/g, (a) => uw[a]);
}
function gw(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function mx(t) {
  return typeof t != "number" ? gw(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function rv(t) {
  const {
    x: a,
    y: o,
    width: c,
    height: n
  } = t;
  return {
    width: c,
    height: n,
    top: o,
    left: a,
    right: a + c,
    bottom: o + n,
    x: a,
    y: o
  };
}
function Yv(t, a, o) {
  let {
    reference: c,
    floating: n
  } = t;
  const i = D2(a), d = $v(a), r = Ov(d), h = Te(a), s = i === "y", M = c.x + c.width / 2 - n.width / 2, y = c.y + c.height / 2 - n.height / 2, p = c[r] / 2 - n[r] / 2;
  let m;
  switch (h) {
    case "top":
      m = {
        x: M,
        y: c.y - n.height
      };
      break;
    case "bottom":
      m = {
        x: M,
        y: c.y + c.height
      };
      break;
    case "right":
      m = {
        x: c.x + c.width,
        y
      };
      break;
    case "left":
      m = {
        x: c.x - n.width,
        y
      };
      break;
    default:
      m = {
        x: c.x,
        y: c.y
      };
  }
  switch (He(a)) {
    case "start":
      m[d] -= p * (o && s ? -1 : 1);
      break;
    case "end":
      m[d] += p * (o && s ? -1 : 1);
      break;
  }
  return m;
}
const mw = async (t, a, o) => {
  const {
    placement: c = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: d
  } = o, r = i.filter(Boolean), h = await (d.isRTL == null ? void 0 : d.isRTL(a));
  let s = await d.getElementRects({
    reference: t,
    floating: a,
    strategy: n
  }), {
    x: M,
    y
  } = Yv(s, c, h), p = c, m = {}, C = 0;
  for (let z = 0; z < r.length; z++) {
    const {
      name: w,
      fn: A
    } = r[z], {
      x: b,
      y: x,
      data: v,
      reset: S
    } = await A({
      x: M,
      y,
      initialPlacement: c,
      placement: p,
      strategy: n,
      middlewareData: m,
      rects: s,
      platform: d,
      elements: {
        reference: t,
        floating: a
      }
    });
    M = b ?? M, y = x ?? y, m = {
      ...m,
      [w]: {
        ...m[w],
        ...v
      }
    }, S && C <= 50 && (C++, typeof S == "object" && (S.placement && (p = S.placement), S.rects && (s = S.rects === !0 ? await d.getElementRects({
      reference: t,
      floating: a,
      strategy: n
    }) : S.rects), {
      x: M,
      y
    } = Yv(s, p, h)), z = -1);
  }
  return {
    x: M,
    y,
    placement: p,
    strategy: n,
    middlewareData: m
  };
};
async function Ev(t, a) {
  var o;
  a === void 0 && (a = {});
  const {
    x: c,
    y: n,
    platform: i,
    rects: d,
    elements: r,
    strategy: h
  } = t, {
    boundary: s = "clippingAncestors",
    rootBoundary: M = "viewport",
    elementContext: y = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = U2(a, t), C = mx(m), w = r[p ? y === "floating" ? "reference" : "floating" : y], A = rv(await i.getClippingRect({
    element: (o = await (i.isElement == null ? void 0 : i.isElement(w))) == null || o ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(r.floating)),
    boundary: s,
    rootBoundary: M,
    strategy: h
  })), b = y === "floating" ? {
    x: c,
    y: n,
    width: d.floating.width,
    height: d.floating.height
  } : d.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(r.floating)), v = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = rv(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: r,
    rect: b,
    offsetParent: x,
    strategy: h
  }) : b);
  return {
    top: (A.top - S.top + C.top) / v.y,
    bottom: (S.bottom - A.bottom + C.bottom) / v.y,
    left: (A.left - S.left + C.left) / v.x,
    right: (S.right - A.right + C.right) / v.x
  };
}
const vw = (t) => ({
  name: "arrow",
  options: t,
  async fn(a) {
    const {
      x: o,
      y: c,
      placement: n,
      rects: i,
      platform: d,
      elements: r,
      middlewareData: h
    } = a, {
      element: s,
      padding: M = 0
    } = U2(t, a) || {};
    if (s == null)
      return {};
    const y = mx(M), p = {
      x: o,
      y: c
    }, m = $v(n), C = Ov(m), z = await d.getDimensions(s), w = m === "y", A = w ? "top" : "left", b = w ? "bottom" : "right", x = w ? "clientHeight" : "clientWidth", v = i.reference[C] + i.reference[m] - p[m] - i.floating[C], S = p[m] - i.reference[m], V = await (d.getOffsetParent == null ? void 0 : d.getOffsetParent(s));
    let Z = V ? V[x] : 0;
    (!Z || !await (d.isElement == null ? void 0 : d.isElement(V))) && (Z = r.floating[x] || i.floating[C]);
    const K = v / 2 - S / 2, B = Z / 2 - z[C] / 2 - 1, P = j2(y[A], B), D = j2(y[b], B), Y = P, oe = Z - z[C] - D, G = Z / 2 - z[C] / 2 + K, le = qv(Y, G, oe), he = !h.arrow && He(n) != null && G !== le && i.reference[C] / 2 - (G < Y ? P : D) - z[C] / 2 < 0, de = he ? G < Y ? G - Y : G - oe : 0;
    return {
      [m]: p[m] + de,
      data: {
        [m]: le,
        centerOffset: G - le - de,
        ...he && {
          alignmentOffset: de
        }
      },
      reset: he
    };
  }
});
function xw(t, a, o) {
  return (t ? [...o.filter((n) => He(n) === t), ...o.filter((n) => He(n) !== t)] : o.filter((n) => Te(n) === n)).filter((n) => t ? He(n) === t || (a ? nv(n) !== n : !1) : !0);
}
const Iw = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(a) {
      var o, c, n;
      const {
        rects: i,
        middlewareData: d,
        placement: r,
        platform: h,
        elements: s
      } = a, {
        crossAxis: M = !1,
        alignment: y,
        allowedPlacements: p = Qv,
        autoAlignment: m = !0,
        ...C
      } = U2(t, a), z = y !== void 0 || p === Qv ? xw(y || null, m, p) : p, w = await Ev(a, C), A = ((o = d.autoPlacement) == null ? void 0 : o.index) || 0, b = z[A];
      if (b == null)
        return {};
      const x = gx(b, i, await (h.isRTL == null ? void 0 : h.isRTL(s.floating)));
      if (r !== b)
        return {
          reset: {
            placement: z[0]
          }
        };
      const v = [w[Te(b)], w[x[0]], w[x[1]]], S = [...((c = d.autoPlacement) == null ? void 0 : c.overflows) || [], {
        placement: b,
        overflows: v
      }], V = z[A + 1];
      if (V)
        return {
          data: {
            index: A + 1,
            overflows: S
          },
          reset: {
            placement: V
          }
        };
      const Z = S.map((P) => {
        const D = He(P.placement);
        return [P.placement, D && M ? (
          // Check along the mainAxis and main crossAxis side.
          P.overflows.slice(0, 2).reduce((Y, oe) => Y + oe, 0)
        ) : (
          // Check only the mainAxis.
          P.overflows[0]
        ), P.overflows];
      }).sort((P, D) => P[1] - D[1]), B = ((n = Z.filter((P) => P[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        He(P[0]) ? 2 : 3
      ).every((D) => D <= 0))[0]) == null ? void 0 : n[0]) || Z[0][0];
      return B !== r ? {
        data: {
          index: A + 1,
          overflows: S
        },
        reset: {
          placement: B
        }
      } : {};
    }
  };
}, ww = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(a) {
      var o, c;
      const {
        placement: n,
        middlewareData: i,
        rects: d,
        initialPlacement: r,
        platform: h,
        elements: s
      } = a, {
        mainAxis: M = !0,
        crossAxis: y = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: z = !0,
        ...w
      } = U2(t, a);
      if ((o = i.arrow) != null && o.alignmentOffset)
        return {};
      const A = Te(n), b = D2(r), x = Te(r) === r, v = await (h.isRTL == null ? void 0 : h.isRTL(s.floating)), S = p || (x || !z ? [iv(r)] : kw(r)), V = C !== "none";
      !p && V && S.push(...fw(r, z, C, v));
      const Z = [r, ...S], K = await Ev(a, w), B = [];
      let P = ((c = i.flip) == null ? void 0 : c.overflows) || [];
      if (M && B.push(K[A]), y) {
        const G = gx(n, d, v);
        B.push(K[G[0]], K[G[1]]);
      }
      if (P = [...P, {
        placement: n,
        overflows: B
      }], !B.every((G) => G <= 0)) {
        var D, Y;
        const G = (((D = i.flip) == null ? void 0 : D.index) || 0) + 1, le = Z[G];
        if (le)
          return {
            data: {
              index: G,
              overflows: P
            },
            reset: {
              placement: le
            }
          };
        let he = (Y = P.filter((de) => de.overflows[0] <= 0).sort((de, q) => de.overflows[1] - q.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!he)
          switch (m) {
            case "bestFit": {
              var oe;
              const de = (oe = P.filter((q) => {
                if (V) {
                  const F = D2(q.placement);
                  return F === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((F) => F > 0).reduce((F, _) => F + _, 0)]).sort((q, F) => q[1] - F[1])[0]) == null ? void 0 : oe[0];
              de && (he = de);
              break;
            }
            case "initialPlacement":
              he = r;
              break;
          }
        if (n !== he)
          return {
            reset: {
              placement: he
            }
          };
      }
      return {};
    }
  };
};
async function Cw(t, a) {
  const {
    placement: o,
    platform: c,
    elements: n
  } = t, i = await (c.isRTL == null ? void 0 : c.isRTL(n.floating)), d = Te(o), r = He(o), h = D2(o) === "y", s = ["left", "top"].includes(d) ? -1 : 1, M = i && h ? -1 : 1, y = U2(a, t);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: C
  } = typeof y == "number" ? {
    mainAxis: y,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: y.mainAxis || 0,
    crossAxis: y.crossAxis || 0,
    alignmentAxis: y.alignmentAxis
  };
  return r && typeof C == "number" && (m = r === "end" ? C * -1 : C), h ? {
    x: m * M,
    y: p * s
  } : {
    x: p * s,
    y: m * M
  };
}
const Lw = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(a) {
      var o, c;
      const {
        x: n,
        y: i,
        placement: d,
        middlewareData: r
      } = a, h = await Cw(a, t);
      return d === ((o = r.offset) == null ? void 0 : o.placement) && (c = r.arrow) != null && c.alignmentOffset ? {} : {
        x: n + h.x,
        y: i + h.y,
        data: {
          ...h,
          placement: d
        }
      };
    }
  };
}, bw = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(a) {
      const {
        x: o,
        y: c,
        placement: n
      } = a, {
        mainAxis: i = !0,
        crossAxis: d = !1,
        limiter: r = {
          fn: (w) => {
            let {
              x: A,
              y: b
            } = w;
            return {
              x: A,
              y: b
            };
          }
        },
        ...h
      } = U2(t, a), s = {
        x: o,
        y: c
      }, M = await Ev(a, h), y = D2(Te(n)), p = fx(y);
      let m = s[p], C = s[y];
      if (i) {
        const w = p === "y" ? "top" : "left", A = p === "y" ? "bottom" : "right", b = m + M[w], x = m - M[A];
        m = qv(b, m, x);
      }
      if (d) {
        const w = y === "y" ? "top" : "left", A = y === "y" ? "bottom" : "right", b = C + M[w], x = C - M[A];
        C = qv(b, C, x);
      }
      const z = r.fn({
        ...a,
        [p]: m,
        [y]: C
      });
      return {
        ...z,
        data: {
          x: z.x - o,
          y: z.y - c,
          enabled: {
            [p]: i,
            [y]: d
          }
        }
      };
    }
  };
};
function uv() {
  return typeof window < "u";
}
function z2(t) {
  return Uv(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function ge(t) {
  var a;
  return (t == null || (a = t.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function Fe(t) {
  var a;
  return (a = (Uv(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : a.documentElement;
}
function Uv(t) {
  return uv() ? t instanceof Node || t instanceof ge(t).Node : !1;
}
function we(t) {
  return uv() ? t instanceof Element || t instanceof ge(t).Element : !1;
}
function Be(t) {
  return uv() ? t instanceof HTMLElement || t instanceof ge(t).HTMLElement : !1;
}
function _v(t) {
  return !uv() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof ge(t).ShadowRoot;
}
function J2(t) {
  const {
    overflow: a,
    overflowX: o,
    overflowY: c,
    display: n
  } = Ce(t);
  return /auto|scroll|overlay|hidden|clip/.test(a + c + o) && !["inline", "contents"].includes(n);
}
function Sw(t) {
  return ["table", "td", "th"].includes(z2(t));
}
function pv(t) {
  return [":popover-open", ":modal"].some((a) => {
    try {
      return t.matches(a);
    } catch {
      return !1;
    }
  });
}
function Zv(t) {
  const a = Nv(), o = we(t) ? Ce(t) : t;
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !a && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !a && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((c) => (o.willChange || "").includes(c)) || ["paint", "layout", "strict", "content"].some((c) => (o.contain || "").includes(c));
}
function qw(t) {
  let a = Ne(t);
  for (; Be(a) && !T2(a); ) {
    if (Zv(a))
      return a;
    if (pv(a))
      return null;
    a = Ne(a);
  }
  return null;
}
function Nv() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function T2(t) {
  return ["html", "body", "#document"].includes(z2(t));
}
function Ce(t) {
  return ge(t).getComputedStyle(t);
}
function kv(t) {
  return we(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Ne(t) {
  if (z2(t) === "html")
    return t;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    _v(t) && t.host || // Fallback.
    Fe(t)
  );
  return _v(a) ? a.host : a;
}
function vx(t) {
  const a = Ne(t);
  return T2(a) ? t.ownerDocument ? t.ownerDocument.body : t.body : Be(a) && J2(a) ? a : vx(a);
}
function G2(t, a, o) {
  var c;
  a === void 0 && (a = []), o === void 0 && (o = !0);
  const n = vx(t), i = n === ((c = t.ownerDocument) == null ? void 0 : c.body), d = ge(n);
  if (i) {
    const r = zv(d);
    return a.concat(d, d.visualViewport || [], J2(n) ? n : [], r && o ? G2(r) : []);
  }
  return a.concat(n, G2(n, [], o));
}
function zv(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function xx(t) {
  const a = Ce(t);
  let o = parseFloat(a.width) || 0, c = parseFloat(a.height) || 0;
  const n = Be(t), i = n ? t.offsetWidth : o, d = n ? t.offsetHeight : c, r = cv(o) !== i || cv(c) !== d;
  return r && (o = i, c = d), {
    width: o,
    height: c,
    $: r
  };
}
function Wv(t) {
  return we(t) ? t : t.contextElement;
}
function B2(t) {
  const a = Wv(t);
  if (!Be(a))
    return Ae(1);
  const o = a.getBoundingClientRect(), {
    width: c,
    height: n,
    $: i
  } = xx(a);
  let d = (i ? cv(o.width) : o.width) / c, r = (i ? cv(o.height) : o.height) / n;
  return (!d || !Number.isFinite(d)) && (d = 1), (!r || !Number.isFinite(r)) && (r = 1), {
    x: d,
    y: r
  };
}
const zw = /* @__PURE__ */ Ae(0);
function Ix(t) {
  const a = ge(t);
  return !Nv() || !a.visualViewport ? zw : {
    x: a.visualViewport.offsetLeft,
    y: a.visualViewport.offsetTop
  };
}
function Aw(t, a, o) {
  return a === void 0 && (a = !1), !o || a && o !== ge(t) ? !1 : a;
}
function q2(t, a, o, c) {
  a === void 0 && (a = !1), o === void 0 && (o = !1);
  const n = t.getBoundingClientRect(), i = Wv(t);
  let d = Ae(1);
  a && (c ? we(c) && (d = B2(c)) : d = B2(t));
  const r = Aw(i, o, c) ? Ix(i) : Ae(0);
  let h = (n.left + r.x) / d.x, s = (n.top + r.y) / d.y, M = n.width / d.x, y = n.height / d.y;
  if (i) {
    const p = ge(i), m = c && we(c) ? ge(c) : c;
    let C = p, z = zv(C);
    for (; z && c && m !== C; ) {
      const w = B2(z), A = z.getBoundingClientRect(), b = Ce(z), x = A.left + (z.clientLeft + parseFloat(b.paddingLeft)) * w.x, v = A.top + (z.clientTop + parseFloat(b.paddingTop)) * w.y;
      h *= w.x, s *= w.y, M *= w.x, y *= w.y, h += x, s += v, C = ge(z), z = zv(C);
    }
  }
  return rv({
    width: M,
    height: y,
    x: h,
    y: s
  });
}
function Gv(t, a) {
  const o = kv(t).scrollLeft;
  return a ? a.left + o : q2(Fe(t)).left + o;
}
function wx(t, a, o) {
  o === void 0 && (o = !1);
  const c = t.getBoundingClientRect(), n = c.left + a.scrollLeft - (o ? 0 : (
    // RTL <body> scrollbar.
    Gv(t, c)
  )), i = c.top + a.scrollTop;
  return {
    x: n,
    y: i
  };
}
function Hw(t) {
  let {
    elements: a,
    rect: o,
    offsetParent: c,
    strategy: n
  } = t;
  const i = n === "fixed", d = Fe(c), r = a ? pv(a.floating) : !1;
  if (c === d || r && i)
    return o;
  let h = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Ae(1);
  const M = Ae(0), y = Be(c);
  if ((y || !y && !i) && ((z2(c) !== "body" || J2(d)) && (h = kv(c)), Be(c))) {
    const m = q2(c);
    s = B2(c), M.x = m.x + c.clientLeft, M.y = m.y + c.clientTop;
  }
  const p = d && !y && !i ? wx(d, h, !0) : Ae(0);
  return {
    width: o.width * s.x,
    height: o.height * s.y,
    x: o.x * s.x - h.scrollLeft * s.x + M.x + p.x,
    y: o.y * s.y - h.scrollTop * s.y + M.y + p.y
  };
}
function Pw(t) {
  return Array.from(t.getClientRects());
}
function Bw(t) {
  const a = Fe(t), o = kv(t), c = t.ownerDocument.body, n = L2(a.scrollWidth, a.clientWidth, c.scrollWidth, c.clientWidth), i = L2(a.scrollHeight, a.clientHeight, c.scrollHeight, c.clientHeight);
  let d = -o.scrollLeft + Gv(t);
  const r = -o.scrollTop;
  return Ce(c).direction === "rtl" && (d += L2(a.clientWidth, c.clientWidth) - n), {
    width: n,
    height: i,
    x: d,
    y: r
  };
}
function Vw(t, a) {
  const o = ge(t), c = Fe(t), n = o.visualViewport;
  let i = c.clientWidth, d = c.clientHeight, r = 0, h = 0;
  if (n) {
    i = n.width, d = n.height;
    const s = Nv();
    (!s || s && a === "fixed") && (r = n.offsetLeft, h = n.offsetTop);
  }
  return {
    width: i,
    height: d,
    x: r,
    y: h
  };
}
function Fw(t, a) {
  const o = q2(t, !0, a === "fixed"), c = o.top + t.clientTop, n = o.left + t.clientLeft, i = Be(t) ? B2(t) : Ae(1), d = t.clientWidth * i.x, r = t.clientHeight * i.y, h = n * i.x, s = c * i.y;
  return {
    width: d,
    height: r,
    x: h,
    y: s
  };
}
function ex(t, a, o) {
  let c;
  if (a === "viewport")
    c = Vw(t, o);
  else if (a === "document")
    c = Bw(Fe(t));
  else if (we(a))
    c = Fw(a, o);
  else {
    const n = Ix(t);
    c = {
      x: a.x - n.x,
      y: a.y - n.y,
      width: a.width,
      height: a.height
    };
  }
  return rv(c);
}
function Cx(t, a) {
  const o = Ne(t);
  return o === a || !we(o) || T2(o) ? !1 : Ce(o).position === "fixed" || Cx(o, a);
}
function jw(t, a) {
  const o = a.get(t);
  if (o)
    return o;
  let c = G2(t, [], !1).filter((r) => we(r) && z2(r) !== "body"), n = null;
  const i = Ce(t).position === "fixed";
  let d = i ? Ne(t) : t;
  for (; we(d) && !T2(d); ) {
    const r = Ce(d), h = Zv(d);
    !h && r.position === "fixed" && (n = null), (i ? !h && !n : !h && r.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || J2(d) && !h && Cx(t, d)) ? c = c.filter((M) => M !== d) : n = r, d = Ne(d);
  }
  return a.set(t, c), c;
}
function Dw(t) {
  let {
    element: a,
    boundary: o,
    rootBoundary: c,
    strategy: n
  } = t;
  const d = [...o === "clippingAncestors" ? pv(a) ? [] : jw(a, this._c) : [].concat(o), c], r = d[0], h = d.reduce((s, M) => {
    const y = ex(a, M, n);
    return s.top = L2(y.top, s.top), s.right = j2(y.right, s.right), s.bottom = j2(y.bottom, s.bottom), s.left = L2(y.left, s.left), s;
  }, ex(a, r, n));
  return {
    width: h.right - h.left,
    height: h.bottom - h.top,
    x: h.left,
    y: h.top
  };
}
function Tw(t) {
  const {
    width: a,
    height: o
  } = xx(t);
  return {
    width: a,
    height: o
  };
}
function Rw(t, a, o) {
  const c = Be(a), n = Fe(a), i = o === "fixed", d = q2(t, !0, i, a);
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const h = Ae(0);
  if (c || !c && !i)
    if ((z2(a) !== "body" || J2(n)) && (r = kv(a)), c) {
      const p = q2(a, !0, i, a);
      h.x = p.x + a.clientLeft, h.y = p.y + a.clientTop;
    } else
      n && (h.x = Gv(n));
  const s = n && !c && !i ? wx(n, r) : Ae(0), M = d.left + r.scrollLeft - h.x - s.x, y = d.top + r.scrollTop - h.y - s.y;
  return {
    x: M,
    y,
    width: d.width,
    height: d.height
  };
}
function Cv(t) {
  return Ce(t).position === "static";
}
function tx(t, a) {
  if (!Be(t) || Ce(t).position === "fixed")
    return null;
  if (a)
    return a(t);
  let o = t.offsetParent;
  return Fe(t) === o && (o = o.ownerDocument.body), o;
}
function Lx(t, a) {
  const o = ge(t);
  if (pv(t))
    return o;
  if (!Be(t)) {
    let n = Ne(t);
    for (; n && !T2(n); ) {
      if (we(n) && !Cv(n))
        return n;
      n = Ne(n);
    }
    return o;
  }
  let c = tx(t, a);
  for (; c && Sw(c) && Cv(c); )
    c = tx(c, a);
  return c && T2(c) && Cv(c) && !Zv(c) ? o : c || qw(t) || o;
}
const Ow = async function(t) {
  const a = this.getOffsetParent || Lx, o = this.getDimensions, c = await o(t.floating);
  return {
    reference: Rw(t.reference, await a(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: c.width,
      height: c.height
    }
  };
};
function $w(t) {
  return Ce(t).direction === "rtl";
}
const Ew = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Hw,
  getDocumentElement: Fe,
  getClippingRect: Dw,
  getOffsetParent: Lx,
  getElementRects: Ow,
  getClientRects: Pw,
  getDimensions: Tw,
  getScale: B2,
  isElement: we,
  isRTL: $w
};
function Uw(t, a) {
  let o = null, c;
  const n = Fe(t);
  function i() {
    var r;
    clearTimeout(c), (r = o) == null || r.disconnect(), o = null;
  }
  function d(r, h) {
    r === void 0 && (r = !1), h === void 0 && (h = 1), i();
    const {
      left: s,
      top: M,
      width: y,
      height: p
    } = t.getBoundingClientRect();
    if (r || a(), !y || !p)
      return;
    const m = _2(M), C = _2(n.clientWidth - (s + y)), z = _2(n.clientHeight - (M + p)), w = _2(s), b = {
      rootMargin: -m + "px " + -C + "px " + -z + "px " + -w + "px",
      threshold: L2(0, j2(1, h)) || 1
    };
    let x = !0;
    function v(S) {
      const V = S[0].intersectionRatio;
      if (V !== h) {
        if (!x)
          return d();
        V ? d(!1, V) : c = setTimeout(() => {
          d(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      o = new IntersectionObserver(v, {
        ...b,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(v, b);
    }
    o.observe(t);
  }
  return d(!0), i;
}
function bx(t, a, o, c) {
  c === void 0 && (c = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: i = !0,
    elementResize: d = typeof ResizeObserver == "function",
    layoutShift: r = typeof IntersectionObserver == "function",
    animationFrame: h = !1
  } = c, s = Wv(t), M = n || i ? [...s ? G2(s) : [], ...G2(a)] : [];
  M.forEach((A) => {
    n && A.addEventListener("scroll", o, {
      passive: !0
    }), i && A.addEventListener("resize", o);
  });
  const y = s && r ? Uw(s, o) : null;
  let p = -1, m = null;
  d && (m = new ResizeObserver((A) => {
    let [b] = A;
    b && b.target === s && m && (m.unobserve(a), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = m) == null || x.observe(a);
    })), o();
  }), s && !h && m.observe(s), m.observe(a));
  let C, z = h ? q2(t) : null;
  h && w();
  function w() {
    const A = q2(t);
    z && (A.x !== z.x || A.y !== z.y || A.width !== z.width || A.height !== z.height) && o(), z = A, C = requestAnimationFrame(w);
  }
  return o(), () => {
    var A;
    M.forEach((b) => {
      n && b.removeEventListener("scroll", o), i && b.removeEventListener("resize", o);
    }), y == null || y(), (A = m) == null || A.disconnect(), m = null, h && cancelAnimationFrame(C);
  };
}
const Mv = Lw, Sx = Iw, fv = bw, gv = ww, Zw = vw, Nw = (t, a, o) => {
  const c = /* @__PURE__ */ new Map(), n = {
    platform: Ew,
    ...o
  }, i = {
    ...n.platform,
    _c: c
  };
  return mw(t, a, {
    ...n,
    platform: i
  });
};
function Ww(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function Av(t) {
  if (Ww(t)) {
    const a = t.$el;
    return Uv(a) && z2(a) === "#comment" ? null : a;
  }
  return t;
}
function P2(t) {
  return typeof t == "function" ? t() : l(t);
}
function qx(t) {
  return {
    name: "arrow",
    options: t,
    fn(a) {
      const o = Av(P2(t.element));
      return o == null ? {} : Zw({
        element: o,
        padding: t.padding
      }).fn(a);
    }
  };
}
function zx(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ax(t, a) {
  const o = zx(t);
  return Math.round(a * o) / o;
}
function mv(t, a, o) {
  o === void 0 && (o = {});
  const c = o.whileElementsMounted, n = u(() => {
    var Z;
    return (Z = P2(o.open)) != null ? Z : !0;
  }), i = u(() => P2(o.middleware)), d = u(() => {
    var Z;
    return (Z = P2(o.placement)) != null ? Z : "bottom";
  }), r = u(() => {
    var Z;
    return (Z = P2(o.strategy)) != null ? Z : "absolute";
  }), h = u(() => {
    var Z;
    return (Z = P2(o.transform)) != null ? Z : !0;
  }), s = u(() => Av(t.value)), M = u(() => Av(a.value)), y = j(0), p = j(0), m = j(r.value), C = j(d.value), z = Yx({}), w = j(!1), A = u(() => {
    const Z = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!M.value)
      return Z;
    const K = ax(M.value, y.value), B = ax(M.value, p.value);
    return h.value ? {
      ...Z,
      transform: "translate(" + K + "px, " + B + "px)",
      ...zx(M.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: K + "px",
      top: B + "px"
    };
  });
  let b;
  function x() {
    if (s.value == null || M.value == null)
      return;
    const Z = n.value;
    Nw(s.value, M.value, {
      middleware: i.value,
      placement: d.value,
      strategy: r.value
    }).then((K) => {
      y.value = K.x, p.value = K.y, m.value = K.strategy, C.value = K.placement, z.value = K.middlewareData, w.value = Z !== !1;
    });
  }
  function v() {
    typeof b == "function" && (b(), b = void 0);
  }
  function S() {
    if (v(), c === void 0) {
      x();
      return;
    }
    if (s.value != null && M.value != null) {
      b = c(s.value, M.value, x);
      return;
    }
  }
  function V() {
    n.value || (w.value = !1);
  }
  return ne([i, d, r, n], x, {
    flush: "sync"
  }), ne([s, M], S, {
    flush: "sync"
  }), ne(n, V, {
    flush: "sync"
  }), lx() && hx(v), {
    x: H2(y),
    y: H2(p),
    strategy: H2(m),
    placement: H2(C),
    middlewareData: H2(z),
    isPositioned: H2(w),
    floatingStyles: A,
    update: x
  };
}
function Gw(t) {
  return lx() ? (hx(t), !0) : !1;
}
function Xw(t) {
  return typeof t == "function" ? t() : l(t);
}
const Kw = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function ox(t, a, o = {}) {
  const {
    immediate: c = !0
  } = o, n = j(!1);
  let i = null;
  function d() {
    i && (clearTimeout(i), i = null);
  }
  function r() {
    n.value = !1, d();
  }
  function h(...s) {
    d(), n.value = !0, i = setTimeout(() => {
      n.value = !1, i = null, t(...s);
    }, Xw(a));
  }
  return c && (n.value = !0, Kw && h()), Gw(r), {
    isPending: _x(n),
    start: h,
    stop: r
  };
}
function Jw(t = {}) {
  const {
    openDelay: a = 0,
    closeDelay: o = 150,
    onOpen: c,
    onClose: n,
    initiallyOpened: i = !1
  } = t, d = j(!1), { start: r, stop: h } = ox(() => {
    d.value = !0, c == null || c();
  }, a), { start: s, stop: M } = ox(() => {
    d.value = !1, n == null || n();
  }, o), y = () => {
    M(), a === 0 ? (d.value = !0, c == null || c()) : r();
  }, p = () => {
    h(), o === 0 ? (d.value = !1, n == null || n()) : s();
  };
  return i && y(), {
    isOpen: d,
    open: y,
    close: p
  };
}
const Ax = Symbol("hover-card"), Hx = /* @__PURE__ */ O({
  __name: "HoverCardTarget",
  props: {
    withWrapper: { type: Boolean, default: !1 },
    wrapperClass: { default: "" }
  },
  setup(t) {
    return fe(Ax, null), (a, o) => t.withWrapper ? (k(), g("div", {
      key: 0,
      class: I(t.wrapperClass)
    }, [
      H(a.$slots, "default")
    ], 2)) : H(a.$slots, "default", { key: 1 });
  }
}), Qw = { class: "rounded-lg bg-white shadow-lg border border-gray-200 px-3 py-2" }, Yw = /* @__PURE__ */ O({
  __name: "HoverCard",
  props: {
    initiallyOpened: { type: Boolean, default: !1 },
    openDelay: { default: 0 },
    closeDelay: { default: 150 },
    placement: { default: "bottom" },
    onOpen: null,
    onClose: null,
    offset: { default: 8 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    withArrow: { type: Boolean, default: !0 },
    arrowOffset: { default: 8 },
    trapFocus: { type: Boolean, default: !0 },
    zIndex: { default: 1e3 }
  },
  setup(t) {
    const a = t, o = j(!1);
    xe(() => {
      o.value = !0;
    });
    const c = j(null), n = j(null), i = j(null), { isOpen: d, open: r, close: h } = Jw({
      openDelay: a.openDelay,
      closeDelay: a.closeDelay,
      initiallyOpened: a.initiallyOpened
    });
    Ee(Ax, {
      isOpen: d,
      open: r,
      close: h
    });
    const {
      x: s,
      y: M,
      strategy: y,
      middlewareData: p,
      placement: m,
      update: C
    } = mv(n, i, {
      placement: a.placement,
      middleware: [
        Mv(a.offset),
        gv({
          fallbackPlacements: ["top", "bottom", "right", "left"].filter((v) => v !== a.placement)
        }),
        fv({ padding: 8 }),
        qx({ element: c })
      ]
    });
    ne(d, async (v) => {
      v && await C();
    });
    const z = u(() => {
      var v, S;
      return (S = (v = p.value) == null ? void 0 : v.arrow) == null ? void 0 : S.x;
    }), w = u(() => {
      var v, S;
      return (S = (v = p.value) == null ? void 0 : v.arrow) == null ? void 0 : S.y;
    }), A = u(() => {
      switch (m.value) {
        case "top":
          return "bottom";
        case "bottom":
          return "top";
        case "left":
          return "right";
        case "right":
          return "left";
        default:
          return "bottom";
      }
    }), b = u(() => {
      switch (m.value) {
        case "top":
          return "translate(-50%, 50%)";
        case "bottom":
          return "translate(-50%, -50%)";
        case "left":
          return "translate(50%, -50%)";
        case "right":
          return "translate(-50%, -50%)";
        default:
          return "translate(-50%, -50%)";
      }
    }), x = u(() => ({
      xs: "w-[200px]",
      sm: "w-[240px]",
      md: "w-[320px]",
      lg: "w-[400px]",
      xl: "w-[480px]"
    })[a.size]);
    return (v, S) => (k(), g("div", {
      ref_key: "reference",
      ref: n,
      class: "relative inline-block",
      onMouseenter: S[2] || (S[2] = (V) => !t.disabled && l(r)()),
      onMouseleave: S[3] || (S[3] = (V) => !t.disabled && l(h)())
    }, [
      E(Hx, null, {
        default: N(() => [
          H(v.$slots, "target")
        ]),
        _: 3
      }),
      o.value ? (k(), J($2, {
        key: 0,
        to: "body"
      }, [
        E(se, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition duration-150 ease-in",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: N(() => [
            l(d) ? (k(), g("div", {
              key: 0,
              ref_key: "floating",
              ref: i,
              style: W({
                position: l(y),
                top: `${l(M) ?? 0}px`,
                left: `${l(s) ?? 0}px`,
                zIndex: t.zIndex || 1e3
              }),
              class: I(["min-w-[200px]", [l(x)]]),
              onMouseenter: S[0] || (S[0] = (V) => !t.disabled && l(r)()),
              onMouseleave: S[1] || (S[1] = (V) => !t.disabled && l(h)())
            }, [
              f("div", Qw, [
                H(v.$slots, "dropdown")
              ]),
              t.withArrow ? (k(), g("div", {
                key: 0,
                ref_key: "arrowRef",
                ref: c,
                class: "absolute w-2 h-2 rotate-45 bg-white border border-gray-200",
                style: W({
                  position: "absolute",
                  left: `${l(z) ?? 0}px`,
                  top: `${l(w) ?? 0}px`,
                  [l(A)]: "-1px",
                  "z-index": -1,
                  "transform-origin": "center",
                  transform: `rotate(45deg) ${l(b)}`
                })
              }, null, 4)) : L("", !0)
            ], 38)) : L("", !0)
          ]),
          _: 3
        })
      ])) : L("", !0)
    ], 544));
  }
});
Object.assign(Yw, {
  Target: Hx
});
const _w = /* @__PURE__ */ f("span", { tabindex: "0" }, null, -1), eC = { class: "cstu-modal-title" }, tC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "cstu-size-6"
}, [
  /* @__PURE__ */ f("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18 18 6M6 6l12 12"
  })
], -1), aC = [
  tC
], oC = ["innerHTML"], cC = /* @__PURE__ */ f("span", { tabindex: "0" }, null, -1), nC = /* @__PURE__ */ O({
  __name: "MessageBoxOk",
  props: {
    message: {
      type: [String, Object],
      default: ""
    },
    title: {
      type: String,
      default: "Message"
    },
    okTitle: {
      type: String,
      default: "OK"
    },
    okVariant: {
      type: String,
      default: "filled"
    },
    okColor: {
      type: String,
      default: "primary"
    },
    okDisabled: {
      type: Boolean,
      default: !1
    },
    centered: {
      type: Boolean,
      default: !0
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    fullscreen: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    headerClass: {
      type: String,
      default: ""
    },
    bodyClass: {
      type: String,
      default: ""
    },
    footerClass: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    },
    dialogClass: {
      type: String,
      default: ""
    },
    modalClass: {
      type: String,
      default: ""
    },
    showHeaderDivider: {
      type: Boolean,
      default: !1
    },
    showFooterDivider: {
      type: Boolean,
      default: !1
    },
    showDividers: {
      type: Boolean,
      default: !1
    },
    radius: {
      type: String,
      default: ""
    },
    busy: {
      type: Boolean,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 1050
    }
  },
  emits: ["close"],
  setup(t, { emit: a }) {
    const o = t, c = j(!1), n = u(() => o.radius ? {
      [`cstu-radius-${o.radius}`]: !0
    } : {});
    function i() {
      d(!1);
    }
    function d(r) {
      c.value = !1, setTimeout(() => {
        document.body.classList.remove("cstu-modal-open"), a("close", r);
      }, 300);
    }
    return xe(() => {
      document.body.classList.add("cstu-modal-open"), me(() => {
        c.value = !0;
      });
    }), K2(() => {
      c.value = !1, document.body.classList.remove("cstu-modal-open");
    }), (r, h) => (k(), g(re, null, [
      E(se, { name: "fade" }, {
        default: N(() => [
          c.value ? (k(), g("div", {
            key: 0,
            class: "cstu-modal-backdrop",
            style: W({ zIndex: t.zIndex - 10 })
          }, null, 4)) : L("", !0)
        ]),
        _: 1
      }),
      E(se, { name: "cstu-modal" }, {
        default: N(() => [
          c.value ? (k(), g("div", {
            key: 0,
            class: I([
              "cstu-modal modal",
              {
                "cstu-modal-static": !0,
                "cstu-modal-scrollable": t.scrollable
              },
              t.modalClass
            ]),
            style: W({ display: c.value ? "block" : "none", zIndex: t.zIndex }),
            tabindex: "-1",
            role: "dialog",
            "aria-modal": "true",
            onClick: i
          }, [
            f("div", {
              class: I([
                "cstu-modal-dialog",
                t.dialogClass,
                {
                  "cstu-modal-fullscreen": t.fullscreen,
                  "cstu-modal-dialog-centered": t.centered && !t.fullscreen,
                  "cstu-modal-dialog-scrollable": t.scrollable,
                  [`cstu-modal-${t.size}`]: t.size && !t.fullscreen
                }
              ]),
              onClick: h[2] || (h[2] = Pe(() => {
              }, ["stop"]))
            }, [
              _w,
              f("div", {
                class: I([
                  "cstu-modal-content",
                  t.contentClass,
                  { "cstu-modal-content-fullscreen": t.fullscreen },
                  l(n)
                ]),
                tabindex: "-1"
              }, [
                f("header", {
                  class: I([
                    "cstu-modal-header",
                    t.headerClass,
                    { "show-divider": t.showHeaderDivider || t.showDividers }
                  ])
                }, [
                  f("h5", eC, U(t.title || "Message"), 1),
                  f("button", {
                    type: "button",
                    class: "cstu-close",
                    "aria-label": "Close",
                    onClick: h[0] || (h[0] = (s) => d(!1))
                  }, aC)
                ], 2),
                f("div", {
                  class: I(["cstu-modal-body", t.bodyClass])
                }, [
                  typeof t.message == "string" ? (k(), g("div", {
                    key: 0,
                    innerHTML: t.message
                  }, null, 8, oC)) : (k(), J(ve(t.message), { key: 1 }))
                ], 2),
                f("footer", {
                  class: I([
                    "cstu-modal-footer",
                    t.footerClass,
                    { "show-divider": t.showFooterDivider || t.showDividers }
                  ])
                }, [
                  E(Me, {
                    variant: t.okVariant,
                    color: t.okColor,
                    disabled: t.okDisabled || t.busy,
                    loading: t.busy,
                    size: "sm",
                    onClick: h[1] || (h[1] = (s) => d(!0))
                  }, {
                    default: N(() => [
                      ae(U(t.okTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["variant", "color", "disabled", "loading"])
                ], 2)
              ], 2),
              cC
            ], 2)
          ], 6)) : L("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), iC = /* @__PURE__ */ f("span", { tabindex: "0" }, null, -1), rC = { class: "cstu-modal-title" }, dC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "cstu-size-6"
}, [
  /* @__PURE__ */ f("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18 18 6M6 6l12 12"
  })
], -1), sC = [
  dC
], lC = ["innerHTML"], hC = /* @__PURE__ */ f("span", { tabindex: "0" }, null, -1), yC = /* @__PURE__ */ O({
  __name: "MessageBoxConfirm",
  props: {
    message: {
      type: [String, Object],
      default: ""
    },
    title: {
      type: String,
      default: "Confirm"
    },
    okTitle: {
      type: String,
      default: "OK"
    },
    okVariant: {
      type: String,
      default: "filled"
    },
    okColor: {
      type: String,
      default: "primary"
    },
    okDisabled: {
      type: Boolean,
      default: !1
    },
    cancelTitle: {
      type: String,
      default: "Cancel"
    },
    cancelVariant: {
      type: String,
      default: "outline"
    },
    cancelColor: {
      type: String,
      default: "secondary"
    },
    cancelDisabled: {
      type: Boolean,
      default: !1
    },
    centered: {
      type: Boolean,
      default: !0
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    fullscreen: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    headerClass: {
      type: String,
      default: ""
    },
    bodyClass: {
      type: String,
      default: ""
    },
    footerClass: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    },
    dialogClass: {
      type: String,
      default: ""
    },
    modalClass: {
      type: String,
      default: ""
    },
    showHeaderDivider: {
      type: Boolean,
      default: !1
    },
    showFooterDivider: {
      type: Boolean,
      default: !1
    },
    showDividers: {
      type: Boolean,
      default: !1
    },
    radius: {
      type: String,
      default: ""
    },
    busy: {
      type: Boolean,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 1050
    }
  },
  emits: ["close"],
  setup(t, { emit: a }) {
    const o = t, c = j(!1), n = u(() => o.radius ? {
      [`cstu-radius-${o.radius}`]: !0
    } : {});
    function i() {
      d(!1);
    }
    function d(r) {
      c.value = !1, setTimeout(() => {
        document.body.classList.remove("cstu-modal-open"), a("close", r);
      }, 300);
    }
    return xe(() => {
      document.body.classList.add("cstu-modal-open"), me(() => {
        c.value = !0;
      });
    }), K2(() => {
      c.value = !1, document.body.classList.remove("cstu-modal-open");
    }), (r, h) => (k(), g(re, null, [
      E(se, { name: "fade" }, {
        default: N(() => [
          c.value ? (k(), g("div", {
            key: 0,
            class: "cstu-modal-backdrop",
            style: W({ zIndex: t.zIndex - 10 })
          }, null, 4)) : L("", !0)
        ]),
        _: 1
      }),
      E(se, { name: "cstu-modal" }, {
        default: N(() => [
          c.value ? (k(), g("div", {
            key: 0,
            class: I([
              "cstu-modal modal",
              {
                "cstu-modal-static": !0,
                "cstu-modal-scrollable": t.scrollable
              },
              t.modalClass
            ]),
            style: W({ display: c.value ? "block" : "none", zIndex: t.zIndex }),
            tabindex: "-1",
            role: "dialog",
            "aria-modal": "true",
            onClick: i
          }, [
            f("div", {
              class: I([
                "cstu-modal-dialog",
                t.dialogClass,
                {
                  "cstu-modal-fullscreen": t.fullscreen,
                  "cstu-modal-dialog-centered": t.centered && !t.fullscreen,
                  "cstu-modal-dialog-scrollable": t.scrollable,
                  [`cstu-modal-${t.size}`]: t.size && !t.fullscreen
                }
              ]),
              onClick: h[3] || (h[3] = Pe(() => {
              }, ["stop"]))
            }, [
              iC,
              f("div", {
                class: I([
                  "cstu-modal-content",
                  t.contentClass,
                  { "cstu-modal-content-fullscreen": t.fullscreen },
                  l(n)
                ]),
                tabindex: "-1"
              }, [
                f("header", {
                  class: I([
                    "cstu-modal-header",
                    t.headerClass,
                    { "show-divider": t.showHeaderDivider || t.showDividers }
                  ])
                }, [
                  f("h5", rC, U(t.title || "Confirm"), 1),
                  f("button", {
                    type: "button",
                    class: "cstu-close",
                    "aria-label": "Close",
                    onClick: h[0] || (h[0] = (s) => d(!1))
                  }, sC)
                ], 2),
                f("div", {
                  class: I(["cstu-modal-body", t.bodyClass])
                }, [
                  typeof t.message == "string" ? (k(), g("div", {
                    key: 0,
                    innerHTML: t.message
                  }, null, 8, lC)) : (k(), J(ve(t.message), { key: 1 }))
                ], 2),
                f("footer", {
                  class: I([
                    "cstu-modal-footer",
                    t.footerClass,
                    { "show-divider": t.showFooterDivider || t.showDividers }
                  ])
                }, [
                  E(Me, {
                    variant: t.cancelVariant,
                    color: t.cancelColor,
                    disabled: t.cancelDisabled || t.busy,
                    size: "sm",
                    onClick: h[1] || (h[1] = (s) => d(!1))
                  }, {
                    default: N(() => [
                      ae(U(t.cancelTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["variant", "color", "disabled"]),
                  E(Me, {
                    variant: t.okVariant,
                    color: t.okColor,
                    disabled: t.okDisabled || t.busy,
                    size: "sm",
                    loading: t.busy,
                    onClick: h[2] || (h[2] = (s) => d(!0))
                  }, {
                    default: N(() => [
                      ae(U(t.okTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["variant", "color", "disabled", "loading"])
                ], 2)
              ], 2),
              hC
            ], 2)
          ], 6)) : L("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), uC = Symbol("CstuModal"), Z2 = E2(/* @__PURE__ */ new Map()), dv = {
  show: (t) => {
    const a = Z2.get(t);
    a && typeof a.show == "function" && a.show();
  },
  hide: (t) => {
    const a = Z2.get(t);
    a && typeof a.hide == "function" && a.hide();
  },
  toggle: (t) => {
    const a = Z2.get(t);
    a && typeof a.toggle == "function" && a.toggle();
  },
  msgBoxOk: (t, a = {}) => {
    const o = document.createElement("div");
    document.body.appendChild(o);
    const c = {
      ...a,
      message: t
    };
    return new Promise((n) => {
      const i = Sv(nC, {
        ...c,
        onClose: (d) => {
          n(d), setTimeout(() => {
            i.unmount(), o.parentNode && o.parentNode.removeChild(o);
          }, 300);
        }
      });
      i.mount(o);
    });
  },
  msgBoxConfirm: (t, a = {}) => {
    const o = document.createElement("div");
    document.body.appendChild(o);
    const c = {
      ...a,
      message: t
    };
    return new Promise((n) => {
      const i = Sv(yC, {
        ...c,
        onClose: (d) => {
          n(d), setTimeout(() => {
            i.unmount(), o.parentNode && o.parentNode.removeChild(o);
          }, 300);
        }
      });
      i.mount(o);
    });
  }
}, cx = dv;
function mS() {
  return dv;
}
function nx(t, a) {
  Z2.set(t, a);
}
function ix(t) {
  Z2.delete(t);
}
const vS = {
  install: (t) => {
    t.provide(uC, dv), t.config.globalProperties.$cstuModal = dv;
  }
}, Px = document.createElement("style");
Px.textContent = `
.cstu-msgbox-container {
  position: relative;
  z-index: 9999;
}

.cstu-modal.hiding,
.cstu-modal-backdrop.hiding {
  opacity: 0 !important;
  transition: opacity 0.15s linear;
}
`;
document.head.appendChild(Px);
const pC = ["id"], kC = ["id", "aria-labelledby"], MC = /* @__PURE__ */ f("span", { tabindex: "0" }, null, -1), fC = ["aria-label"], gC = ["id"], mC = ["aria-label"], vC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "cstu-size-6"
}, [
  /* @__PURE__ */ f("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18 18 6M6 6l12 12"
  })
], -1), xC = [
  vC
], IC = { key: 0 }, wC = /* @__PURE__ */ f("span", { tabindex: "0" }, null, -1), xS = /* @__PURE__ */ O({
  __name: "Modal",
  props: {
    id: {
      type: String,
      default: () => `modal-${Date.now()}`
    },
    title: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    radius: {
      type: String,
      default: ""
    },
    centered: {
      type: Boolean,
      default: !0
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    fullscreen: {
      type: Boolean,
      default: !1
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    hideFooter: {
      type: Boolean,
      default: !1
    },
    hideHeaderClose: {
      type: Boolean,
      default: !1
    },
    titleSrOnly: {
      type: Boolean,
      default: !1
    },
    ariaLabel: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    okTitle: {
      type: String,
      default: "OK"
    },
    okVariant: {
      type: String,
      default: "filled"
    },
    okColor: {
      type: String,
      default: "primary"
    },
    okDisabled: {
      type: Boolean,
      default: !1
    },
    cancelTitle: {
      type: String,
      default: "Cancel"
    },
    cancelVariant: {
      type: String,
      default: "outline"
    },
    cancelColor: {
      type: String,
      default: "secondary"
    },
    cancelDisabled: {
      type: Boolean,
      default: !1
    },
    modalClass: {
      type: String,
      default: ""
    },
    dialogClass: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    },
    headerClass: {
      type: String,
      default: ""
    },
    bodyClass: {
      type: String,
      default: ""
    },
    footerClass: {
      type: String,
      default: ""
    },
    ariaLabelledby: {
      type: String,
      default: ""
    },
    teleport: {
      type: Boolean,
      default: !0
    },
    backdrop: {
      type: Boolean,
      default: !0
    },
    backdropClass: {
      type: String,
      default: ""
    },
    titleClass: {
      type: String,
      default: ""
    },
    showHeaderDivider: {
      type: Boolean,
      default: !1
    },
    showFooterDivider: {
      type: Boolean,
      default: !1
    },
    showDividers: {
      type: Boolean,
      default: void 0
    },
    closeTitle: {
      type: String,
      default: "Close"
    },
    busy: {
      type: Boolean,
      default: !1
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: !1
    },
    noCloseOnEsc: {
      type: Boolean,
      default: !1
    },
    static: {
      type: Boolean,
      default: !1
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    okOnly: {
      type: Boolean,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 1050
    }
  },
  emits: [
    "update:modelValue",
    "show",
    "shown",
    "hide",
    "hidden",
    "ok",
    "cancel",
    "close"
  ],
  setup(t, { expose: a, emit: o }) {
    const c = t;
    class n {
      constructor(P, D = {}) {
        Oe(this, "type");
        Oe(this, "cancelable", !0);
        Oe(this, "target", null);
        Oe(this, "vueTarget", null);
        Oe(this, "defaultPrevented", !1);
        Oe(this, "componentId", "");
        Oe(this, "trigger", "programmatic");
        this.type = P, Object.assign(this, D);
      }
      preventDefault() {
        this.defaultPrevented = !0;
      }
    }
    const i = j(!1), d = j(null), r = j(null), h = j(c.zIndex), s = j(!1), M = j(0), y = u(() => c.zIndex !== 1050 ? c.zIndex : h.value);
    function p() {
      if (c.zIndex !== 1050) {
        h.value = c.zIndex;
        return;
      }
      const B = document.querySelectorAll(".cstu-modal");
      let P = 1050;
      B.forEach((D) => {
        const Y = parseInt(window.getComputedStyle(D).zIndex, 10);
        !isNaN(Y) && Y > P && (P = Y);
      }), h.value = P + 10;
    }
    const m = u(() => c.fullscreen ? "" : C(c.radius));
    function C(B) {
      const P = {
        none: "",
        sm: "cstu-rounded-sm",
        md: "cstu-rounded-md",
        lg: "cstu-rounded-lg",
        xl: "cstu-rounded-xl",
        full: "cstu-rounded-full"
      };
      return P[B || c.size] || P.md;
    }
    function z() {
      if (i.value)
        return;
      const B = new n("show", {
        trigger: "programmatic",
        target: null,
        vueTarget: null,
        componentId: c.id
      });
      o("show", B), !B.defaultPrevented && (d.value = document.activeElement, i.value = !0, M.value++, p(), document.body.classList.add("cstu-modal-open"), o("update:modelValue", !0), me(() => {
        S(), o("shown", B);
      }));
    }
    function w(B = "programmatic") {
      if (!i.value)
        return;
      const P = new n("hide", {
        trigger: B,
        target: null,
        vueTarget: null,
        componentId: c.id
      });
      o("hide", P), !P.defaultPrevented && (i.value = !1, s.value = !1, document.body.classList.remove("cstu-modal-open"), o("update:modelValue", !1), me(() => {
        V(d.value), o("hidden", P);
      }));
    }
    function A(B) {
      B && (d.value = typeof B == "string" ? document.querySelector(B) : B), i.value ? w() : z();
    }
    function b(B) {
      B === "ok" ? o("ok") : B === "cancel" && o("cancel"), w(B);
    }
    function x(B) {
      const P = B.target, D = P.closest(".cstu-dropdown-menu"), Y = P.tagName && ["input", "select", "textarea", "button"].includes(P.tagName.toLowerCase()), oe = P.closest(".cstu-modal-content");
      D || Y || oe && P !== B.currentTarget || !c.noCloseOnBackdrop && P === B.currentTarget && w("backdrop");
    }
    function v(B) {
      B.key === "Escape" && i.value && !c.noCloseOnEsc && !c.busy && w("esc");
    }
    function S() {
      me(() => {
        if (!r.value)
          return;
        const B = r.value, P = K(B);
        P.length > 0 && P[0].focus();
      });
    }
    function V(B) {
      if (B && i.value === !1)
        try {
          B.focus();
        } catch {
        }
    }
    function Z(B) {
      if (i.value && r.value && B.target) {
        const P = B.target, D = r.value, Y = !!P.closest(".cstu-modal-content");
        if (D !== P && !D.contains(P) && // Only trap focus if not inside any modal content (allows nested modals to work)
        !Y) {
          if (s.value)
            return;
          s.value = !0;
          try {
            const oe = K(D);
            oe.length > 0 ? oe[0].focus() : D.focus();
          } finally {
            setTimeout(() => {
              s.value = !1;
            }, 0);
          }
        }
      }
    }
    function K(B) {
      return Array.from(B.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ));
    }
    return ne(() => c.modelValue, (B) => {
      B !== i.value && (B ? z() : w());
    }), ne(() => c.id, () => {
      ix(c.id), nx(c.id, {
        show: z,
        hide: w,
        toggle: A
      });
    }), xe(() => {
      nx(c.id, {
        show: z,
        hide: w,
        toggle: A
      }), document.addEventListener("keydown", v), document.addEventListener("focusin", Z), c.modelValue && (z(), i.value && me(() => {
        setTimeout(() => {
          const B = document.getElementById(c.id);
          let P = null;
          B && B.parentNode && (P = B.parentNode.querySelector(".cstu-modal-backdrop")), B && window.getComputedStyle(B).display === "none" && (B.style.display = "block"), P && window.getComputedStyle(P).display === "none" && (P.style.display = "block");
        }, 50);
      }));
    }), K2(() => {
      ix(c.id), document.removeEventListener("keydown", v), document.removeEventListener("focusin", Z), i.value && (i.value = !1, o("update:modelValue", !1));
    }), a({
      hide: w,
      show: z,
      close: b,
      toggle: A
    }), (B, P) => (k(), J($2, {
      to: "body",
      disabled: c.static || c.teleport === !1
    }, [
      E(se, { name: "fade" }, {
        default: N(() => [
          i.value && t.backdrop !== !1 ? (k(), g("div", {
            key: 0,
            id: `${c.id}-backdrop`,
            class: I(["cstu-modal-backdrop", t.backdropClass]),
            style: W({ zIndex: l(y) - 10 })
          }, null, 14, pC)) : L("", !0)
        ]),
        _: 1
      }),
      E(se, { name: "modal" }, {
        default: N(() => [
          i.value ? (k(), g("div", {
            key: 0,
            id: c.id,
            class: I(["cstu-modal", [
              {
                "cstu-modal-static": c.static,
                "cstu-modal-scrollable": c.scrollable
              },
              c.modalClass
            ]]),
            tabindex: "-1",
            role: "dialog",
            "aria-modal": "true",
            style: W({ zIndex: l(y) }),
            "aria-labelledby": !t.hideHeader && t.title ? `modal-title-${c.id}` : void 0,
            onClick: x,
            onMousedown: P[5] || (P[5] = Pe(() => {
            }, ["stop"]))
          }, [
            f("div", {
              class: I([
                "cstu-modal-dialog",
                t.dialogClass,
                {
                  "cstu-modal-fullscreen": t.fullscreen,
                  "cstu-modal-dialog-centered": t.centered && !t.fullscreen,
                  "cstu-modal-dialog-scrollable": t.scrollable,
                  [`cstu-modal-${t.size}`]: t.size && !t.fullscreen
                }
              ]),
              onClick: P[4] || (P[4] = Pe((D) => D.target === D.currentTarget && D.stopPropagation(), ["stop"]))
            }, [
              MC,
              f("div", {
                class: I([
                  "cstu-modal-content",
                  t.contentClass,
                  { "cstu-modal-content-fullscreen": t.fullscreen },
                  l(m)
                ]),
                tabindex: "-1",
                ref_key: "modalElement",
                ref: r,
                "aria-label": t.ariaLabel,
                onClick: P[3] || (P[3] = (D) => D.target === D.currentTarget && D.stopPropagation())
              }, [
                t.hideHeader ? L("", !0) : (k(), g("header", {
                  key: 0,
                  class: I([
                    "cstu-modal-header",
                    t.headerClass,
                    { "show-divider": t.showHeaderDivider || t.showDividers }
                  ])
                }, [
                  H(B.$slots, "modal-header", {}, () => [
                    H(B.$slots, "modal-title", {}, () => [
                      f("h5", {
                        id: `modal-title-${c.id}`,
                        class: I([c.titleClass || "cstu-modal-title", { "sr-only": t.titleSrOnly }])
                      }, U(t.title), 11, gC)
                    ]),
                    t.hideHeaderClose ? L("", !0) : (k(), g("button", {
                      key: 0,
                      type: "button",
                      "aria-label": t.closeTitle,
                      class: "cstu-close",
                      onClick: P[0] || (P[0] = (D) => b("headerClose"))
                    }, xC, 8, mC))
                  ])
                ], 2)),
                f("div", {
                  class: I([
                    "cstu-modal-body",
                    t.bodyClass,
                    { "cstu-modal-body-scrollable": t.scrollable }
                  ])
                }, [
                  H(B.$slots, "default", {}, () => [
                    t.content ? (k(), g("div", IC, U(t.content), 1)) : L("", !0)
                  ])
                ], 2),
                t.hideFooter ? L("", !0) : (k(), g("footer", {
                  key: 1,
                  class: I([
                    "cstu-modal-footer",
                    t.footerClass,
                    { "show-divider": t.showFooterDivider || t.showDividers }
                  ])
                }, [
                  H(B.$slots, "modal-footer", {}, () => [
                    t.okOnly ? L("", !0) : (k(), J(Me, {
                      key: 0,
                      variant: t.cancelVariant,
                      color: t.cancelColor,
                      disabled: t.cancelDisabled || t.busy,
                      onClick: P[1] || (P[1] = (D) => b("cancel"))
                    }, {
                      default: N(() => [
                        ae(U(t.cancelTitle), 1)
                      ]),
                      _: 1
                    }, 8, ["variant", "color", "disabled"])),
                    E(Me, {
                      variant: t.okVariant,
                      color: t.okColor,
                      disabled: t.okDisabled || t.busy,
                      loading: t.busy,
                      onClick: P[2] || (P[2] = (D) => b("ok"))
                    }, {
                      default: N(() => [
                        ae(U(t.okTitle), 1)
                      ]),
                      _: 1
                    }, 8, ["variant", "color", "disabled", "loading"])
                  ])
                ], 2))
              ], 10, fC),
              wC
            ], 2)
          ], 46, kC)) : L("", !0)
        ]),
        _: 3
      })
    ], 8, ["disabled"]));
  }
});
const CC = {
  mounted(t, a) {
    const o = typeof a.value == "string" ? a.value : Object.keys(a.modifiers)[0];
    if (!o) {
      console.warn("v-cstu-modal directive requires a modal ID");
      return;
    }
    t.addEventListener("click", () => {
      cx.show(o);
    }), t.tagName !== "BUTTON" && (t.setAttribute("role", "button"), t.addEventListener("keydown", (c) => {
      (c.key === "Enter" || c.key === " ") && (c.preventDefault(), cx.show(o));
    }), t.hasAttribute("tabindex") || t.setAttribute("tabindex", "0"));
  }
}, IS = {
  install: (t) => {
    t.directive("cstu-modal", CC);
  }
}, LC = [
  "primary",
  "secondary",
  "success",
  "warning",
  "info"
];
function bC(t, a = LC) {
  if (!t || !a || a.length === 0)
    return "primary";
  let o = 0;
  for (let n = 0; n < t.length; n += 1)
    o = t.charCodeAt(n) + ((o << 5) - o);
  const c = Math.abs(o) % a.length;
  return a[c];
}
function SC(t) {
  return !t || typeof t != "string" ? "" : t.trim().split(" ").slice(0, 2).map((a) => a.charAt(0).toUpperCase()).join("");
}
const qC = ["src", "alt"], zC = ["title"], AC = {
  key: 1,
  "data-avatar-placeholder-icon": "true",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HC = /* @__PURE__ */ f("path", {
  d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1), PC = [
  HC
], BC = /* @__PURE__ */ O({
  __name: "Avatar",
  props: {
    size: { default: "md" },
    radius: { default: "full" },
    color: { default: "primary" },
    gradient: null,
    src: { default: null },
    alt: null,
    imageProps: null,
    children: null,
    autoContrast: { type: Boolean, default: !0 },
    name: null,
    allowedInitialsColors: null,
    variant: { default: "light" },
    component: { default: "div" },
    hover: { type: Boolean, default: !1 },
    customClasses: { default: "" }
  },
  setup(t) {
    const a = t, o = j(!a.src);
    ne(() => a.src, (y) => {
      o.value = !y;
    }, { immediate: !0 });
    const c = (y) => y ? ["primary", "secondary", "success", "warning", "danger", "info", "dark", "light", "initials"].includes(y) : !0, n = u(() => a.name ? SC(a.name) : ""), i = u(() => {
      const y = {
        sm: "w-5 h-5 text-xs",
        md: "w-6 h-6 text-xs",
        lg: "w-[30px] h-[30px] text-sm",
        xl: "w-[32px] h-[32px] text-sm",
        "2xl": "w-[34px] h-[34px] text-base",
        "3xl": "w-[36px] h-[36px] text-base",
        "4xl": "w-[38px] h-[38px] text-lg",
        "5xl": "w-[52px] h-[52px] text-xl"
      };
      return typeof a.size == "string" ? y[a.size] || y.md : typeof a.size == "number" ? `w-[${a.size}px] h-[${a.size}px]` : y.md;
    }), d = u(() => De(a.radius)), r = u(() => {
      if (a.src && !o.value || !c(a.color) && a.color !== "initials")
        return "";
      if (a.color === "initials" && a.name) {
        const C = bC(a.name, a.allowedInitialsColors || ["primary", "secondary", "success", "warning", "info"]);
        return C ? ee(C, "filled", {}) : ee("primary", "filled", {});
      }
      const y = a.variant === "transparent" ? "default" : a.variant === "gradient" ? "filled" : a.variant, p = a.color && a.color !== "initials" ? a.color : "primary", m = ee(p, y, {});
      return a.variant === "transparent" ? "bg-transparent" : m;
    }), h = u(() => !c(a.color) && a.color !== "initials" ? "" : a.variant === "transparent" ? "bg-transparent" : a.variant === "gradient" && a.gradient ? `bg-gradient-to-r from-${a.gradient.from} to-${a.gradient.to}` : ux(a.variant)), s = u(() => {
      if (a.src && !o.value || c(a.color) || a.color === "initials")
        return {};
      const y = {};
      switch (a.variant) {
        case "filled":
          y.backgroundColor = a.color, a.autoContrast && (y.color = "white");
          break;
        case "light":
          y.backgroundColor = `${a.color}20`, y.color = a.color;
          break;
        case "outline":
          y.backgroundColor = "transparent", y.color = a.color, y.border = `1px solid ${a.color}`;
          break;
        case "transparent":
          y.backgroundColor = "transparent", y.color = a.color;
          break;
      }
      return y;
    }), M = (y) => {
      var p;
      o.value = !0, (p = a.imageProps) != null && p.onError && a.imageProps.onError(y);
    };
    return (y, p) => (k(), J(ve(t.component || "div"), {
      class: I([
        "avatar",
        l(i),
        l(d),
        !o.value && t.src ? "" : l(r),
        !o.value && t.src ? "" : l(h),
        { "avatar--with-image": !o.value && t.src },
        { "hover:opacity-80 transition-opacity": t.hover },
        t.customClasses
      ]),
      style: W(l(s))
    }, {
      default: N(() => [
        !o.value && t.src ? (k(), g("img", ce({
          key: 0,
          class: "avatar__image",
          src: t.src,
          alt: t.alt
        }, t.imageProps, { onError: M }), null, 16, qC)) : (k(), g("span", {
          key: 1,
          class: "avatar__placeholder",
          title: t.alt
        }, [
          H(y.$slots, "default", {}, () => [
            t.name ? (k(), g(re, { key: 0 }, [
              ae(U(l(n)), 1)
            ], 64)) : (k(), g("svg", AC, PC))
          ])
        ], 8, zC))
      ]),
      _: 3
    }, 8, ["class", "style"]));
  }
});
const VC = /* @__PURE__ */ O({
  __name: "AvatarGroup",
  props: {
    spacing: { default: "sm" },
    gap: { default: "none" },
    outlineWidth: { default: "normal" },
    outlineColor: { default: "white" },
    outlineOffset: { default: "small" },
    customClasses: { default: "" },
    max: null,
    hover: { type: Boolean, default: !1 }
  },
  setup(t) {
    const a = t, o = u(() => {
      if (typeof a.spacing == "number")
        return `${a.spacing}px`;
      const s = {
        xs: "-1rem",
        sm: "-0.75rem",
        md: "-0.5rem",
        lg: "-0.25rem",
        xl: "0"
      };
      return s[a.spacing] || s.sm;
    }), c = u(() => {
      if (typeof a.gap == "number")
        return `${a.gap}px`;
      if (typeof a.gap == "string" && !isNaN(parseFloat(a.gap)))
        return a.gap;
      const s = {
        none: "0",
        xs: "0.25rem",
        sm: "0.5rem",
        md: "0.75rem",
        lg: "1rem"
      };
      return s[a.gap] || s.none;
    }), n = u(() => {
      if (typeof a.outlineWidth == "number")
        return `${a.outlineWidth}px`;
      if (typeof a.outlineWidth == "string" && !isNaN(parseFloat(a.outlineWidth)))
        return a.outlineWidth;
      const s = {
        none: "0",
        thin: "1px",
        normal: "2px",
        medium: "3px",
        thick: "4px"
      };
      return s[a.outlineWidth] || s.normal;
    }), i = u(() => {
      if (typeof a.outlineOffset == "number")
        return `${a.outlineOffset}px`;
      if (typeof a.outlineOffset == "string" && !isNaN(parseFloat(a.outlineOffset)))
        return a.outlineOffset;
      const s = {
        none: "0",
        inset: "-2px",
        small: "1px",
        medium: "2px",
        large: "3px"
      };
      return s[a.outlineOffset] || s.small;
    }), d = u(() => typeof a.outlineColor == "string" && ["primary", "secondary", "success", "danger", "warning", "info", "dark", "light"].includes(a.outlineColor) ? `outline-${a.outlineColor}` : ""), r = u(() => typeof a.outlineColor == "string" && ["primary", "secondary", "success", "danger", "warning", "info", "dark", "light"].includes(a.outlineColor) ? "var(--color-" + a.outlineColor + ")" : a.outlineColor), h = u(() => ({
      "--avatar-group-spacing": o.value,
      "--avatar-group-gap": c.value,
      "--avatar-group-outline-width": n.value,
      "--avatar-group-outline-color": r.value,
      "--avatar-group-outline-offset": i.value
    }));
    return (s, M) => (k(), g("div", {
      class: I([
        "avatar-group",
        t.customClasses,
        l(d),
        { "avatar-group--hover": t.hover }
      ]),
      style: W(l(h))
    }, [
      H(s.$slots, "default", {}, void 0, !0)
    ], 6));
  }
});
const FC = /* @__PURE__ */ Rv(VC, [["__scopeId", "data-v-f582d4fb"]]);
BC.Group = FC;
const Xv = /* @__PURE__ */ O({
  __name: "Tabs",
  props: {
    /** Value for controlled component */
    value: {
      type: String,
      default: void 0
    },
    /** Default value for uncontrolled component */
    defaultValue: {
      type: String,
      default: "first"
    },
    /** Orientation of tabs */
    orientation: {
      type: String,
      default: "horizontal"
    },
    /** Placement of tabs (left/right for vertical, top/bottom for horizontal) */
    placement: {
      type: String,
      default: void 0
    },
    /** Variant of the tabs */
    variant: {
      type: String,
      default: "text"
    }
  },
  emits: ["change"],
  setup(t, { emit: a }) {
    const o = t, c = u(() => o.placement ? o.placement : o.orientation === "horizontal" ? "top" : "left"), n = u(() => o.orientation), i = u(() => o.variant), d = j(o.value !== void 0 ? o.value : o.defaultValue);
    ne(() => o.value, (h) => {
      h !== void 0 && (d.value = h);
    });
    const r = (h) => {
      o.value !== void 0 ? a("change", h) : d.value = h;
    };
    return Ee("activeTab", d), Ee("setActiveTab", r), Ee("tabsOrientation", n), Ee("tabsPlacement", c), (h, s) => (k(), g("div", {
      class: I(["cstu-tabs", `cstu-tabs-${l(n)}`, `cstu-tabs-placement-${l(c)}`, `cstu-tabs-variant-${l(i)}`])
    }, [
      H(h.$slots, "default")
    ], 2));
  }
});
const jC = /* @__PURE__ */ O({
  __name: "TabsList",
  props: {
    /** Justify content alignment */
    justify: {
      type: String,
      default: "flex-start"
    },
    /** Whether to show a divider */
    divider: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const a = t, o = fe("tabsOrientation", j("horizontal")), c = fe("tabsPlacement", j("top")), n = u(() => [
      "tabs-list",
      `tabs-list-${o.value}`,
      `tabs-list-placement-${c.value}`,
      a.divider ? "tabs-list-with-divider" : ""
    ]), i = (r) => {
      if (["space-between", "space-around", "space-evenly"].includes(r))
        return r;
      switch (r) {
        case "flex-start":
          return "flex-start";
        case "flex-end":
          return "flex-end";
        case "center":
          return "center";
        default:
          return "flex-start";
      }
    }, d = u(() => o.value === "horizontal" ? {
      justifyContent: a.justify
    } : {
      justifyContent: i(a.justify)
    });
    return (r, h) => (k(), g("div", {
      class: I(l(n)),
      style: W(l(d))
    }, [
      H(r.$slots, "default")
    ], 6));
  }
});
const DC = /* @__PURE__ */ O({
  __name: "TabsTab",
  props: {
    /** Tab value, used for matching with active value */
    value: {
      type: String,
      required: !0
    },
    /** Button color */
    color: {
      type: String,
      default: "primary"
    },
    /** Button variant */
    variant: {
      type: String,
      default: "text"
    },
    /** Button size */
    size: {
      type: String,
      default: "md"
    },
    /** Button radius */
    radius: {
      type: String,
      default: "md"
    },
    /** Disabled state */
    disabled: {
      type: Boolean,
      default: !1
    },
    /** Loading state */
    loading: {
      type: Boolean,
      default: !1
    },
    /** Full width */
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const a = t, o = fe("activeTab", j("")), c = fe("setActiveTab", () => {
    }), n = fe("tabsOrientation", j("horizontal")), i = fe("tabsPlacement", j("top")), d = u(() => o.value), r = u(() => n.value), h = u(() => i.value), s = u(() => d.value === a.value), M = u(() => r.value === "vertical"), y = u(() => a.fullWidth && r.value === "horizontal"), p = () => {
      !a.disabled && !a.loading && c(a.value);
    };
    return (m, C) => (k(), J(l(Me), {
      class: I(
        [
          "tabs-tab",
          l(s) ? "tabs-tab-active" : "tabs-tab-inactive",
          `tabs-tab-${a.variant}`,
          a.color ? `tabs-tab-color-${a.color}` : "",
          `tabs-tab-orientation-${l(r)}`,
          `tabs-tab-placement-${l(h)}`,
          { "tabs-tab-full-width": l(y) }
        ]
      ),
      disabled: a.disabled,
      loading: a.loading,
      color: l(s) ? a.color : "secondary",
      variant: l(s) ? a.variant : "subtle",
      size: a.size,
      radius: a.variant === "text" ? "none" : a.radius,
      "full-width": l(M),
      onClick: p
    }, eI({
      default: N(() => [
        H(m.$slots, "default")
      ]),
      _: 2
    }, [
      m.$slots.leftSection ? {
        name: "leftSection",
        fn: N(() => [
          H(m.$slots, "leftSection")
        ]),
        key: "0"
      } : void 0,
      m.$slots.rightSection ? {
        name: "rightSection",
        fn: N(() => [
          H(m.$slots, "rightSection")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["class", "disabled", "loading", "color", "variant", "size", "radius", "full-width"]));
  }
});
const TC = /* @__PURE__ */ O({
  __name: "TabsPanel",
  props: {
    /** Panel value, used for matching with active value */
    value: {
      type: String,
      required: !0
    },
    KeepAlive: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const a = t, o = fe("activeTab", j("")), c = fe("tabsOrientation", j("horizontal")), n = fe("tabsPlacement", j("top")), i = u(() => o.value === a.value), d = u(() => [
      "tabs-panel",
      i.value ? "tabs-panel-active" : "tabs-panel-inactive",
      `tabs-panel-${c.value}`,
      `tabs-panel-placement-${n.value}`
    ]);
    return (r, h) => t.KeepAlive || l(i) ? F2((k(), g("div", {
      key: 0,
      class: I(l(d))
    }, [
      H(r.$slots, "default")
    ], 2)), [
      [yv, l(i)]
    ]) : L("", !0);
  }
});
Xv.List = jC;
Xv.Tab = DC;
Xv.Panel = TC;
const RC = /* @__PURE__ */ f("span", { class: "cstu-sr-only" }, "First page", -1), OC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "cstu-h-4 cstu-w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ f("polyline", { points: "11 17 6 12 11 7" }),
  /* @__PURE__ */ f("polyline", { points: "18 17 13 12 18 7" })
], -1), $C = /* @__PURE__ */ f("span", { class: "cstu-sr-only" }, "Previous page", -1), EC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "cstu-h-4 cstu-w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ f("polyline", { points: "15 18 9 12 15 6" })
], -1), UC = {
  key: 2,
  class: "cstu-flex cstu-items-center cstu-gap-2"
}, ZC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "cstu-h-4 cstu-w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ f("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }),
  /* @__PURE__ */ f("circle", {
    cx: "19",
    cy: "12",
    r: "1"
  }),
  /* @__PURE__ */ f("circle", {
    cx: "5",
    cy: "12",
    r: "1"
  })
], -1), NC = [
  ZC
], WC = /* @__PURE__ */ f("span", { class: "cstu-sr-only" }, "Next page", -1), GC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "cstu-h-4 cstu-w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ f("polyline", { points: "9 18 15 12 9 6" })
], -1), XC = /* @__PURE__ */ f("span", { class: "cstu-sr-only" }, "Last page", -1), KC = /* @__PURE__ */ f("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "cstu-h-4 cstu-w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ f("polyline", { points: "13 17 18 12 13 7" }),
  /* @__PURE__ */ f("polyline", { points: "6 17 11 12 6 7" })
], -1), wS = /* @__PURE__ */ O({
  __name: "Pagination",
  props: {
    modelValue: { default: 1 },
    total: null,
    siblings: { default: 1 },
    boundaries: { default: 1 },
    variant: { default: "filled" },
    color: { default: "primary" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    withControls: { type: Boolean, default: !0 },
    withEdges: { type: Boolean, default: !1 },
    withPages: { type: Boolean, default: !0 },
    class: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: a }) {
    const o = t, c = j(o.modelValue);
    ne(() => o.modelValue, (p) => {
      c.value = p;
    });
    const n = u(() => c.value === 1), i = u(() => c.value === o.total), d = u(() => {
      switch (o.size) {
        case "xs":
          return "cstu-!h-[30px] cstu-!w-[30px] cstu-min-w-[30px] !cstu-p-0";
        case "sm":
          return "cstu-!h-[36px] cstu-!w-[36px] cstu-min-w-[36px] !cstu-p-0";
        case "md":
          return "cstu-!h-[40px] cstu-!w-[40px] cstu-min-w-[40px] !cstu-p-0";
        case "lg":
          return "cstu-!h-[45px] cstu-!w-[45px] cstu-min-w-[45px] !cstu-p-0";
        case "xl":
          return "cstu-!h-[50px] cstu-!w-[50px] cstu-min-w-[50px] !cstu-p-0";
        default:
          return "cstu-!h-[40px] cstu-!w-[40px] cstu-min-w-[40px] !cstu-p-0";
      }
    }), r = u(() => [
      "cstu-flex cstu-items-center cstu-justify-center",
      M(o.size)
    ]), h = u(() => {
      const p = [], m = o.total;
      if (o.siblings * 2 + 3 + o.boundaries * 2 >= m)
        return Array.from({ length: m }, (v, S) => S + 1);
      const z = Math.max(c.value - o.siblings, o.boundaries + 1), w = Math.min(c.value + o.siblings, m - o.boundaries), A = z > o.boundaries + 2, b = w < m - (o.boundaries + 1), x = /* @__PURE__ */ new Set();
      for (let v = 1; v <= o.boundaries; v++)
        p.push(v), x.add(v);
      if (A)
        p.push("dots");
      else if (!A && z > o.boundaries)
        for (let v = o.boundaries + 1; v < z; v++)
          x.has(v) || (p.push(v), x.add(v));
      for (let v = z; v <= w; v++)
        x.has(v) || (p.push(v), x.add(v));
      if (b)
        p.push("dots");
      else if (!b && w < m - o.boundaries)
        for (let v = w + 1; v < m - o.boundaries + 1; v++)
          x.has(v) || (p.push(v), x.add(v));
      for (let v = m - o.boundaries + 1; v <= m; v++)
        x.has(v) || (p.push(v), x.add(v));
      return p;
    }), s = (p) => {
      p < 1 || p > o.total || o.disabled || (c.value = p, a("update:modelValue", p));
    };
    function M(p) {
      const m = {
        xs: "cstu-h-6 cstu-w-6 cstu-text-xs",
        sm: "cstu-h-7 cstu-w-7 cstu-text-sm",
        md: "cstu-h-8 cstu-w-8 cstu-text-sm",
        lg: "cstu-h-9 cstu-w-9 cstu-text-base",
        xl: "cstu-h-10 cstu-w-10 cstu-text-base"
      };
      return m[p] || m.md;
    }
    const y = u(() => o.variant === "filled" ? "subtle" : "bordered-transparent");
    return (p, m) => (k(), g("div", {
      class: I(["cstu-flex cstu-items-center cstu-gap-2", [o.class]])
    }, [
      o.withEdges ? (k(), J(Me, {
        key: 0,
        variant: l(y),
        color: "light",
        size: o.size,
        disabled: l(n) || o.disabled,
        onClick: m[0] || (m[0] = (C) => s(1)),
        "aria-label": "Go to first page",
        class: I(l(d))
      }, {
        default: N(() => [
          RC,
          OC
        ]),
        _: 1
      }, 8, ["variant", "size", "disabled", "class"])) : L("", !0),
      o.withControls ? (k(), J(Me, {
        key: 1,
        variant: l(y),
        color: "light",
        size: o.size,
        disabled: l(n) || o.disabled,
        onClick: m[1] || (m[1] = (C) => s(c.value - 1)),
        "aria-label": "Go to previous page",
        class: I(l(d))
      }, {
        default: N(() => [
          $C,
          EC
        ]),
        _: 1
      }, 8, ["variant", "size", "disabled", "class"])) : L("", !0),
      o.withPages ? (k(), g("div", UC, [
        (k(!0), g(re, null, O2(l(h), (C, z) => (k(), g(re, { key: z }, [
          C !== "dots" ? (k(), J(Me, {
            key: 0,
            variant: C === c.value ? "filled" : l(y),
            color: C === c.value ? o.color : "light",
            size: o.size,
            disabled: o.disabled,
            onClick: (w) => s(Number(C)),
            "aria-current": C === c.value ? "page" : void 0,
            "aria-label": `Page ${C}`,
            class: I(l(d))
          }, {
            default: N(() => [
              ae(U(C), 1)
            ]),
            _: 2
          }, 1032, ["variant", "color", "size", "disabled", "onClick", "aria-current", "aria-label", "class"])) : (k(), g("span", {
            key: 1,
            class: I(["pagination-dots", [l(r), l(d)]])
          }, NC, 2))
        ], 64))), 128))
      ])) : L("", !0),
      o.withControls ? (k(), J(Me, {
        key: 3,
        variant: l(y),
        color: "light",
        size: o.size,
        disabled: l(i) || o.disabled,
        onClick: m[2] || (m[2] = (C) => s(c.value + 1)),
        "aria-label": "Go to next page",
        class: I(l(d))
      }, {
        default: N(() => [
          WC,
          GC
        ]),
        _: 1
      }, 8, ["variant", "size", "disabled", "class"])) : L("", !0),
      o.withEdges ? (k(), J(Me, {
        key: 4,
        variant: l(y),
        color: "light",
        size: o.size,
        disabled: l(i) || o.disabled,
        onClick: m[3] || (m[3] = (C) => s(o.total)),
        "aria-label": "Go to last page",
        class: I(l(d))
      }, {
        default: N(() => [
          XC,
          KC
        ]),
        _: 1
      }, 8, ["variant", "size", "disabled", "class"])) : L("", !0)
    ], 2));
  }
}), Bx = {
  mounted(t, a) {
    t._clickOutside = (o) => {
      const c = o.target;
      if (!(t === c || t.contains(c))) {
        const n = o.target, i = n.tagName && n.tagName.toLowerCase() === "input", d = n.closest(".cstu-dropdown-menu");
        !i && !d && a.value(o);
      }
    }, document.addEventListener("click", t._clickOutside, !0), document.addEventListener("touchstart", t._clickOutside, !0);
  },
  unmounted(t) {
    t._clickOutside && (document.removeEventListener("click", t._clickOutside, !0), document.removeEventListener("touchstart", t._clickOutside, !0));
  }
}, JC = ["id", "aria-labelledby", "aria-modal", "onKeydown"], QC = { class: "cstu-popover-inner" }, YC = ["id"], CS = /* @__PURE__ */ O({
  __name: "Popover",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    placement: { default: "bottom" },
    variant: { default: "shadow" },
    color: { default: "primary" },
    size: { default: "md" },
    radius: { default: "md" },
    hideHeader: { type: Boolean, default: !1 },
    showCloseIcon: { type: Boolean, default: !0 },
    hideFooter: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    closeOnClick: { type: Boolean, default: !1 },
    title: { default: "" },
    content: { default: "" },
    zIndex: { default: 1e3 },
    trigger: { default: "click" },
    backdrop: { type: [Boolean, String], default: !1 },
    offsetDistance: { default: 8 },
    disabled: { type: Boolean, default: !1 },
    popoverClass: { default: "" },
    headerClass: { default: "" },
    bodyClass: { default: "" },
    footerClass: { default: "" },
    trapFocus: { type: Boolean, default: !1 },
    id: { default: () => `popover-${Date.now()}` },
    shadow: { default: "md" },
    width: null
  },
  emits: ["update:open", "open", "close"],
  setup(t, { emit: a }) {
    const o = t, c = j(o.defaultOpen), n = j(null), i = j(null), d = j(null), r = j(null), h = j(o.zIndex);
    o.open !== void 0 && (c.value = o.open);
    const s = u(() => {
      if (o.placement !== "auto")
        return o.placement;
    }), M = u(() => {
      const q = [Mv(o.offsetDistance)];
      return d.value && q.push(qx({ element: d })), o.placement === "auto" ? q.push(Sx({ padding: 8 })) : q.push(
        gv({
          fallbackPlacements: ["top", "bottom", "left", "right"],
          padding: 8
        })
      ), q.push(fv({ padding: 8 })), q;
    }), {
      floatingStyles: y,
      update: p
    } = mv(n, i, {
      placement: s,
      middleware: M,
      whileElementsMounted: bx
    }), m = (q) => {
      o.disabled || (o.trigger === "click" || o.trigger === "manual") && V();
    }, C = () => {
      o.disabled || o.trigger === "hover" && v();
    }, z = () => {
      o.disabled || o.trigger === "hover" && setTimeout(() => {
        S("hover");
      }, 100);
    }, w = (q) => {
      o.closeOnClick && S("popoverClick"), q.stopPropagation();
    }, A = (q) => {
      o.closeOnClickOutside && c.value && i.value && !i.value.contains(q.target) && n.value && !n.value.contains(q.target) && S("clickAway");
    }, b = () => {
      o.closeOnClickOutside && S("backdrop");
    }, x = (q) => {
      o.closeOnEscape && q.key === "Escape" && (q.preventDefault(), S("escape"));
    }, v = () => {
      o.disabled || c.value || (r.value = document.activeElement, c.value = !0, me(() => {
        p(), o.trapFocus && Z();
      }), a("open"), a("update:open", !0));
    }, S = (q = "programmatic") => {
      c.value && (c.value = !1, o.trapFocus && K(r.value), a("close", q), a("update:open", !1));
    }, V = () => {
      c.value ? S() : v();
    }, Z = () => {
      if (!i.value)
        return;
      const q = B(i.value);
      q.length > 0 ? q[0].focus() : i.value.focus();
    }, K = (q) => {
      q && typeof q.focus == "function" && q.focus();
    }, B = (q) => Array.from(
      q.querySelectorAll(
        'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(
      (F) => !F.hasAttribute("disabled") && !F.getAttribute("aria-hidden")
    ), P = (q) => {
      if (!c.value || !o.trapFocus || !i.value)
        return;
      const F = q.target;
      i.value.contains(F) || (q.preventDefault(), Z());
    };
    ne(
      () => o.open,
      (q) => {
        q !== c.value && (q ? v() : S());
      }
    ), ne(n, (q) => {
      q && p();
    }), xe(() => {
      document.addEventListener("keydown", x), o.trapFocus && document.addEventListener("focusin", P);
    }), K2(() => {
      document.removeEventListener("keydown", x), o.trapFocus && document.removeEventListener("focusin", P);
    });
    const D = u(() => [
      De(o.radius),
      !o.variant || o.variant === "shadow" ? o.shadow ? `cstu-shadow-${o.shadow}` : "cstu-shadow-md" : "",
      o.popoverClass
    ]), Y = u(() => {
      const q = [
        ...D.value.filter(Boolean)
      ];
      let F = !1;
      const _ = o.color;
      if (_ && ue(_) && o.variant === "color") {
        const X = ee(_, "filled", {
          disabled: o.disabled
        });
        typeof X == "string" && X.trim() && (q.push(...X.split(" ").filter(Boolean)), F = !0);
      }
      return F || (q.push("cstu-bg-white"), o.variant === "outline" && q.push("cstu-border", "cstu-border-gray-300"), q.push("cstu-text-gray-700")), q.filter(Boolean).map(
        (X) => typeof X == "string" ? X : Object.keys(X).filter((Ge) => X[Ge]).join(" ")
      ).join(" ");
    }), oe = u(() => {
      const q = {
        width: typeof o.width == "number" ? `${o.width}px` : o.width
      }, F = o.color;
      if (F && !ue(F) && o.variant === "color") {
        q.backgroundColor = F;
        const _ = G(F);
        q.color = _ > 128 ? "#000000" : "#FFFFFF";
      }
      return { ...y.value, ...q };
    });
    u(() => {
      const q = {
        backgroundColor: "white"
        // Default background
      }, F = o.color;
      return o.variant === "color" && F ? ue(F) ? (q.borderWidth = "1px", q.borderStyle = "solid", q.borderColor = `var(--${F}-500)`) : q.backgroundColor = F : o.variant === "outline" && (q.borderWidth = "1px", q.borderStyle = "solid", q.borderColor = "#e2e8f0"), q;
    });
    function G(q) {
      if (q.startsWith("#"))
        try {
          const F = parseInt(q.substring(1, 3), 16), _ = parseInt(q.substring(3, 5), 16), X = parseInt(q.substring(5, 7), 16);
          return (F * 299 + _ * 587 + X * 114) / 1e3;
        } catch {
          return 128;
        }
      else if (q.startsWith("rgb"))
        try {
          const F = q.match(/\d+/g);
          if (F && F.length >= 3) {
            const _ = parseInt(F[0], 10), X = parseInt(F[1], 10), Ge = parseInt(F[2], 10);
            return (_ * 299 + X * 587 + Ge * 114) / 1e3;
          }
        } catch {
          return 128;
        }
      return 128;
    }
    const le = u(() => {
      const q = o.color, F = !(q && ue(q)), _ = o.variant === "outline";
      return [
        "cstu-popover-header",
        {
          xs: "cstu-px-2 cstu-py-1.5",
          sm: "cstu-px-2.5 cstu-py-1.5",
          md: "cstu-px-3 cstu-py-2",
          // Default
          lg: "cstu-px-3.5 cstu-py-2.5",
          xl: "cstu-px-4 cstu-py-3"
        }[o.size || "md"],
        C2(o.size || "md"),
        "cstu-flex cstu-items-center cstu-justify-between",
        // Add border only for outline variant or default background
        _ || F ? "cstu-border-b cstu-border-gray-200 dark:cstu-border-gray-700" : "",
        o.headerClass
      ].filter(Boolean).join(" ");
    }), he = u(() => [
      "cstu-popover-body",
      {
        xs: "cstu-p-2",
        sm: "cstu-p-2.5",
        md: "cstu-p-3",
        // Default
        lg: "cstu-p-3.5",
        xl: "cstu-p-4"
      }[o.size || "md"],
      C2(o.size || "sm"),
      o.bodyClass
    ].filter(Boolean).join(" ")), de = u(() => {
      const q = o.color, F = !(q && ue(q)), _ = o.variant === "outline";
      return [
        "cstu-popover-footer",
        {
          xs: "cstu-px-2 cstu-py-1.5",
          sm: "cstu-px-2.5 cstu-py-1.5",
          md: "cstu-px-3 cstu-py-2",
          // Default
          lg: "cstu-px-3.5 cstu-py-2.5",
          xl: "cstu-px-4 cstu-py-3"
        }[o.size || "md"],
        // Add border only for outline variant or default background
        _ || F ? "cstu-border-t cstu-border-gray-200 dark:cstu-border-gray-700" : "",
        "cstu-flex cstu-justify-end cstu-space-x-2",
        o.footerClass
      ].filter(Boolean).join(" ");
    });
    return (q, F) => (k(), g(re, null, [
      f("div", {
        ref_key: "triggerRef",
        ref: n,
        class: I(["cstu-inline-block cstu-popover-trigger", { "cstu-cursor-not-allowed cstu-opacity-70": t.disabled }]),
        onClick: m,
        onMouseenter: C,
        onMouseleave: z
      }, [
        H(q.$slots, "trigger")
      ], 34),
      (k(), J($2, { to: "body" }, [
        E(se, {
          name: "fade",
          appear: ""
        }, {
          default: N(() => [
            c.value && t.backdrop !== !1 ? (k(), g("div", {
              key: 0,
              class: I(["cstu-popover-backdrop", {
                "cstu-bg-black/50": t.backdrop === !0,
                "cstu-bg-transparent": t.backdrop === "transparent"
              }]),
              style: W({ zIndex: t.zIndex - 10 }),
              onClick: b
            }, null, 6)) : L("", !0)
          ]),
          _: 1
        }),
        E(se, {
          "enter-active-class": "cstu-transition cstu-ease-out cstu-duration-100",
          "enter-from-class": "cstu-transform cstu-opacity-0 cstu-scale-95",
          "enter-to-class": "cstu-transform cstu-opacity-100 cstu-scale-100",
          "leave-active-class": "cstu-transition cstu-ease-in cstu-duration-75",
          "leave-from-class": "cstu-transform cstu-opacity-100 cstu-scale-100",
          "leave-to-class": "cstu-transform cstu-opacity-0 cstu-scale-95"
        }, {
          default: N(() => [
            c.value ? (k(), g("div", {
              key: 0,
              class: "cstu-popover-container",
              style: W({ zIndex: h.value })
            }, [
              F2((k(), g("div", {
                ref_key: "popoverRef",
                ref: i,
                id: o.id,
                class: I(l(Y)),
                style: W([l(y), l(oe)]),
                role: "dialog",
                "aria-labelledby": o.title ? `${o.id}-title` : void 0,
                "aria-modal": o.trapFocus,
                tabindex: "-1",
                onClick: w,
                onKeydown: sx(x, ["esc"])
              }, [
                f("div", QC, [
                  o.hideHeader ? L("", !0) : (k(), g("div", {
                    key: 0,
                    class: I(l(le))
                  }, [
                    H(q.$slots, "header", {}, () => [
                      f("h3", {
                        id: `${o.id}-title`,
                        class: I(["cstu-popover-title cstu-font-medium", l(C2)(o.size || "md")])
                      }, U(o.title), 11, YC),
                      o.showCloseIcon ? (k(), J(Me, {
                        key: 0,
                        icon: "X",
                        variant: "text",
                        size: "xs",
                        color: o.color && l(ue)(o.color) ? "white" : "gray",
                        class: "cstu-ml-auto",
                        "aria-label": "Close popover",
                        onClick: F[0] || (F[0] = Pe((_) => S("headerClose"), ["stop"]))
                      }, null, 8, ["color"])) : L("", !0)
                    ])
                  ], 2)),
                  f("div", {
                    class: I(l(he))
                  }, [
                    H(q.$slots, "default", {}, () => [
                      t.content ? (k(), g("div", {
                        key: 0,
                        class: I(l(C2)(o.size || "sm"))
                      }, U(t.content), 3)) : L("", !0)
                    ])
                  ], 2),
                  o.hideFooter ? L("", !0) : (k(), g("div", {
                    key: 1,
                    class: I(l(de))
                  }, [
                    H(q.$slots, "footer", {}, () => [
                      E(Me, {
                        size: "sm",
                        variant: "subtle",
                        onClick: F[1] || (F[1] = (_) => S("cancel"))
                      }, {
                        default: N(() => [
                          ae(" Close ")
                        ]),
                        _: 1
                      })
                    ])
                  ], 2))
                ])
              ], 46, JC)), [
                [l(Bx), A]
              ])
            ], 4)) : L("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
});
const LS = /* @__PURE__ */ O({
  __name: "Breadcrumbs",
  props: {
    separator: { default: "/" },
    separatorMargin: { default: "xs" },
    size: { default: "md" },
    radius: { default: "md" },
    color: { default: "primary" },
    highlightActive: { type: Boolean, default: !0 },
    class: null,
    separatorClass: null,
    activeClass: null
  },
  setup(t) {
    const a = t, o = tI(), c = u(() => !!o.default), n = u(() => o.default ? o.default() : []), i = (y) => y === n.value.length - 1, d = (y) => y ? ["primary", "secondary", "success", "warning", "danger", "info", "dark", "light"].includes(y) : !0, r = (y) => {
      if (!i(y) || !a.highlightActive)
        return "";
      if (d(a.color)) {
        const p = b2[a.color];
        if (p)
          return `cstu-text-${p.base}-${p.main}`;
      }
      return "";
    }, h = (y) => !i(y) || !a.highlightActive ? {} : d(a.color) ? {} : { color: a.color }, s = u(() => {
      const y = {
        xs: "text-xs",
        sm: "text-sm",
        md: "text-base",
        lg: "text-lg",
        xl: "text-xl"
      };
      return y[a.size] || y.md;
    }), M = u(() => {
      const y = {
        xs: "mx-1",
        sm: "mx-2",
        md: "mx-3",
        lg: "mx-4",
        xl: "mx-5"
      };
      return y[a.separatorMargin] || y.xs;
    });
    return (y, p) => (k(), g("div", {
      class: I(["cstu-breadcrumbs", a.class])
    }, [
      l(c) ? (k(!0), g(re, { key: 1 }, O2(l(n), (m, C) => (k(), g(re, { key: C }, [
        f("div", {
          class: I([
            "cstu-breadcrumb-item",
            l(s),
            i(C) ? "cstu-breadcrumb-active" : "cstu-breadcrumb-inactive",
            i(C) ? a.activeClass : "",
            i(C) && a.highlightActive ? r(C) : ""
          ]),
          style: W(h(C))
        }, [
          H(y.$slots, `item-${C}`, {
            isActive: i(C)
          }, () => [
            (k(), J(ve(m)))
          ])
        ], 6),
        i(C) ? L("", !0) : (k(), g("div", {
          key: 0,
          class: I([
            "cstu-breadcrumb-separator",
            l(M),
            a.separatorClass
          ])
        }, [
          H(y.$slots, "separator", {}, () => [
            typeof a.separator == "string" ? (k(), g(re, { key: 0 }, [
              ae(U(a.separator), 1)
            ], 64)) : a.separator ? (k(), J(ve(a.separator), { key: 1 })) : L("", !0)
          ])
        ], 2))
      ], 64))), 128)) : H(y.$slots, "default", { key: 0 })
    ], 2));
  }
});
const _C = {
  key: 0,
  class: "cstu-flex cstu-justify-between cstu-items-center cstu-mb-1"
}, eL = ["for"], tL = {
  key: 0,
  class: "cstu-text-red-500 cstu-ml-1"
}, aL = {
  key: 0,
  class: "cstu-flex cstu-items-center cstu-justify-center cstu-w-[15px] cstu-h-[15px] cstu-mt-1"
}, oL = ["id", "value", "placeholder", "disabled", "required", "readonly", "rows", "maxlength"], cL = {
  key: 1,
  class: "cstu-flex cstu-items-center cstu-justify-center cstu-w-[15px] cstu-h-[15px] cstu-mt-1"
}, bS = /* @__PURE__ */ O({
  __name: "Textarea",
  props: {
    id: null,
    modelValue: null,
    placeholder: null,
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    label: null,
    labelProps: null,
    description: null,
    descriptionProps: null,
    error: null,
    errorProps: null,
    hasError: { type: Boolean },
    showBothErrorAndDescription: { type: Boolean },
    textareaProps: null,
    size: null,
    radius: null,
    variant: null,
    required: { type: Boolean },
    withAsterisk: { type: Boolean },
    rows: null,
    resize: null,
    fullWidth: { type: Boolean },
    color: null,
    class: null,
    inputClass: null,
    maxLength: null
  },
  emits: ["update:modelValue", "focus", "blur", "change"],
  setup(t, { expose: a, emit: o }) {
    const {
      id: c,
      modelValue: n,
      placeholder: i,
      label: d,
      description: r,
      error: h,
      hasError: s = !1,
      disabled: M = !1,
      readonly: y = !1,
      required: p = !1,
      withAsterisk: m = !1,
      showBothErrorAndDescription: C = !1,
      textareaProps: z,
      labelProps: w,
      descriptionProps: A,
      errorProps: b,
      size: x = "md",
      variant: v = "default",
      radius: S = "md",
      color: V = "primary",
      class: Z,
      fullWidth: K = !1,
      inputClass: B = "",
      rows: P = 3,
      resize: D = "none",
      maxLength: Y = void 0
    } = t, oe = `textarea-${Math.random().toString(36).substring(2, 11)}`, G = j(null), le = {
      xs: {
        inputClass: `cstu-min-h-8 ${K ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-xs cstu-font-medium",
        descriptionSize: "cstu-text-xs"
      },
      sm: {
        inputClass: `cstu-min-h-9 ${K ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-sm cstu-font-medium",
        descriptionSize: "cstu-text-xs"
      },
      md: {
        inputClass: `cstu-min-h-10 ${K ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-sm cstu-font-medium",
        descriptionSize: "cstu-text-sm"
      },
      lg: {
        inputClass: `cstu-min-h-11 ${K ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-sm cstu-font-medium",
        descriptionSize: "cstu-text-sm"
      },
      xl: {
        inputClass: `cstu-min-h-12 ${K ? "cstu-w-full" : "cstu-max-w-[20.5rem]"}`,
        labelSize: "cstu-text-base cstu-font-medium",
        descriptionSize: "cstu-text-sm"
      }
    }, he = u(() => `${le[x].inputClass.split(" ")[0]} cstu-transition-all cstu-duration-300`), de = u(() => le[x].labelSize), q = u(() => le[x].descriptionSize), F = u(() => {
      switch (x) {
        case "xs":
          return "cstu-text-xs";
        case "sm":
          return "cstu-text-sm";
        case "md":
          return "cstu-text-sm";
        case "lg":
          return "cstu-text-base";
        case "xl":
          return "cstu-text-base";
        default:
          return "cstu-text-sm";
      }
    }), _ = u(() => De(S)), X = u(() => h !== void 0 && h !== "" || s), Ge = u(() => v === "unstyled" || !ue(V) && !X.value ? "" : X.value ? "cstu-border-red-500 hover:cstu-border-red-500 focus-within:cstu-border-red-500 focus-within:cstu-ring-1 focus-within:cstu-ring-red-500" : v === "default" || v === "outline" ? `cstu-border-${V}-500 hover:cstu-border-${V}-600 focus-within:cstu-border-${V}-500 focus-within:cstu-ring-1 focus-within:cstu-ring-${V}-500` : v === "filled" ? `cstu-bg-${V}-50 hover:cstu-bg-${V}-100` : v === "light" ? `cstu-bg-${V}-50 cstu-text-${V}-500 hover:cstu-bg-${V}-100` : v === "subtle" ? `cstu-text-${V}-500 hover:cstu-bg-${V}-50` : ""), wv = u(() => v === "unstyled" ? {} : ue(V) || X.value ? {} : v === "default" || v === "outline" ? {
      "--border-color": V,
      "border-color": "var(--border-color)"
    } : v === "filled" ? {
      "--bg-color": `${V}10`,
      "background-color": "var(--bg-color)"
    } : v === "light" ? {
      "--bg-color": `${V}10`,
      "--text-color": V,
      "background-color": "var(--bg-color)",
      color: "var(--text-color)"
    } : v === "subtle" ? {
      "--text-color": V,
      color: "var(--text-color)"
    } : {}), R = u(() => {
      const $ = {
        default: "cstu-bg-white cstu-border cstu-transition-colors cstu-duration-150 cstu-px-3",
        filled: "cstu-bg-gray-100 cstu-border cstu-border-transparent cstu-transition-colors cstu-duration-150 cstu-px-3",
        light: "cstu-border cstu-transition-colors cstu-duration-150 cstu-px-3",
        outline: "cstu-bg-white cstu-border cstu-transition-colors cstu-duration-150 cstu-px-3",
        subtle: "cstu-bg-transparent cstu-transition-colors cstu-duration-150 cstu-px-3",
        unstyled: "cstu-bg-transparent !cstu-border-0"
      };
      if (v === "unstyled")
        return [$[v]];
      const be = X.value ? "" : v === "default" || v === "outline" ? "cstu-border-gray-300/45" : "", A2 = X.value ? "cstu-border-red-500" : "";
      return [
        $[v],
        be,
        A2,
        // Hover classes - only apply on hover
        X.value ? "hover:cstu-border-red-500" : "hover:cstu-border-blue-450",
        // Focus classes - only apply when focused via focus-within
        X.value ? "focus-within:cstu-border-red-500 focus-within:cstu-ring-1 focus-within:cstu-ring-red-500" : "focus-within:cstu-border-blue-450 focus-within:cstu-ring-1 focus-within:cstu-ring-blue-450"
      ];
    }), pe = j(!1), Re = ($) => {
      pe.value = !0, o("focus", $);
    }, Xx = ($) => {
      pe.value = !1, o("blur", $);
    }, Kx = ($) => {
      o("change", $);
    };
    return a({
      // Expose the textarea element itself
      textarea: G,
      // Expose common textarea methods
      focus: () => {
        var $;
        return ($ = G.value) == null ? void 0 : $.focus();
      },
      blur: () => {
        var $;
        return ($ = G.value) == null ? void 0 : $.blur();
      },
      select: () => {
        var $;
        return ($ = G.value) == null ? void 0 : $.select();
      },
      setSelectionRange: ($, be) => {
        var A2;
        return (A2 = G.value) == null ? void 0 : A2.setSelectionRange($, be);
      },
      setRangeText: ($) => {
        var be;
        return (be = G.value) == null ? void 0 : be.setRangeText($);
      },
      // Expose common properties
      get value() {
        var $;
        return ($ = G.value) == null ? void 0 : $.value;
      },
      set value($) {
        G.value && $ !== void 0 && (G.value.value = $);
      }
    }), ($, be) => (k(), g("div", {
      class: I(["cstu-flex cstu-flex-col cstu-transition-all cstu-duration-300", [$.customClass, t.fullWidth ? "cstu-w-full" : "cstu-max-w-[20.5rem]"]])
    }, [
      t.label || $.$slots.label ? (k(), g("div", _C, [
        f("label", ce({
          for: t.id || oe,
          class: [
            "cstu-flex cstu-items-center",
            l(de)
          ]
        }, t.labelProps), [
          H($.$slots, "label", {}, () => [
            ae(U(t.label) + " ", 1),
            t.withAsterisk || t.required ? (k(), g("span", tL, "*")) : L("", !0)
          ])
        ], 16, eL),
        H($.$slots, "labelIcon")
      ])) : L("", !0),
      f("div", null, [
        f("div", {
          class: I([
            "cstu-flex cstu-items-start cstu-gap-2 cstu-py-2",
            l(he),
            l(_),
            l(R),
            l(Ge),
            {
              "cstu-opacity-50 cstu-pointer-events-none cstu-cursor-not-allowed": t.disabled
            }
          ]),
          style: W(l(wv))
        }, [
          $.$slots.leftSection ? (k(), g("div", aL, [
            H($.$slots, "leftSection")
          ])) : L("", !0),
          f("textarea", ce({
            ref_key: "textareaRef",
            ref: G,
            id: t.id || oe,
            value: t.modelValue,
            placeholder: t.placeholder,
            disabled: t.disabled,
            required: t.required,
            readonly: t.readonly,
            rows: t.rows,
            maxlength: t.maxLength,
            class: [
              "cstu-flex-1 cstu-bg-transparent cstu-outline-none cstu-w-full",
              l(F),
              t.inputClass,
              {
                "cstu-text-gray-500": t.modelValue,
                "cstu-text-red-500": l(X) && !t.modelValue
              }
            ],
            style: {
              resize: t.resize
            },
            onInput: be[0] || (be[0] = (A2) => $.$emit("update:modelValue", A2.target.value)),
            onFocus: Re,
            onBlur: Xx,
            onChange: Kx
          }, t.textareaProps), null, 16, oL),
          $.$slots.rightSection ? (k(), g("div", cL, [
            H($.$slots, "rightSection")
          ])) : L("", !0)
        ], 6)
      ]),
      t.description && !l(X) || $.$slots.description && !l(X) || t.showBothErrorAndDescription && t.description || t.showBothErrorAndDescription && $.$slots.description ? (k(), g("div", ce({
        key: 1,
        class: "cstu-mt-1"
      }, t.descriptionProps), [
        f("p", {
          class: I(["cstu-text-gray-500", l(q)])
        }, [
          H($.$slots, "description", {}, () => [
            ae(U(t.description), 1)
          ])
        ], 2)
      ], 16)) : L("", !0),
      l(X) && t.error || l(X) && $.$slots.error || t.showBothErrorAndDescription && t.error || t.showBothErrorAndDescription && $.$slots.error ? (k(), g("div", ce({
        key: 2,
        class: "cstu-mt-1"
      }, t.errorProps), [
        f("p", {
          class: I(["cstu-text-red-500", l(q)])
        }, [
          H($.$slots, "error", {}, () => [
            ae(U(t.error), 1)
          ])
        ], 2)
      ], 16)) : L("", !0)
    ], 2));
  }
});
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nL = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var eo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vx = ({ size: t, strokeWidth: a = 2, absoluteStrokeWidth: o, color: c, iconNode: n, name: i, class: d, ...r }, { slots: h }) => Ue(
  "svg",
  {
    ...eo,
    width: t || eo.width,
    height: t || eo.height,
    stroke: c || eo.stroke,
    "stroke-width": o ? Number(a) * 24 / Number(t) : a,
    class: ["lucide", `lucide-${nL(i ?? "icon")}`],
    ...r
  },
  [...n.map((s) => Ue(...s)), ...h.default ? [h.default()] : []]
);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e = (t, a) => (o, { slots: c }) => Ue(
  Vx,
  {
    ...o,
    iconNode: a,
    name: t
  },
  c
);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ao = e("AArrowDownIcon", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oo = e("AArrowUpIcon", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const co = e("ALargeSmallIcon", [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const no = e("AccessibilityIcon", [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const io = e("ActivityIcon", [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ro = e("AirVentIcon", [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const so = e("AirplayIcon", [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xe = e("AlarmClockCheckIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ke = e("AlarmClockMinusIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lo = e("AlarmClockOffIcon", [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Je = e("AlarmClockPlusIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ho = e("AlarmClockIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yo = e("AlarmSmokeIcon", [
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8", key: "1bvca4" }],
  [
    "path",
    { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z", key: "x3qr1j" }
  ],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uo = e("AlbumIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const po = e("AlignCenterHorizontalIcon", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ko = e("AlignCenterVerticalIcon", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mo = e("AlignCenterIcon", [
  ["path", { d: "M17 12H7", key: "16if0g" }],
  ["path", { d: "M19 18H5", key: "18s9l3" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fo = e("AlignEndHorizontalIcon", [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const go = e("AlignEndVerticalIcon", [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mo = e("AlignHorizontalDistributeCenterIcon", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vo = e("AlignHorizontalDistributeEndIcon", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xo = e("AlignHorizontalDistributeStartIcon", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Io = e("AlignHorizontalJustifyCenterIcon", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wo = e("AlignHorizontalJustifyEndIcon", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Co = e("AlignHorizontalJustifyStartIcon", [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lo = e("AlignHorizontalSpaceAroundIcon", [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bo = e("AlignHorizontalSpaceBetweenIcon", [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const So = e("AlignJustifyIcon", [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qo = e("AlignLeftIcon", [
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 18H3", key: "1amg6g" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zo = e("AlignRightIcon", [
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M21 18H7", key: "1ygte8" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ao = e("AlignStartHorizontalIcon", [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ho = e("AlignStartVerticalIcon", [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Po = e("AlignVerticalDistributeCenterIcon", [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bo = e("AlignVerticalDistributeEndIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vo = e("AlignVerticalDistributeStartIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fo = e("AlignVerticalJustifyCenterIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jo = e("AlignVerticalJustifyEndIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Do = e("AlignVerticalJustifyStartIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const To = e("AlignVerticalSpaceAroundIcon", [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ro = e("AlignVerticalSpaceBetweenIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oo = e("AmbulanceIcon", [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $o = e("AmpersandIcon", [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eo = e("AmpersandsIcon", [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uo = e("AmphoraIcon", [
  [
    "path",
    { d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8", key: "1h8rid" }
  ],
  ["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68", key: "3ezsi6" }],
  ["path", { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8", key: "yt6q09" }],
  ["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68", key: "8f95yk" }],
  ["path", { d: "M18 22H6", key: "mg6kv4" }],
  ["path", { d: "M9 2h6", key: "1jrp98" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zo = e("AnchorIcon", [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const No = e("AngryIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wo = e("AnnoyedIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Go = e("AntennaIcon", [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xo = e("AnvilIcon", [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ko = e("ApertureIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jo = e("AppWindowMacIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qo = e("AppWindowIcon", [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yo = e("AppleIcon", [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _o = e("ArchiveRestoreIcon", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ec = e("ArchiveXIcon", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tc = e("ArchiveIcon", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ac = e("ArmchairIcon", [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "1qyhux"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oc = e("ArrowBigDownDashIcon", [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cc = e("ArrowBigDownIcon", [
  ["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nc = e("ArrowBigLeftDashIcon", [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ic = e("ArrowBigLeftIcon", [
  ["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rc = e("ArrowBigRightDashIcon", [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dc = e("ArrowBigRightIcon", [
  ["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sc = e("ArrowBigUpDashIcon", [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lc = e("ArrowBigUpIcon", [
  ["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hc = e("ArrowDown01Icon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yc = e("ArrowDown10Icon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qe = e("ArrowDownAZIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uc = e("ArrowDownFromLineIcon", [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pc = e("ArrowDownLeftIcon", [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kc = e("ArrowDownNarrowWideIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mc = e("ArrowDownRightIcon", [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fc = e("ArrowDownToDotIcon", [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gc = e("ArrowDownToLineIcon", [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mc = e("ArrowDownUpIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ye = e("ArrowDownWideNarrowIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _e = e("ArrowDownZAIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vc = e("ArrowDownIcon", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xc = e("ArrowLeftFromLineIcon", [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ic = e("ArrowLeftRightIcon", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wc = e("ArrowLeftToLineIcon", [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cc = e("ArrowLeftIcon", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lc = e("ArrowRightFromLineIcon", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bc = e("ArrowRightLeftIcon", [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sc = e("ArrowRightToLineIcon", [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qc = e("ArrowRightIcon", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zc = e("ArrowUp01Icon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ac = e("ArrowUp10Icon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e1 = e("ArrowUpAZIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hc = e("ArrowUpDownIcon", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pc = e("ArrowUpFromDotIcon", [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bc = e("ArrowUpFromLineIcon", [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vc = e("ArrowUpLeftIcon", [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t1 = e("ArrowUpNarrowWideIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fc = e("ArrowUpRightIcon", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jc = e("ArrowUpToLineIcon", [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dc = e("ArrowUpWideNarrowIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a1 = e("ArrowUpZAIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tc = e("ArrowUpIcon", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rc = e("ArrowsUpFromLineIcon", [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oc = e("AsteriskIcon", [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $c = e("AtSignIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ec = e("AtomIcon", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uc = e("AudioLinesIcon", [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zc = e("AudioWaveformIcon", [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nc = e("AwardIcon", [
  [
    "path",
    {
      d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      key: "1yiouv"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wc = e("AxeIcon", [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o1 = e("Axis3dIcon", [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gc = e("BabyIcon", [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xc = e("BackpackIcon", [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "1ol0lm" }
  ],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }],
  ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6", key: "1fr6do" }],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kc = e("BadgeAlertIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jc = e("BadgeCentIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c1 = e("BadgeCheckIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qc = e("BadgeDollarSignIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yc = e("BadgeEuroIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _c = e("BadgeHelpIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const en = e("BadgeIndianRupeeIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tn = e("BadgeInfoIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const an = e("BadgeJapaneseYenIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const on = e("BadgeMinusIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cn = e("BadgePercentIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nn = e("BadgePlusIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rn = e("BadgePoundSterlingIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dn = e("BadgeRussianRubleIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sn = e("BadgeSwissFrancIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ln = e("BadgeXIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hn = e("BadgeIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yn = e("BaggageClaimIcon", [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const un = e("BanIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pn = e("BananaIcon", [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kn = e("BandageIcon", [
  ["path", { d: "M10 10.01h.01", key: "1e9xi7" }],
  ["path", { d: "M10 14.01h.01", key: "ac23bv" }],
  ["path", { d: "M14 10.01h.01", key: "2wfrvf" }],
  ["path", { d: "M14 14.01h.01", key: "8tw8yn" }],
  ["path", { d: "M18 6v11.5", key: "dkbidh" }],
  ["path", { d: "M6 6v12", key: "vkc79e" }],
  ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2", key: "1wpnh2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mn = e("BanknoteIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fn = e("BarcodeIcon", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gn = e("BaselineIcon", [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mn = e("BathIcon", [
  ["path", { d: "M10 4 8 6", key: "1rru8s" }],
  ["path", { d: "M17 19v2", key: "ts1sot" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M7 19v2", key: "12npes" }],
  [
    "path",
    {
      d: "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "14ym8i"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vn = e("BatteryChargingIcon", [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xn = e("BatteryFullIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const In = e("BatteryLowIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wn = e("BatteryMediumIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cn = e("BatteryWarningIcon", [
  ["path", { d: "M10 17h.01", key: "nbq80n" }],
  ["path", { d: "M10 7v6", key: "nne03l" }],
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1x5o8m" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "1mdjgh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ln = e("BatteryIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bn = e("BeakerIcon", [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sn = e("BeanOffIcon", [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qn = e("BeanIcon", [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zn = e("BedDoubleIcon", [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const An = e("BedSingleIcon", [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hn = e("BedIcon", [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pn = e("BeefIcon", [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bn = e("BeerOffIcon", [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vn = e("BeerIcon", [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fn = e("BellDotIcon", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665",
      key: "1tip0g"
    }
  ],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jn = e("BellElectricIcon", [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dn = e("BellMinusIcon", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  [
    "path",
    {
      d: "M16.243 3.757A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673A9.4 9.4 0 0 1 18.667 12",
      key: "bdwj86"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tn = e("BellOffIcon", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
      key: "178tsu"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rn = e("BellPlusIcon", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }],
  [
    "path",
    {
      d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
      key: "1abcvy"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const On = e("BellRingIcon", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $n = e("BellIcon", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n1 = e("BetweenHorizontalEndIcon", [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i1 = e("BetweenHorizontalStartIcon", [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const En = e("BetweenVerticalEndIcon", [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Un = e("BetweenVerticalStartIcon", [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zn = e("BicepsFlexedIcon", [
  [
    "path",
    {
      d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
      key: "1pmlyh"
    }
  ],
  ["path", { d: "M15 14a5 5 0 0 0-7.584 2", key: "5rb254" }],
  ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15", key: "kbvsx9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nn = e("BikeIcon", [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wn = e("BinaryIcon", [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gn = e("BinocularsIcon", [
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3", key: "3apit1" }],
  [
    "path",
    {
      d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
      key: "rhpgnw"
    }
  ],
  ["path", { d: "M 22 16 L 2 16", key: "14lkq7" }],
  [
    "path",
    {
      d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
      key: "104b3k"
    }
  ],
  ["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3", key: "14fczp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xn = e("BiohazardIcon", [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kn = e("BirdIcon", [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jn = e("BitcoinIcon", [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qn = e("BlendIcon", [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yn = e("BlindsIcon", [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _n = e("BlocksIcon", [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e0 = e("BluetoothConnectedIcon", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t0 = e("BluetoothOffIcon", [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a0 = e("BluetoothSearchingIcon", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o0 = e("BluetoothIcon", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c0 = e("BoldIcon", [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n0 = e("BoltIcon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i0 = e("BombIcon", [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r0 = e("BoneIcon", [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d0 = e("BookAIcon", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s0 = e("BookAudioIcon", [
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 8v3", key: "1qzp49" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l0 = e("BookCheckIcon", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h0 = e("BookCopyIcon", [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  [
    "path",
    {
      d: "M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12",
      key: "1wz07i"
    }
  ],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r1 = e("BookDashedIcon", [
  ["path", { d: "M12 17h1.5", key: "1gkc67" }],
  ["path", { d: "M12 22h1.5", key: "1my7sn" }],
  ["path", { d: "M12 2h1.5", key: "19tvb7" }],
  ["path", { d: "M17.5 22H19a1 1 0 0 0 1-1", key: "10akbh" }],
  ["path", { d: "M17.5 2H19a1 1 0 0 1 1 1v1.5", key: "1vrfjs" }],
  ["path", { d: "M20 14v3h-2.5", key: "1naeju" }],
  ["path", { d: "M20 8.5V10", key: "1ctpfu" }],
  ["path", { d: "M4 10V8.5", key: "1o3zg5" }],
  ["path", { d: "M4 19.5V14", key: "ob81pf" }],
  ["path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2H8", key: "s8vcyb" }],
  ["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8", key: "1cu73q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y0 = e("BookDownIcon", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u0 = e("BookHeadphonesIcon", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p0 = e("BookHeartIcon", [
  [
    "path",
    {
      d: "M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7",
      key: "1t75a8"
    }
  ],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k0 = e("BookImageIcon", [
  ["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17", key: "q6ojf0" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M0 = e("BookKeyIcon", [
  ["path", { d: "m19 3 1 1", key: "ze14oc" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "M20 8v13a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1ocbpn" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f0 = e("BookLockIcon", [
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }],
  ["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1rkj32" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1", key: "73l30o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g0 = e("BookMarkedIcon", [
  ["path", { d: "M10 2v8l3-3 3 3V2", key: "sqw3rj" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m0 = e("BookMinusIcon", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v0 = e("BookOpenCheckIcon", [
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
      key: "8arnkb"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x0 = e("BookOpenTextIcon", [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M6 8h2", key: "30oboj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I0 = e("BookOpenIcon", [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w0 = e("BookPlusIcon", [
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C0 = e("BookTextIcon", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L0 = e("BookTypeIcon", [
  ["path", { d: "M10 13h4", key: "ytezjc" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b0 = e("BookUp2Icon", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "161d7n" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S0 = e("BookUpIcon", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q0 = e("BookUserIcon", [
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z0 = e("BookXIcon", [
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A0 = e("BookIcon", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H0 = e("BookmarkCheckIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P0 = e("BookmarkMinusIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B0 = e("BookmarkPlusIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V0 = e("BookmarkXIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F0 = e("BookmarkIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j0 = e("BoomBoxIcon", [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D0 = e("BotMessageSquareIcon", [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T0 = e("BotOffIcon", [
  ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33", key: "7az073" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586", key: "s09a7a" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ["path", { d: "M9.67 4H12v2.33", key: "110xot" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R0 = e("BotIcon", [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O0 = e("BoxIcon", [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $0 = e("BoxesIcon", [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d1 = e("BracesIcon", [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E0 = e("BracketsIcon", [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U0 = e("BrainCircuitIcon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z0 = e("BrainCogIcon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N0 = e("BrainIcon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W0 = e("BrickWallIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G0 = e("BriefcaseBusinessIcon", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X0 = e("BriefcaseConveyorBeltIcon", [
  ["path", { d: "M10 20v2", key: "1n8e1g" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M18 20v2", key: "10uadw" }],
  ["path", { d: "M21 20H3", key: "kdqkdp" }],
  ["path", { d: "M6 20v2", key: "a9bc87" }],
  ["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12", key: "17n9tx" }],
  ["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2", key: "1097i5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K0 = e("BriefcaseMedicalIcon", [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J0 = e("BriefcaseIcon", [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q0 = e("BringToFrontIcon", [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y0 = e("BrushIcon", [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _0 = e("BugOffIcon", [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ei = e("BugPlayIcon", [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ti = e("BugIcon", [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ai = e("Building2Icon", [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oi = e("BuildingIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ci = e("BusFrontIcon", [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ni = e("BusIcon", [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ii = e("CableCarIcon", [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ri = e("CableIcon", [
  [
    "path",
    {
      d: "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1",
      key: "10bnsj"
    }
  ],
  ["path", { d: "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9", key: "1eqmu1" }],
  ["path", { d: "M21 21v-2h-4", key: "14zm7j" }],
  ["path", { d: "M3 5h4V3", key: "z442eg" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3", key: "ebdjd7" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const di = e("CakeSliceIcon", [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const si = e("CakeIcon", [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const li = e("CalculatorIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hi = e("Calendar1Icon", [
  ["path", { d: "M11 14h1v4", key: "fy54vd" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yi = e("CalendarArrowDownIcon", [
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 14v8", key: "irew45" }],
  [
    "path",
    { d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343", key: "bse4f3" }
  ],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ui = e("CalendarArrowUpIcon", [
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }],
  ["path", { d: "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9", key: "1exg90" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pi = e("CalendarCheck2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ki = e("CalendarCheckIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mi = e("CalendarClockIcon", [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fi = e("CalendarCogIcon", [
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "11kmuh" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gi = e("CalendarDaysIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mi = e("CalendarFoldIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vi = e("CalendarHeartIcon", [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xi = e("CalendarMinus2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ii = e("CalendarMinusIcon", [
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5", key: "1scpom" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wi = e("CalendarOffIcon", [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ci = e("CalendarPlus2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Li = e("CalendarPlusIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bi = e("CalendarRangeIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Si = e("CalendarSearchIcon", [
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25", key: "1jrsq6" }],
  ["path", { d: "m22 22-1.875-1.875", key: "13zax7" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qi = e("CalendarSyncIcon", [
  ["path", { d: "M11 10v4h4", key: "172dkj" }],
  ["path", { d: "m11 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "vu0qm5" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m21 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "1qgeyt" }],
  ["path", { d: "M21 22v-4h-4", key: "hrummi" }],
  ["path", { d: "M21 8.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3", key: "mctw84" }],
  ["path", { d: "M3 10h4", key: "1el30a" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zi = e("CalendarX2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ai = e("CalendarXIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hi = e("CalendarIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pi = e("CameraOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bi = e("CameraIcon", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vi = e("CandyCaneIcon", [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fi = e("CandyOffIcon", [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    { d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657", key: "1sbrv4" }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ji = e("CandyIcon", [
  ["path", { d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z", key: "ue6khb" }],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    { d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1", key: "b9cp6k" }
  ],
  [
    "path",
    { d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1", key: "5lney8" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Di = e("CannabisIcon", [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ti = e("CaptionsOffIcon", [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s1 = e("CaptionsIcon", [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ri = e("CarFrontIcon", [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oi = e("CarTaxiFrontIcon", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $i = e("CarIcon", [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ei = e("CaravanIcon", [
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2", key: "13hakp" }],
  ["path", { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9", key: "1crci8" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ui = e("CarrotIcon", [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zi = e("CaseLowerIcon", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ni = e("CaseSensitiveIcon", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wi = e("CaseUpperIcon", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gi = e("CassetteTapeIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xi = e("CastIcon", [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ki = e("CastleIcon", [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4", key: "1k4jtn" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ji = e("CatIcon", [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qi = e("CctvIcon", [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l1 = e("ChartAreaIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  [
    "path",
    {
      d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
      key: "q0gr47"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h1 = e("ChartBarBigIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yi = e("ChartBarDecreasingIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h3", key: "ur6vzw" }],
  ["path", { d: "M7 6h12", key: "sz5b0d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _i = e("ChartBarIncreasingIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h12", key: "wsnu98" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const er = e("ChartBarStackedIcon", [
  ["path", { d: "M11 13v4", key: "vyy2rb" }],
  ["path", { d: "M15 5v4", key: "1gx88a" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y1 = e("ChartBarIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u1 = e("ChartCandlestickIcon", [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p1 = e("ChartColumnBigIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tr = e("ChartColumnDecreasingIcon", [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17v-3", key: "1sqioe" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17V5", key: "1wzmnc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k1 = e("ChartColumnIncreasingIcon", [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ar = e("ChartColumnStackedIcon", [
  ["path", { d: "M11 13H7", key: "t0o9gq" }],
  ["path", { d: "M19 9h-4", key: "rera1j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M1 = e("ChartColumnIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const or = e("ChartGanttIcon", [
  ["path", { d: "M10 6h8", key: "zvc2xc" }],
  ["path", { d: "M12 16h6", key: "yi5mkt" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 11h7", key: "wz2hg0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f1 = e("ChartLineIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cr = e("ChartNetworkIcon", [
  ["path", { d: "m13.11 7.664 1.78 2.672", key: "go2gg9" }],
  ["path", { d: "m14.162 12.788-3.324 1.424", key: "11x848" }],
  ["path", { d: "m20 4-6.06 1.515", key: "1wxxh7" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["circle", { cx: "12", cy: "6", r: "2", key: "1jj5th" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }],
  ["circle", { cx: "9", cy: "15", r: "2", key: "lf2ghp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nr = e("ChartNoAxesColumnDecreasingIcon", [
  ["path", { d: "M12 20V10", key: "g8npz5" }],
  ["path", { d: "M18 20v-4", key: "8uic4z" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g1 = e("ChartNoAxesColumnIncreasingIcon", [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m1 = e("ChartNoAxesColumnIcon", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ir = e("ChartNoAxesCombinedIcon", [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v1 = e("ChartNoAxesGanttIcon", [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x1 = e("ChartPieIcon", [
  [
    "path",
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
      key: "pzmjnu"
    }
  ],
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I1 = e("ChartScatterIcon", [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rr = e("ChartSplineIcon", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7", key: "lw07rv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dr = e("CheckCheckIcon", [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sr = e("CheckIcon", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lr = e("ChefHatIcon", [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hr = e("CherryIcon", [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N2 = e("ChevronDownIcon", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yr = e("ChevronFirstIcon", [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ur = e("ChevronLastIcon", [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pr = e("ChevronLeftIcon", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kr = e("ChevronRightIcon", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mr = e("ChevronUpIcon", [
  ["path", { d: "m18 15-6-6-6 6", key: "153udz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fr = e("ChevronsDownUpIcon", [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gr = e("ChevronsDownIcon", [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mr = e("ChevronsLeftRightEllipsisIcon", [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = e("ChevronsLeftRightIcon", [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xr = e("ChevronsLeftIcon", [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ir = e("ChevronsRightLeftIcon", [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wr = e("ChevronsRightIcon", [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cr = e("ChevronsUpDownIcon", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lr = e("ChevronsUpIcon", [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const br = e("ChromeIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = e("ChurchIcon", [
  ["path", { d: "M10 9h4", key: "u4k05v" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-4 0v4", key: "1pdhuj" }],
  [
    "path",
    {
      d: "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22",
      key: "1rkokr"
    }
  ],
  [
    "path",
    {
      d: "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7",
      key: "1w6esw"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qr = e("CigaretteOffIcon", [
  ["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13", key: "1gdiyg" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866", key: "166zjj" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = e("CigaretteIcon", [
  ["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14", key: "1mb5g1" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1", key: "1yl5r7" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w1 = e("CircleAlertIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C1 = e("CircleArrowDownIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L1 = e("CircleArrowLeftIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b1 = e("CircleArrowOutDownLeftIcon", [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S1 = e("CircleArrowOutDownRightIcon", [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q1 = e("CircleArrowOutUpLeftIcon", [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z1 = e("CircleArrowOutUpRightIcon", [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A1 = e("CircleArrowRightIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H1 = e("CircleArrowUpIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P1 = e("CircleCheckBigIcon", [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B1 = e("CircleCheckIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V1 = e("CircleChevronDownIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F1 = e("CircleChevronLeftIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j1 = e("CircleChevronRightIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D1 = e("CircleChevronUpIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ar = e("CircleDashedIcon", [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T1 = e("CircleDivideIcon", [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hr = e("CircleDollarSignIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pr = e("CircleDotDashedIcon", [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Br = e("CircleDotIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vr = e("CircleEllipsisIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fr = e("CircleEqualIcon", [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jr = e("CircleFadingArrowUpIcon", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dr = e("CircleFadingPlusIcon", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R1 = e("CircleGaugeIcon", [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O1 = e("CircleHelpIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $1 = e("CircleMinusIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tr = e("CircleOffIcon", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E1 = e("CircleParkingOffIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U1 = e("CircleParkingIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z1 = e("CirclePauseIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N1 = e("CirclePercentIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W1 = e("CirclePlayIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G1 = e("CirclePlusIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X1 = e("CirclePowerIcon", [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K1 = e("CircleSlash2Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rr = e("CircleSlashIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J1 = e("CircleStopIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q1 = e("CircleUserRoundIcon", [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y1 = e("CircleUserIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _1 = e("CircleXIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Or = e("CircleIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $r = e("CircuitBoardIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Er = e("CitrusIcon", [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ur = e("ClapperboardIcon", [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zr = e("ClipboardCheckIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nr = e("ClipboardCopyIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wr = e("ClipboardListIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gr = e("ClipboardMinusIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xr = e("ClipboardPasteIcon", [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const et = e("ClipboardPenLineIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tt = e("ClipboardPenIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kr = e("ClipboardPlusIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jr = e("ClipboardTypeIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qr = e("ClipboardXIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yr = e("ClipboardIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _r = e("Clock1Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ed = e("Clock10Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const td = e("Clock11Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ad = e("Clock12Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const od = e("Clock2Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cd = e("Clock3Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nd = e("Clock4Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const id = e("Clock5Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rd = e("Clock6Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dd = e("Clock7Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sd = e("Clock8Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ld = e("Clock9Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hd = e("ClockAlertIcon", [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516", key: "cxo92l" }],
  ["path", { d: "M20 11.5v6", key: "2ei3xq" }],
  ["path", { d: "M20 21.5h.01", key: "1r2dzp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yd = e("ClockArrowDownIcon", [
  ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227", key: "1i7shu" }],
  ["path", { d: "M12 6v6l2 1", key: "19cm8n" }],
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M18 14v8", key: "irew45" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ud = e("ClockArrowUpIcon", [
  ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338", key: "1fzlyi" }],
  ["path", { d: "M12 6v6l1.562.781", key: "1ujuk9" }],
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pd = e("ClockIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kd = e("CloudAlertIcon", [
  ["path", { d: "M12 12v4", key: "tww15h" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708", key: "xsb5ju" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Md = e("CloudCogIcon", [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const at = e("CloudDownloadIcon", [
  ["path", { d: "M12 13v8l-4-4", key: "1f5nwf" }],
  ["path", { d: "m12 21 4-4", key: "1lfcce" }],
  ["path", { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284", key: "ui1hmy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fd = e("CloudDrizzleIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gd = e("CloudFogIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const md = e("CloudHailIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vd = e("CloudLightningIcon", [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xd = e("CloudMoonRainIcon", [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Id = e("CloudMoonIcon", [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wd = e("CloudOffIcon", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cd = e("CloudRainWindIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ld = e("CloudRainIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bd = e("CloudSnowIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sd = e("CloudSunRainIcon", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qd = e("CloudSunIcon", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ot = e("CloudUploadIcon", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zd = e("CloudIcon", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ad = e("CloudyIcon", [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hd = e("CloverIcon", [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pd = e("ClubIcon", [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ct = e("CodeXmlIcon", [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bd = e("CodeIcon", [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vd = e("CodepenIcon", [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fd = e("CodesandboxIcon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jd = e("CoffeeIcon", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  [
    "path",
    {
      d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      key: "pwadti"
    }
  ],
  ["path", { d: "M6 2v2", key: "colzsn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dd = e("CogIcon", [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Td = e("CoinsIcon", [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nt = e("Columns2Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const it = e("Columns3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rd = e("Columns4Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Od = e("CombineIcon", [
  ["path", { d: "M10 18H5a3 3 0 0 1-3-3v-1", key: "ru65g8" }],
  ["path", { d: "M14 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "e30een" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "2ahx8o" }],
  ["path", { d: "m7 21 3-3-3-3", key: "127cv2" }],
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $d = e("CommandIcon", [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ed = e("CompassIcon", [
  [
    "path",
    {
      d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
      key: "9ktpf1"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ud = e("ComponentIcon", [
  [
    "path",
    {
      d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1uwlt4"
    }
  ],
  [
    "path",
    {
      d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
      key: "10291m"
    }
  ],
  [
    "path",
    {
      d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
      key: "1tqoq1"
    }
  ],
  [
    "path",
    {
      d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1x6lto"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zd = e("ComputerIcon", [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nd = e("ConciergeBellIcon", [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wd = e("ConeIcon", [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gd = e("ConstructionIcon", [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rt = e("ContactRoundIcon", [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M17.915 22a6 6 0 0 0-12 0", key: "suqz9p" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xd = e("ContactIcon", [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1waht3" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kd = e("ContainerIcon", [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jd = e("ContrastIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qd = e("CookieIcon", [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yd = e("CookingPotIcon", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _d = e("CopyCheckIcon", [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const es = e("CopyMinusIcon", [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ts = e("CopyPlusIcon", [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const as = e("CopySlashIcon", [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const os = e("CopyXIcon", [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cs = e("CopyIcon", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ns = e("CopyleftIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const is = e("CopyrightIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rs = e("CornerDownLeftIcon", [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ds = e("CornerDownRightIcon", [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ss = e("CornerLeftDownIcon", [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ls = e("CornerLeftUpIcon", [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hs = e("CornerRightDownIcon", [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ys = e("CornerRightUpIcon", [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const us = e("CornerUpLeftIcon", [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ps = e("CornerUpRightIcon", [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ks = e("CpuIcon", [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ms = e("CreativeCommonsIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fs = e("CreditCardIcon", [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gs = e("CroissantIcon", [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ms = e("CropIcon", [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vs = e("CrossIcon", [
  [
    "path",
    {
      d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z",
      key: "1xbrqy"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xs = e("CrosshairIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Is = e("CrownIcon", [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ws = e("CuboidIcon", [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cs = e("CupSodaIcon", [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ls = e("CurrencyIcon", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bs = e("CylinderIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ss = e("DamIcon", [
  [
    "path",
    { d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "157kva" }
  ],
  ["path", { d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "d7q6m6" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  [
    "path",
    { d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z", key: "pr6s65" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qs = e("DatabaseBackupIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zs = e("DatabaseZapIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const As = e("DatabaseIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hs = e("DeleteIcon", [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ps = e("DessertIcon", [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bs = e("DiameterIcon", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vs = e("DiamondMinusIcon", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dt = e("DiamondPercentIcon", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fs = e("DiamondPlusIcon", [
  ["path", { d: "M12 8v8", key: "napkw2" }],
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const js = e("DiamondIcon", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ds = e("Dice1Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ts = e("Dice2Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rs = e("Dice3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Os = e("Dice4Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $s = e("Dice5Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Es = e("Dice6Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Us = e("DicesIcon", [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zs = e("DiffIcon", [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ns = e("Disc2Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ws = e("Disc3Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gs = e("DiscAlbumIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xs = e("DiscIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ks = e("DivideIcon", [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Js = e("DnaOffIcon", [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8", key: "1bivrr" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3", key: "nxix30" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1", key: "18cutr" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16", key: "rlvei3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qs = e("DnaIcon", [
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ys = e("DockIcon", [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _s = e("DogIcon", [
  ["path", { d: "M11.25 16.25h1.5L12 17z", key: "w7jh35" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
      key: "u7s9ue"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  [
    "path",
    {
      d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "v8hric"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const el = e("DollarSignIcon", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tl = e("DonutIcon", [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const al = e("DoorClosedIcon", [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ol = e("DoorOpenIcon", [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cl = e("DotIcon", [
  ["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nl = e("DownloadIcon", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const il = e("DraftingCompassIcon", [
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19.136 12a10 10 0 0 1-14.271 0", key: "ppmlo4" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rl = e("DramaIcon", [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dl = e("DribbbleIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sl = e("DrillIcon", [
  [
    "path",
    { d: "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z", key: "ioqxb1" }
  ],
  [
    "path",
    {
      d: "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8",
      key: "1rs59n"
    }
  ],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ll = e("DropletOffIcon", [
  [
    "path",
    {
      d: "M18.715 13.186C18.29 11.858 17.384 10.607 16 9.5c-2-1.6-3.5-4-4-6.5a10.7 10.7 0 0 1-.884 2.586",
      key: "8suz2t"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M8.795 8.797A11 11 0 0 1 8 9.5C6 11.1 5 13 5 15a7 7 0 0 0 13.222 3.208", key: "19dw9m" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hl = e("DropletIcon", [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yl = e("DropletsIcon", [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ul = e("DrumIcon", [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pl = e("DrumstickIcon", [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kl = e("DumbbellIcon", [
  ["path", { d: "M14.4 14.4 9.6 9.6", key: "ic80wn" }],
  [
    "path",
    {
      d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z",
      key: "nnl7wr"
    }
  ],
  ["path", { d: "m21.5 21.5-1.4-1.4", key: "1f1ice" }],
  ["path", { d: "M3.9 3.9 2.5 2.5", key: "1evmna" }],
  [
    "path",
    {
      d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z",
      key: "yhosts"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ml = e("EarOffIcon", [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fl = e("EarIcon", [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gl = e("EarthLockIcon", [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const st = e("EarthIcon", [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
      key: "1tzkfa"
    }
  ],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "14pb5j" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ml = e("EclipseIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vl = e("EggFriedIcon", [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xl = e("EggOffIcon", [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Il = e("EggIcon", [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lt = e("EllipsisVerticalIcon", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ht = e("EllipsisIcon", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wl = e("EqualApproximatelyIcon", [
  ["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "yrdkhy" }],
  ["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "gzkvyz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cl = e("EqualNotIcon", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ll = e("EqualIcon", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bl = e("EraserIcon", [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sl = e("EthernetPortIcon", [
  [
    "path",
    {
      d: "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z",
      key: "rbahqx"
    }
  ],
  ["path", { d: "M6 8v1", key: "1636ez" }],
  ["path", { d: "M10 8v1", key: "1talb4" }],
  ["path", { d: "M14 8v1", key: "1rsfgr" }],
  ["path", { d: "M18 8v1", key: "gnkwox" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ql = e("EuroIcon", [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zl = e("ExpandIcon", [
  ["path", { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8", key: "1c15vz" }],
  ["path", { d: "M3 16.2V21m0 0h4.8M3 21l6-6", key: "1fsnz2" }],
  ["path", { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6", key: "hawz9i" }],
  ["path", { d: "M3 7.8V3m0 0h4.8M3 3l6 6", key: "u9ee12" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Al = e("ExternalLinkIcon", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hl = e("EyeClosedIcon", [
  ["path", { d: "m15 18-.722-3.25", key: "1j64jw" }],
  ["path", { d: "M2 8a10.645 10.645 0 0 0 20 0", key: "1e7gxb" }],
  ["path", { d: "m20 15-1.726-2.05", key: "1cnuld" }],
  ["path", { d: "m4 15 1.726-2.05", key: "1dsqqd" }],
  ["path", { d: "m9 18 .722-3.25", key: "ypw2yx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pl = e("EyeOffIcon", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bl = e("EyeIcon", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vl = e("FacebookIcon", [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fl = e("FactoryIcon", [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jl = e("FanIcon", [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dl = e("FastForwardIcon", [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tl = e("FeatherIcon", [
  [
    "path",
    {
      d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
      key: "18jl4k"
    }
  ],
  ["path", { d: "M16 8 2 22", key: "vp34q" }],
  ["path", { d: "M17.5 15H9", key: "1oz8nu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rl = e("FenceIcon", [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ol = e("FerrisWheelIcon", [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $l = e("FigmaIcon", [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const El = e("FileArchiveIcon", [
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01", key: "gkbcor" }
  ],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ul = e("FileAudio2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zl = e("FileAudioIcon", [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yt = e("FileAxis3dIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nl = e("FileBadge2Icon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wl = e("FileBadgeIcon", [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gl = e("FileBoxIcon", [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ut = e("FileChartColumnIncreasingIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pt = e("FileChartColumnIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kt = e("FileChartLineIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mt = e("FileChartPieIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  [
    "path",
    {
      d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
      key: "1dl6s6"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xl = e("FileCheck2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kl = e("FileCheckIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jl = e("FileClockIcon", [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ql = e("FileCode2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yl = e("FileCodeIcon", [
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ft = e("FileCogIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3.2 12.9-.9-.4", key: "1i3dj5" }],
  ["path", { d: "m3.2 15.1-.9.4", key: "1fvgj0" }],
  [
    "path",
    {
      d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
      key: "1yo3oz"
    }
  ],
  ["path", { d: "m4.9 11.2-.4-.9", key: "otmhb9" }],
  ["path", { d: "m4.9 16.8-.4.9", key: "1b8z07" }],
  ["path", { d: "m7.5 10.3-.4.9", key: "11k65u" }],
  ["path", { d: "m7.5 17.7-.4-.9", key: "431x55" }],
  ["path", { d: "m9.7 12.5-.9.4", key: "87sjan" }],
  ["path", { d: "m9.7 15.5-.9-.4", key: "khqm91" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _l = e("FileDiffIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eh = e("FileDigitIcon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const th = e("FileDownIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ah = e("FileHeartIcon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oh = e("FileImageIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ch = e("FileInputIcon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nh = e("FileJson2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ih = e("FileJsonIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rh = e("FileKey2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dh = e("FileKeyIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sh = e("FileLock2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lh = e("FileLockIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hh = e("FileMinus2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yh = e("FileMinusIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uh = e("FileMusicIcon", [
  ["path", { d: "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4", key: "1d3kfm" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }],
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ph = e("FileOutputIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gt = e("FilePenLineIcon", [
  [
    "path",
    {
      d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
      key: "142zxg"
    }
  ],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mt = e("FilePenIcon", [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kh = e("FilePlus2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mh = e("FilePlusIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fh = e("FileQuestionIcon", [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gh = e("FileScanIcon", [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mh = e("FileSearch2Icon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vh = e("FileSearchIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xh = e("FileSlidersIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ih = e("FileSpreadsheetIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wh = e("FileStackIcon", [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ch = e("FileSymlinkIcon", [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lh = e("FileTerminalIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bh = e("FileTextIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sh = e("FileType2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qh = e("FileTypeIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zh = e("FileUpIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ah = e("FileUserIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 18a3 3 0 1 0-6 0", key: "16awa0" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hh = e("FileVideo2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ph = e("FileVideoIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bh = e("FileVolume2Icon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vh = e("FileVolumeIcon", [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23", key: "ifyjnl" }
  ],
  [
    "path",
    {
      d: "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z",
      key: "mk8rxu"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fh = e("FileWarningIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jh = e("FileX2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dh = e("FileXIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Th = e("FileIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rh = e("FilesIcon", [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oh = e("FilmIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $h = e("FilterXIcon", [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eh = e("FilterIcon", [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uh = e("FingerprintIcon", [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zh = e("FireExtinguisherIcon", [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nh = e("FishOffIcon", [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wh = e("FishSymbolIcon", [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gh = e("FishIcon", [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xh = e("FlagOffIcon", [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kh = e("FlagTriangleLeftIcon", [
  ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jh = e("FlagTriangleRightIcon", [
  ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qh = e("FlagIcon", [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yh = e("FlameKindlingIcon", [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _h = e("FlameIcon", [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ey = e("FlashlightOffIcon", [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ty = e("FlashlightIcon", [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ay = e("FlaskConicalOffIcon", [
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20a2 2 0 0 1-2 2H6a2 2 0 0 1-1.755-2.96l5.227-9.563", key: "k0duyd" }],
  ["path", { d: "M6.453 15H15", key: "1f0z33" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oy = e("FlaskConicalIcon", [
  [
    "path",
    {
      d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
      key: "18mbvz"
    }
  ],
  ["path", { d: "M6.453 15h11.094", key: "3shlmq" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cy = e("FlaskRoundIcon", [
  ["path", { d: "M10 2v6.292a7 7 0 1 0 4 0V2", key: "1s42pc" }],
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ny = e("FlipHorizontal2Icon", [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iy = e("FlipHorizontalIcon", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ry = e("FlipVertical2Icon", [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dy = e("FlipVerticalIcon", [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sy = e("Flower2Icon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ly = e("FlowerIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hy = e("FocusIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yy = e("FoldHorizontalIcon", [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uy = e("FoldVerticalIcon", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const py = e("FolderArchiveIcon", [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ky = e("FolderCheckIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const My = e("FolderClockIcon", [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fy = e("FolderClosedIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gy = e("FolderCodeIcon", [
  ["path", { d: "M10 10.5 8 13l2 2.5", key: "m4t9c1" }],
  ["path", { d: "m14 10.5 2 2.5-2 2.5", key: "14w2eb" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
      key: "1u1bxd"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vt = e("FolderCogIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const my = e("FolderDotIcon", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vy = e("FolderDownIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xy = e("FolderGit2Icon", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iy = e("FolderGitIcon", [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wy = e("FolderHeartIcon", [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "wpff58"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cy = e("FolderInputIcon", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ly = e("FolderKanbanIcon", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const by = e("FolderKeyIcon", [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sy = e("FolderLockIcon", [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qy = e("FolderMinusIcon", [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zy = e("FolderOpenDotIcon", [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ay = e("FolderOpenIcon", [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hy = e("FolderOutputIcon", [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xt = e("FolderPenIcon", [
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ],
  [
    "path",
    {
      d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1saktj"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Py = e("FolderPlusIcon", [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const By = e("FolderRootIcon", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vy = e("FolderSearch2Icon", [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fy = e("FolderSearchIcon", [
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jy = e("FolderSymlinkIcon", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dy = e("FolderSyncIcon", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ty = e("FolderTreeIcon", [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ry = e("FolderUpIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oy = e("FolderXIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $y = e("FolderIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ey = e("FoldersIcon", [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uy = e("FootprintsIcon", [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zy = e("ForkliftIcon", [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ny = e("ForwardIcon", [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wy = e("FrameIcon", [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gy = e("FramerIcon", [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xy = e("FrownIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ky = e("FuelIcon", [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jy = e("FullscreenIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qy = e("GalleryHorizontalEndIcon", [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yy = e("GalleryHorizontalIcon", [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _y = e("GalleryThumbnailsIcon", [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eu = e("GalleryVerticalEndIcon", [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tu = e("GalleryVerticalIcon", [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const au = e("Gamepad2Icon", [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ou = e("GamepadIcon", [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cu = e("GaugeIcon", [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nu = e("GavelIcon", [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iu = e("GemIcon", [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ru = e("GhostIcon", [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const du = e("GiftIcon", [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const su = e("GitBranchPlusIcon", [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lu = e("GitBranchIcon", [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const It = e("GitCommitHorizontalIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hu = e("GitCommitVerticalIcon", [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yu = e("GitCompareArrowsIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uu = e("GitCompareIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pu = e("GitForkIcon", [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ku = e("GitGraphIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mu = e("GitMergeIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fu = e("GitPullRequestArrowIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gu = e("GitPullRequestClosedIcon", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mu = e("GitPullRequestCreateArrowIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vu = e("GitPullRequestCreateIcon", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xu = e("GitPullRequestDraftIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iu = e("GitPullRequestIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wu = e("GithubIcon", [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cu = e("GitlabIcon", [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lu = e("GlassWaterIcon", [
  [
    "path",
    {
      d: "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
      key: "p55z4y"
    }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bu = e("GlassesIcon", [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Su = e("GlobeLockIcon", [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qu = e("GlobeIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zu = e("GoalIcon", [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Au = e("GrabIcon", [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "edstyy" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "19wdwo" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "1lugqo" }],
  ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1hbeus" }],
  [
    "path",
    { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "1etffm" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hu = e("GraduationCapIcon", [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pu = e("GrapeIcon", [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bu = e("Grid2x2CheckIcon", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wt = e("Grid2x2PlusIcon", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 22v-6", key: "qhmiwi" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vu = e("Grid2x2XIcon", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 16 5 5", key: "8tpb07" }],
  ["path", { d: "m16 21 5-5", key: "193jll" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ct = e("Grid2x2Icon", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Se = e("Grid3x3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fu = e("GripHorizontalIcon", [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ju = e("GripVerticalIcon", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Du = e("GripIcon", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tu = e("GroupIcon", [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ru = e("GuitarIcon", [
  ["path", { d: "m11.9 12.1 4.514-4.514", key: "109xqo" }],
  [
    "path",
    {
      d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
      key: "txyc8t"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  [
    "path",
    {
      d: "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z",
      key: "1u8q3z"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ou = e("HamIcon", [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $u = e("HammerIcon", [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eu = e("HandCoinsIcon", [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uu = e("HandHeartIcon", [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lt = e("HandHelpingIcon", [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zu = e("HandMetalIcon", [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "wc6myp" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nu = e("HandPlatterIcon", [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5",
      key: "n2g93r"
    }
  ],
  ["path", { d: "M2 14h12a2 2 0 0 1 0 4h-2", key: "1o2jem" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M5 10a7 7 0 0 1 14 0", key: "1ega1o" }],
  ["path", { d: "M5 14v6a1 1 0 0 1-1 1H2", key: "1hescx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wu = e("HandIcon", [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gu = e("HandshakeIcon", [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xu = e("HardDriveDownloadIcon", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ku = e("HardDriveUploadIcon", [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ju = e("HardDriveIcon", [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qu = e("HardHatIcon", [
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M14 6a6 6 0 0 1 6 6v3", key: "1hnv84" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6", key: "9ciidu" }],
  ["rect", { x: "2", y: "15", width: "20", height: "4", rx: "1", key: "g3x8cw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yu = e("HashIcon", [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _u = e("HazeIcon", [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ep = e("HdmiPortIcon", [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tp = e("Heading1Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ap = e("Heading2Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const op = e("Heading3Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cp = e("Heading4Icon", [
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v3a1 1 0 0 0 1 1h3", key: "tj5zdr" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }],
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const np = e("Heading5Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ip = e("Heading6Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rp = e("HeadingIcon", [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dp = e("HeadphoneOffIcon", [
  ["path", { d: "M21 14h-1.343", key: "1jdnxi" }],
  ["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343", key: "6kipu2" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3", key: "9x50f4" }],
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364",
      key: "1bkxnm"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sp = e("HeadphonesIcon", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lp = e("HeadsetIcon", [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hp = e("HeartCrackIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yp = e("HeartHandshakeIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "4oyue0"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const up = e("HeartOffIcon", [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pp = e("HeartPulseIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kp = e("HeartIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mp = e("HeaterIcon", [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fp = e("HexagonIcon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gp = e("HighlighterIcon", [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mp = e("HistoryIcon", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vp = e("HopOffIcon", [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xp = e("HopIcon", [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ip = e("HospitalIcon", [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wp = e("HotelIcon", [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cp = e("HourglassIcon", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lp = e("HousePlugIcon", [
  ["path", { d: "M10 12V8.964", key: "1vll13" }],
  ["path", { d: "M14 12V8.964", key: "1x3qvg" }],
  [
    "path",
    { d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z", key: "ppykja" }
  ],
  [
    "path",
    {
      d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
      key: "1gvg2z"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bp = e("HousePlusIcon", [
  [
    "path",
    {
      d: "M13.22 2.416a2 2 0 0 0-2.511.057l-7 5.999A2 2 0 0 0 3 10v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.354",
      key: "5phn05"
    }
  ],
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 3v6", key: "x1uolp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bt = e("HouseIcon", [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const St = e("IceCreamBowlIcon", [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qt = e("IceCreamConeIcon", [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sp = e("IdCardIcon", [
  ["path", { d: "M16 10h2", key: "8sgtl7" }],
  ["path", { d: "M16 14h2", key: "epxaof" }],
  ["path", { d: "M6.17 15a3 3 0 0 1 5.66 0", key: "n6f512" }],
  ["circle", { cx: "9", cy: "11", r: "2", key: "yxgjnd" }],
  ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2", key: "qneu4z" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qp = e("ImageDownIcon", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zp = e("ImageMinusIcon", [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ap = e("ImageOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hp = e("ImagePlayIcon", [
  ["path", { d: "m11 16-5 5", key: "j5f7ct" }],
  ["path", { d: "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5", key: "7s81lt" }],
  [
    "path",
    {
      d: "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "1omb6s"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pp = e("ImagePlusIcon", [
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }],
  ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bp = e("ImageUpIcon", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vp = e("ImageUpscaleIcon", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M17 21h2a2 2 0 0 0 2-2", key: "130fy9" }],
  ["path", { d: "M21 12v3", key: "1wzk3p" }],
  ["path", { d: "m21 3-5 5", key: "1g5oa7" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2", key: "kk3yz1" }],
  ["path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19", key: "fyekpt" }],
  ["path", { d: "M9 3h3", key: "d52fa" }],
  ["rect", { x: "3", y: "11", width: "10", height: "10", rx: "1", key: "1wpmix" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fp = e("ImageIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jp = e("ImagesIcon", [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dp = e("ImportIcon", [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tp = e("InboxIcon", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zt = e("IndentDecreaseIcon", [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m7 8-4 4 4 4", key: "o5hrat" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const At = e("IndentIncreaseIcon", [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m3 8 4 4-4 4", key: "1a3j6y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rp = e("IndianRupeeIcon", [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Op = e("InfinityIcon", [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $p = e("InfoIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ep = e("InspectionPanelIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Up = e("InstagramIcon", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zp = e("ItalicIcon", [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Np = e("IterationCcwIcon", [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wp = e("IterationCwIcon", [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gp = e("JapaneseYenIcon", [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xp = e("JoystickIcon", [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kp = e("KanbanIcon", [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jp = e("KeyRoundIcon", [
  [
    "path",
    {
      d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
      key: "1s6t7t"
    }
  ],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qp = e("KeySquareIcon", [
  [
    "path",
    {
      d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
      key: "165ttr"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  [
    "path",
    {
      d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
      key: "1ubxi2"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yp = e("KeyIcon", [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _p = e("KeyboardMusicIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e4 = e("KeyboardOffIcon", [
  ["path", { d: "M 20 4 A2 2 0 0 1 22 6", key: "1g1fkt" }],
  ["path", { d: "M 22 6 L 22 16.41", key: "1qjg3w" }],
  ["path", { d: "M 7 16 L 16 16", key: "n0yqwb" }],
  ["path", { d: "M 9.69 4 L 20 4", key: "kbpcgx" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2", key: "s23sx2" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t4 = e("KeyboardIcon", [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a4 = e("LampCeilingIcon", [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o4 = e("LampDeskIcon", [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c4 = e("LampFloorIcon", [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n4 = e("LampWallDownIcon", [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i4 = e("LampWallUpIcon", [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r4 = e("LampIcon", [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d4 = e("LandPlotIcon", [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s4 = e("LandmarkIcon", [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l4 = e("LanguagesIcon", [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h4 = e("LaptopMinimalCheckIcon", [
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2", key: "8ur36m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ht = e("LaptopMinimalIcon", [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y4 = e("LaptopIcon", [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u4 = e("LassoSelectIcon", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
      key: "72q637"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p4 = e("LassoIcon", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k4 = e("LaughIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M4 = e("Layers2Icon", [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pt = e("LayersIcon", [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f4 = e("LayoutDashboardIcon", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g4 = e("LayoutGridIcon", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m4 = e("LayoutListIcon", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v4 = e("LayoutPanelLeftIcon", [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x4 = e("LayoutPanelTopIcon", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I4 = e("LayoutTemplateIcon", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w4 = e("LeafIcon", [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C4 = e("LeafyGreenIcon", [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L4 = e("LecternIcon", [
  [
    "path",
    {
      d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
      key: "13jjxg"
    }
  ],
  ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3", key: "1550fe" }],
  ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1", key: "qmu8b6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b4 = e("LetterTextIcon", [
  ["path", { d: "M15 12h6", key: "upa0zy" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "m3 13 3.553-7.724a.5.5 0 0 1 .894 0L11 13", key: "blevx4" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M4 11h6", key: "olkgv1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S4 = e("LibraryBigIcon", [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q4 = e("LibraryIcon", [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z4 = e("LifeBuoyIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A4 = e("LigatureIcon", [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H4 = e("LightbulbOffIcon", [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P4 = e("LightbulbIcon", [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B4 = e("Link2OffIcon", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V4 = e("Link2Icon", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F4 = e("LinkIcon", [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j4 = e("LinkedinIcon", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D4 = e("ListCheckIcon", [
  ["path", { d: "M11 18H3", key: "n3j2dh" }],
  ["path", { d: "m15 18 2 2 4-4", key: "1szwhi" }],
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T4 = e("ListChecksIcon", [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R4 = e("ListCollapseIcon", [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O4 = e("ListEndIcon", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $4 = e("ListFilterPlusIcon", [
  ["path", { d: "M10 18h4", key: "1ulq68" }],
  ["path", { d: "M11 6H3", key: "1u26ik" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 9V3", key: "xwwp7m" }],
  ["path", { d: "M7 12h8", key: "7a1bxv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E4 = e("ListFilterIcon", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U4 = e("ListMinusIcon", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z4 = e("ListMusicIcon", [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N4 = e("ListOrderedIcon", [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W4 = e("ListPlusIcon", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G4 = e("ListRestartIcon", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X4 = e("ListStartIcon", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K4 = e("ListTodoIcon", [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J4 = e("ListTreeIcon", [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q4 = e("ListVideoIcon", [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y4 = e("ListXIcon", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _4 = e("ListIcon", [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bt = e("LoaderCircleIcon", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ek = e("LoaderPinwheelIcon", [
  ["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0", key: "1lzz15" }],
  ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6", key: "1gnrpi" }],
  ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6", key: "u9yy5q" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tk = e("LoaderIcon", [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ak = e("LocateFixedIcon", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ok = e("LocateOffIcon", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ck = e("LocateIcon", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vt = e("LockKeyholeOpenIcon", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nk = e("LockKeyholeIcon", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ft = e("LockOpenIcon", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ik = e("LockIcon", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rk = e("LogInIcon", [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dk = e("LogOutIcon", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sk = e("LogsIcon", [
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M3 18h1", key: "1eiwyy" }],
  ["path", { d: "M3 6h1", key: "rgxa97" }],
  ["path", { d: "M8 12h1", key: "1con00" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M8 6h1", key: "tn6mkg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lk = e("LollipopIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hk = e("LuggageIcon", [
  [
    "path",
    { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1m57jg" }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yk = e("MagnetIcon", [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uk = e("MailCheckIcon", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pk = e("MailMinusIcon", [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kk = e("MailOpenIcon", [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mk = e("MailPlusIcon", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fk = e("MailQuestionIcon", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gk = e("MailSearchIcon", [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "8lzu5m" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mk = e("MailWarningIcon", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vk = e("MailXIcon", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xk = e("MailIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ik = e("MailboxIcon", [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2", key: "15i455" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wk = e("MailsIcon", [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ck = e("MapPinCheckInsideIcon", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lk = e("MapPinCheckIcon", [
  [
    "path",
    {
      d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
      key: "1dq61d"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m16 18 2 2 4-4", key: "1mkfmb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bk = e("MapPinHouseIcon", [
  [
    "path",
    {
      d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
      key: "1p1rcz"
    }
  ],
  [
    "path",
    {
      d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
      key: "mcbcs9"
    }
  ],
  ["path", { d: "M18 22v-3", key: "1t1ugv" }],
  ["circle", { cx: "10", cy: "10", r: "3", key: "1ns7v1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sk = e("MapPinMinusInsideIcon", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qk = e("MapPinMinusIcon", [
  [
    "path",
    {
      d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "11uxia"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zk = e("MapPinOffIcon", [
  ["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16", key: "1d4wjd" }],
  [
    "path",
    {
      d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
      key: "12yil7"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533", key: "lhrkcz" }],
  ["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74", key: "13wojd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ak = e("MapPinPlusInsideIcon", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hk = e("MapPinPlusIcon", [
  [
    "path",
    {
      d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "fcdtly"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }],
  ["path", { d: "M19 15v6", key: "10aioa" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pk = e("MapPinXInsideIcon", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bk = e("MapPinXIcon", [
  [
    "path",
    {
      d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
      key: "y0ewhp"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m21.5 15.5-5 5", key: "11iqnx" }],
  ["path", { d: "m21.5 20.5-5-5", key: "1bylgx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vk = e("MapPinIcon", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fk = e("MapPinnedIcon", [
  [
    "path",
    {
      d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0",
      key: "11u0oz"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712",
      key: "q8zwxj"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jk = e("MapIcon", [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dk = e("MartiniIcon", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tk = e("Maximize2Icon", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rk = e("MaximizeIcon", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ok = e("MedalIcon", [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $k = e("MegaphoneOffIcon", [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ek = e("MegaphoneIcon", [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uk = e("MehIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zk = e("MemoryStickIcon", [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nk = e("MenuIcon", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wk = e("MergeIcon", [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gk = e("MessageCircleCodeIcon", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22z", key: "k85zhp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xk = e("MessageCircleDashedIcon", [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kk = e("MessageCircleHeartIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jk = e("MessageCircleMoreIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qk = e("MessageCircleOffIcon", [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yk = e("MessageCirclePlusIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _k = e("MessageCircleQuestionIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e5 = e("MessageCircleReplyIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t5 = e("MessageCircleWarningIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a5 = e("MessageCircleXIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o5 = e("MessageCircleIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c5 = e("MessageSquareCodeIcon", [
  ["path", { d: "M10 7.5 8 10l2 2.5", key: "xb17xw" }],
  ["path", { d: "m14 7.5 2 2.5-2 2.5", key: "5rap1v" }],
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n5 = e("MessageSquareDashedIcon", [
  ["path", { d: "M10 17H7l-4 4v-7", key: "1r71xu" }],
  ["path", { d: "M14 17h1", key: "nufu4t" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 14v1a2 2 0 0 1-2 2", key: "29akq3" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i5 = e("MessageSquareDiffIcon", [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r5 = e("MessageSquareDotIcon", [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d5 = e("MessageSquareHeartIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s5 = e("MessageSquareLockIcon", [
  ["path", { d: "M19 15v-2a2 2 0 1 0-4 0v2", key: "h3d1vz" }],
  ["path", { d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5", key: "xsnnhn" }],
  ["rect", { x: "13", y: "15", width: "8", height: "5", rx: "1", key: "1ccwuk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l5 = e("MessageSquareMoreIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h5 = e("MessageSquareOffIcon", [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y5 = e("MessageSquarePlusIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u5 = e("MessageSquareQuoteIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p5 = e("MessageSquareReplyIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k5 = e("MessageSquareShareIcon", [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M5 = e("MessageSquareTextIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f5 = e("MessageSquareWarningIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g5 = e("MessageSquareXIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m5 = e("MessageSquareIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v5 = e("MessagesSquareIcon", [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z", key: "p1xzt8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x5 = e("MicOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jt = e("MicVocalIcon", [
  [
    "path",
    {
      d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
      key: "80a601"
    }
  ],
  [
    "path",
    {
      d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
      key: "j0ngtp"
    }
  ],
  ["circle", { cx: "16", cy: "7", r: "5", key: "d08jfb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I5 = e("MicIcon", [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w5 = e("MicrochipIcon", [
  ["path", { d: "M18 12h2", key: "quuxs7" }],
  ["path", { d: "M18 16h2", key: "zsn3lv" }],
  ["path", { d: "M18 20h2", key: "9x5y9y" }],
  ["path", { d: "M18 4h2", key: "1luxfb" }],
  ["path", { d: "M18 8h2", key: "nxqzg" }],
  ["path", { d: "M4 12h2", key: "1ltxp0" }],
  ["path", { d: "M4 16h2", key: "8a5zha" }],
  ["path", { d: "M4 20h2", key: "27dk57" }],
  ["path", { d: "M4 4h2", key: "10groj" }],
  ["path", { d: "M4 8h2", key: "18vq6w" }],
  [
    "path",
    {
      d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
      key: "1681fp"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C5 = e("MicroscopeIcon", [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L5 = e("MicrowaveIcon", [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b5 = e("MilestoneIcon", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z",
      key: "1btarq"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S5 = e("MilkOffIcon", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q5 = e("MilkIcon", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z5 = e("Minimize2Icon", [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A5 = e("MinimizeIcon", [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H5 = e("MinusIcon", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P5 = e("MonitorCheckIcon", [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B5 = e("MonitorCogIcon", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m15.2 4.9-.9-.4", key: "12wd2u" }],
  ["path", { d: "m15.2 7.1-.9.4", key: "1r2vl7" }],
  ["path", { d: "m16.9 3.2-.4-.9", key: "3zbo91" }],
  ["path", { d: "m16.9 8.8-.4.9", key: "1qr2dn" }],
  ["path", { d: "m19.5 2.3-.4.9", key: "1rjrkq" }],
  ["path", { d: "m19.5 9.7-.4-.9", key: "heryx5" }],
  ["path", { d: "m21.7 4.5-.9.4", key: "17fqt1" }],
  ["path", { d: "m21.7 7.5-.9-.4", key: "14zyni" }],
  ["path", { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "1tnzv8" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V5 = e("MonitorDotIcon", [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F5 = e("MonitorDownIcon", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j5 = e("MonitorOffIcon", [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D5 = e("MonitorPauseIcon", [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T5 = e("MonitorPlayIcon", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R5 = e("MonitorSmartphoneIcon", [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O5 = e("MonitorSpeakerIcon", [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $5 = e("MonitorStopIcon", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E5 = e("MonitorUpIcon", [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U5 = e("MonitorXIcon", [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z5 = e("MonitorIcon", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N5 = e("MoonStarIcon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9", key: "4ay0iu" }],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W5 = e("MoonIcon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G5 = e("MountainSnowIcon", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X5 = e("MountainIcon", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K5 = e("MouseOffIcon", [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J5 = e("MousePointer2Icon", [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q5 = e("MousePointerBanIcon", [
  [
    "path",
    {
      d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
      key: "11pp1i"
    }
  ],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "m11.8 11.8 8.4 8.4", key: "oogvdj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y5 = e("MousePointerClickIcon", [
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  [
    "path",
    {
      d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
      key: "s0h3yz"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _5 = e("MousePointerIcon", [
  ["path", { d: "M12.586 12.586 19 19", key: "ea5xo7" }],
  [
    "path",
    {
      d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
      key: "277e5u"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e3 = e("MouseIcon", [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dt = e("Move3dIcon", [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t3 = e("MoveDiagonal2Icon", [
  ["path", { d: "M19 13v6h-6", key: "1hxl6d" }],
  ["path", { d: "M5 11V5h6", key: "12e2xe" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a3 = e("MoveDiagonalIcon", [
  ["path", { d: "M11 19H5v-6", key: "8awifj" }],
  ["path", { d: "M13 5h6v6", key: "7voy1q" }],
  ["path", { d: "M19 5 5 19", key: "wwaj1z" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o3 = e("MoveDownLeftIcon", [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c3 = e("MoveDownRightIcon", [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n3 = e("MoveDownIcon", [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i3 = e("MoveHorizontalIcon", [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r3 = e("MoveLeftIcon", [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d3 = e("MoveRightIcon", [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s3 = e("MoveUpLeftIcon", [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l3 = e("MoveUpRightIcon", [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h3 = e("MoveUpIcon", [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y3 = e("MoveVerticalIcon", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m8 18 4 4 4-4", key: "bh5tu3" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u3 = e("MoveIcon", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p3 = e("Music2Icon", [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k3 = e("Music3Icon", [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M3 = e("Music4Icon", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f3 = e("MusicIcon", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g3 = e("Navigation2OffIcon", [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m3 = e("Navigation2Icon", [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v3 = e("NavigationOffIcon", [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x3 = e("NavigationIcon", [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I3 = e("NetworkIcon", [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w3 = e("NewspaperIcon", [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C3 = e("NfcIcon", [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L3 = e("NotebookPenIcon", [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  [
    "path",
    {
      d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "pqwjuv"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b3 = e("NotebookTabsIcon", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S3 = e("NotebookTextIcon", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q3 = e("NotebookIcon", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z3 = e("NotepadTextDashedIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A3 = e("NotepadTextIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H3 = e("NutOffIcon", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P3 = e("NutIcon", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tt = e("OctagonAlertIcon", [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B3 = e("OctagonMinusIcon", [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rt = e("OctagonPauseIcon", [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ot = e("OctagonXIcon", [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V3 = e("OctagonIcon", [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F3 = e("OmegaIcon", [
  [
    "path",
    {
      d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
      key: "1x94xo"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j3 = e("OptionIcon", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D3 = e("OrbitIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T3 = e("OrigamiIcon", [
  ["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025", key: "1bx4vc" }],
  [
    "path",
    {
      d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
      key: "1h3km6"
    }
  ],
  [
    "path",
    {
      d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
      key: "1hj4wg"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R3 = e("Package2Icon", [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O3 = e("PackageCheckIcon", [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $3 = e("PackageMinusIcon", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E3 = e("PackageOpenIcon", [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U3 = e("PackagePlusIcon", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z3 = e("PackageSearchIcon", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N3 = e("PackageXIcon", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W3 = e("PackageIcon", [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["path", { d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7", key: "yx3hmr" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G3 = e("PaintBucketIcon", [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X3 = e("PaintRollerIcon", [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $t = e("PaintbrushVerticalIcon", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z", key: "ycvu00" }],
  [
    "path",
    {
      d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
      key: "iw4wnp"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K3 = e("PaintbrushIcon", [
  ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
  [
    "path",
    {
      d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
      key: "18tc5c"
    }
  ],
  [
    "path",
    {
      d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
      key: "ytzfxy"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J3 = e("PaletteIcon", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q3 = e("PanelBottomCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Et = e("PanelBottomDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y3 = e("PanelBottomOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _3 = e("PanelBottomIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ut = e("PanelLeftCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zt = e("PanelLeftDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nt = e("PanelLeftOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wt = e("PanelLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e6 = e("PanelRightCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gt = e("PanelRightDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t6 = e("PanelRightOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a6 = e("PanelRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o6 = e("PanelTopCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xt = e("PanelTopDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c6 = e("PanelTopOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n6 = e("PanelTopIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i6 = e("PanelsLeftBottomIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r6 = e("PanelsRightBottomIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kt = e("PanelsTopLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d6 = e("PaperclipIcon", [
  ["path", { d: "M13.234 20.252 21 12.3", key: "1cbrk9" }],
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486",
      key: "1pkts6"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s6 = e("ParenthesesIcon", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l6 = e("ParkingMeterIcon", [
  ["path", { d: "M11 15h2", key: "199qp6" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M12 19v3", key: "npa21l" }],
  [
    "path",
    {
      d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
      key: "1jofit"
    }
  ],
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h6 = e("PartyPopperIcon", [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "hbicv8"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17", key: "1i94pl" }
  ],
  ["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7", key: "1cofks" }],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y6 = e("PauseIcon", [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u6 = e("PawPrintIcon", [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p6 = e("PcCaseIcon", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jt = e("PenLineIcon", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k6 = e("PenOffIcon", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M6 = e("PenToolIcon", [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qt = e("PenIcon", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f6 = e("PencilLineIcon", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g6 = e("PencilOffIcon", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m6 = e("PencilRulerIcon", [
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v6 = e("PencilIcon", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x6 = e("PentagonIcon", [
  [
    "path",
    {
      d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
      key: "2hea0t"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I6 = e("PercentIcon", [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w6 = e("PersonStandingIcon", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C6 = e("PhilippinePesoIcon", [
  ["path", { d: "M20 11H4", key: "6ut86h" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7", key: "1ana5r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L6 = e("PhoneCallIcon", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b6 = e("PhoneForwardedIcon", [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S6 = e("PhoneIncomingIcon", [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q6 = e("PhoneMissedIcon", [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z6 = e("PhoneOffIcon", [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A6 = e("PhoneOutgoingIcon", [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H6 = e("PhoneIcon", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P6 = e("PiIcon", [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B6 = e("PianoIcon", [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V6 = e("PickaxeIcon", [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F6 = e("PictureInPicture2Icon", [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j6 = e("PictureInPictureIcon", [
  ["path", { d: "M2 10h6V4", key: "zwrco" }],
  ["path", { d: "m2 4 6 6", key: "ug085t" }],
  ["path", { d: "M21 10V7a2 2 0 0 0-2-2h-7", key: "git5jr" }],
  ["path", { d: "M3 14v2a2 2 0 0 0 2 2h3", key: "1f7fh3" }],
  ["rect", { x: "12", y: "14", width: "10", height: "7", rx: "1", key: "1wjs3o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D6 = e("PiggyBankIcon", [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z",
      key: "1ivx2i"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T6 = e("PilcrowLeftIcon", [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R6 = e("PilcrowRightIcon", [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O6 = e("PilcrowIcon", [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $6 = e("PillBottleIcon", [
  ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4", key: "17ldeb" }],
  ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7", key: "nc37y6" }],
  ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1", key: "3jeezo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E6 = e("PillIcon", [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U6 = e("PinOffIcon", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
      key: "c9qhm2"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z6 = e("PinIcon", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N6 = e("PipetteIcon", [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W6 = e("PizzaIcon", [
  ["path", { d: "m12 14-1 1", key: "11onhr" }],
  ["path", { d: "m13.75 18.25-1.25 1.42", key: "1yisr3" }],
  ["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12", key: "1qtqk6" }],
  ["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7", key: "fbbbr2" }],
  [
    "path",
    {
      d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
      key: "1hyfdd"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G6 = e("PlaneLandingIcon", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X6 = e("PlaneTakeoffIcon", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K6 = e("PlaneIcon", [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J6 = e("PlayIcon", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q6 = e("Plug2Icon", [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z", key: "wtfw2c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yt = e("PlugZapIcon", [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y6 = e("PlugIcon", [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _6 = e("PlusIcon", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e8 = e("PocketKnifeIcon", [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t8 = e("PocketIcon", [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a8 = e("PodcastIcon", [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o8 = e("PointerOffIcon", [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c8 = e("PointerIcon", [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1agjmk" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1", key: "wdbh2u" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10", key: "1ibuk9" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n8 = e("PopcornIcon", [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i8 = e("PopsicleIcon", [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r8 = e("PoundSterlingIcon", [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d8 = e("PowerOffIcon", [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s8 = e("PowerIcon", [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l8 = e("PresentationIcon", [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h8 = e("PrinterCheckIcon", [
  ["path", { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5", key: "qeb09x" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2", key: "1md90i" }],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y8 = e("PrinterIcon", [
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }],
  ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1", key: "1ue0tg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u8 = e("ProjectorIcon", [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p8 = e("ProportionsIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k8 = e("PuzzleIcon", [
  [
    "path",
    {
      d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
      key: "w46dr5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M8 = e("PyramidIcon", [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f8 = e("QrCodeIcon", [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g8 = e("QuoteIcon", [
  [
    "path",
    {
      d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "rib7q0"
    }
  ],
  [
    "path",
    {
      d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "1ymkrd"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m8 = e("RabbitIcon", [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v8 = e("RadarIcon", [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x8 = e("RadiationIcon", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I8 = e("RadicalIcon", [
  [
    "path",
    {
      d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
      key: "1mqj8i"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w8 = e("RadioReceiverIcon", [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C8 = e("RadioTowerIcon", [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L8 = e("RadioIcon", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b8 = e("RadiusIcon", [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S8 = e("RailSymbolIcon", [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q8 = e("RainbowIcon", [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z8 = e("RatIcon", [
  [
    "path",
    {
      d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7c0 2.2 1.8 4 4 4",
      key: "1wq71c"
    }
  ],
  [
    "path",
    {
      d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3",
      key: "1crdmb"
    }
  ],
  ["path", { d: "M13.2 18a3 3 0 0 0-2.2-5", key: "1ol3lk" }],
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A8 = e("RatioIcon", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H8 = e("ReceiptCentIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P8 = e("ReceiptEuroIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B8 = e("ReceiptIndianRupeeIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V8 = e("ReceiptJapaneseYenIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F8 = e("ReceiptPoundSterlingIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j8 = e("ReceiptRussianRubleIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D8 = e("ReceiptSwissFrancIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T8 = e("ReceiptTextIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R8 = e("ReceiptIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _t = e("RectangleEllipsisIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O8 = e("RectangleHorizontalIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $8 = e("RectangleVerticalIcon", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E8 = e("RecycleIcon", [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U8 = e("Redo2Icon", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z8 = e("RedoDotIcon", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N8 = e("RedoIcon", [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W8 = e("RefreshCcwDotIcon", [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G8 = e("RefreshCcwIcon", [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X8 = e("RefreshCwOffIcon", [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K8 = e("RefreshCwIcon", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J8 = e("RefrigeratorIcon", [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q8 = e("RegexIcon", [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y8 = e("RemoveFormattingIcon", [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _8 = e("Repeat1Icon", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e7 = e("Repeat2Icon", [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t7 = e("RepeatIcon", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a7 = e("ReplaceAllIcon", [
  ["path", { d: "M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "1yyzbs" }],
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "zfj4xr" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a 3 3 0 0 1 3-3h1", key: "1ageje" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o7 = e("ReplaceIcon", [
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a3 3 0 0 1 3-3h1", key: "3y3t5z" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c7 = e("ReplyAllIcon", [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n7 = e("ReplyIcon", [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i7 = e("RewindIcon", [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r7 = e("RibbonIcon", [
  [
    "path",
    { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22", key: "1rnhq3" }
  ],
  ["path", { d: "m12 18 2.57-3.5", key: "116vt7" }],
  ["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009", key: "10dq0b" }],
  ["path", { d: "M9.35 14.53 12 11.22", key: "tdsyp2" }],
  [
    "path",
    {
      d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
      key: "nmifey"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d7 = e("RocketIcon", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s7 = e("RockingChairIcon", [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l7 = e("RollerCoasterIcon", [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ea = e("Rotate3dIcon", [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h7 = e("RotateCcwSquareIcon", [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y7 = e("RotateCcwIcon", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u7 = e("RotateCwSquareIcon", [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p7 = e("RotateCwIcon", [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k7 = e("RouteOffIcon", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M7 = e("RouteIcon", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f7 = e("RouterIcon", [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ta = e("Rows2Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aa = e("Rows3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g7 = e("Rows4Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m7 = e("RssIcon", [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v7 = e("RulerIcon", [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x7 = e("RussianRubleIcon", [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I7 = e("SailboatIcon", [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w7 = e("SaladIcon", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C7 = e("SandwichIcon", [
  ["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777", key: "f1wd0e" }],
  ["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25", key: "1pfu07" }],
  ["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9", key: "1oq9qw" }],
  ["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2", key: "1fnwu5" }],
  ["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1", key: "itshg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L7 = e("SatelliteDishIcon", [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b7 = e("SatelliteIcon", [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S7 = e("SaveAllIcon", [
  ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5", key: "1xspal" }],
  ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6", key: "1ra60u" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  [
    "path",
    {
      d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
      key: "1yve0x"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q7 = e("SaveOffIcon", [
  ["path", { d: "M13 13H8a1 1 0 0 0-1 1v7", key: "h8g396" }],
  ["path", { d: "M14 8h1", key: "1lfen6" }],
  ["path", { d: "M17 21v-4", key: "1yknxs" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41", key: "1t4vdl" }
  ],
  ["path", { d: "M29.5 11.5s5 5 4 5", key: "zzn4i6" }],
  ["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15", key: "24cby9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z7 = e("SaveIcon", [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oa = e("Scale3dIcon", [
  ["path", { d: "M5 7v11a1 1 0 0 0 1 1h11", key: "13dt1j" }],
  ["path", { d: "M5.293 18.707 11 13", key: "ezgbsx" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A7 = e("ScaleIcon", [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H7 = e("ScalingIcon", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P7 = e("ScanBarcodeIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B7 = e("ScanEyeIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V7 = e("ScanFaceIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F7 = e("ScanHeartIcon", [
  [
    "path",
    {
      d: "M11.246 16.657a1 1 0 0 0 1.508 0l3.57-4.101A2.75 2.75 0 1 0 12 9.168a2.75 2.75 0 1 0-4.324 3.388z",
      key: "1algrk"
    }
  ],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j7 = e("ScanLineIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D7 = e("ScanQrCodeIcon", [
  ["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4", key: "uk4fdo" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M17 8V7", key: "q2g9wo" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1", key: "m9kyts" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T7 = e("ScanSearchIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R7 = e("ScanTextIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O7 = e("ScanIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $7 = e("SchoolIcon", [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  [
    "path",
    {
      d: "m18 10 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.382a1 1 0 0 1 .553-.894L6 10",
      key: "1xqip1"
    }
  ],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 7.106-3.553a2 2 0 0 1 1.788 0L20 6", key: "9d2mlk" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E7 = e("ScissorsLineDashedIcon", [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U7 = e("ScissorsIcon", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z7 = e("ScreenShareOffIcon", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N7 = e("ScreenShareIcon", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W7 = e("ScrollTextIcon", [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G7 = e("ScrollIcon", [
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X7 = e("SearchCheckIcon", [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K7 = e("SearchCodeIcon", [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J7 = e("SearchSlashIcon", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q7 = e("SearchXIcon", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y7 = e("SearchIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _7 = e("SectionIcon", [
  ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0", key: "vqan6v" }],
  ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0", key: "wdjd8o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ca = e("SendHorizontalIcon", [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e9 = e("SendToBackIcon", [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t9 = e("SendIcon", [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a9 = e("SeparatorHorizontalIcon", [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o9 = e("SeparatorVerticalIcon", [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c9 = e("ServerCogIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n9 = e("ServerCrashIcon", [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i9 = e("ServerOffIcon", [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r9 = e("ServerIcon", [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d9 = e("Settings2Icon", [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s9 = e("SettingsIcon", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l9 = e("ShapesIcon", [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h9 = e("Share2Icon", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y9 = e("ShareIcon", [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u9 = e("SheetIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p9 = e("ShellIcon", [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k9 = e("ShieldAlertIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M9 = e("ShieldBanIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f9 = e("ShieldCheckIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g9 = e("ShieldEllipsisIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m9 = e("ShieldHalfIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v9 = e("ShieldMinusIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x9 = e("ShieldOffIcon", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I9 = e("ShieldPlusIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w9 = e("ShieldQuestionIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const na = e("ShieldXIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C9 = e("ShieldIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L9 = e("ShipWheelIcon", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b9 = e("ShipIcon", [
  ["path", { d: "M12 10.189V14", key: "1p8cqu" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  [
    "path",
    {
      d: "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76",
      key: "7tigtc"
    }
  ],
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "1924j5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S9 = e("ShirtIcon", [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q9 = e("ShoppingBagIcon", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z9 = e("ShoppingBasketIcon", [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A9 = e("ShoppingCartIcon", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H9 = e("ShovelIcon", [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P9 = e("ShowerHeadIcon", [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B9 = e("ShrinkIcon", [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V9 = e("ShrubIcon", [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  ["path", { d: "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z", key: "ubcgy" }],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F9 = e("ShuffleIcon", [
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22", key: "1ailkh" }],
  ["path", { d: "M2 6h1.972a4 4 0 0 1 3.6 2.2", key: "km57vx" }],
  ["path", { d: "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45", key: "os18l9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j9 = e("SigmaIcon", [
  [
    "path",
    {
      d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
      key: "wuwx1p"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D9 = e("SignalHighIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T9 = e("SignalLowIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R9 = e("SignalMediumIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O9 = e("SignalZeroIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $9 = e("SignalIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E9 = e("SignatureIcon", [
  [
    "path",
    {
      d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
      key: "y32ogt"
    }
  ],
  ["path", { d: "M3 21h18", key: "itz85i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U9 = e("SignpostBigIcon", [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z9 = e("SignpostIcon", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z",
      key: "gqqp9m"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N9 = e("SirenIcon", [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W9 = e("SkipBackIcon", [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G9 = e("SkipForwardIcon", [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X9 = e("SkullIcon", [
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  [
    "path",
    {
      d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
      key: "1o5pge"
    }
  ],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K9 = e("SlackIcon", [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J9 = e("SlashIcon", [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q9 = e("SliceIcon", [
  [
    "path",
    {
      d: "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14",
      key: "1sllp5"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y9 = e("SlidersHorizontalIcon", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ia = e("SlidersVerticalIcon", [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _9 = e("SmartphoneChargingIcon", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eM = e("SmartphoneNfcIcon", [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tM = e("SmartphoneIcon", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aM = e("SmilePlusIcon", [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oM = e("SmileIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cM = e("SnailIcon", [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nM = e("SnowflakeIcon", [
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "m20 16-4-4 4-4", key: "rquw4f" }],
  ["path", { d: "m4 8 4 4-4 4", key: "12s3z9" }],
  ["path", { d: "m16 4-4 4-4-4", key: "1tumq1" }],
  ["path", { d: "m8 20 4-4 4 4", key: "9p200w" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iM = e("SofaIcon", [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "xacw8m"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rM = e("SoupIcon", [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dM = e("SpaceIcon", [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sM = e("SpadeIcon", [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lM = e("SparkleIcon", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ra = e("SparklesIcon", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hM = e("SpeakerIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yM = e("SpeechIcon", [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uM = e("SpellCheck2Icon", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pM = e("SpellCheckIcon", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kM = e("SplineIcon", [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MM = e("SplitIcon", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fM = e("SprayCanIcon", [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gM = e("SproutIcon", [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const da = e("SquareActivityIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sa = e("SquareArrowDownLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const la = e("SquareArrowDownRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ha = e("SquareArrowDownIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ya = e("SquareArrowLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ua = e("SquareArrowOutDownLeftIcon", [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pa = e("SquareArrowOutDownRightIcon", [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ka = e("SquareArrowOutUpLeftIcon", [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ma = e("SquareArrowOutUpRightIcon", [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fa = e("SquareArrowRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ga = e("SquareArrowUpLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ma = e("SquareArrowUpRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const va = e("SquareArrowUpIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xa = e("SquareAsteriskIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ia = e("SquareBottomDashedScissorsIcon", [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qe = e("SquareChartGanttIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wa = e("SquareCheckBigIcon", [
  ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5", key: "1uzm8b" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ca = e("SquareCheckIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const La = e("SquareChevronDownIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ba = e("SquareChevronLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sa = e("SquareChevronRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qa = e("SquareChevronUpIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const za = e("SquareCodeIcon", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mM = e("SquareDashedBottomCodeIcon", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vM = e("SquareDashedBottomIcon", [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aa = e("SquareDashedKanbanIcon", [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ha = e("SquareDashedMousePointerIcon", [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pa = e("SquareDashedIcon", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ba = e("SquareDivideIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Va = e("SquareDotIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fa = e("SquareEqualIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ja = e("SquareFunctionIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Da = e("SquareKanbanIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ta = e("SquareLibraryIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ra = e("SquareMIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oa = e("SquareMenuIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $a = e("SquareMinusIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ea = e("SquareMousePointerIcon", [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ua = e("SquareParkingOffIcon", [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Za = e("SquareParkingIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ke = e("SquarePenIcon", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Na = e("SquarePercentIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wa = e("SquarePiIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ga = e("SquarePilcrowIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xa = e("SquarePlayIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ka = e("SquarePlusIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ja = e("SquarePowerIcon", [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xM = e("SquareRadicalIcon", [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qa = e("SquareScissorsIcon", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ya = e("SquareSigmaIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _a = e("SquareSlashIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e2 = e("SquareSplitHorizontalIcon", [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t2 = e("SquareSplitVerticalIcon", [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IM = e("SquareSquareIcon", [
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }],
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wM = e("SquareStackIcon", [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a2 = e("SquareTerminalIcon", [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o2 = e("SquareUserRoundIcon", [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c2 = e("SquareUserIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n2 = e("SquareXIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CM = e("SquareIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LM = e("SquircleIcon", [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bM = e("SquirrelIcon", [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SM = e("StampIcon", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qM = e("StarHalfIcon", [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zM = e("StarOffIcon", [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AM = e("StarIcon", [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HM = e("StepBackIcon", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PM = e("StepForwardIcon", [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BM = e("StethoscopeIcon", [
  ["path", { d: "M11 2v2", key: "1539x4" }],
  ["path", { d: "M5 2v2", key: "1yf1q8" }],
  ["path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1", key: "rb5t3r" }],
  ["path", { d: "M8 15a6 6 0 0 0 12 0v-3", key: "x18d4x" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VM = e("StickerIcon", [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h.01", key: "1sbv64" }],
  ["path", { d: "M16 13h.01", key: "wip0gl" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FM = e("StickyNoteIcon", [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jM = e("StoreIcon", [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
      key: "6c3vgh"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DM = e("StretchHorizontalIcon", [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TM = e("StretchVerticalIcon", [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RM = e("StrikethroughIcon", [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OM = e("SubscriptIcon", [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $M = e("SunDimIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EM = e("SunMediumIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UM = e("SunMoonIcon", [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZM = e("SunSnowIcon", [
  ["path", { d: "M10 9a3 3 0 1 0 0 6", key: "6zmtdl" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M14 21V3", key: "1llu3z" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "m17 4-3 3", key: "15jcng" }],
  ["path", { d: "m14 17 3 3", key: "6tlq38" }],
  ["path", { d: "m21 15-3-3 3-3", key: "1nlnje" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NM = e("SunIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WM = e("SunriseIcon", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GM = e("SunsetIcon", [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XM = e("SuperscriptIcon", [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KM = e("SwatchBookIcon", [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h.01", key: "1euzgo" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JM = e("SwissFrancIcon", [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QM = e("SwitchCameraIcon", [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YM = e("SwordIcon", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _M = e("SwordsIcon", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ef = e("SyringeIcon", [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tf = e("Table2Icon", [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const af = e("TableCellsMergeIcon", [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const of = e("TableCellsSplitIcon", [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cf = e("TableColumnsSplitIcon", [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nf = e("TableOfContentsIcon", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M21 12h.01", key: "msek7k" }],
  ["path", { d: "M21 18h.01", key: "1e8rq1" }],
  ["path", { d: "M21 6h.01", key: "1koanj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rf = e("TablePropertiesIcon", [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const df = e("TableRowsSplitIcon", [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sf = e("TableIcon", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lf = e("TabletSmartphoneIcon", [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hf = e("TabletIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yf = e("TabletsIcon", [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uf = e("TagIcon", [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pf = e("TagsIcon", [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kf = e("Tally1Icon", [["path", { d: "M4 4v16", key: "6qkkli" }]]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mf = e("Tally2Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ff = e("Tally3Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gf = e("Tally4Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mf = e("Tally5Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vf = e("TangentIcon", [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xf = e("TargetIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const If = e("TelescopeIcon", [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wf = e("TentTreeIcon", [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cf = e("TentIcon", [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lf = e("TerminalIcon", [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i2 = e("TestTubeDiagonalIcon", [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3", key: "1ub6xw" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bf = e("TestTubeIcon", [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sf = e("TestTubesIcon", [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2", key: "1hjrqt" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2", key: "16lc8n" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qf = e("TextCursorInputIcon", [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zf = e("TextCursorIcon", [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Af = e("TextQuoteIcon", [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hf = e("TextSearchIcon", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r2 = e("TextSelectIcon", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pf = e("TextIcon", [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bf = e("TheaterIcon", [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vf = e("ThermometerSnowflakeIcon", [
  ["path", { d: "M2 12h10", key: "19562f" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "m3 9 3 3-3 3", key: "1sas0l" }],
  ["path", { d: "M12 6 9 9 6 6", key: "pfrgxu" }],
  ["path", { d: "m6 18 3-3 1.5 1.5", key: "1e277p" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ff = e("ThermometerSunIcon", [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jf = e("ThermometerIcon", [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Df = e("ThumbsDownIcon", [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tf = e("ThumbsUpIcon", [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rf = e("TicketCheckIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Of = e("TicketMinusIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $f = e("TicketPercentIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ef = e("TicketPlusIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uf = e("TicketSlashIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zf = e("TicketXIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nf = e("TicketIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wf = e("TicketsPlaneIcon", [
  ["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12", key: "16muxl" }],
  ["path", { d: "m12 13.5 3.75.5", key: "1i9qhk" }],
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gf = e("TicketsIcon", [
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xf = e("TimerOffIcon", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kf = e("TimerResetIcon", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jf = e("TimerIcon", [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qf = e("ToggleLeftIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yf = e("ToggleRightIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _f = e("ToiletIcon", [
  [
    "path",
    {
      d: "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18",
      key: "kc4kqr"
    }
  ],
  ["path", { d: "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8", key: "1tqs57" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eg = e("TornadoIcon", [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tg = e("TorusIcon", [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ag = e("TouchpadOffIcon", [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const og = e("TouchpadIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cg = e("TowerControlIcon", [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ng = e("ToyBrickIcon", [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ig = e("TractorIcon", [
  ["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20", key: "she1j9" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246", key: "1q1ert" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rg = e("TrafficConeIcon", [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dg = e("TrainFrontTunnelIcon", [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sg = e("TrainFrontIcon", [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lg = e("TrainTrackIcon", [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d2 = e("TramFrontIcon", [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hg = e("Trash2Icon", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yg = e("TrashIcon", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ug = e("TreeDeciduousIcon", [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s2 = e("TreePalmIcon", [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pg = e("TreePineIcon", [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kg = e("TreesIcon", [
  ["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mg = e("TrelloIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fg = e("TrendingDownIcon", [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gg = e("TrendingUpDownIcon", [
  ["path", { d: "M14.828 14.828 21 21", key: "ar5fw7" }],
  ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
  ["path", { d: "m21 3-9 9-4-4-6 6", key: "1h02xo" }],
  ["path", { d: "M21 8V3h-5", key: "1qoq8a" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mg = e("TrendingUpIcon", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l2 = e("TriangleAlertIcon", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vg = e("TriangleRightIcon", [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xg = e("TriangleIcon", [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ig = e("TrophyIcon", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wg = e("TruckIcon", [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cg = e("TurtleIcon", [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lg = e("TvMinimalPlayIcon", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h2 = e("TvMinimalIcon", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bg = e("TvIcon", [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sg = e("TwitchIcon", [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qg = e("TwitterIcon", [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zg = e("TypeOutlineIcon", [
  [
    "path",
    {
      d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
      key: "1reda3"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ag = e("TypeIcon", [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hg = e("UmbrellaOffIcon", [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pg = e("UmbrellaIcon", [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bg = e("UnderlineIcon", [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vg = e("Undo2Icon", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fg = e("UndoDotIcon", [
  ["path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13", key: "8mp6z9" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jg = e("UndoIcon", [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dg = e("UnfoldHorizontalIcon", [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tg = e("UnfoldVerticalIcon", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rg = e("UngroupIcon", [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y2 = e("UniversityIcon", [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "11g7fi" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Og = e("Unlink2Icon", [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $g = e("UnlinkIcon", [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eg = e("UnplugIcon", [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ug = e("UploadIcon", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zg = e("UsbIcon", [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ng = e("UserCheckIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wg = e("UserCogIcon", [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gg = e("UserMinusIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xg = e("UserPenIcon", [
  ["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2", key: "15lzij" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kg = e("UserPlusIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u2 = e("UserRoundCheckIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p2 = e("UserRoundCogIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k2 = e("UserRoundMinusIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jg = e("UserRoundPenIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 10.821-7.487", key: "1c8h7z" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M2 = e("UserRoundPlusIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qg = e("UserRoundSearchIcon", [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f2 = e("UserRoundXIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g2 = e("UserRoundIcon", [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yg = e("UserSearchIcon", [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _g = e("UserXIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const em = e("UserIcon", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m2 = e("UsersRoundIcon", [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tm = e("UsersIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v2 = e("UtensilsCrossedIcon", [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x2 = e("UtensilsIcon", [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "j28e5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const am = e("UtilityPoleIcon", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const om = e("VariableIcon", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cm = e("VaultIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nm = e("VeganIcon", [
  ["path", { d: "M16 8q6 0 6-6-6 0-6 6", key: "qsyyc4" }],
  ["path", { d: "M17.41 3.59a10 10 0 1 0 3 3", key: "41m9h7" }],
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const im = e("VenetianMaskIcon", [
  ["path", { d: "M18 11c-1.5 0-2.5.5-3 2", key: "1fod00" }],
  [
    "path",
    {
      d: "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z",
      key: "d70hit"
    }
  ],
  ["path", { d: "M6 11c1.5 0 2.5.5 3 2", key: "136fht" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rm = e("VibrateOffIcon", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dm = e("VibrateIcon", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sm = e("VideoOffIcon", [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lm = e("VideoIcon", [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hm = e("VideotapeIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ym = e("ViewIcon", [
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const um = e("VoicemailIcon", [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pm = e("VolleyballIcon", [
  ["path", { d: "M11.1 7.1a16.55 16.55 0 0 1 10.9 4", key: "2880wi" }],
  ["path", { d: "M12 12a12.6 12.6 0 0 1-8.7 5", key: "113sja" }],
  ["path", { d: "M16.8 13.6a16.55 16.55 0 0 1-9 7.5", key: "1qmsgl" }],
  ["path", { d: "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10", key: "1bmeqp" }],
  ["path", { d: "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5", key: "iekzv9" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const km = e("Volume1Icon", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mm = e("Volume2Icon", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }],
  ["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728", key: "ijwkga" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fm = e("VolumeOffIcon", [
  ["path", { d: "M16 9a5 5 0 0 1 .95 2.293", key: "1fgyg8" }],
  ["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96", key: "l3zxae" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
      key: "1gbwow"
    }
  ],
  ["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686", key: "s2je0y" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gm = e("VolumeXIcon", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mm = e("VolumeIcon", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vm = e("VoteIcon", [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xm = e("WalletCardsIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I2 = e("WalletMinimalIcon", [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Im = e("WalletIcon", [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wm = e("WallpaperIcon", [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w2 = e("WandSparklesIcon", [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cm = e("WandIcon", [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lm = e("WarehouseIcon", [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bm = e("WashingMachineIcon", [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sm = e("WatchIcon", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qm = e("WavesLadderIcon", [
  ["path", { d: "M19 5a2 2 0 0 0-2 2v11", key: "s41o68" }],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ],
  ["path", { d: "M7 13h10", key: "1rwob1" }],
  ["path", { d: "M7 9h10", key: "12czzb" }],
  ["path", { d: "M9 5a2 2 0 0 0-2 2v11", key: "x0q4gh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zm = e("WavesIcon", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Am = e("WaypointsIcon", [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hm = e("WebcamIcon", [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pm = e("WebhookOffIcon", [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bm = e("WebhookIcon", [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vm = e("WeightIcon", [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fm = e("WheatOffIcon", [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jm = e("WheatIcon", [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dm = e("WholeWordIcon", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tm = e("WifiHighIcon", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rm = e("WifiLowIcon", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Om = e("WifiOffIcon", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $m = e("WifiZeroIcon", [["path", { d: "M12 20h.01", key: "zekei9" }]]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Em = e("WifiIcon", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Um = e("WindArrowDownIcon", [
  ["path", { d: "M10 2v8", key: "d4bbey" }],
  ["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2", key: "19kp1d" }],
  ["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2", key: "19kpjc" }],
  ["path", { d: "m6 6 4 4 4-4", key: "k13n16" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zm = e("WindIcon", [
  ["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2", key: "148xed" }],
  ["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2", key: "1u4tom" }],
  ["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2", key: "75valh" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nm = e("WineOffIcon", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wm = e("WineIcon", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gm = e("WorkflowIcon", [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xm = e("WormIcon", [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Km = e("WrapTextIcon", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jm = e("WrenchIcon", [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qm = e("XIcon", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ym = e("YoutubeIcon", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _m = e("ZapOffIcon", [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ev = e("ZapIcon", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tv = e("ZoomInIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const av = e("ZoomOutIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: ao,
  AArrowUp: oo,
  ALargeSmall: co,
  Accessibility: no,
  Activity: io,
  AirVent: ro,
  Airplay: so,
  AlarmClock: ho,
  AlarmClockCheck: Xe,
  AlarmClockMinus: Ke,
  AlarmClockOff: lo,
  AlarmClockPlus: Je,
  AlarmSmoke: yo,
  Album: uo,
  AlignCenter: Mo,
  AlignCenterHorizontal: po,
  AlignCenterVertical: ko,
  AlignEndHorizontal: fo,
  AlignEndVertical: go,
  AlignHorizontalDistributeCenter: mo,
  AlignHorizontalDistributeEnd: vo,
  AlignHorizontalDistributeStart: xo,
  AlignHorizontalJustifyCenter: Io,
  AlignHorizontalJustifyEnd: wo,
  AlignHorizontalJustifyStart: Co,
  AlignHorizontalSpaceAround: Lo,
  AlignHorizontalSpaceBetween: bo,
  AlignJustify: So,
  AlignLeft: qo,
  AlignRight: zo,
  AlignStartHorizontal: Ao,
  AlignStartVertical: Ho,
  AlignVerticalDistributeCenter: Po,
  AlignVerticalDistributeEnd: Bo,
  AlignVerticalDistributeStart: Vo,
  AlignVerticalJustifyCenter: Fo,
  AlignVerticalJustifyEnd: jo,
  AlignVerticalJustifyStart: Do,
  AlignVerticalSpaceAround: To,
  AlignVerticalSpaceBetween: Ro,
  Ambulance: Oo,
  Ampersand: $o,
  Ampersands: Eo,
  Amphora: Uo,
  Anchor: Zo,
  Angry: No,
  Annoyed: Wo,
  Antenna: Go,
  Anvil: Xo,
  Aperture: Ko,
  AppWindow: Qo,
  AppWindowMac: Jo,
  Apple: Yo,
  Archive: tc,
  ArchiveRestore: _o,
  ArchiveX: ec,
  Armchair: ac,
  ArrowBigDown: cc,
  ArrowBigDownDash: oc,
  ArrowBigLeft: ic,
  ArrowBigLeftDash: nc,
  ArrowBigRight: dc,
  ArrowBigRightDash: rc,
  ArrowBigUp: lc,
  ArrowBigUpDash: sc,
  ArrowDown: vc,
  ArrowDown01: hc,
  ArrowDown10: yc,
  ArrowDownAZ: Qe,
  ArrowDownFromLine: uc,
  ArrowDownLeft: pc,
  ArrowDownNarrowWide: kc,
  ArrowDownRight: Mc,
  ArrowDownToDot: fc,
  ArrowDownToLine: gc,
  ArrowDownUp: mc,
  ArrowDownWideNarrow: Ye,
  ArrowDownZA: _e,
  ArrowLeft: Cc,
  ArrowLeftFromLine: xc,
  ArrowLeftRight: Ic,
  ArrowLeftToLine: wc,
  ArrowRight: qc,
  ArrowRightFromLine: Lc,
  ArrowRightLeft: bc,
  ArrowRightToLine: Sc,
  ArrowUp: Tc,
  ArrowUp01: zc,
  ArrowUp10: Ac,
  ArrowUpAZ: e1,
  ArrowUpDown: Hc,
  ArrowUpFromDot: Pc,
  ArrowUpFromLine: Bc,
  ArrowUpLeft: Vc,
  ArrowUpNarrowWide: t1,
  ArrowUpRight: Fc,
  ArrowUpToLine: jc,
  ArrowUpWideNarrow: Dc,
  ArrowUpZA: a1,
  ArrowsUpFromLine: Rc,
  Asterisk: Oc,
  AtSign: $c,
  Atom: Ec,
  AudioLines: Uc,
  AudioWaveform: Zc,
  Award: Nc,
  Axe: Wc,
  Axis3d: o1,
  Baby: Gc,
  Backpack: Xc,
  Badge: hn,
  BadgeAlert: Kc,
  BadgeCent: Jc,
  BadgeCheck: c1,
  BadgeDollarSign: Qc,
  BadgeEuro: Yc,
  BadgeHelp: _c,
  BadgeIndianRupee: en,
  BadgeInfo: tn,
  BadgeJapaneseYen: an,
  BadgeMinus: on,
  BadgePercent: cn,
  BadgePlus: nn,
  BadgePoundSterling: rn,
  BadgeRussianRuble: dn,
  BadgeSwissFranc: sn,
  BadgeX: ln,
  BaggageClaim: yn,
  Ban: un,
  Banana: pn,
  Bandage: kn,
  Banknote: Mn,
  Barcode: fn,
  Baseline: gn,
  Bath: mn,
  Battery: Ln,
  BatteryCharging: vn,
  BatteryFull: xn,
  BatteryLow: In,
  BatteryMedium: wn,
  BatteryWarning: Cn,
  Beaker: bn,
  Bean: qn,
  BeanOff: Sn,
  Bed: Hn,
  BedDouble: zn,
  BedSingle: An,
  Beef: Pn,
  Beer: Vn,
  BeerOff: Bn,
  Bell: $n,
  BellDot: Fn,
  BellElectric: jn,
  BellMinus: Dn,
  BellOff: Tn,
  BellPlus: Rn,
  BellRing: On,
  BetweenHorizontalEnd: n1,
  BetweenHorizontalStart: i1,
  BetweenVerticalEnd: En,
  BetweenVerticalStart: Un,
  BicepsFlexed: Zn,
  Bike: Nn,
  Binary: Wn,
  Binoculars: Gn,
  Biohazard: Xn,
  Bird: Kn,
  Bitcoin: Jn,
  Blend: Qn,
  Blinds: Yn,
  Blocks: _n,
  Bluetooth: o0,
  BluetoothConnected: e0,
  BluetoothOff: t0,
  BluetoothSearching: a0,
  Bold: c0,
  Bolt: n0,
  Bomb: i0,
  Bone: r0,
  Book: A0,
  BookA: d0,
  BookAudio: s0,
  BookCheck: l0,
  BookCopy: h0,
  BookDashed: r1,
  BookDown: y0,
  BookHeadphones: u0,
  BookHeart: p0,
  BookImage: k0,
  BookKey: M0,
  BookLock: f0,
  BookMarked: g0,
  BookMinus: m0,
  BookOpen: I0,
  BookOpenCheck: v0,
  BookOpenText: x0,
  BookPlus: w0,
  BookText: C0,
  BookType: L0,
  BookUp: S0,
  BookUp2: b0,
  BookUser: q0,
  BookX: z0,
  Bookmark: F0,
  BookmarkCheck: H0,
  BookmarkMinus: P0,
  BookmarkPlus: B0,
  BookmarkX: V0,
  BoomBox: j0,
  Bot: R0,
  BotMessageSquare: D0,
  BotOff: T0,
  Box: O0,
  Boxes: $0,
  Braces: d1,
  Brackets: E0,
  Brain: N0,
  BrainCircuit: U0,
  BrainCog: Z0,
  BrickWall: W0,
  Briefcase: J0,
  BriefcaseBusiness: G0,
  BriefcaseConveyorBelt: X0,
  BriefcaseMedical: K0,
  BringToFront: Q0,
  Brush: Y0,
  Bug: ti,
  BugOff: _0,
  BugPlay: ei,
  Building: oi,
  Building2: ai,
  Bus: ni,
  BusFront: ci,
  Cable: ri,
  CableCar: ii,
  Cake: si,
  CakeSlice: di,
  Calculator: li,
  Calendar: Hi,
  Calendar1: hi,
  CalendarArrowDown: yi,
  CalendarArrowUp: ui,
  CalendarCheck: ki,
  CalendarCheck2: pi,
  CalendarClock: Mi,
  CalendarCog: fi,
  CalendarDays: gi,
  CalendarFold: mi,
  CalendarHeart: vi,
  CalendarMinus: Ii,
  CalendarMinus2: xi,
  CalendarOff: wi,
  CalendarPlus: Li,
  CalendarPlus2: Ci,
  CalendarRange: bi,
  CalendarSearch: Si,
  CalendarSync: qi,
  CalendarX: Ai,
  CalendarX2: zi,
  Camera: Bi,
  CameraOff: Pi,
  Candy: ji,
  CandyCane: Vi,
  CandyOff: Fi,
  Cannabis: Di,
  Captions: s1,
  CaptionsOff: Ti,
  Car: $i,
  CarFront: Ri,
  CarTaxiFront: Oi,
  Caravan: Ei,
  Carrot: Ui,
  CaseLower: Zi,
  CaseSensitive: Ni,
  CaseUpper: Wi,
  CassetteTape: Gi,
  Cast: Xi,
  Castle: Ki,
  Cat: Ji,
  Cctv: Qi,
  ChartArea: l1,
  ChartBar: y1,
  ChartBarBig: h1,
  ChartBarDecreasing: Yi,
  ChartBarIncreasing: _i,
  ChartBarStacked: er,
  ChartCandlestick: u1,
  ChartColumn: M1,
  ChartColumnBig: p1,
  ChartColumnDecreasing: tr,
  ChartColumnIncreasing: k1,
  ChartColumnStacked: ar,
  ChartGantt: or,
  ChartLine: f1,
  ChartNetwork: cr,
  ChartNoAxesColumn: m1,
  ChartNoAxesColumnDecreasing: nr,
  ChartNoAxesColumnIncreasing: g1,
  ChartNoAxesCombined: ir,
  ChartNoAxesGantt: v1,
  ChartPie: x1,
  ChartScatter: I1,
  ChartSpline: rr,
  Check: sr,
  CheckCheck: dr,
  ChefHat: lr,
  Cherry: hr,
  ChevronDown: N2,
  ChevronFirst: yr,
  ChevronLast: ur,
  ChevronLeft: pr,
  ChevronRight: kr,
  ChevronUp: Mr,
  ChevronsDown: gr,
  ChevronsDownUp: fr,
  ChevronsLeft: xr,
  ChevronsLeftRight: vr,
  ChevronsLeftRightEllipsis: mr,
  ChevronsRight: wr,
  ChevronsRightLeft: Ir,
  ChevronsUp: Lr,
  ChevronsUpDown: Cr,
  Chrome: br,
  Church: Sr,
  Cigarette: zr,
  CigaretteOff: qr,
  Circle: Or,
  CircleAlert: w1,
  CircleArrowDown: C1,
  CircleArrowLeft: L1,
  CircleArrowOutDownLeft: b1,
  CircleArrowOutDownRight: S1,
  CircleArrowOutUpLeft: q1,
  CircleArrowOutUpRight: z1,
  CircleArrowRight: A1,
  CircleArrowUp: H1,
  CircleCheck: B1,
  CircleCheckBig: P1,
  CircleChevronDown: V1,
  CircleChevronLeft: F1,
  CircleChevronRight: j1,
  CircleChevronUp: D1,
  CircleDashed: Ar,
  CircleDivide: T1,
  CircleDollarSign: Hr,
  CircleDot: Br,
  CircleDotDashed: Pr,
  CircleEllipsis: Vr,
  CircleEqual: Fr,
  CircleFadingArrowUp: jr,
  CircleFadingPlus: Dr,
  CircleGauge: R1,
  CircleHelp: O1,
  CircleMinus: $1,
  CircleOff: Tr,
  CircleParking: U1,
  CircleParkingOff: E1,
  CirclePause: Z1,
  CirclePercent: N1,
  CirclePlay: W1,
  CirclePlus: G1,
  CirclePower: X1,
  CircleSlash: Rr,
  CircleSlash2: K1,
  CircleStop: J1,
  CircleUser: Y1,
  CircleUserRound: Q1,
  CircleX: _1,
  CircuitBoard: $r,
  Citrus: Er,
  Clapperboard: Ur,
  Clipboard: Yr,
  ClipboardCheck: Zr,
  ClipboardCopy: Nr,
  ClipboardList: Wr,
  ClipboardMinus: Gr,
  ClipboardPaste: Xr,
  ClipboardPen: tt,
  ClipboardPenLine: et,
  ClipboardPlus: Kr,
  ClipboardType: Jr,
  ClipboardX: Qr,
  Clock: pd,
  Clock1: _r,
  Clock10: ed,
  Clock11: td,
  Clock12: ad,
  Clock2: od,
  Clock3: cd,
  Clock4: nd,
  Clock5: id,
  Clock6: rd,
  Clock7: dd,
  Clock8: sd,
  Clock9: ld,
  ClockAlert: hd,
  ClockArrowDown: yd,
  ClockArrowUp: ud,
  Cloud: zd,
  CloudAlert: kd,
  CloudCog: Md,
  CloudDownload: at,
  CloudDrizzle: fd,
  CloudFog: gd,
  CloudHail: md,
  CloudLightning: vd,
  CloudMoon: Id,
  CloudMoonRain: xd,
  CloudOff: wd,
  CloudRain: Ld,
  CloudRainWind: Cd,
  CloudSnow: bd,
  CloudSun: qd,
  CloudSunRain: Sd,
  CloudUpload: ot,
  Cloudy: Ad,
  Clover: Hd,
  Club: Pd,
  Code: Bd,
  CodeXml: ct,
  Codepen: Vd,
  Codesandbox: Fd,
  Coffee: jd,
  Cog: Dd,
  Coins: Td,
  Columns2: nt,
  Columns3: it,
  Columns4: Rd,
  Combine: Od,
  Command: $d,
  Compass: Ed,
  Component: Ud,
  Computer: Zd,
  ConciergeBell: Nd,
  Cone: Wd,
  Construction: Gd,
  Contact: Xd,
  ContactRound: rt,
  Container: Kd,
  Contrast: Jd,
  Cookie: Qd,
  CookingPot: Yd,
  Copy: cs,
  CopyCheck: _d,
  CopyMinus: es,
  CopyPlus: ts,
  CopySlash: as,
  CopyX: os,
  Copyleft: ns,
  Copyright: is,
  CornerDownLeft: rs,
  CornerDownRight: ds,
  CornerLeftDown: ss,
  CornerLeftUp: ls,
  CornerRightDown: hs,
  CornerRightUp: ys,
  CornerUpLeft: us,
  CornerUpRight: ps,
  Cpu: ks,
  CreativeCommons: Ms,
  CreditCard: fs,
  Croissant: gs,
  Crop: ms,
  Cross: vs,
  Crosshair: xs,
  Crown: Is,
  Cuboid: ws,
  CupSoda: Cs,
  Currency: Ls,
  Cylinder: bs,
  Dam: Ss,
  Database: As,
  DatabaseBackup: qs,
  DatabaseZap: zs,
  Delete: Hs,
  Dessert: Ps,
  Diameter: Bs,
  Diamond: js,
  DiamondMinus: Vs,
  DiamondPercent: dt,
  DiamondPlus: Fs,
  Dice1: Ds,
  Dice2: Ts,
  Dice3: Rs,
  Dice4: Os,
  Dice5: $s,
  Dice6: Es,
  Dices: Us,
  Diff: Zs,
  Disc: Xs,
  Disc2: Ns,
  Disc3: Ws,
  DiscAlbum: Gs,
  Divide: Ks,
  Dna: Qs,
  DnaOff: Js,
  Dock: Ys,
  Dog: _s,
  DollarSign: el,
  Donut: tl,
  DoorClosed: al,
  DoorOpen: ol,
  Dot: cl,
  Download: nl,
  DraftingCompass: il,
  Drama: rl,
  Dribbble: dl,
  Drill: sl,
  Droplet: hl,
  DropletOff: ll,
  Droplets: yl,
  Drum: ul,
  Drumstick: pl,
  Dumbbell: kl,
  Ear: fl,
  EarOff: Ml,
  Earth: st,
  EarthLock: gl,
  Eclipse: ml,
  Egg: Il,
  EggFried: vl,
  EggOff: xl,
  Ellipsis: ht,
  EllipsisVertical: lt,
  Equal: Ll,
  EqualApproximately: wl,
  EqualNot: Cl,
  Eraser: bl,
  EthernetPort: Sl,
  Euro: ql,
  Expand: zl,
  ExternalLink: Al,
  Eye: Bl,
  EyeClosed: Hl,
  EyeOff: Pl,
  Facebook: Vl,
  Factory: Fl,
  Fan: jl,
  FastForward: Dl,
  Feather: Tl,
  Fence: Rl,
  FerrisWheel: Ol,
  Figma: $l,
  File: Th,
  FileArchive: El,
  FileAudio: Zl,
  FileAudio2: Ul,
  FileAxis3d: yt,
  FileBadge: Wl,
  FileBadge2: Nl,
  FileBox: Gl,
  FileChartColumn: pt,
  FileChartColumnIncreasing: ut,
  FileChartLine: kt,
  FileChartPie: Mt,
  FileCheck: Kl,
  FileCheck2: Xl,
  FileClock: Jl,
  FileCode: Yl,
  FileCode2: Ql,
  FileCog: ft,
  FileDiff: _l,
  FileDigit: eh,
  FileDown: th,
  FileHeart: ah,
  FileImage: oh,
  FileInput: ch,
  FileJson: ih,
  FileJson2: nh,
  FileKey: dh,
  FileKey2: rh,
  FileLock: lh,
  FileLock2: sh,
  FileMinus: yh,
  FileMinus2: hh,
  FileMusic: uh,
  FileOutput: ph,
  FilePen: mt,
  FilePenLine: gt,
  FilePlus: Mh,
  FilePlus2: kh,
  FileQuestion: fh,
  FileScan: gh,
  FileSearch: vh,
  FileSearch2: mh,
  FileSliders: xh,
  FileSpreadsheet: Ih,
  FileStack: wh,
  FileSymlink: Ch,
  FileTerminal: Lh,
  FileText: bh,
  FileType: qh,
  FileType2: Sh,
  FileUp: zh,
  FileUser: Ah,
  FileVideo: Ph,
  FileVideo2: Hh,
  FileVolume: Vh,
  FileVolume2: Bh,
  FileWarning: Fh,
  FileX: Dh,
  FileX2: jh,
  Files: Rh,
  Film: Oh,
  Filter: Eh,
  FilterX: $h,
  Fingerprint: Uh,
  FireExtinguisher: Zh,
  Fish: Gh,
  FishOff: Nh,
  FishSymbol: Wh,
  Flag: Qh,
  FlagOff: Xh,
  FlagTriangleLeft: Kh,
  FlagTriangleRight: Jh,
  Flame: _h,
  FlameKindling: Yh,
  Flashlight: ty,
  FlashlightOff: ey,
  FlaskConical: oy,
  FlaskConicalOff: ay,
  FlaskRound: cy,
  FlipHorizontal: iy,
  FlipHorizontal2: ny,
  FlipVertical: dy,
  FlipVertical2: ry,
  Flower: ly,
  Flower2: sy,
  Focus: hy,
  FoldHorizontal: yy,
  FoldVertical: uy,
  Folder: $y,
  FolderArchive: py,
  FolderCheck: ky,
  FolderClock: My,
  FolderClosed: fy,
  FolderCode: gy,
  FolderCog: vt,
  FolderDot: my,
  FolderDown: vy,
  FolderGit: Iy,
  FolderGit2: xy,
  FolderHeart: wy,
  FolderInput: Cy,
  FolderKanban: Ly,
  FolderKey: by,
  FolderLock: Sy,
  FolderMinus: qy,
  FolderOpen: Ay,
  FolderOpenDot: zy,
  FolderOutput: Hy,
  FolderPen: xt,
  FolderPlus: Py,
  FolderRoot: By,
  FolderSearch: Fy,
  FolderSearch2: Vy,
  FolderSymlink: jy,
  FolderSync: Dy,
  FolderTree: Ty,
  FolderUp: Ry,
  FolderX: Oy,
  Folders: Ey,
  Footprints: Uy,
  Forklift: Zy,
  Forward: Ny,
  Frame: Wy,
  Framer: Gy,
  Frown: Xy,
  Fuel: Ky,
  Fullscreen: Jy,
  GalleryHorizontal: Yy,
  GalleryHorizontalEnd: Qy,
  GalleryThumbnails: _y,
  GalleryVertical: tu,
  GalleryVerticalEnd: eu,
  Gamepad: ou,
  Gamepad2: au,
  Gauge: cu,
  Gavel: nu,
  Gem: iu,
  Ghost: ru,
  Gift: du,
  GitBranch: lu,
  GitBranchPlus: su,
  GitCommitHorizontal: It,
  GitCommitVertical: hu,
  GitCompare: uu,
  GitCompareArrows: yu,
  GitFork: pu,
  GitGraph: ku,
  GitMerge: Mu,
  GitPullRequest: Iu,
  GitPullRequestArrow: fu,
  GitPullRequestClosed: gu,
  GitPullRequestCreate: vu,
  GitPullRequestCreateArrow: mu,
  GitPullRequestDraft: xu,
  Github: wu,
  Gitlab: Cu,
  GlassWater: Lu,
  Glasses: bu,
  Globe: qu,
  GlobeLock: Su,
  Goal: zu,
  Grab: Au,
  GraduationCap: Hu,
  Grape: Pu,
  Grid2x2: Ct,
  Grid2x2Check: Bu,
  Grid2x2Plus: wt,
  Grid2x2X: Vu,
  Grid3x3: Se,
  Grip: Du,
  GripHorizontal: Fu,
  GripVertical: ju,
  Group: Tu,
  Guitar: Ru,
  Ham: Ou,
  Hammer: $u,
  Hand: Wu,
  HandCoins: Eu,
  HandHeart: Uu,
  HandHelping: Lt,
  HandMetal: Zu,
  HandPlatter: Nu,
  Handshake: Gu,
  HardDrive: Ju,
  HardDriveDownload: Xu,
  HardDriveUpload: Ku,
  HardHat: Qu,
  Hash: Yu,
  Haze: _u,
  HdmiPort: ep,
  Heading: rp,
  Heading1: tp,
  Heading2: ap,
  Heading3: op,
  Heading4: cp,
  Heading5: np,
  Heading6: ip,
  HeadphoneOff: dp,
  Headphones: sp,
  Headset: lp,
  Heart: kp,
  HeartCrack: hp,
  HeartHandshake: yp,
  HeartOff: up,
  HeartPulse: pp,
  Heater: Mp,
  Hexagon: fp,
  Highlighter: gp,
  History: mp,
  Hop: xp,
  HopOff: vp,
  Hospital: Ip,
  Hotel: wp,
  Hourglass: Cp,
  House: bt,
  HousePlug: Lp,
  HousePlus: bp,
  IceCreamBowl: St,
  IceCreamCone: qt,
  IdCard: Sp,
  Image: Fp,
  ImageDown: qp,
  ImageMinus: zp,
  ImageOff: Ap,
  ImagePlay: Hp,
  ImagePlus: Pp,
  ImageUp: Bp,
  ImageUpscale: Vp,
  Images: jp,
  Import: Dp,
  Inbox: Tp,
  IndentDecrease: zt,
  IndentIncrease: At,
  IndianRupee: Rp,
  Infinity: Op,
  Info: $p,
  InspectionPanel: Ep,
  Instagram: Up,
  Italic: Zp,
  IterationCcw: Np,
  IterationCw: Wp,
  JapaneseYen: Gp,
  Joystick: Xp,
  Kanban: Kp,
  Key: Yp,
  KeyRound: Jp,
  KeySquare: Qp,
  Keyboard: t4,
  KeyboardMusic: _p,
  KeyboardOff: e4,
  Lamp: r4,
  LampCeiling: a4,
  LampDesk: o4,
  LampFloor: c4,
  LampWallDown: n4,
  LampWallUp: i4,
  LandPlot: d4,
  Landmark: s4,
  Languages: l4,
  Laptop: y4,
  LaptopMinimal: Ht,
  LaptopMinimalCheck: h4,
  Lasso: p4,
  LassoSelect: u4,
  Laugh: k4,
  Layers: Pt,
  Layers2: M4,
  LayoutDashboard: f4,
  LayoutGrid: g4,
  LayoutList: m4,
  LayoutPanelLeft: v4,
  LayoutPanelTop: x4,
  LayoutTemplate: I4,
  Leaf: w4,
  LeafyGreen: C4,
  Lectern: L4,
  LetterText: b4,
  Library: q4,
  LibraryBig: S4,
  LifeBuoy: z4,
  Ligature: A4,
  Lightbulb: P4,
  LightbulbOff: H4,
  Link: F4,
  Link2: V4,
  Link2Off: B4,
  Linkedin: j4,
  List: _4,
  ListCheck: D4,
  ListChecks: T4,
  ListCollapse: R4,
  ListEnd: O4,
  ListFilter: E4,
  ListFilterPlus: $4,
  ListMinus: U4,
  ListMusic: Z4,
  ListOrdered: N4,
  ListPlus: W4,
  ListRestart: G4,
  ListStart: X4,
  ListTodo: K4,
  ListTree: J4,
  ListVideo: Q4,
  ListX: Y4,
  Loader: tk,
  LoaderCircle: Bt,
  LoaderPinwheel: ek,
  Locate: ck,
  LocateFixed: ak,
  LocateOff: ok,
  Lock: ik,
  LockKeyhole: nk,
  LockKeyholeOpen: Vt,
  LockOpen: Ft,
  LogIn: rk,
  LogOut: dk,
  Logs: sk,
  Lollipop: lk,
  Luggage: hk,
  Magnet: yk,
  Mail: xk,
  MailCheck: uk,
  MailMinus: pk,
  MailOpen: kk,
  MailPlus: Mk,
  MailQuestion: fk,
  MailSearch: gk,
  MailWarning: mk,
  MailX: vk,
  Mailbox: Ik,
  Mails: wk,
  Map: jk,
  MapPin: Vk,
  MapPinCheck: Lk,
  MapPinCheckInside: Ck,
  MapPinHouse: bk,
  MapPinMinus: qk,
  MapPinMinusInside: Sk,
  MapPinOff: zk,
  MapPinPlus: Hk,
  MapPinPlusInside: Ak,
  MapPinX: Bk,
  MapPinXInside: Pk,
  MapPinned: Fk,
  Martini: Dk,
  Maximize: Rk,
  Maximize2: Tk,
  Medal: Ok,
  Megaphone: Ek,
  MegaphoneOff: $k,
  Meh: Uk,
  MemoryStick: Zk,
  Menu: Nk,
  Merge: Wk,
  MessageCircle: o5,
  MessageCircleCode: Gk,
  MessageCircleDashed: Xk,
  MessageCircleHeart: Kk,
  MessageCircleMore: Jk,
  MessageCircleOff: Qk,
  MessageCirclePlus: Yk,
  MessageCircleQuestion: _k,
  MessageCircleReply: e5,
  MessageCircleWarning: t5,
  MessageCircleX: a5,
  MessageSquare: m5,
  MessageSquareCode: c5,
  MessageSquareDashed: n5,
  MessageSquareDiff: i5,
  MessageSquareDot: r5,
  MessageSquareHeart: d5,
  MessageSquareLock: s5,
  MessageSquareMore: l5,
  MessageSquareOff: h5,
  MessageSquarePlus: y5,
  MessageSquareQuote: u5,
  MessageSquareReply: p5,
  MessageSquareShare: k5,
  MessageSquareText: M5,
  MessageSquareWarning: f5,
  MessageSquareX: g5,
  MessagesSquare: v5,
  Mic: I5,
  MicOff: x5,
  MicVocal: jt,
  Microchip: w5,
  Microscope: C5,
  Microwave: L5,
  Milestone: b5,
  Milk: q5,
  MilkOff: S5,
  Minimize: A5,
  Minimize2: z5,
  Minus: H5,
  Monitor: Z5,
  MonitorCheck: P5,
  MonitorCog: B5,
  MonitorDot: V5,
  MonitorDown: F5,
  MonitorOff: j5,
  MonitorPause: D5,
  MonitorPlay: T5,
  MonitorSmartphone: R5,
  MonitorSpeaker: O5,
  MonitorStop: $5,
  MonitorUp: E5,
  MonitorX: U5,
  Moon: W5,
  MoonStar: N5,
  Mountain: X5,
  MountainSnow: G5,
  Mouse: e3,
  MouseOff: K5,
  MousePointer: _5,
  MousePointer2: J5,
  MousePointerBan: Q5,
  MousePointerClick: Y5,
  Move: u3,
  Move3d: Dt,
  MoveDiagonal: a3,
  MoveDiagonal2: t3,
  MoveDown: n3,
  MoveDownLeft: o3,
  MoveDownRight: c3,
  MoveHorizontal: i3,
  MoveLeft: r3,
  MoveRight: d3,
  MoveUp: h3,
  MoveUpLeft: s3,
  MoveUpRight: l3,
  MoveVertical: y3,
  Music: f3,
  Music2: p3,
  Music3: k3,
  Music4: M3,
  Navigation: x3,
  Navigation2: m3,
  Navigation2Off: g3,
  NavigationOff: v3,
  Network: I3,
  Newspaper: w3,
  Nfc: C3,
  Notebook: q3,
  NotebookPen: L3,
  NotebookTabs: b3,
  NotebookText: S3,
  NotepadText: A3,
  NotepadTextDashed: z3,
  Nut: P3,
  NutOff: H3,
  Octagon: V3,
  OctagonAlert: Tt,
  OctagonMinus: B3,
  OctagonPause: Rt,
  OctagonX: Ot,
  Omega: F3,
  Option: j3,
  Orbit: D3,
  Origami: T3,
  Package: W3,
  Package2: R3,
  PackageCheck: O3,
  PackageMinus: $3,
  PackageOpen: E3,
  PackagePlus: U3,
  PackageSearch: Z3,
  PackageX: N3,
  PaintBucket: G3,
  PaintRoller: X3,
  Paintbrush: K3,
  PaintbrushVertical: $t,
  Palette: J3,
  PanelBottom: _3,
  PanelBottomClose: Q3,
  PanelBottomDashed: Et,
  PanelBottomOpen: Y3,
  PanelLeft: Wt,
  PanelLeftClose: Ut,
  PanelLeftDashed: Zt,
  PanelLeftOpen: Nt,
  PanelRight: a6,
  PanelRightClose: e6,
  PanelRightDashed: Gt,
  PanelRightOpen: t6,
  PanelTop: n6,
  PanelTopClose: o6,
  PanelTopDashed: Xt,
  PanelTopOpen: c6,
  PanelsLeftBottom: i6,
  PanelsRightBottom: r6,
  PanelsTopLeft: Kt,
  Paperclip: d6,
  Parentheses: s6,
  ParkingMeter: l6,
  PartyPopper: h6,
  Pause: y6,
  PawPrint: u6,
  PcCase: p6,
  Pen: Qt,
  PenLine: Jt,
  PenOff: k6,
  PenTool: M6,
  Pencil: v6,
  PencilLine: f6,
  PencilOff: g6,
  PencilRuler: m6,
  Pentagon: x6,
  Percent: I6,
  PersonStanding: w6,
  PhilippinePeso: C6,
  Phone: H6,
  PhoneCall: L6,
  PhoneForwarded: b6,
  PhoneIncoming: S6,
  PhoneMissed: q6,
  PhoneOff: z6,
  PhoneOutgoing: A6,
  Pi: P6,
  Piano: B6,
  Pickaxe: V6,
  PictureInPicture: j6,
  PictureInPicture2: F6,
  PiggyBank: D6,
  Pilcrow: O6,
  PilcrowLeft: T6,
  PilcrowRight: R6,
  Pill: E6,
  PillBottle: $6,
  Pin: Z6,
  PinOff: U6,
  Pipette: N6,
  Pizza: W6,
  Plane: K6,
  PlaneLanding: G6,
  PlaneTakeoff: X6,
  Play: J6,
  Plug: Y6,
  Plug2: Q6,
  PlugZap: Yt,
  Plus: _6,
  Pocket: t8,
  PocketKnife: e8,
  Podcast: a8,
  Pointer: c8,
  PointerOff: o8,
  Popcorn: n8,
  Popsicle: i8,
  PoundSterling: r8,
  Power: s8,
  PowerOff: d8,
  Presentation: l8,
  Printer: y8,
  PrinterCheck: h8,
  Projector: u8,
  Proportions: p8,
  Puzzle: k8,
  Pyramid: M8,
  QrCode: f8,
  Quote: g8,
  Rabbit: m8,
  Radar: v8,
  Radiation: x8,
  Radical: I8,
  Radio: L8,
  RadioReceiver: w8,
  RadioTower: C8,
  Radius: b8,
  RailSymbol: S8,
  Rainbow: q8,
  Rat: z8,
  Ratio: A8,
  Receipt: R8,
  ReceiptCent: H8,
  ReceiptEuro: P8,
  ReceiptIndianRupee: B8,
  ReceiptJapaneseYen: V8,
  ReceiptPoundSterling: F8,
  ReceiptRussianRuble: j8,
  ReceiptSwissFranc: D8,
  ReceiptText: T8,
  RectangleEllipsis: _t,
  RectangleHorizontal: O8,
  RectangleVertical: $8,
  Recycle: E8,
  Redo: N8,
  Redo2: U8,
  RedoDot: Z8,
  RefreshCcw: G8,
  RefreshCcwDot: W8,
  RefreshCw: K8,
  RefreshCwOff: X8,
  Refrigerator: J8,
  Regex: Q8,
  RemoveFormatting: Y8,
  Repeat: t7,
  Repeat1: _8,
  Repeat2: e7,
  Replace: o7,
  ReplaceAll: a7,
  Reply: n7,
  ReplyAll: c7,
  Rewind: i7,
  Ribbon: r7,
  Rocket: d7,
  RockingChair: s7,
  RollerCoaster: l7,
  Rotate3d: ea,
  RotateCcw: y7,
  RotateCcwSquare: h7,
  RotateCw: p7,
  RotateCwSquare: u7,
  Route: M7,
  RouteOff: k7,
  Router: f7,
  Rows2: ta,
  Rows3: aa,
  Rows4: g7,
  Rss: m7,
  Ruler: v7,
  RussianRuble: x7,
  Sailboat: I7,
  Salad: w7,
  Sandwich: C7,
  Satellite: b7,
  SatelliteDish: L7,
  Save: z7,
  SaveAll: S7,
  SaveOff: q7,
  Scale: A7,
  Scale3d: oa,
  Scaling: H7,
  Scan: O7,
  ScanBarcode: P7,
  ScanEye: B7,
  ScanFace: V7,
  ScanHeart: F7,
  ScanLine: j7,
  ScanQrCode: D7,
  ScanSearch: T7,
  ScanText: R7,
  School: $7,
  Scissors: U7,
  ScissorsLineDashed: E7,
  ScreenShare: N7,
  ScreenShareOff: Z7,
  Scroll: G7,
  ScrollText: W7,
  Search: Y7,
  SearchCheck: X7,
  SearchCode: K7,
  SearchSlash: J7,
  SearchX: Q7,
  Section: _7,
  Send: t9,
  SendHorizontal: ca,
  SendToBack: e9,
  SeparatorHorizontal: a9,
  SeparatorVertical: o9,
  Server: r9,
  ServerCog: c9,
  ServerCrash: n9,
  ServerOff: i9,
  Settings: s9,
  Settings2: d9,
  Shapes: l9,
  Share: y9,
  Share2: h9,
  Sheet: u9,
  Shell: p9,
  Shield: C9,
  ShieldAlert: k9,
  ShieldBan: M9,
  ShieldCheck: f9,
  ShieldEllipsis: g9,
  ShieldHalf: m9,
  ShieldMinus: v9,
  ShieldOff: x9,
  ShieldPlus: I9,
  ShieldQuestion: w9,
  ShieldX: na,
  Ship: b9,
  ShipWheel: L9,
  Shirt: S9,
  ShoppingBag: q9,
  ShoppingBasket: z9,
  ShoppingCart: A9,
  Shovel: H9,
  ShowerHead: P9,
  Shrink: B9,
  Shrub: V9,
  Shuffle: F9,
  Sigma: j9,
  Signal: $9,
  SignalHigh: D9,
  SignalLow: T9,
  SignalMedium: R9,
  SignalZero: O9,
  Signature: E9,
  Signpost: Z9,
  SignpostBig: U9,
  Siren: N9,
  SkipBack: W9,
  SkipForward: G9,
  Skull: X9,
  Slack: K9,
  Slash: J9,
  Slice: Q9,
  SlidersHorizontal: Y9,
  SlidersVertical: ia,
  Smartphone: tM,
  SmartphoneCharging: _9,
  SmartphoneNfc: eM,
  Smile: oM,
  SmilePlus: aM,
  Snail: cM,
  Snowflake: nM,
  Sofa: iM,
  Soup: rM,
  Space: dM,
  Spade: sM,
  Sparkle: lM,
  Sparkles: ra,
  Speaker: hM,
  Speech: yM,
  SpellCheck: pM,
  SpellCheck2: uM,
  Spline: kM,
  Split: MM,
  SprayCan: fM,
  Sprout: gM,
  Square: CM,
  SquareActivity: da,
  SquareArrowDown: ha,
  SquareArrowDownLeft: sa,
  SquareArrowDownRight: la,
  SquareArrowLeft: ya,
  SquareArrowOutDownLeft: ua,
  SquareArrowOutDownRight: pa,
  SquareArrowOutUpLeft: ka,
  SquareArrowOutUpRight: Ma,
  SquareArrowRight: fa,
  SquareArrowUp: va,
  SquareArrowUpLeft: ga,
  SquareArrowUpRight: ma,
  SquareAsterisk: xa,
  SquareBottomDashedScissors: Ia,
  SquareChartGantt: qe,
  SquareCheck: Ca,
  SquareCheckBig: wa,
  SquareChevronDown: La,
  SquareChevronLeft: ba,
  SquareChevronRight: Sa,
  SquareChevronUp: qa,
  SquareCode: za,
  SquareDashed: Pa,
  SquareDashedBottom: vM,
  SquareDashedBottomCode: mM,
  SquareDashedKanban: Aa,
  SquareDashedMousePointer: Ha,
  SquareDivide: Ba,
  SquareDot: Va,
  SquareEqual: Fa,
  SquareFunction: ja,
  SquareKanban: Da,
  SquareLibrary: Ta,
  SquareM: Ra,
  SquareMenu: Oa,
  SquareMinus: $a,
  SquareMousePointer: Ea,
  SquareParking: Za,
  SquareParkingOff: Ua,
  SquarePen: ke,
  SquarePercent: Na,
  SquarePi: Wa,
  SquarePilcrow: Ga,
  SquarePlay: Xa,
  SquarePlus: Ka,
  SquarePower: Ja,
  SquareRadical: xM,
  SquareScissors: Qa,
  SquareSigma: Ya,
  SquareSlash: _a,
  SquareSplitHorizontal: e2,
  SquareSplitVertical: t2,
  SquareSquare: IM,
  SquareStack: wM,
  SquareTerminal: a2,
  SquareUser: c2,
  SquareUserRound: o2,
  SquareX: n2,
  Squircle: LM,
  Squirrel: bM,
  Stamp: SM,
  Star: AM,
  StarHalf: qM,
  StarOff: zM,
  StepBack: HM,
  StepForward: PM,
  Stethoscope: BM,
  Sticker: VM,
  StickyNote: FM,
  Store: jM,
  StretchHorizontal: DM,
  StretchVertical: TM,
  Strikethrough: RM,
  Subscript: OM,
  Sun: NM,
  SunDim: $M,
  SunMedium: EM,
  SunMoon: UM,
  SunSnow: ZM,
  Sunrise: WM,
  Sunset: GM,
  Superscript: XM,
  SwatchBook: KM,
  SwissFranc: JM,
  SwitchCamera: QM,
  Sword: YM,
  Swords: _M,
  Syringe: ef,
  Table: sf,
  Table2: tf,
  TableCellsMerge: af,
  TableCellsSplit: of,
  TableColumnsSplit: cf,
  TableOfContents: nf,
  TableProperties: rf,
  TableRowsSplit: df,
  Tablet: hf,
  TabletSmartphone: lf,
  Tablets: yf,
  Tag: uf,
  Tags: pf,
  Tally1: kf,
  Tally2: Mf,
  Tally3: ff,
  Tally4: gf,
  Tally5: mf,
  Tangent: vf,
  Target: xf,
  Telescope: If,
  Tent: Cf,
  TentTree: wf,
  Terminal: Lf,
  TestTube: bf,
  TestTubeDiagonal: i2,
  TestTubes: Sf,
  Text: Pf,
  TextCursor: zf,
  TextCursorInput: qf,
  TextQuote: Af,
  TextSearch: Hf,
  TextSelect: r2,
  Theater: Bf,
  Thermometer: jf,
  ThermometerSnowflake: Vf,
  ThermometerSun: Ff,
  ThumbsDown: Df,
  ThumbsUp: Tf,
  Ticket: Nf,
  TicketCheck: Rf,
  TicketMinus: Of,
  TicketPercent: $f,
  TicketPlus: Ef,
  TicketSlash: Uf,
  TicketX: Zf,
  Tickets: Gf,
  TicketsPlane: Wf,
  Timer: Jf,
  TimerOff: Xf,
  TimerReset: Kf,
  ToggleLeft: Qf,
  ToggleRight: Yf,
  Toilet: _f,
  Tornado: eg,
  Torus: tg,
  Touchpad: og,
  TouchpadOff: ag,
  TowerControl: cg,
  ToyBrick: ng,
  Tractor: ig,
  TrafficCone: rg,
  TrainFront: sg,
  TrainFrontTunnel: dg,
  TrainTrack: lg,
  TramFront: d2,
  Trash: yg,
  Trash2: hg,
  TreeDeciduous: ug,
  TreePalm: s2,
  TreePine: pg,
  Trees: kg,
  Trello: Mg,
  TrendingDown: fg,
  TrendingUp: mg,
  TrendingUpDown: gg,
  Triangle: xg,
  TriangleAlert: l2,
  TriangleRight: vg,
  Trophy: Ig,
  Truck: wg,
  Turtle: Cg,
  Tv: bg,
  TvMinimal: h2,
  TvMinimalPlay: Lg,
  Twitch: Sg,
  Twitter: qg,
  Type: Ag,
  TypeOutline: zg,
  Umbrella: Pg,
  UmbrellaOff: Hg,
  Underline: Bg,
  Undo: jg,
  Undo2: Vg,
  UndoDot: Fg,
  UnfoldHorizontal: Dg,
  UnfoldVertical: Tg,
  Ungroup: Rg,
  University: y2,
  Unlink: $g,
  Unlink2: Og,
  Unplug: Eg,
  Upload: Ug,
  Usb: Zg,
  User: em,
  UserCheck: Ng,
  UserCog: Wg,
  UserMinus: Gg,
  UserPen: Xg,
  UserPlus: Kg,
  UserRound: g2,
  UserRoundCheck: u2,
  UserRoundCog: p2,
  UserRoundMinus: k2,
  UserRoundPen: Jg,
  UserRoundPlus: M2,
  UserRoundSearch: Qg,
  UserRoundX: f2,
  UserSearch: Yg,
  UserX: _g,
  Users: tm,
  UsersRound: m2,
  Utensils: x2,
  UtensilsCrossed: v2,
  UtilityPole: am,
  Variable: om,
  Vault: cm,
  Vegan: nm,
  VenetianMask: im,
  Vibrate: dm,
  VibrateOff: rm,
  Video: lm,
  VideoOff: sm,
  Videotape: hm,
  View: ym,
  Voicemail: um,
  Volleyball: pm,
  Volume: mm,
  Volume1: km,
  Volume2: Mm,
  VolumeOff: fm,
  VolumeX: gm,
  Vote: vm,
  Wallet: Im,
  WalletCards: xm,
  WalletMinimal: I2,
  Wallpaper: wm,
  Wand: Cm,
  WandSparkles: w2,
  Warehouse: Lm,
  WashingMachine: bm,
  Watch: Sm,
  Waves: zm,
  WavesLadder: qm,
  Waypoints: Am,
  Webcam: Hm,
  Webhook: Bm,
  WebhookOff: Pm,
  Weight: Vm,
  Wheat: jm,
  WheatOff: Fm,
  WholeWord: Dm,
  Wifi: Em,
  WifiHigh: Tm,
  WifiLow: Rm,
  WifiOff: Om,
  WifiZero: $m,
  Wind: Zm,
  WindArrowDown: Um,
  Wine: Wm,
  WineOff: Nm,
  Workflow: Gm,
  Worm: Xm,
  WrapText: Km,
  Wrench: Jm,
  X: Qm,
  Youtube: Ym,
  Zap: ev,
  ZapOff: _m,
  ZoomIn: tv,
  ZoomOut: av
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license lucide-vue-next v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: ao,
  AArrowDownIcon: ao,
  AArrowUp: oo,
  AArrowUpIcon: oo,
  ALargeSmall: co,
  ALargeSmallIcon: co,
  Accessibility: no,
  AccessibilityIcon: no,
  Activity: io,
  ActivityIcon: io,
  ActivitySquare: da,
  ActivitySquareIcon: da,
  AirVent: ro,
  AirVentIcon: ro,
  Airplay: so,
  AirplayIcon: so,
  AlarmCheck: Xe,
  AlarmCheckIcon: Xe,
  AlarmClock: ho,
  AlarmClockCheck: Xe,
  AlarmClockCheckIcon: Xe,
  AlarmClockIcon: ho,
  AlarmClockMinus: Ke,
  AlarmClockMinusIcon: Ke,
  AlarmClockOff: lo,
  AlarmClockOffIcon: lo,
  AlarmClockPlus: Je,
  AlarmClockPlusIcon: Je,
  AlarmMinus: Ke,
  AlarmMinusIcon: Ke,
  AlarmPlus: Je,
  AlarmPlusIcon: Je,
  AlarmSmoke: yo,
  AlarmSmokeIcon: yo,
  Album: uo,
  AlbumIcon: uo,
  AlertCircle: w1,
  AlertCircleIcon: w1,
  AlertOctagon: Tt,
  AlertOctagonIcon: Tt,
  AlertTriangle: l2,
  AlertTriangleIcon: l2,
  AlignCenter: Mo,
  AlignCenterHorizontal: po,
  AlignCenterHorizontalIcon: po,
  AlignCenterIcon: Mo,
  AlignCenterVertical: ko,
  AlignCenterVerticalIcon: ko,
  AlignEndHorizontal: fo,
  AlignEndHorizontalIcon: fo,
  AlignEndVertical: go,
  AlignEndVerticalIcon: go,
  AlignHorizontalDistributeCenter: mo,
  AlignHorizontalDistributeCenterIcon: mo,
  AlignHorizontalDistributeEnd: vo,
  AlignHorizontalDistributeEndIcon: vo,
  AlignHorizontalDistributeStart: xo,
  AlignHorizontalDistributeStartIcon: xo,
  AlignHorizontalJustifyCenter: Io,
  AlignHorizontalJustifyCenterIcon: Io,
  AlignHorizontalJustifyEnd: wo,
  AlignHorizontalJustifyEndIcon: wo,
  AlignHorizontalJustifyStart: Co,
  AlignHorizontalJustifyStartIcon: Co,
  AlignHorizontalSpaceAround: Lo,
  AlignHorizontalSpaceAroundIcon: Lo,
  AlignHorizontalSpaceBetween: bo,
  AlignHorizontalSpaceBetweenIcon: bo,
  AlignJustify: So,
  AlignJustifyIcon: So,
  AlignLeft: qo,
  AlignLeftIcon: qo,
  AlignRight: zo,
  AlignRightIcon: zo,
  AlignStartHorizontal: Ao,
  AlignStartHorizontalIcon: Ao,
  AlignStartVertical: Ho,
  AlignStartVerticalIcon: Ho,
  AlignVerticalDistributeCenter: Po,
  AlignVerticalDistributeCenterIcon: Po,
  AlignVerticalDistributeEnd: Bo,
  AlignVerticalDistributeEndIcon: Bo,
  AlignVerticalDistributeStart: Vo,
  AlignVerticalDistributeStartIcon: Vo,
  AlignVerticalJustifyCenter: Fo,
  AlignVerticalJustifyCenterIcon: Fo,
  AlignVerticalJustifyEnd: jo,
  AlignVerticalJustifyEndIcon: jo,
  AlignVerticalJustifyStart: Do,
  AlignVerticalJustifyStartIcon: Do,
  AlignVerticalSpaceAround: To,
  AlignVerticalSpaceAroundIcon: To,
  AlignVerticalSpaceBetween: Ro,
  AlignVerticalSpaceBetweenIcon: Ro,
  Ambulance: Oo,
  AmbulanceIcon: Oo,
  Ampersand: $o,
  AmpersandIcon: $o,
  Ampersands: Eo,
  AmpersandsIcon: Eo,
  Amphora: Uo,
  AmphoraIcon: Uo,
  Anchor: Zo,
  AnchorIcon: Zo,
  Angry: No,
  AngryIcon: No,
  Annoyed: Wo,
  AnnoyedIcon: Wo,
  Antenna: Go,
  AntennaIcon: Go,
  Anvil: Xo,
  AnvilIcon: Xo,
  Aperture: Ko,
  ApertureIcon: Ko,
  AppWindow: Qo,
  AppWindowIcon: Qo,
  AppWindowMac: Jo,
  AppWindowMacIcon: Jo,
  Apple: Yo,
  AppleIcon: Yo,
  Archive: tc,
  ArchiveIcon: tc,
  ArchiveRestore: _o,
  ArchiveRestoreIcon: _o,
  ArchiveX: ec,
  ArchiveXIcon: ec,
  AreaChart: l1,
  AreaChartIcon: l1,
  Armchair: ac,
  ArmchairIcon: ac,
  ArrowBigDown: cc,
  ArrowBigDownDash: oc,
  ArrowBigDownDashIcon: oc,
  ArrowBigDownIcon: cc,
  ArrowBigLeft: ic,
  ArrowBigLeftDash: nc,
  ArrowBigLeftDashIcon: nc,
  ArrowBigLeftIcon: ic,
  ArrowBigRight: dc,
  ArrowBigRightDash: rc,
  ArrowBigRightDashIcon: rc,
  ArrowBigRightIcon: dc,
  ArrowBigUp: lc,
  ArrowBigUpDash: sc,
  ArrowBigUpDashIcon: sc,
  ArrowBigUpIcon: lc,
  ArrowDown: vc,
  ArrowDown01: hc,
  ArrowDown01Icon: hc,
  ArrowDown10: yc,
  ArrowDown10Icon: yc,
  ArrowDownAZ: Qe,
  ArrowDownAZIcon: Qe,
  ArrowDownAz: Qe,
  ArrowDownAzIcon: Qe,
  ArrowDownCircle: C1,
  ArrowDownCircleIcon: C1,
  ArrowDownFromLine: uc,
  ArrowDownFromLineIcon: uc,
  ArrowDownIcon: vc,
  ArrowDownLeft: pc,
  ArrowDownLeftFromCircle: b1,
  ArrowDownLeftFromCircleIcon: b1,
  ArrowDownLeftFromSquare: ua,
  ArrowDownLeftFromSquareIcon: ua,
  ArrowDownLeftIcon: pc,
  ArrowDownLeftSquare: sa,
  ArrowDownLeftSquareIcon: sa,
  ArrowDownNarrowWide: kc,
  ArrowDownNarrowWideIcon: kc,
  ArrowDownRight: Mc,
  ArrowDownRightFromCircle: S1,
  ArrowDownRightFromCircleIcon: S1,
  ArrowDownRightFromSquare: pa,
  ArrowDownRightFromSquareIcon: pa,
  ArrowDownRightIcon: Mc,
  ArrowDownRightSquare: la,
  ArrowDownRightSquareIcon: la,
  ArrowDownSquare: ha,
  ArrowDownSquareIcon: ha,
  ArrowDownToDot: fc,
  ArrowDownToDotIcon: fc,
  ArrowDownToLine: gc,
  ArrowDownToLineIcon: gc,
  ArrowDownUp: mc,
  ArrowDownUpIcon: mc,
  ArrowDownWideNarrow: Ye,
  ArrowDownWideNarrowIcon: Ye,
  ArrowDownZA: _e,
  ArrowDownZAIcon: _e,
  ArrowDownZa: _e,
  ArrowDownZaIcon: _e,
  ArrowLeft: Cc,
  ArrowLeftCircle: L1,
  ArrowLeftCircleIcon: L1,
  ArrowLeftFromLine: xc,
  ArrowLeftFromLineIcon: xc,
  ArrowLeftIcon: Cc,
  ArrowLeftRight: Ic,
  ArrowLeftRightIcon: Ic,
  ArrowLeftSquare: ya,
  ArrowLeftSquareIcon: ya,
  ArrowLeftToLine: wc,
  ArrowLeftToLineIcon: wc,
  ArrowRight: qc,
  ArrowRightCircle: A1,
  ArrowRightCircleIcon: A1,
  ArrowRightFromLine: Lc,
  ArrowRightFromLineIcon: Lc,
  ArrowRightIcon: qc,
  ArrowRightLeft: bc,
  ArrowRightLeftIcon: bc,
  ArrowRightSquare: fa,
  ArrowRightSquareIcon: fa,
  ArrowRightToLine: Sc,
  ArrowRightToLineIcon: Sc,
  ArrowUp: Tc,
  ArrowUp01: zc,
  ArrowUp01Icon: zc,
  ArrowUp10: Ac,
  ArrowUp10Icon: Ac,
  ArrowUpAZ: e1,
  ArrowUpAZIcon: e1,
  ArrowUpAz: e1,
  ArrowUpAzIcon: e1,
  ArrowUpCircle: H1,
  ArrowUpCircleIcon: H1,
  ArrowUpDown: Hc,
  ArrowUpDownIcon: Hc,
  ArrowUpFromDot: Pc,
  ArrowUpFromDotIcon: Pc,
  ArrowUpFromLine: Bc,
  ArrowUpFromLineIcon: Bc,
  ArrowUpIcon: Tc,
  ArrowUpLeft: Vc,
  ArrowUpLeftFromCircle: q1,
  ArrowUpLeftFromCircleIcon: q1,
  ArrowUpLeftFromSquare: ka,
  ArrowUpLeftFromSquareIcon: ka,
  ArrowUpLeftIcon: Vc,
  ArrowUpLeftSquare: ga,
  ArrowUpLeftSquareIcon: ga,
  ArrowUpNarrowWide: t1,
  ArrowUpNarrowWideIcon: t1,
  ArrowUpRight: Fc,
  ArrowUpRightFromCircle: z1,
  ArrowUpRightFromCircleIcon: z1,
  ArrowUpRightFromSquare: Ma,
  ArrowUpRightFromSquareIcon: Ma,
  ArrowUpRightIcon: Fc,
  ArrowUpRightSquare: ma,
  ArrowUpRightSquareIcon: ma,
  ArrowUpSquare: va,
  ArrowUpSquareIcon: va,
  ArrowUpToLine: jc,
  ArrowUpToLineIcon: jc,
  ArrowUpWideNarrow: Dc,
  ArrowUpWideNarrowIcon: Dc,
  ArrowUpZA: a1,
  ArrowUpZAIcon: a1,
  ArrowUpZa: a1,
  ArrowUpZaIcon: a1,
  ArrowsUpFromLine: Rc,
  ArrowsUpFromLineIcon: Rc,
  Asterisk: Oc,
  AsteriskIcon: Oc,
  AsteriskSquare: xa,
  AsteriskSquareIcon: xa,
  AtSign: $c,
  AtSignIcon: $c,
  Atom: Ec,
  AtomIcon: Ec,
  AudioLines: Uc,
  AudioLinesIcon: Uc,
  AudioWaveform: Zc,
  AudioWaveformIcon: Zc,
  Award: Nc,
  AwardIcon: Nc,
  Axe: Wc,
  AxeIcon: Wc,
  Axis3D: o1,
  Axis3DIcon: o1,
  Axis3d: o1,
  Axis3dIcon: o1,
  Baby: Gc,
  BabyIcon: Gc,
  Backpack: Xc,
  BackpackIcon: Xc,
  Badge: hn,
  BadgeAlert: Kc,
  BadgeAlertIcon: Kc,
  BadgeCent: Jc,
  BadgeCentIcon: Jc,
  BadgeCheck: c1,
  BadgeCheckIcon: c1,
  BadgeDollarSign: Qc,
  BadgeDollarSignIcon: Qc,
  BadgeEuro: Yc,
  BadgeEuroIcon: Yc,
  BadgeHelp: _c,
  BadgeHelpIcon: _c,
  BadgeIcon: hn,
  BadgeIndianRupee: en,
  BadgeIndianRupeeIcon: en,
  BadgeInfo: tn,
  BadgeInfoIcon: tn,
  BadgeJapaneseYen: an,
  BadgeJapaneseYenIcon: an,
  BadgeMinus: on,
  BadgeMinusIcon: on,
  BadgePercent: cn,
  BadgePercentIcon: cn,
  BadgePlus: nn,
  BadgePlusIcon: nn,
  BadgePoundSterling: rn,
  BadgePoundSterlingIcon: rn,
  BadgeRussianRuble: dn,
  BadgeRussianRubleIcon: dn,
  BadgeSwissFranc: sn,
  BadgeSwissFrancIcon: sn,
  BadgeX: ln,
  BadgeXIcon: ln,
  BaggageClaim: yn,
  BaggageClaimIcon: yn,
  Ban: un,
  BanIcon: un,
  Banana: pn,
  BananaIcon: pn,
  Bandage: kn,
  BandageIcon: kn,
  Banknote: Mn,
  BanknoteIcon: Mn,
  BarChart: g1,
  BarChart2: m1,
  BarChart2Icon: m1,
  BarChart3: M1,
  BarChart3Icon: M1,
  BarChart4: k1,
  BarChart4Icon: k1,
  BarChartBig: p1,
  BarChartBigIcon: p1,
  BarChartHorizontal: y1,
  BarChartHorizontalBig: h1,
  BarChartHorizontalBigIcon: h1,
  BarChartHorizontalIcon: y1,
  BarChartIcon: g1,
  Barcode: fn,
  BarcodeIcon: fn,
  Baseline: gn,
  BaselineIcon: gn,
  Bath: mn,
  BathIcon: mn,
  Battery: Ln,
  BatteryCharging: vn,
  BatteryChargingIcon: vn,
  BatteryFull: xn,
  BatteryFullIcon: xn,
  BatteryIcon: Ln,
  BatteryLow: In,
  BatteryLowIcon: In,
  BatteryMedium: wn,
  BatteryMediumIcon: wn,
  BatteryWarning: Cn,
  BatteryWarningIcon: Cn,
  Beaker: bn,
  BeakerIcon: bn,
  Bean: qn,
  BeanIcon: qn,
  BeanOff: Sn,
  BeanOffIcon: Sn,
  Bed: Hn,
  BedDouble: zn,
  BedDoubleIcon: zn,
  BedIcon: Hn,
  BedSingle: An,
  BedSingleIcon: An,
  Beef: Pn,
  BeefIcon: Pn,
  Beer: Vn,
  BeerIcon: Vn,
  BeerOff: Bn,
  BeerOffIcon: Bn,
  Bell: $n,
  BellDot: Fn,
  BellDotIcon: Fn,
  BellElectric: jn,
  BellElectricIcon: jn,
  BellIcon: $n,
  BellMinus: Dn,
  BellMinusIcon: Dn,
  BellOff: Tn,
  BellOffIcon: Tn,
  BellPlus: Rn,
  BellPlusIcon: Rn,
  BellRing: On,
  BellRingIcon: On,
  BetweenHorizonalEnd: n1,
  BetweenHorizonalEndIcon: n1,
  BetweenHorizonalStart: i1,
  BetweenHorizonalStartIcon: i1,
  BetweenHorizontalEnd: n1,
  BetweenHorizontalEndIcon: n1,
  BetweenHorizontalStart: i1,
  BetweenHorizontalStartIcon: i1,
  BetweenVerticalEnd: En,
  BetweenVerticalEndIcon: En,
  BetweenVerticalStart: Un,
  BetweenVerticalStartIcon: Un,
  BicepsFlexed: Zn,
  BicepsFlexedIcon: Zn,
  Bike: Nn,
  BikeIcon: Nn,
  Binary: Wn,
  BinaryIcon: Wn,
  Binoculars: Gn,
  BinocularsIcon: Gn,
  Biohazard: Xn,
  BiohazardIcon: Xn,
  Bird: Kn,
  BirdIcon: Kn,
  Bitcoin: Jn,
  BitcoinIcon: Jn,
  Blend: Qn,
  BlendIcon: Qn,
  Blinds: Yn,
  BlindsIcon: Yn,
  Blocks: _n,
  BlocksIcon: _n,
  Bluetooth: o0,
  BluetoothConnected: e0,
  BluetoothConnectedIcon: e0,
  BluetoothIcon: o0,
  BluetoothOff: t0,
  BluetoothOffIcon: t0,
  BluetoothSearching: a0,
  BluetoothSearchingIcon: a0,
  Bold: c0,
  BoldIcon: c0,
  Bolt: n0,
  BoltIcon: n0,
  Bomb: i0,
  BombIcon: i0,
  Bone: r0,
  BoneIcon: r0,
  Book: A0,
  BookA: d0,
  BookAIcon: d0,
  BookAudio: s0,
  BookAudioIcon: s0,
  BookCheck: l0,
  BookCheckIcon: l0,
  BookCopy: h0,
  BookCopyIcon: h0,
  BookDashed: r1,
  BookDashedIcon: r1,
  BookDown: y0,
  BookDownIcon: y0,
  BookHeadphones: u0,
  BookHeadphonesIcon: u0,
  BookHeart: p0,
  BookHeartIcon: p0,
  BookIcon: A0,
  BookImage: k0,
  BookImageIcon: k0,
  BookKey: M0,
  BookKeyIcon: M0,
  BookLock: f0,
  BookLockIcon: f0,
  BookMarked: g0,
  BookMarkedIcon: g0,
  BookMinus: m0,
  BookMinusIcon: m0,
  BookOpen: I0,
  BookOpenCheck: v0,
  BookOpenCheckIcon: v0,
  BookOpenIcon: I0,
  BookOpenText: x0,
  BookOpenTextIcon: x0,
  BookPlus: w0,
  BookPlusIcon: w0,
  BookTemplate: r1,
  BookTemplateIcon: r1,
  BookText: C0,
  BookTextIcon: C0,
  BookType: L0,
  BookTypeIcon: L0,
  BookUp: S0,
  BookUp2: b0,
  BookUp2Icon: b0,
  BookUpIcon: S0,
  BookUser: q0,
  BookUserIcon: q0,
  BookX: z0,
  BookXIcon: z0,
  Bookmark: F0,
  BookmarkCheck: H0,
  BookmarkCheckIcon: H0,
  BookmarkIcon: F0,
  BookmarkMinus: P0,
  BookmarkMinusIcon: P0,
  BookmarkPlus: B0,
  BookmarkPlusIcon: B0,
  BookmarkX: V0,
  BookmarkXIcon: V0,
  BoomBox: j0,
  BoomBoxIcon: j0,
  Bot: R0,
  BotIcon: R0,
  BotMessageSquare: D0,
  BotMessageSquareIcon: D0,
  BotOff: T0,
  BotOffIcon: T0,
  Box: O0,
  BoxIcon: O0,
  BoxSelect: Pa,
  BoxSelectIcon: Pa,
  Boxes: $0,
  BoxesIcon: $0,
  Braces: d1,
  BracesIcon: d1,
  Brackets: E0,
  BracketsIcon: E0,
  Brain: N0,
  BrainCircuit: U0,
  BrainCircuitIcon: U0,
  BrainCog: Z0,
  BrainCogIcon: Z0,
  BrainIcon: N0,
  BrickWall: W0,
  BrickWallIcon: W0,
  Briefcase: J0,
  BriefcaseBusiness: G0,
  BriefcaseBusinessIcon: G0,
  BriefcaseConveyorBelt: X0,
  BriefcaseConveyorBeltIcon: X0,
  BriefcaseIcon: J0,
  BriefcaseMedical: K0,
  BriefcaseMedicalIcon: K0,
  BringToFront: Q0,
  BringToFrontIcon: Q0,
  Brush: Y0,
  BrushIcon: Y0,
  Bug: ti,
  BugIcon: ti,
  BugOff: _0,
  BugOffIcon: _0,
  BugPlay: ei,
  BugPlayIcon: ei,
  Building: oi,
  Building2: ai,
  Building2Icon: ai,
  BuildingIcon: oi,
  Bus: ni,
  BusFront: ci,
  BusFrontIcon: ci,
  BusIcon: ni,
  Cable: ri,
  CableCar: ii,
  CableCarIcon: ii,
  CableIcon: ri,
  Cake: si,
  CakeIcon: si,
  CakeSlice: di,
  CakeSliceIcon: di,
  Calculator: li,
  CalculatorIcon: li,
  Calendar: Hi,
  Calendar1: hi,
  Calendar1Icon: hi,
  CalendarArrowDown: yi,
  CalendarArrowDownIcon: yi,
  CalendarArrowUp: ui,
  CalendarArrowUpIcon: ui,
  CalendarCheck: ki,
  CalendarCheck2: pi,
  CalendarCheck2Icon: pi,
  CalendarCheckIcon: ki,
  CalendarClock: Mi,
  CalendarClockIcon: Mi,
  CalendarCog: fi,
  CalendarCogIcon: fi,
  CalendarDays: gi,
  CalendarDaysIcon: gi,
  CalendarFold: mi,
  CalendarFoldIcon: mi,
  CalendarHeart: vi,
  CalendarHeartIcon: vi,
  CalendarIcon: Hi,
  CalendarMinus: Ii,
  CalendarMinus2: xi,
  CalendarMinus2Icon: xi,
  CalendarMinusIcon: Ii,
  CalendarOff: wi,
  CalendarOffIcon: wi,
  CalendarPlus: Li,
  CalendarPlus2: Ci,
  CalendarPlus2Icon: Ci,
  CalendarPlusIcon: Li,
  CalendarRange: bi,
  CalendarRangeIcon: bi,
  CalendarSearch: Si,
  CalendarSearchIcon: Si,
  CalendarSync: qi,
  CalendarSyncIcon: qi,
  CalendarX: Ai,
  CalendarX2: zi,
  CalendarX2Icon: zi,
  CalendarXIcon: Ai,
  Camera: Bi,
  CameraIcon: Bi,
  CameraOff: Pi,
  CameraOffIcon: Pi,
  CandlestickChart: u1,
  CandlestickChartIcon: u1,
  Candy: ji,
  CandyCane: Vi,
  CandyCaneIcon: Vi,
  CandyIcon: ji,
  CandyOff: Fi,
  CandyOffIcon: Fi,
  Cannabis: Di,
  CannabisIcon: Di,
  Captions: s1,
  CaptionsIcon: s1,
  CaptionsOff: Ti,
  CaptionsOffIcon: Ti,
  Car: $i,
  CarFront: Ri,
  CarFrontIcon: Ri,
  CarIcon: $i,
  CarTaxiFront: Oi,
  CarTaxiFrontIcon: Oi,
  Caravan: Ei,
  CaravanIcon: Ei,
  Carrot: Ui,
  CarrotIcon: Ui,
  CaseLower: Zi,
  CaseLowerIcon: Zi,
  CaseSensitive: Ni,
  CaseSensitiveIcon: Ni,
  CaseUpper: Wi,
  CaseUpperIcon: Wi,
  CassetteTape: Gi,
  CassetteTapeIcon: Gi,
  Cast: Xi,
  CastIcon: Xi,
  Castle: Ki,
  CastleIcon: Ki,
  Cat: Ji,
  CatIcon: Ji,
  Cctv: Qi,
  CctvIcon: Qi,
  ChartArea: l1,
  ChartAreaIcon: l1,
  ChartBar: y1,
  ChartBarBig: h1,
  ChartBarBigIcon: h1,
  ChartBarDecreasing: Yi,
  ChartBarDecreasingIcon: Yi,
  ChartBarIcon: y1,
  ChartBarIncreasing: _i,
  ChartBarIncreasingIcon: _i,
  ChartBarStacked: er,
  ChartBarStackedIcon: er,
  ChartCandlestick: u1,
  ChartCandlestickIcon: u1,
  ChartColumn: M1,
  ChartColumnBig: p1,
  ChartColumnBigIcon: p1,
  ChartColumnDecreasing: tr,
  ChartColumnDecreasingIcon: tr,
  ChartColumnIcon: M1,
  ChartColumnIncreasing: k1,
  ChartColumnIncreasingIcon: k1,
  ChartColumnStacked: ar,
  ChartColumnStackedIcon: ar,
  ChartGantt: or,
  ChartGanttIcon: or,
  ChartLine: f1,
  ChartLineIcon: f1,
  ChartNetwork: cr,
  ChartNetworkIcon: cr,
  ChartNoAxesColumn: m1,
  ChartNoAxesColumnDecreasing: nr,
  ChartNoAxesColumnDecreasingIcon: nr,
  ChartNoAxesColumnIcon: m1,
  ChartNoAxesColumnIncreasing: g1,
  ChartNoAxesColumnIncreasingIcon: g1,
  ChartNoAxesCombined: ir,
  ChartNoAxesCombinedIcon: ir,
  ChartNoAxesGantt: v1,
  ChartNoAxesGanttIcon: v1,
  ChartPie: x1,
  ChartPieIcon: x1,
  ChartScatter: I1,
  ChartScatterIcon: I1,
  ChartSpline: rr,
  ChartSplineIcon: rr,
  Check: sr,
  CheckCheck: dr,
  CheckCheckIcon: dr,
  CheckCircle: P1,
  CheckCircle2: B1,
  CheckCircle2Icon: B1,
  CheckCircleIcon: P1,
  CheckIcon: sr,
  CheckSquare: wa,
  CheckSquare2: Ca,
  CheckSquare2Icon: Ca,
  CheckSquareIcon: wa,
  ChefHat: lr,
  ChefHatIcon: lr,
  Cherry: hr,
  CherryIcon: hr,
  ChevronDown: N2,
  ChevronDownCircle: V1,
  ChevronDownCircleIcon: V1,
  ChevronDownIcon: N2,
  ChevronDownSquare: La,
  ChevronDownSquareIcon: La,
  ChevronFirst: yr,
  ChevronFirstIcon: yr,
  ChevronLast: ur,
  ChevronLastIcon: ur,
  ChevronLeft: pr,
  ChevronLeftCircle: F1,
  ChevronLeftCircleIcon: F1,
  ChevronLeftIcon: pr,
  ChevronLeftSquare: ba,
  ChevronLeftSquareIcon: ba,
  ChevronRight: kr,
  ChevronRightCircle: j1,
  ChevronRightCircleIcon: j1,
  ChevronRightIcon: kr,
  ChevronRightSquare: Sa,
  ChevronRightSquareIcon: Sa,
  ChevronUp: Mr,
  ChevronUpCircle: D1,
  ChevronUpCircleIcon: D1,
  ChevronUpIcon: Mr,
  ChevronUpSquare: qa,
  ChevronUpSquareIcon: qa,
  ChevronsDown: gr,
  ChevronsDownIcon: gr,
  ChevronsDownUp: fr,
  ChevronsDownUpIcon: fr,
  ChevronsLeft: xr,
  ChevronsLeftIcon: xr,
  ChevronsLeftRight: vr,
  ChevronsLeftRightEllipsis: mr,
  ChevronsLeftRightEllipsisIcon: mr,
  ChevronsLeftRightIcon: vr,
  ChevronsRight: wr,
  ChevronsRightIcon: wr,
  ChevronsRightLeft: Ir,
  ChevronsRightLeftIcon: Ir,
  ChevronsUp: Lr,
  ChevronsUpDown: Cr,
  ChevronsUpDownIcon: Cr,
  ChevronsUpIcon: Lr,
  Chrome: br,
  ChromeIcon: br,
  Church: Sr,
  ChurchIcon: Sr,
  Cigarette: zr,
  CigaretteIcon: zr,
  CigaretteOff: qr,
  CigaretteOffIcon: qr,
  Circle: Or,
  CircleAlert: w1,
  CircleAlertIcon: w1,
  CircleArrowDown: C1,
  CircleArrowDownIcon: C1,
  CircleArrowLeft: L1,
  CircleArrowLeftIcon: L1,
  CircleArrowOutDownLeft: b1,
  CircleArrowOutDownLeftIcon: b1,
  CircleArrowOutDownRight: S1,
  CircleArrowOutDownRightIcon: S1,
  CircleArrowOutUpLeft: q1,
  CircleArrowOutUpLeftIcon: q1,
  CircleArrowOutUpRight: z1,
  CircleArrowOutUpRightIcon: z1,
  CircleArrowRight: A1,
  CircleArrowRightIcon: A1,
  CircleArrowUp: H1,
  CircleArrowUpIcon: H1,
  CircleCheck: B1,
  CircleCheckBig: P1,
  CircleCheckBigIcon: P1,
  CircleCheckIcon: B1,
  CircleChevronDown: V1,
  CircleChevronDownIcon: V1,
  CircleChevronLeft: F1,
  CircleChevronLeftIcon: F1,
  CircleChevronRight: j1,
  CircleChevronRightIcon: j1,
  CircleChevronUp: D1,
  CircleChevronUpIcon: D1,
  CircleDashed: Ar,
  CircleDashedIcon: Ar,
  CircleDivide: T1,
  CircleDivideIcon: T1,
  CircleDollarSign: Hr,
  CircleDollarSignIcon: Hr,
  CircleDot: Br,
  CircleDotDashed: Pr,
  CircleDotDashedIcon: Pr,
  CircleDotIcon: Br,
  CircleEllipsis: Vr,
  CircleEllipsisIcon: Vr,
  CircleEqual: Fr,
  CircleEqualIcon: Fr,
  CircleFadingArrowUp: jr,
  CircleFadingArrowUpIcon: jr,
  CircleFadingPlus: Dr,
  CircleFadingPlusIcon: Dr,
  CircleGauge: R1,
  CircleGaugeIcon: R1,
  CircleHelp: O1,
  CircleHelpIcon: O1,
  CircleIcon: Or,
  CircleMinus: $1,
  CircleMinusIcon: $1,
  CircleOff: Tr,
  CircleOffIcon: Tr,
  CircleParking: U1,
  CircleParkingIcon: U1,
  CircleParkingOff: E1,
  CircleParkingOffIcon: E1,
  CirclePause: Z1,
  CirclePauseIcon: Z1,
  CirclePercent: N1,
  CirclePercentIcon: N1,
  CirclePlay: W1,
  CirclePlayIcon: W1,
  CirclePlus: G1,
  CirclePlusIcon: G1,
  CirclePower: X1,
  CirclePowerIcon: X1,
  CircleSlash: Rr,
  CircleSlash2: K1,
  CircleSlash2Icon: K1,
  CircleSlashIcon: Rr,
  CircleSlashed: K1,
  CircleSlashedIcon: K1,
  CircleStop: J1,
  CircleStopIcon: J1,
  CircleUser: Y1,
  CircleUserIcon: Y1,
  CircleUserRound: Q1,
  CircleUserRoundIcon: Q1,
  CircleX: _1,
  CircleXIcon: _1,
  CircuitBoard: $r,
  CircuitBoardIcon: $r,
  Citrus: Er,
  CitrusIcon: Er,
  Clapperboard: Ur,
  ClapperboardIcon: Ur,
  Clipboard: Yr,
  ClipboardCheck: Zr,
  ClipboardCheckIcon: Zr,
  ClipboardCopy: Nr,
  ClipboardCopyIcon: Nr,
  ClipboardEdit: tt,
  ClipboardEditIcon: tt,
  ClipboardIcon: Yr,
  ClipboardList: Wr,
  ClipboardListIcon: Wr,
  ClipboardMinus: Gr,
  ClipboardMinusIcon: Gr,
  ClipboardPaste: Xr,
  ClipboardPasteIcon: Xr,
  ClipboardPen: tt,
  ClipboardPenIcon: tt,
  ClipboardPenLine: et,
  ClipboardPenLineIcon: et,
  ClipboardPlus: Kr,
  ClipboardPlusIcon: Kr,
  ClipboardSignature: et,
  ClipboardSignatureIcon: et,
  ClipboardType: Jr,
  ClipboardTypeIcon: Jr,
  ClipboardX: Qr,
  ClipboardXIcon: Qr,
  Clock: pd,
  Clock1: _r,
  Clock10: ed,
  Clock10Icon: ed,
  Clock11: td,
  Clock11Icon: td,
  Clock12: ad,
  Clock12Icon: ad,
  Clock1Icon: _r,
  Clock2: od,
  Clock2Icon: od,
  Clock3: cd,
  Clock3Icon: cd,
  Clock4: nd,
  Clock4Icon: nd,
  Clock5: id,
  Clock5Icon: id,
  Clock6: rd,
  Clock6Icon: rd,
  Clock7: dd,
  Clock7Icon: dd,
  Clock8: sd,
  Clock8Icon: sd,
  Clock9: ld,
  Clock9Icon: ld,
  ClockAlert: hd,
  ClockAlertIcon: hd,
  ClockArrowDown: yd,
  ClockArrowDownIcon: yd,
  ClockArrowUp: ud,
  ClockArrowUpIcon: ud,
  ClockIcon: pd,
  Cloud: zd,
  CloudAlert: kd,
  CloudAlertIcon: kd,
  CloudCog: Md,
  CloudCogIcon: Md,
  CloudDownload: at,
  CloudDownloadIcon: at,
  CloudDrizzle: fd,
  CloudDrizzleIcon: fd,
  CloudFog: gd,
  CloudFogIcon: gd,
  CloudHail: md,
  CloudHailIcon: md,
  CloudIcon: zd,
  CloudLightning: vd,
  CloudLightningIcon: vd,
  CloudMoon: Id,
  CloudMoonIcon: Id,
  CloudMoonRain: xd,
  CloudMoonRainIcon: xd,
  CloudOff: wd,
  CloudOffIcon: wd,
  CloudRain: Ld,
  CloudRainIcon: Ld,
  CloudRainWind: Cd,
  CloudRainWindIcon: Cd,
  CloudSnow: bd,
  CloudSnowIcon: bd,
  CloudSun: qd,
  CloudSunIcon: qd,
  CloudSunRain: Sd,
  CloudSunRainIcon: Sd,
  CloudUpload: ot,
  CloudUploadIcon: ot,
  Cloudy: Ad,
  CloudyIcon: Ad,
  Clover: Hd,
  CloverIcon: Hd,
  Club: Pd,
  ClubIcon: Pd,
  Code: Bd,
  Code2: ct,
  Code2Icon: ct,
  CodeIcon: Bd,
  CodeSquare: za,
  CodeSquareIcon: za,
  CodeXml: ct,
  CodeXmlIcon: ct,
  Codepen: Vd,
  CodepenIcon: Vd,
  Codesandbox: Fd,
  CodesandboxIcon: Fd,
  Coffee: jd,
  CoffeeIcon: jd,
  Cog: Dd,
  CogIcon: Dd,
  Coins: Td,
  CoinsIcon: Td,
  Columns: nt,
  Columns2: nt,
  Columns2Icon: nt,
  Columns3: it,
  Columns3Icon: it,
  Columns4: Rd,
  Columns4Icon: Rd,
  ColumnsIcon: nt,
  Combine: Od,
  CombineIcon: Od,
  Command: $d,
  CommandIcon: $d,
  Compass: Ed,
  CompassIcon: Ed,
  Component: Ud,
  ComponentIcon: Ud,
  Computer: Zd,
  ComputerIcon: Zd,
  ConciergeBell: Nd,
  ConciergeBellIcon: Nd,
  Cone: Wd,
  ConeIcon: Wd,
  Construction: Gd,
  ConstructionIcon: Gd,
  Contact: Xd,
  Contact2: rt,
  Contact2Icon: rt,
  ContactIcon: Xd,
  ContactRound: rt,
  ContactRoundIcon: rt,
  Container: Kd,
  ContainerIcon: Kd,
  Contrast: Jd,
  ContrastIcon: Jd,
  Cookie: Qd,
  CookieIcon: Qd,
  CookingPot: Yd,
  CookingPotIcon: Yd,
  Copy: cs,
  CopyCheck: _d,
  CopyCheckIcon: _d,
  CopyIcon: cs,
  CopyMinus: es,
  CopyMinusIcon: es,
  CopyPlus: ts,
  CopyPlusIcon: ts,
  CopySlash: as,
  CopySlashIcon: as,
  CopyX: os,
  CopyXIcon: os,
  Copyleft: ns,
  CopyleftIcon: ns,
  Copyright: is,
  CopyrightIcon: is,
  CornerDownLeft: rs,
  CornerDownLeftIcon: rs,
  CornerDownRight: ds,
  CornerDownRightIcon: ds,
  CornerLeftDown: ss,
  CornerLeftDownIcon: ss,
  CornerLeftUp: ls,
  CornerLeftUpIcon: ls,
  CornerRightDown: hs,
  CornerRightDownIcon: hs,
  CornerRightUp: ys,
  CornerRightUpIcon: ys,
  CornerUpLeft: us,
  CornerUpLeftIcon: us,
  CornerUpRight: ps,
  CornerUpRightIcon: ps,
  Cpu: ks,
  CpuIcon: ks,
  CreativeCommons: Ms,
  CreativeCommonsIcon: Ms,
  CreditCard: fs,
  CreditCardIcon: fs,
  Croissant: gs,
  CroissantIcon: gs,
  Crop: ms,
  CropIcon: ms,
  Cross: vs,
  CrossIcon: vs,
  Crosshair: xs,
  CrosshairIcon: xs,
  Crown: Is,
  CrownIcon: Is,
  Cuboid: ws,
  CuboidIcon: ws,
  CupSoda: Cs,
  CupSodaIcon: Cs,
  CurlyBraces: d1,
  CurlyBracesIcon: d1,
  Currency: Ls,
  CurrencyIcon: Ls,
  Cylinder: bs,
  CylinderIcon: bs,
  Dam: Ss,
  DamIcon: Ss,
  Database: As,
  DatabaseBackup: qs,
  DatabaseBackupIcon: qs,
  DatabaseIcon: As,
  DatabaseZap: zs,
  DatabaseZapIcon: zs,
  Delete: Hs,
  DeleteIcon: Hs,
  Dessert: Ps,
  DessertIcon: Ps,
  Diameter: Bs,
  DiameterIcon: Bs,
  Diamond: js,
  DiamondIcon: js,
  DiamondMinus: Vs,
  DiamondMinusIcon: Vs,
  DiamondPercent: dt,
  DiamondPercentIcon: dt,
  DiamondPlus: Fs,
  DiamondPlusIcon: Fs,
  Dice1: Ds,
  Dice1Icon: Ds,
  Dice2: Ts,
  Dice2Icon: Ts,
  Dice3: Rs,
  Dice3Icon: Rs,
  Dice4: Os,
  Dice4Icon: Os,
  Dice5: $s,
  Dice5Icon: $s,
  Dice6: Es,
  Dice6Icon: Es,
  Dices: Us,
  DicesIcon: Us,
  Diff: Zs,
  DiffIcon: Zs,
  Disc: Xs,
  Disc2: Ns,
  Disc2Icon: Ns,
  Disc3: Ws,
  Disc3Icon: Ws,
  DiscAlbum: Gs,
  DiscAlbumIcon: Gs,
  DiscIcon: Xs,
  Divide: Ks,
  DivideCircle: T1,
  DivideCircleIcon: T1,
  DivideIcon: Ks,
  DivideSquare: Ba,
  DivideSquareIcon: Ba,
  Dna: Qs,
  DnaIcon: Qs,
  DnaOff: Js,
  DnaOffIcon: Js,
  Dock: Ys,
  DockIcon: Ys,
  Dog: _s,
  DogIcon: _s,
  DollarSign: el,
  DollarSignIcon: el,
  Donut: tl,
  DonutIcon: tl,
  DoorClosed: al,
  DoorClosedIcon: al,
  DoorOpen: ol,
  DoorOpenIcon: ol,
  Dot: cl,
  DotIcon: cl,
  DotSquare: Va,
  DotSquareIcon: Va,
  Download: nl,
  DownloadCloud: at,
  DownloadCloudIcon: at,
  DownloadIcon: nl,
  DraftingCompass: il,
  DraftingCompassIcon: il,
  Drama: rl,
  DramaIcon: rl,
  Dribbble: dl,
  DribbbleIcon: dl,
  Drill: sl,
  DrillIcon: sl,
  Droplet: hl,
  DropletIcon: hl,
  DropletOff: ll,
  DropletOffIcon: ll,
  Droplets: yl,
  DropletsIcon: yl,
  Drum: ul,
  DrumIcon: ul,
  Drumstick: pl,
  DrumstickIcon: pl,
  Dumbbell: kl,
  DumbbellIcon: kl,
  Ear: fl,
  EarIcon: fl,
  EarOff: Ml,
  EarOffIcon: Ml,
  Earth: st,
  EarthIcon: st,
  EarthLock: gl,
  EarthLockIcon: gl,
  Eclipse: ml,
  EclipseIcon: ml,
  Edit: ke,
  Edit2: Qt,
  Edit2Icon: Qt,
  Edit3: Jt,
  Edit3Icon: Jt,
  EditIcon: ke,
  Egg: Il,
  EggFried: vl,
  EggFriedIcon: vl,
  EggIcon: Il,
  EggOff: xl,
  EggOffIcon: xl,
  Ellipsis: ht,
  EllipsisIcon: ht,
  EllipsisVertical: lt,
  EllipsisVerticalIcon: lt,
  Equal: Ll,
  EqualApproximately: wl,
  EqualApproximatelyIcon: wl,
  EqualIcon: Ll,
  EqualNot: Cl,
  EqualNotIcon: Cl,
  EqualSquare: Fa,
  EqualSquareIcon: Fa,
  Eraser: bl,
  EraserIcon: bl,
  EthernetPort: Sl,
  EthernetPortIcon: Sl,
  Euro: ql,
  EuroIcon: ql,
  Expand: zl,
  ExpandIcon: zl,
  ExternalLink: Al,
  ExternalLinkIcon: Al,
  Eye: Bl,
  EyeClosed: Hl,
  EyeClosedIcon: Hl,
  EyeIcon: Bl,
  EyeOff: Pl,
  EyeOffIcon: Pl,
  Facebook: Vl,
  FacebookIcon: Vl,
  Factory: Fl,
  FactoryIcon: Fl,
  Fan: jl,
  FanIcon: jl,
  FastForward: Dl,
  FastForwardIcon: Dl,
  Feather: Tl,
  FeatherIcon: Tl,
  Fence: Rl,
  FenceIcon: Rl,
  FerrisWheel: Ol,
  FerrisWheelIcon: Ol,
  Figma: $l,
  FigmaIcon: $l,
  File: Th,
  FileArchive: El,
  FileArchiveIcon: El,
  FileAudio: Zl,
  FileAudio2: Ul,
  FileAudio2Icon: Ul,
  FileAudioIcon: Zl,
  FileAxis3D: yt,
  FileAxis3DIcon: yt,
  FileAxis3d: yt,
  FileAxis3dIcon: yt,
  FileBadge: Wl,
  FileBadge2: Nl,
  FileBadge2Icon: Nl,
  FileBadgeIcon: Wl,
  FileBarChart: ut,
  FileBarChart2: pt,
  FileBarChart2Icon: pt,
  FileBarChartIcon: ut,
  FileBox: Gl,
  FileBoxIcon: Gl,
  FileChartColumn: pt,
  FileChartColumnIcon: pt,
  FileChartColumnIncreasing: ut,
  FileChartColumnIncreasingIcon: ut,
  FileChartLine: kt,
  FileChartLineIcon: kt,
  FileChartPie: Mt,
  FileChartPieIcon: Mt,
  FileCheck: Kl,
  FileCheck2: Xl,
  FileCheck2Icon: Xl,
  FileCheckIcon: Kl,
  FileClock: Jl,
  FileClockIcon: Jl,
  FileCode: Yl,
  FileCode2: Ql,
  FileCode2Icon: Ql,
  FileCodeIcon: Yl,
  FileCog: ft,
  FileCog2: ft,
  FileCog2Icon: ft,
  FileCogIcon: ft,
  FileDiff: _l,
  FileDiffIcon: _l,
  FileDigit: eh,
  FileDigitIcon: eh,
  FileDown: th,
  FileDownIcon: th,
  FileEdit: mt,
  FileEditIcon: mt,
  FileHeart: ah,
  FileHeartIcon: ah,
  FileIcon: Th,
  FileImage: oh,
  FileImageIcon: oh,
  FileInput: ch,
  FileInputIcon: ch,
  FileJson: ih,
  FileJson2: nh,
  FileJson2Icon: nh,
  FileJsonIcon: ih,
  FileKey: dh,
  FileKey2: rh,
  FileKey2Icon: rh,
  FileKeyIcon: dh,
  FileLineChart: kt,
  FileLineChartIcon: kt,
  FileLock: lh,
  FileLock2: sh,
  FileLock2Icon: sh,
  FileLockIcon: lh,
  FileMinus: yh,
  FileMinus2: hh,
  FileMinus2Icon: hh,
  FileMinusIcon: yh,
  FileMusic: uh,
  FileMusicIcon: uh,
  FileOutput: ph,
  FileOutputIcon: ph,
  FilePen: mt,
  FilePenIcon: mt,
  FilePenLine: gt,
  FilePenLineIcon: gt,
  FilePieChart: Mt,
  FilePieChartIcon: Mt,
  FilePlus: Mh,
  FilePlus2: kh,
  FilePlus2Icon: kh,
  FilePlusIcon: Mh,
  FileQuestion: fh,
  FileQuestionIcon: fh,
  FileScan: gh,
  FileScanIcon: gh,
  FileSearch: vh,
  FileSearch2: mh,
  FileSearch2Icon: mh,
  FileSearchIcon: vh,
  FileSignature: gt,
  FileSignatureIcon: gt,
  FileSliders: xh,
  FileSlidersIcon: xh,
  FileSpreadsheet: Ih,
  FileSpreadsheetIcon: Ih,
  FileStack: wh,
  FileStackIcon: wh,
  FileSymlink: Ch,
  FileSymlinkIcon: Ch,
  FileTerminal: Lh,
  FileTerminalIcon: Lh,
  FileText: bh,
  FileTextIcon: bh,
  FileType: qh,
  FileType2: Sh,
  FileType2Icon: Sh,
  FileTypeIcon: qh,
  FileUp: zh,
  FileUpIcon: zh,
  FileUser: Ah,
  FileUserIcon: Ah,
  FileVideo: Ph,
  FileVideo2: Hh,
  FileVideo2Icon: Hh,
  FileVideoIcon: Ph,
  FileVolume: Vh,
  FileVolume2: Bh,
  FileVolume2Icon: Bh,
  FileVolumeIcon: Vh,
  FileWarning: Fh,
  FileWarningIcon: Fh,
  FileX: Dh,
  FileX2: jh,
  FileX2Icon: jh,
  FileXIcon: Dh,
  Files: Rh,
  FilesIcon: Rh,
  Film: Oh,
  FilmIcon: Oh,
  Filter: Eh,
  FilterIcon: Eh,
  FilterX: $h,
  FilterXIcon: $h,
  Fingerprint: Uh,
  FingerprintIcon: Uh,
  FireExtinguisher: Zh,
  FireExtinguisherIcon: Zh,
  Fish: Gh,
  FishIcon: Gh,
  FishOff: Nh,
  FishOffIcon: Nh,
  FishSymbol: Wh,
  FishSymbolIcon: Wh,
  Flag: Qh,
  FlagIcon: Qh,
  FlagOff: Xh,
  FlagOffIcon: Xh,
  FlagTriangleLeft: Kh,
  FlagTriangleLeftIcon: Kh,
  FlagTriangleRight: Jh,
  FlagTriangleRightIcon: Jh,
  Flame: _h,
  FlameIcon: _h,
  FlameKindling: Yh,
  FlameKindlingIcon: Yh,
  Flashlight: ty,
  FlashlightIcon: ty,
  FlashlightOff: ey,
  FlashlightOffIcon: ey,
  FlaskConical: oy,
  FlaskConicalIcon: oy,
  FlaskConicalOff: ay,
  FlaskConicalOffIcon: ay,
  FlaskRound: cy,
  FlaskRoundIcon: cy,
  FlipHorizontal: iy,
  FlipHorizontal2: ny,
  FlipHorizontal2Icon: ny,
  FlipHorizontalIcon: iy,
  FlipVertical: dy,
  FlipVertical2: ry,
  FlipVertical2Icon: ry,
  FlipVerticalIcon: dy,
  Flower: ly,
  Flower2: sy,
  Flower2Icon: sy,
  FlowerIcon: ly,
  Focus: hy,
  FocusIcon: hy,
  FoldHorizontal: yy,
  FoldHorizontalIcon: yy,
  FoldVertical: uy,
  FoldVerticalIcon: uy,
  Folder: $y,
  FolderArchive: py,
  FolderArchiveIcon: py,
  FolderCheck: ky,
  FolderCheckIcon: ky,
  FolderClock: My,
  FolderClockIcon: My,
  FolderClosed: fy,
  FolderClosedIcon: fy,
  FolderCode: gy,
  FolderCodeIcon: gy,
  FolderCog: vt,
  FolderCog2: vt,
  FolderCog2Icon: vt,
  FolderCogIcon: vt,
  FolderDot: my,
  FolderDotIcon: my,
  FolderDown: vy,
  FolderDownIcon: vy,
  FolderEdit: xt,
  FolderEditIcon: xt,
  FolderGit: Iy,
  FolderGit2: xy,
  FolderGit2Icon: xy,
  FolderGitIcon: Iy,
  FolderHeart: wy,
  FolderHeartIcon: wy,
  FolderIcon: $y,
  FolderInput: Cy,
  FolderInputIcon: Cy,
  FolderKanban: Ly,
  FolderKanbanIcon: Ly,
  FolderKey: by,
  FolderKeyIcon: by,
  FolderLock: Sy,
  FolderLockIcon: Sy,
  FolderMinus: qy,
  FolderMinusIcon: qy,
  FolderOpen: Ay,
  FolderOpenDot: zy,
  FolderOpenDotIcon: zy,
  FolderOpenIcon: Ay,
  FolderOutput: Hy,
  FolderOutputIcon: Hy,
  FolderPen: xt,
  FolderPenIcon: xt,
  FolderPlus: Py,
  FolderPlusIcon: Py,
  FolderRoot: By,
  FolderRootIcon: By,
  FolderSearch: Fy,
  FolderSearch2: Vy,
  FolderSearch2Icon: Vy,
  FolderSearchIcon: Fy,
  FolderSymlink: jy,
  FolderSymlinkIcon: jy,
  FolderSync: Dy,
  FolderSyncIcon: Dy,
  FolderTree: Ty,
  FolderTreeIcon: Ty,
  FolderUp: Ry,
  FolderUpIcon: Ry,
  FolderX: Oy,
  FolderXIcon: Oy,
  Folders: Ey,
  FoldersIcon: Ey,
  Footprints: Uy,
  FootprintsIcon: Uy,
  ForkKnife: x2,
  ForkKnifeCrossed: v2,
  ForkKnifeCrossedIcon: v2,
  ForkKnifeIcon: x2,
  Forklift: Zy,
  ForkliftIcon: Zy,
  FormInput: _t,
  FormInputIcon: _t,
  Forward: Ny,
  ForwardIcon: Ny,
  Frame: Wy,
  FrameIcon: Wy,
  Framer: Gy,
  FramerIcon: Gy,
  Frown: Xy,
  FrownIcon: Xy,
  Fuel: Ky,
  FuelIcon: Ky,
  Fullscreen: Jy,
  FullscreenIcon: Jy,
  FunctionSquare: ja,
  FunctionSquareIcon: ja,
  GalleryHorizontal: Yy,
  GalleryHorizontalEnd: Qy,
  GalleryHorizontalEndIcon: Qy,
  GalleryHorizontalIcon: Yy,
  GalleryThumbnails: _y,
  GalleryThumbnailsIcon: _y,
  GalleryVertical: tu,
  GalleryVerticalEnd: eu,
  GalleryVerticalEndIcon: eu,
  GalleryVerticalIcon: tu,
  Gamepad: ou,
  Gamepad2: au,
  Gamepad2Icon: au,
  GamepadIcon: ou,
  GanttChart: v1,
  GanttChartIcon: v1,
  GanttChartSquare: qe,
  GanttChartSquareIcon: qe,
  Gauge: cu,
  GaugeCircle: R1,
  GaugeCircleIcon: R1,
  GaugeIcon: cu,
  Gavel: nu,
  GavelIcon: nu,
  Gem: iu,
  GemIcon: iu,
  Ghost: ru,
  GhostIcon: ru,
  Gift: du,
  GiftIcon: du,
  GitBranch: lu,
  GitBranchIcon: lu,
  GitBranchPlus: su,
  GitBranchPlusIcon: su,
  GitCommit: It,
  GitCommitHorizontal: It,
  GitCommitHorizontalIcon: It,
  GitCommitIcon: It,
  GitCommitVertical: hu,
  GitCommitVerticalIcon: hu,
  GitCompare: uu,
  GitCompareArrows: yu,
  GitCompareArrowsIcon: yu,
  GitCompareIcon: uu,
  GitFork: pu,
  GitForkIcon: pu,
  GitGraph: ku,
  GitGraphIcon: ku,
  GitMerge: Mu,
  GitMergeIcon: Mu,
  GitPullRequest: Iu,
  GitPullRequestArrow: fu,
  GitPullRequestArrowIcon: fu,
  GitPullRequestClosed: gu,
  GitPullRequestClosedIcon: gu,
  GitPullRequestCreate: vu,
  GitPullRequestCreateArrow: mu,
  GitPullRequestCreateArrowIcon: mu,
  GitPullRequestCreateIcon: vu,
  GitPullRequestDraft: xu,
  GitPullRequestDraftIcon: xu,
  GitPullRequestIcon: Iu,
  Github: wu,
  GithubIcon: wu,
  Gitlab: Cu,
  GitlabIcon: Cu,
  GlassWater: Lu,
  GlassWaterIcon: Lu,
  Glasses: bu,
  GlassesIcon: bu,
  Globe: qu,
  Globe2: st,
  Globe2Icon: st,
  GlobeIcon: qu,
  GlobeLock: Su,
  GlobeLockIcon: Su,
  Goal: zu,
  GoalIcon: zu,
  Grab: Au,
  GrabIcon: Au,
  GraduationCap: Hu,
  GraduationCapIcon: Hu,
  Grape: Pu,
  GrapeIcon: Pu,
  Grid: Se,
  Grid2X2: Ct,
  Grid2X2Icon: Ct,
  Grid2X2Plus: wt,
  Grid2X2PlusIcon: wt,
  Grid2x2: Ct,
  Grid2x2Check: Bu,
  Grid2x2CheckIcon: Bu,
  Grid2x2Icon: Ct,
  Grid2x2Plus: wt,
  Grid2x2PlusIcon: wt,
  Grid2x2X: Vu,
  Grid2x2XIcon: Vu,
  Grid3X3: Se,
  Grid3X3Icon: Se,
  Grid3x3: Se,
  Grid3x3Icon: Se,
  GridIcon: Se,
  Grip: Du,
  GripHorizontal: Fu,
  GripHorizontalIcon: Fu,
  GripIcon: Du,
  GripVertical: ju,
  GripVerticalIcon: ju,
  Group: Tu,
  GroupIcon: Tu,
  Guitar: Ru,
  GuitarIcon: Ru,
  Ham: Ou,
  HamIcon: Ou,
  Hammer: $u,
  HammerIcon: $u,
  Hand: Wu,
  HandCoins: Eu,
  HandCoinsIcon: Eu,
  HandHeart: Uu,
  HandHeartIcon: Uu,
  HandHelping: Lt,
  HandHelpingIcon: Lt,
  HandIcon: Wu,
  HandMetal: Zu,
  HandMetalIcon: Zu,
  HandPlatter: Nu,
  HandPlatterIcon: Nu,
  Handshake: Gu,
  HandshakeIcon: Gu,
  HardDrive: Ju,
  HardDriveDownload: Xu,
  HardDriveDownloadIcon: Xu,
  HardDriveIcon: Ju,
  HardDriveUpload: Ku,
  HardDriveUploadIcon: Ku,
  HardHat: Qu,
  HardHatIcon: Qu,
  Hash: Yu,
  HashIcon: Yu,
  Haze: _u,
  HazeIcon: _u,
  HdmiPort: ep,
  HdmiPortIcon: ep,
  Heading: rp,
  Heading1: tp,
  Heading1Icon: tp,
  Heading2: ap,
  Heading2Icon: ap,
  Heading3: op,
  Heading3Icon: op,
  Heading4: cp,
  Heading4Icon: cp,
  Heading5: np,
  Heading5Icon: np,
  Heading6: ip,
  Heading6Icon: ip,
  HeadingIcon: rp,
  HeadphoneOff: dp,
  HeadphoneOffIcon: dp,
  Headphones: sp,
  HeadphonesIcon: sp,
  Headset: lp,
  HeadsetIcon: lp,
  Heart: kp,
  HeartCrack: hp,
  HeartCrackIcon: hp,
  HeartHandshake: yp,
  HeartHandshakeIcon: yp,
  HeartIcon: kp,
  HeartOff: up,
  HeartOffIcon: up,
  HeartPulse: pp,
  HeartPulseIcon: pp,
  Heater: Mp,
  HeaterIcon: Mp,
  HelpCircle: O1,
  HelpCircleIcon: O1,
  HelpingHand: Lt,
  HelpingHandIcon: Lt,
  Hexagon: fp,
  HexagonIcon: fp,
  Highlighter: gp,
  HighlighterIcon: gp,
  History: mp,
  HistoryIcon: mp,
  Home: bt,
  HomeIcon: bt,
  Hop: xp,
  HopIcon: xp,
  HopOff: vp,
  HopOffIcon: vp,
  Hospital: Ip,
  HospitalIcon: Ip,
  Hotel: wp,
  HotelIcon: wp,
  Hourglass: Cp,
  HourglassIcon: Cp,
  House: bt,
  HouseIcon: bt,
  HousePlug: Lp,
  HousePlugIcon: Lp,
  HousePlus: bp,
  HousePlusIcon: bp,
  IceCream: qt,
  IceCream2: St,
  IceCream2Icon: St,
  IceCreamBowl: St,
  IceCreamBowlIcon: St,
  IceCreamCone: qt,
  IceCreamConeIcon: qt,
  IceCreamIcon: qt,
  Icon: Vx,
  IdCard: Sp,
  IdCardIcon: Sp,
  Image: Fp,
  ImageDown: qp,
  ImageDownIcon: qp,
  ImageIcon: Fp,
  ImageMinus: zp,
  ImageMinusIcon: zp,
  ImageOff: Ap,
  ImageOffIcon: Ap,
  ImagePlay: Hp,
  ImagePlayIcon: Hp,
  ImagePlus: Pp,
  ImagePlusIcon: Pp,
  ImageUp: Bp,
  ImageUpIcon: Bp,
  ImageUpscale: Vp,
  ImageUpscaleIcon: Vp,
  Images: jp,
  ImagesIcon: jp,
  Import: Dp,
  ImportIcon: Dp,
  Inbox: Tp,
  InboxIcon: Tp,
  Indent: At,
  IndentDecrease: zt,
  IndentDecreaseIcon: zt,
  IndentIcon: At,
  IndentIncrease: At,
  IndentIncreaseIcon: At,
  IndianRupee: Rp,
  IndianRupeeIcon: Rp,
  Infinity: Op,
  InfinityIcon: Op,
  Info: $p,
  InfoIcon: $p,
  Inspect: Ea,
  InspectIcon: Ea,
  InspectionPanel: Ep,
  InspectionPanelIcon: Ep,
  Instagram: Up,
  InstagramIcon: Up,
  Italic: Zp,
  ItalicIcon: Zp,
  IterationCcw: Np,
  IterationCcwIcon: Np,
  IterationCw: Wp,
  IterationCwIcon: Wp,
  JapaneseYen: Gp,
  JapaneseYenIcon: Gp,
  Joystick: Xp,
  JoystickIcon: Xp,
  Kanban: Kp,
  KanbanIcon: Kp,
  KanbanSquare: Da,
  KanbanSquareDashed: Aa,
  KanbanSquareDashedIcon: Aa,
  KanbanSquareIcon: Da,
  Key: Yp,
  KeyIcon: Yp,
  KeyRound: Jp,
  KeyRoundIcon: Jp,
  KeySquare: Qp,
  KeySquareIcon: Qp,
  Keyboard: t4,
  KeyboardIcon: t4,
  KeyboardMusic: _p,
  KeyboardMusicIcon: _p,
  KeyboardOff: e4,
  KeyboardOffIcon: e4,
  Lamp: r4,
  LampCeiling: a4,
  LampCeilingIcon: a4,
  LampDesk: o4,
  LampDeskIcon: o4,
  LampFloor: c4,
  LampFloorIcon: c4,
  LampIcon: r4,
  LampWallDown: n4,
  LampWallDownIcon: n4,
  LampWallUp: i4,
  LampWallUpIcon: i4,
  LandPlot: d4,
  LandPlotIcon: d4,
  Landmark: s4,
  LandmarkIcon: s4,
  Languages: l4,
  LanguagesIcon: l4,
  Laptop: y4,
  Laptop2: Ht,
  Laptop2Icon: Ht,
  LaptopIcon: y4,
  LaptopMinimal: Ht,
  LaptopMinimalCheck: h4,
  LaptopMinimalCheckIcon: h4,
  LaptopMinimalIcon: Ht,
  Lasso: p4,
  LassoIcon: p4,
  LassoSelect: u4,
  LassoSelectIcon: u4,
  Laugh: k4,
  LaughIcon: k4,
  Layers: Pt,
  Layers2: M4,
  Layers2Icon: M4,
  Layers3: Pt,
  Layers3Icon: Pt,
  LayersIcon: Pt,
  Layout: Kt,
  LayoutDashboard: f4,
  LayoutDashboardIcon: f4,
  LayoutGrid: g4,
  LayoutGridIcon: g4,
  LayoutIcon: Kt,
  LayoutList: m4,
  LayoutListIcon: m4,
  LayoutPanelLeft: v4,
  LayoutPanelLeftIcon: v4,
  LayoutPanelTop: x4,
  LayoutPanelTopIcon: x4,
  LayoutTemplate: I4,
  LayoutTemplateIcon: I4,
  Leaf: w4,
  LeafIcon: w4,
  LeafyGreen: C4,
  LeafyGreenIcon: C4,
  Lectern: L4,
  LecternIcon: L4,
  LetterText: b4,
  LetterTextIcon: b4,
  Library: q4,
  LibraryBig: S4,
  LibraryBigIcon: S4,
  LibraryIcon: q4,
  LibrarySquare: Ta,
  LibrarySquareIcon: Ta,
  LifeBuoy: z4,
  LifeBuoyIcon: z4,
  Ligature: A4,
  LigatureIcon: A4,
  Lightbulb: P4,
  LightbulbIcon: P4,
  LightbulbOff: H4,
  LightbulbOffIcon: H4,
  LineChart: f1,
  LineChartIcon: f1,
  Link: F4,
  Link2: V4,
  Link2Icon: V4,
  Link2Off: B4,
  Link2OffIcon: B4,
  LinkIcon: F4,
  Linkedin: j4,
  LinkedinIcon: j4,
  List: _4,
  ListCheck: D4,
  ListCheckIcon: D4,
  ListChecks: T4,
  ListChecksIcon: T4,
  ListCollapse: R4,
  ListCollapseIcon: R4,
  ListEnd: O4,
  ListEndIcon: O4,
  ListFilter: E4,
  ListFilterIcon: E4,
  ListFilterPlus: $4,
  ListFilterPlusIcon: $4,
  ListIcon: _4,
  ListMinus: U4,
  ListMinusIcon: U4,
  ListMusic: Z4,
  ListMusicIcon: Z4,
  ListOrdered: N4,
  ListOrderedIcon: N4,
  ListPlus: W4,
  ListPlusIcon: W4,
  ListRestart: G4,
  ListRestartIcon: G4,
  ListStart: X4,
  ListStartIcon: X4,
  ListTodo: K4,
  ListTodoIcon: K4,
  ListTree: J4,
  ListTreeIcon: J4,
  ListVideo: Q4,
  ListVideoIcon: Q4,
  ListX: Y4,
  ListXIcon: Y4,
  Loader: tk,
  Loader2: Bt,
  Loader2Icon: Bt,
  LoaderCircle: Bt,
  LoaderCircleIcon: Bt,
  LoaderIcon: tk,
  LoaderPinwheel: ek,
  LoaderPinwheelIcon: ek,
  Locate: ck,
  LocateFixed: ak,
  LocateFixedIcon: ak,
  LocateIcon: ck,
  LocateOff: ok,
  LocateOffIcon: ok,
  Lock: ik,
  LockIcon: ik,
  LockKeyhole: nk,
  LockKeyholeIcon: nk,
  LockKeyholeOpen: Vt,
  LockKeyholeOpenIcon: Vt,
  LockOpen: Ft,
  LockOpenIcon: Ft,
  LogIn: rk,
  LogInIcon: rk,
  LogOut: dk,
  LogOutIcon: dk,
  Logs: sk,
  LogsIcon: sk,
  Lollipop: lk,
  LollipopIcon: lk,
  LucideAArrowDown: ao,
  LucideAArrowUp: oo,
  LucideALargeSmall: co,
  LucideAccessibility: no,
  LucideActivity: io,
  LucideActivitySquare: da,
  LucideAirVent: ro,
  LucideAirplay: so,
  LucideAlarmCheck: Xe,
  LucideAlarmClock: ho,
  LucideAlarmClockCheck: Xe,
  LucideAlarmClockMinus: Ke,
  LucideAlarmClockOff: lo,
  LucideAlarmClockPlus: Je,
  LucideAlarmMinus: Ke,
  LucideAlarmPlus: Je,
  LucideAlarmSmoke: yo,
  LucideAlbum: uo,
  LucideAlertCircle: w1,
  LucideAlertOctagon: Tt,
  LucideAlertTriangle: l2,
  LucideAlignCenter: Mo,
  LucideAlignCenterHorizontal: po,
  LucideAlignCenterVertical: ko,
  LucideAlignEndHorizontal: fo,
  LucideAlignEndVertical: go,
  LucideAlignHorizontalDistributeCenter: mo,
  LucideAlignHorizontalDistributeEnd: vo,
  LucideAlignHorizontalDistributeStart: xo,
  LucideAlignHorizontalJustifyCenter: Io,
  LucideAlignHorizontalJustifyEnd: wo,
  LucideAlignHorizontalJustifyStart: Co,
  LucideAlignHorizontalSpaceAround: Lo,
  LucideAlignHorizontalSpaceBetween: bo,
  LucideAlignJustify: So,
  LucideAlignLeft: qo,
  LucideAlignRight: zo,
  LucideAlignStartHorizontal: Ao,
  LucideAlignStartVertical: Ho,
  LucideAlignVerticalDistributeCenter: Po,
  LucideAlignVerticalDistributeEnd: Bo,
  LucideAlignVerticalDistributeStart: Vo,
  LucideAlignVerticalJustifyCenter: Fo,
  LucideAlignVerticalJustifyEnd: jo,
  LucideAlignVerticalJustifyStart: Do,
  LucideAlignVerticalSpaceAround: To,
  LucideAlignVerticalSpaceBetween: Ro,
  LucideAmbulance: Oo,
  LucideAmpersand: $o,
  LucideAmpersands: Eo,
  LucideAmphora: Uo,
  LucideAnchor: Zo,
  LucideAngry: No,
  LucideAnnoyed: Wo,
  LucideAntenna: Go,
  LucideAnvil: Xo,
  LucideAperture: Ko,
  LucideAppWindow: Qo,
  LucideAppWindowMac: Jo,
  LucideApple: Yo,
  LucideArchive: tc,
  LucideArchiveRestore: _o,
  LucideArchiveX: ec,
  LucideAreaChart: l1,
  LucideArmchair: ac,
  LucideArrowBigDown: cc,
  LucideArrowBigDownDash: oc,
  LucideArrowBigLeft: ic,
  LucideArrowBigLeftDash: nc,
  LucideArrowBigRight: dc,
  LucideArrowBigRightDash: rc,
  LucideArrowBigUp: lc,
  LucideArrowBigUpDash: sc,
  LucideArrowDown: vc,
  LucideArrowDown01: hc,
  LucideArrowDown10: yc,
  LucideArrowDownAZ: Qe,
  LucideArrowDownAz: Qe,
  LucideArrowDownCircle: C1,
  LucideArrowDownFromLine: uc,
  LucideArrowDownLeft: pc,
  LucideArrowDownLeftFromCircle: b1,
  LucideArrowDownLeftFromSquare: ua,
  LucideArrowDownLeftSquare: sa,
  LucideArrowDownNarrowWide: kc,
  LucideArrowDownRight: Mc,
  LucideArrowDownRightFromCircle: S1,
  LucideArrowDownRightFromSquare: pa,
  LucideArrowDownRightSquare: la,
  LucideArrowDownSquare: ha,
  LucideArrowDownToDot: fc,
  LucideArrowDownToLine: gc,
  LucideArrowDownUp: mc,
  LucideArrowDownWideNarrow: Ye,
  LucideArrowDownZA: _e,
  LucideArrowDownZa: _e,
  LucideArrowLeft: Cc,
  LucideArrowLeftCircle: L1,
  LucideArrowLeftFromLine: xc,
  LucideArrowLeftRight: Ic,
  LucideArrowLeftSquare: ya,
  LucideArrowLeftToLine: wc,
  LucideArrowRight: qc,
  LucideArrowRightCircle: A1,
  LucideArrowRightFromLine: Lc,
  LucideArrowRightLeft: bc,
  LucideArrowRightSquare: fa,
  LucideArrowRightToLine: Sc,
  LucideArrowUp: Tc,
  LucideArrowUp01: zc,
  LucideArrowUp10: Ac,
  LucideArrowUpAZ: e1,
  LucideArrowUpAz: e1,
  LucideArrowUpCircle: H1,
  LucideArrowUpDown: Hc,
  LucideArrowUpFromDot: Pc,
  LucideArrowUpFromLine: Bc,
  LucideArrowUpLeft: Vc,
  LucideArrowUpLeftFromCircle: q1,
  LucideArrowUpLeftFromSquare: ka,
  LucideArrowUpLeftSquare: ga,
  LucideArrowUpNarrowWide: t1,
  LucideArrowUpRight: Fc,
  LucideArrowUpRightFromCircle: z1,
  LucideArrowUpRightFromSquare: Ma,
  LucideArrowUpRightSquare: ma,
  LucideArrowUpSquare: va,
  LucideArrowUpToLine: jc,
  LucideArrowUpWideNarrow: Dc,
  LucideArrowUpZA: a1,
  LucideArrowUpZa: a1,
  LucideArrowsUpFromLine: Rc,
  LucideAsterisk: Oc,
  LucideAsteriskSquare: xa,
  LucideAtSign: $c,
  LucideAtom: Ec,
  LucideAudioLines: Uc,
  LucideAudioWaveform: Zc,
  LucideAward: Nc,
  LucideAxe: Wc,
  LucideAxis3D: o1,
  LucideAxis3d: o1,
  LucideBaby: Gc,
  LucideBackpack: Xc,
  LucideBadge: hn,
  LucideBadgeAlert: Kc,
  LucideBadgeCent: Jc,
  LucideBadgeCheck: c1,
  LucideBadgeDollarSign: Qc,
  LucideBadgeEuro: Yc,
  LucideBadgeHelp: _c,
  LucideBadgeIndianRupee: en,
  LucideBadgeInfo: tn,
  LucideBadgeJapaneseYen: an,
  LucideBadgeMinus: on,
  LucideBadgePercent: cn,
  LucideBadgePlus: nn,
  LucideBadgePoundSterling: rn,
  LucideBadgeRussianRuble: dn,
  LucideBadgeSwissFranc: sn,
  LucideBadgeX: ln,
  LucideBaggageClaim: yn,
  LucideBan: un,
  LucideBanana: pn,
  LucideBandage: kn,
  LucideBanknote: Mn,
  LucideBarChart: g1,
  LucideBarChart2: m1,
  LucideBarChart3: M1,
  LucideBarChart4: k1,
  LucideBarChartBig: p1,
  LucideBarChartHorizontal: y1,
  LucideBarChartHorizontalBig: h1,
  LucideBarcode: fn,
  LucideBaseline: gn,
  LucideBath: mn,
  LucideBattery: Ln,
  LucideBatteryCharging: vn,
  LucideBatteryFull: xn,
  LucideBatteryLow: In,
  LucideBatteryMedium: wn,
  LucideBatteryWarning: Cn,
  LucideBeaker: bn,
  LucideBean: qn,
  LucideBeanOff: Sn,
  LucideBed: Hn,
  LucideBedDouble: zn,
  LucideBedSingle: An,
  LucideBeef: Pn,
  LucideBeer: Vn,
  LucideBeerOff: Bn,
  LucideBell: $n,
  LucideBellDot: Fn,
  LucideBellElectric: jn,
  LucideBellMinus: Dn,
  LucideBellOff: Tn,
  LucideBellPlus: Rn,
  LucideBellRing: On,
  LucideBetweenHorizonalEnd: n1,
  LucideBetweenHorizonalStart: i1,
  LucideBetweenHorizontalEnd: n1,
  LucideBetweenHorizontalStart: i1,
  LucideBetweenVerticalEnd: En,
  LucideBetweenVerticalStart: Un,
  LucideBicepsFlexed: Zn,
  LucideBike: Nn,
  LucideBinary: Wn,
  LucideBinoculars: Gn,
  LucideBiohazard: Xn,
  LucideBird: Kn,
  LucideBitcoin: Jn,
  LucideBlend: Qn,
  LucideBlinds: Yn,
  LucideBlocks: _n,
  LucideBluetooth: o0,
  LucideBluetoothConnected: e0,
  LucideBluetoothOff: t0,
  LucideBluetoothSearching: a0,
  LucideBold: c0,
  LucideBolt: n0,
  LucideBomb: i0,
  LucideBone: r0,
  LucideBook: A0,
  LucideBookA: d0,
  LucideBookAudio: s0,
  LucideBookCheck: l0,
  LucideBookCopy: h0,
  LucideBookDashed: r1,
  LucideBookDown: y0,
  LucideBookHeadphones: u0,
  LucideBookHeart: p0,
  LucideBookImage: k0,
  LucideBookKey: M0,
  LucideBookLock: f0,
  LucideBookMarked: g0,
  LucideBookMinus: m0,
  LucideBookOpen: I0,
  LucideBookOpenCheck: v0,
  LucideBookOpenText: x0,
  LucideBookPlus: w0,
  LucideBookTemplate: r1,
  LucideBookText: C0,
  LucideBookType: L0,
  LucideBookUp: S0,
  LucideBookUp2: b0,
  LucideBookUser: q0,
  LucideBookX: z0,
  LucideBookmark: F0,
  LucideBookmarkCheck: H0,
  LucideBookmarkMinus: P0,
  LucideBookmarkPlus: B0,
  LucideBookmarkX: V0,
  LucideBoomBox: j0,
  LucideBot: R0,
  LucideBotMessageSquare: D0,
  LucideBotOff: T0,
  LucideBox: O0,
  LucideBoxSelect: Pa,
  LucideBoxes: $0,
  LucideBraces: d1,
  LucideBrackets: E0,
  LucideBrain: N0,
  LucideBrainCircuit: U0,
  LucideBrainCog: Z0,
  LucideBrickWall: W0,
  LucideBriefcase: J0,
  LucideBriefcaseBusiness: G0,
  LucideBriefcaseConveyorBelt: X0,
  LucideBriefcaseMedical: K0,
  LucideBringToFront: Q0,
  LucideBrush: Y0,
  LucideBug: ti,
  LucideBugOff: _0,
  LucideBugPlay: ei,
  LucideBuilding: oi,
  LucideBuilding2: ai,
  LucideBus: ni,
  LucideBusFront: ci,
  LucideCable: ri,
  LucideCableCar: ii,
  LucideCake: si,
  LucideCakeSlice: di,
  LucideCalculator: li,
  LucideCalendar: Hi,
  LucideCalendar1: hi,
  LucideCalendarArrowDown: yi,
  LucideCalendarArrowUp: ui,
  LucideCalendarCheck: ki,
  LucideCalendarCheck2: pi,
  LucideCalendarClock: Mi,
  LucideCalendarCog: fi,
  LucideCalendarDays: gi,
  LucideCalendarFold: mi,
  LucideCalendarHeart: vi,
  LucideCalendarMinus: Ii,
  LucideCalendarMinus2: xi,
  LucideCalendarOff: wi,
  LucideCalendarPlus: Li,
  LucideCalendarPlus2: Ci,
  LucideCalendarRange: bi,
  LucideCalendarSearch: Si,
  LucideCalendarSync: qi,
  LucideCalendarX: Ai,
  LucideCalendarX2: zi,
  LucideCamera: Bi,
  LucideCameraOff: Pi,
  LucideCandlestickChart: u1,
  LucideCandy: ji,
  LucideCandyCane: Vi,
  LucideCandyOff: Fi,
  LucideCannabis: Di,
  LucideCaptions: s1,
  LucideCaptionsOff: Ti,
  LucideCar: $i,
  LucideCarFront: Ri,
  LucideCarTaxiFront: Oi,
  LucideCaravan: Ei,
  LucideCarrot: Ui,
  LucideCaseLower: Zi,
  LucideCaseSensitive: Ni,
  LucideCaseUpper: Wi,
  LucideCassetteTape: Gi,
  LucideCast: Xi,
  LucideCastle: Ki,
  LucideCat: Ji,
  LucideCctv: Qi,
  LucideChartArea: l1,
  LucideChartBar: y1,
  LucideChartBarBig: h1,
  LucideChartBarDecreasing: Yi,
  LucideChartBarIncreasing: _i,
  LucideChartBarStacked: er,
  LucideChartCandlestick: u1,
  LucideChartColumn: M1,
  LucideChartColumnBig: p1,
  LucideChartColumnDecreasing: tr,
  LucideChartColumnIncreasing: k1,
  LucideChartColumnStacked: ar,
  LucideChartGantt: or,
  LucideChartLine: f1,
  LucideChartNetwork: cr,
  LucideChartNoAxesColumn: m1,
  LucideChartNoAxesColumnDecreasing: nr,
  LucideChartNoAxesColumnIncreasing: g1,
  LucideChartNoAxesCombined: ir,
  LucideChartNoAxesGantt: v1,
  LucideChartPie: x1,
  LucideChartScatter: I1,
  LucideChartSpline: rr,
  LucideCheck: sr,
  LucideCheckCheck: dr,
  LucideCheckCircle: P1,
  LucideCheckCircle2: B1,
  LucideCheckSquare: wa,
  LucideCheckSquare2: Ca,
  LucideChefHat: lr,
  LucideCherry: hr,
  LucideChevronDown: N2,
  LucideChevronDownCircle: V1,
  LucideChevronDownSquare: La,
  LucideChevronFirst: yr,
  LucideChevronLast: ur,
  LucideChevronLeft: pr,
  LucideChevronLeftCircle: F1,
  LucideChevronLeftSquare: ba,
  LucideChevronRight: kr,
  LucideChevronRightCircle: j1,
  LucideChevronRightSquare: Sa,
  LucideChevronUp: Mr,
  LucideChevronUpCircle: D1,
  LucideChevronUpSquare: qa,
  LucideChevronsDown: gr,
  LucideChevronsDownUp: fr,
  LucideChevronsLeft: xr,
  LucideChevronsLeftRight: vr,
  LucideChevronsLeftRightEllipsis: mr,
  LucideChevronsRight: wr,
  LucideChevronsRightLeft: Ir,
  LucideChevronsUp: Lr,
  LucideChevronsUpDown: Cr,
  LucideChrome: br,
  LucideChurch: Sr,
  LucideCigarette: zr,
  LucideCigaretteOff: qr,
  LucideCircle: Or,
  LucideCircleAlert: w1,
  LucideCircleArrowDown: C1,
  LucideCircleArrowLeft: L1,
  LucideCircleArrowOutDownLeft: b1,
  LucideCircleArrowOutDownRight: S1,
  LucideCircleArrowOutUpLeft: q1,
  LucideCircleArrowOutUpRight: z1,
  LucideCircleArrowRight: A1,
  LucideCircleArrowUp: H1,
  LucideCircleCheck: B1,
  LucideCircleCheckBig: P1,
  LucideCircleChevronDown: V1,
  LucideCircleChevronLeft: F1,
  LucideCircleChevronRight: j1,
  LucideCircleChevronUp: D1,
  LucideCircleDashed: Ar,
  LucideCircleDivide: T1,
  LucideCircleDollarSign: Hr,
  LucideCircleDot: Br,
  LucideCircleDotDashed: Pr,
  LucideCircleEllipsis: Vr,
  LucideCircleEqual: Fr,
  LucideCircleFadingArrowUp: jr,
  LucideCircleFadingPlus: Dr,
  LucideCircleGauge: R1,
  LucideCircleHelp: O1,
  LucideCircleMinus: $1,
  LucideCircleOff: Tr,
  LucideCircleParking: U1,
  LucideCircleParkingOff: E1,
  LucideCirclePause: Z1,
  LucideCirclePercent: N1,
  LucideCirclePlay: W1,
  LucideCirclePlus: G1,
  LucideCirclePower: X1,
  LucideCircleSlash: Rr,
  LucideCircleSlash2: K1,
  LucideCircleSlashed: K1,
  LucideCircleStop: J1,
  LucideCircleUser: Y1,
  LucideCircleUserRound: Q1,
  LucideCircleX: _1,
  LucideCircuitBoard: $r,
  LucideCitrus: Er,
  LucideClapperboard: Ur,
  LucideClipboard: Yr,
  LucideClipboardCheck: Zr,
  LucideClipboardCopy: Nr,
  LucideClipboardEdit: tt,
  LucideClipboardList: Wr,
  LucideClipboardMinus: Gr,
  LucideClipboardPaste: Xr,
  LucideClipboardPen: tt,
  LucideClipboardPenLine: et,
  LucideClipboardPlus: Kr,
  LucideClipboardSignature: et,
  LucideClipboardType: Jr,
  LucideClipboardX: Qr,
  LucideClock: pd,
  LucideClock1: _r,
  LucideClock10: ed,
  LucideClock11: td,
  LucideClock12: ad,
  LucideClock2: od,
  LucideClock3: cd,
  LucideClock4: nd,
  LucideClock5: id,
  LucideClock6: rd,
  LucideClock7: dd,
  LucideClock8: sd,
  LucideClock9: ld,
  LucideClockAlert: hd,
  LucideClockArrowDown: yd,
  LucideClockArrowUp: ud,
  LucideCloud: zd,
  LucideCloudAlert: kd,
  LucideCloudCog: Md,
  LucideCloudDownload: at,
  LucideCloudDrizzle: fd,
  LucideCloudFog: gd,
  LucideCloudHail: md,
  LucideCloudLightning: vd,
  LucideCloudMoon: Id,
  LucideCloudMoonRain: xd,
  LucideCloudOff: wd,
  LucideCloudRain: Ld,
  LucideCloudRainWind: Cd,
  LucideCloudSnow: bd,
  LucideCloudSun: qd,
  LucideCloudSunRain: Sd,
  LucideCloudUpload: ot,
  LucideCloudy: Ad,
  LucideClover: Hd,
  LucideClub: Pd,
  LucideCode: Bd,
  LucideCode2: ct,
  LucideCodeSquare: za,
  LucideCodeXml: ct,
  LucideCodepen: Vd,
  LucideCodesandbox: Fd,
  LucideCoffee: jd,
  LucideCog: Dd,
  LucideCoins: Td,
  LucideColumns: nt,
  LucideColumns2: nt,
  LucideColumns3: it,
  LucideColumns4: Rd,
  LucideCombine: Od,
  LucideCommand: $d,
  LucideCompass: Ed,
  LucideComponent: Ud,
  LucideComputer: Zd,
  LucideConciergeBell: Nd,
  LucideCone: Wd,
  LucideConstruction: Gd,
  LucideContact: Xd,
  LucideContact2: rt,
  LucideContactRound: rt,
  LucideContainer: Kd,
  LucideContrast: Jd,
  LucideCookie: Qd,
  LucideCookingPot: Yd,
  LucideCopy: cs,
  LucideCopyCheck: _d,
  LucideCopyMinus: es,
  LucideCopyPlus: ts,
  LucideCopySlash: as,
  LucideCopyX: os,
  LucideCopyleft: ns,
  LucideCopyright: is,
  LucideCornerDownLeft: rs,
  LucideCornerDownRight: ds,
  LucideCornerLeftDown: ss,
  LucideCornerLeftUp: ls,
  LucideCornerRightDown: hs,
  LucideCornerRightUp: ys,
  LucideCornerUpLeft: us,
  LucideCornerUpRight: ps,
  LucideCpu: ks,
  LucideCreativeCommons: Ms,
  LucideCreditCard: fs,
  LucideCroissant: gs,
  LucideCrop: ms,
  LucideCross: vs,
  LucideCrosshair: xs,
  LucideCrown: Is,
  LucideCuboid: ws,
  LucideCupSoda: Cs,
  LucideCurlyBraces: d1,
  LucideCurrency: Ls,
  LucideCylinder: bs,
  LucideDam: Ss,
  LucideDatabase: As,
  LucideDatabaseBackup: qs,
  LucideDatabaseZap: zs,
  LucideDelete: Hs,
  LucideDessert: Ps,
  LucideDiameter: Bs,
  LucideDiamond: js,
  LucideDiamondMinus: Vs,
  LucideDiamondPercent: dt,
  LucideDiamondPlus: Fs,
  LucideDice1: Ds,
  LucideDice2: Ts,
  LucideDice3: Rs,
  LucideDice4: Os,
  LucideDice5: $s,
  LucideDice6: Es,
  LucideDices: Us,
  LucideDiff: Zs,
  LucideDisc: Xs,
  LucideDisc2: Ns,
  LucideDisc3: Ws,
  LucideDiscAlbum: Gs,
  LucideDivide: Ks,
  LucideDivideCircle: T1,
  LucideDivideSquare: Ba,
  LucideDna: Qs,
  LucideDnaOff: Js,
  LucideDock: Ys,
  LucideDog: _s,
  LucideDollarSign: el,
  LucideDonut: tl,
  LucideDoorClosed: al,
  LucideDoorOpen: ol,
  LucideDot: cl,
  LucideDotSquare: Va,
  LucideDownload: nl,
  LucideDownloadCloud: at,
  LucideDraftingCompass: il,
  LucideDrama: rl,
  LucideDribbble: dl,
  LucideDrill: sl,
  LucideDroplet: hl,
  LucideDropletOff: ll,
  LucideDroplets: yl,
  LucideDrum: ul,
  LucideDrumstick: pl,
  LucideDumbbell: kl,
  LucideEar: fl,
  LucideEarOff: Ml,
  LucideEarth: st,
  LucideEarthLock: gl,
  LucideEclipse: ml,
  LucideEdit: ke,
  LucideEdit2: Qt,
  LucideEdit3: Jt,
  LucideEgg: Il,
  LucideEggFried: vl,
  LucideEggOff: xl,
  LucideEllipsis: ht,
  LucideEllipsisVertical: lt,
  LucideEqual: Ll,
  LucideEqualApproximately: wl,
  LucideEqualNot: Cl,
  LucideEqualSquare: Fa,
  LucideEraser: bl,
  LucideEthernetPort: Sl,
  LucideEuro: ql,
  LucideExpand: zl,
  LucideExternalLink: Al,
  LucideEye: Bl,
  LucideEyeClosed: Hl,
  LucideEyeOff: Pl,
  LucideFacebook: Vl,
  LucideFactory: Fl,
  LucideFan: jl,
  LucideFastForward: Dl,
  LucideFeather: Tl,
  LucideFence: Rl,
  LucideFerrisWheel: Ol,
  LucideFigma: $l,
  LucideFile: Th,
  LucideFileArchive: El,
  LucideFileAudio: Zl,
  LucideFileAudio2: Ul,
  LucideFileAxis3D: yt,
  LucideFileAxis3d: yt,
  LucideFileBadge: Wl,
  LucideFileBadge2: Nl,
  LucideFileBarChart: ut,
  LucideFileBarChart2: pt,
  LucideFileBox: Gl,
  LucideFileChartColumn: pt,
  LucideFileChartColumnIncreasing: ut,
  LucideFileChartLine: kt,
  LucideFileChartPie: Mt,
  LucideFileCheck: Kl,
  LucideFileCheck2: Xl,
  LucideFileClock: Jl,
  LucideFileCode: Yl,
  LucideFileCode2: Ql,
  LucideFileCog: ft,
  LucideFileCog2: ft,
  LucideFileDiff: _l,
  LucideFileDigit: eh,
  LucideFileDown: th,
  LucideFileEdit: mt,
  LucideFileHeart: ah,
  LucideFileImage: oh,
  LucideFileInput: ch,
  LucideFileJson: ih,
  LucideFileJson2: nh,
  LucideFileKey: dh,
  LucideFileKey2: rh,
  LucideFileLineChart: kt,
  LucideFileLock: lh,
  LucideFileLock2: sh,
  LucideFileMinus: yh,
  LucideFileMinus2: hh,
  LucideFileMusic: uh,
  LucideFileOutput: ph,
  LucideFilePen: mt,
  LucideFilePenLine: gt,
  LucideFilePieChart: Mt,
  LucideFilePlus: Mh,
  LucideFilePlus2: kh,
  LucideFileQuestion: fh,
  LucideFileScan: gh,
  LucideFileSearch: vh,
  LucideFileSearch2: mh,
  LucideFileSignature: gt,
  LucideFileSliders: xh,
  LucideFileSpreadsheet: Ih,
  LucideFileStack: wh,
  LucideFileSymlink: Ch,
  LucideFileTerminal: Lh,
  LucideFileText: bh,
  LucideFileType: qh,
  LucideFileType2: Sh,
  LucideFileUp: zh,
  LucideFileUser: Ah,
  LucideFileVideo: Ph,
  LucideFileVideo2: Hh,
  LucideFileVolume: Vh,
  LucideFileVolume2: Bh,
  LucideFileWarning: Fh,
  LucideFileX: Dh,
  LucideFileX2: jh,
  LucideFiles: Rh,
  LucideFilm: Oh,
  LucideFilter: Eh,
  LucideFilterX: $h,
  LucideFingerprint: Uh,
  LucideFireExtinguisher: Zh,
  LucideFish: Gh,
  LucideFishOff: Nh,
  LucideFishSymbol: Wh,
  LucideFlag: Qh,
  LucideFlagOff: Xh,
  LucideFlagTriangleLeft: Kh,
  LucideFlagTriangleRight: Jh,
  LucideFlame: _h,
  LucideFlameKindling: Yh,
  LucideFlashlight: ty,
  LucideFlashlightOff: ey,
  LucideFlaskConical: oy,
  LucideFlaskConicalOff: ay,
  LucideFlaskRound: cy,
  LucideFlipHorizontal: iy,
  LucideFlipHorizontal2: ny,
  LucideFlipVertical: dy,
  LucideFlipVertical2: ry,
  LucideFlower: ly,
  LucideFlower2: sy,
  LucideFocus: hy,
  LucideFoldHorizontal: yy,
  LucideFoldVertical: uy,
  LucideFolder: $y,
  LucideFolderArchive: py,
  LucideFolderCheck: ky,
  LucideFolderClock: My,
  LucideFolderClosed: fy,
  LucideFolderCode: gy,
  LucideFolderCog: vt,
  LucideFolderCog2: vt,
  LucideFolderDot: my,
  LucideFolderDown: vy,
  LucideFolderEdit: xt,
  LucideFolderGit: Iy,
  LucideFolderGit2: xy,
  LucideFolderHeart: wy,
  LucideFolderInput: Cy,
  LucideFolderKanban: Ly,
  LucideFolderKey: by,
  LucideFolderLock: Sy,
  LucideFolderMinus: qy,
  LucideFolderOpen: Ay,
  LucideFolderOpenDot: zy,
  LucideFolderOutput: Hy,
  LucideFolderPen: xt,
  LucideFolderPlus: Py,
  LucideFolderRoot: By,
  LucideFolderSearch: Fy,
  LucideFolderSearch2: Vy,
  LucideFolderSymlink: jy,
  LucideFolderSync: Dy,
  LucideFolderTree: Ty,
  LucideFolderUp: Ry,
  LucideFolderX: Oy,
  LucideFolders: Ey,
  LucideFootprints: Uy,
  LucideForkKnife: x2,
  LucideForkKnifeCrossed: v2,
  LucideForklift: Zy,
  LucideFormInput: _t,
  LucideForward: Ny,
  LucideFrame: Wy,
  LucideFramer: Gy,
  LucideFrown: Xy,
  LucideFuel: Ky,
  LucideFullscreen: Jy,
  LucideFunctionSquare: ja,
  LucideGalleryHorizontal: Yy,
  LucideGalleryHorizontalEnd: Qy,
  LucideGalleryThumbnails: _y,
  LucideGalleryVertical: tu,
  LucideGalleryVerticalEnd: eu,
  LucideGamepad: ou,
  LucideGamepad2: au,
  LucideGanttChart: v1,
  LucideGanttChartSquare: qe,
  LucideGauge: cu,
  LucideGaugeCircle: R1,
  LucideGavel: nu,
  LucideGem: iu,
  LucideGhost: ru,
  LucideGift: du,
  LucideGitBranch: lu,
  LucideGitBranchPlus: su,
  LucideGitCommit: It,
  LucideGitCommitHorizontal: It,
  LucideGitCommitVertical: hu,
  LucideGitCompare: uu,
  LucideGitCompareArrows: yu,
  LucideGitFork: pu,
  LucideGitGraph: ku,
  LucideGitMerge: Mu,
  LucideGitPullRequest: Iu,
  LucideGitPullRequestArrow: fu,
  LucideGitPullRequestClosed: gu,
  LucideGitPullRequestCreate: vu,
  LucideGitPullRequestCreateArrow: mu,
  LucideGitPullRequestDraft: xu,
  LucideGithub: wu,
  LucideGitlab: Cu,
  LucideGlassWater: Lu,
  LucideGlasses: bu,
  LucideGlobe: qu,
  LucideGlobe2: st,
  LucideGlobeLock: Su,
  LucideGoal: zu,
  LucideGrab: Au,
  LucideGraduationCap: Hu,
  LucideGrape: Pu,
  LucideGrid: Se,
  LucideGrid2X2: Ct,
  LucideGrid2X2Plus: wt,
  LucideGrid2x2: Ct,
  LucideGrid2x2Check: Bu,
  LucideGrid2x2Plus: wt,
  LucideGrid2x2X: Vu,
  LucideGrid3X3: Se,
  LucideGrid3x3: Se,
  LucideGrip: Du,
  LucideGripHorizontal: Fu,
  LucideGripVertical: ju,
  LucideGroup: Tu,
  LucideGuitar: Ru,
  LucideHam: Ou,
  LucideHammer: $u,
  LucideHand: Wu,
  LucideHandCoins: Eu,
  LucideHandHeart: Uu,
  LucideHandHelping: Lt,
  LucideHandMetal: Zu,
  LucideHandPlatter: Nu,
  LucideHandshake: Gu,
  LucideHardDrive: Ju,
  LucideHardDriveDownload: Xu,
  LucideHardDriveUpload: Ku,
  LucideHardHat: Qu,
  LucideHash: Yu,
  LucideHaze: _u,
  LucideHdmiPort: ep,
  LucideHeading: rp,
  LucideHeading1: tp,
  LucideHeading2: ap,
  LucideHeading3: op,
  LucideHeading4: cp,
  LucideHeading5: np,
  LucideHeading6: ip,
  LucideHeadphoneOff: dp,
  LucideHeadphones: sp,
  LucideHeadset: lp,
  LucideHeart: kp,
  LucideHeartCrack: hp,
  LucideHeartHandshake: yp,
  LucideHeartOff: up,
  LucideHeartPulse: pp,
  LucideHeater: Mp,
  LucideHelpCircle: O1,
  LucideHelpingHand: Lt,
  LucideHexagon: fp,
  LucideHighlighter: gp,
  LucideHistory: mp,
  LucideHome: bt,
  LucideHop: xp,
  LucideHopOff: vp,
  LucideHospital: Ip,
  LucideHotel: wp,
  LucideHourglass: Cp,
  LucideHouse: bt,
  LucideHousePlug: Lp,
  LucideHousePlus: bp,
  LucideIceCream: qt,
  LucideIceCream2: St,
  LucideIceCreamBowl: St,
  LucideIceCreamCone: qt,
  LucideIdCard: Sp,
  LucideImage: Fp,
  LucideImageDown: qp,
  LucideImageMinus: zp,
  LucideImageOff: Ap,
  LucideImagePlay: Hp,
  LucideImagePlus: Pp,
  LucideImageUp: Bp,
  LucideImageUpscale: Vp,
  LucideImages: jp,
  LucideImport: Dp,
  LucideInbox: Tp,
  LucideIndent: At,
  LucideIndentDecrease: zt,
  LucideIndentIncrease: At,
  LucideIndianRupee: Rp,
  LucideInfinity: Op,
  LucideInfo: $p,
  LucideInspect: Ea,
  LucideInspectionPanel: Ep,
  LucideInstagram: Up,
  LucideItalic: Zp,
  LucideIterationCcw: Np,
  LucideIterationCw: Wp,
  LucideJapaneseYen: Gp,
  LucideJoystick: Xp,
  LucideKanban: Kp,
  LucideKanbanSquare: Da,
  LucideKanbanSquareDashed: Aa,
  LucideKey: Yp,
  LucideKeyRound: Jp,
  LucideKeySquare: Qp,
  LucideKeyboard: t4,
  LucideKeyboardMusic: _p,
  LucideKeyboardOff: e4,
  LucideLamp: r4,
  LucideLampCeiling: a4,
  LucideLampDesk: o4,
  LucideLampFloor: c4,
  LucideLampWallDown: n4,
  LucideLampWallUp: i4,
  LucideLandPlot: d4,
  LucideLandmark: s4,
  LucideLanguages: l4,
  LucideLaptop: y4,
  LucideLaptop2: Ht,
  LucideLaptopMinimal: Ht,
  LucideLaptopMinimalCheck: h4,
  LucideLasso: p4,
  LucideLassoSelect: u4,
  LucideLaugh: k4,
  LucideLayers: Pt,
  LucideLayers2: M4,
  LucideLayers3: Pt,
  LucideLayout: Kt,
  LucideLayoutDashboard: f4,
  LucideLayoutGrid: g4,
  LucideLayoutList: m4,
  LucideLayoutPanelLeft: v4,
  LucideLayoutPanelTop: x4,
  LucideLayoutTemplate: I4,
  LucideLeaf: w4,
  LucideLeafyGreen: C4,
  LucideLectern: L4,
  LucideLetterText: b4,
  LucideLibrary: q4,
  LucideLibraryBig: S4,
  LucideLibrarySquare: Ta,
  LucideLifeBuoy: z4,
  LucideLigature: A4,
  LucideLightbulb: P4,
  LucideLightbulbOff: H4,
  LucideLineChart: f1,
  LucideLink: F4,
  LucideLink2: V4,
  LucideLink2Off: B4,
  LucideLinkedin: j4,
  LucideList: _4,
  LucideListCheck: D4,
  LucideListChecks: T4,
  LucideListCollapse: R4,
  LucideListEnd: O4,
  LucideListFilter: E4,
  LucideListFilterPlus: $4,
  LucideListMinus: U4,
  LucideListMusic: Z4,
  LucideListOrdered: N4,
  LucideListPlus: W4,
  LucideListRestart: G4,
  LucideListStart: X4,
  LucideListTodo: K4,
  LucideListTree: J4,
  LucideListVideo: Q4,
  LucideListX: Y4,
  LucideLoader: tk,
  LucideLoader2: Bt,
  LucideLoaderCircle: Bt,
  LucideLoaderPinwheel: ek,
  LucideLocate: ck,
  LucideLocateFixed: ak,
  LucideLocateOff: ok,
  LucideLock: ik,
  LucideLockKeyhole: nk,
  LucideLockKeyholeOpen: Vt,
  LucideLockOpen: Ft,
  LucideLogIn: rk,
  LucideLogOut: dk,
  LucideLogs: sk,
  LucideLollipop: lk,
  LucideLuggage: hk,
  LucideMSquare: Ra,
  LucideMagnet: yk,
  LucideMail: xk,
  LucideMailCheck: uk,
  LucideMailMinus: pk,
  LucideMailOpen: kk,
  LucideMailPlus: Mk,
  LucideMailQuestion: fk,
  LucideMailSearch: gk,
  LucideMailWarning: mk,
  LucideMailX: vk,
  LucideMailbox: Ik,
  LucideMails: wk,
  LucideMap: jk,
  LucideMapPin: Vk,
  LucideMapPinCheck: Lk,
  LucideMapPinCheckInside: Ck,
  LucideMapPinHouse: bk,
  LucideMapPinMinus: qk,
  LucideMapPinMinusInside: Sk,
  LucideMapPinOff: zk,
  LucideMapPinPlus: Hk,
  LucideMapPinPlusInside: Ak,
  LucideMapPinX: Bk,
  LucideMapPinXInside: Pk,
  LucideMapPinned: Fk,
  LucideMartini: Dk,
  LucideMaximize: Rk,
  LucideMaximize2: Tk,
  LucideMedal: Ok,
  LucideMegaphone: Ek,
  LucideMegaphoneOff: $k,
  LucideMeh: Uk,
  LucideMemoryStick: Zk,
  LucideMenu: Nk,
  LucideMenuSquare: Oa,
  LucideMerge: Wk,
  LucideMessageCircle: o5,
  LucideMessageCircleCode: Gk,
  LucideMessageCircleDashed: Xk,
  LucideMessageCircleHeart: Kk,
  LucideMessageCircleMore: Jk,
  LucideMessageCircleOff: Qk,
  LucideMessageCirclePlus: Yk,
  LucideMessageCircleQuestion: _k,
  LucideMessageCircleReply: e5,
  LucideMessageCircleWarning: t5,
  LucideMessageCircleX: a5,
  LucideMessageSquare: m5,
  LucideMessageSquareCode: c5,
  LucideMessageSquareDashed: n5,
  LucideMessageSquareDiff: i5,
  LucideMessageSquareDot: r5,
  LucideMessageSquareHeart: d5,
  LucideMessageSquareLock: s5,
  LucideMessageSquareMore: l5,
  LucideMessageSquareOff: h5,
  LucideMessageSquarePlus: y5,
  LucideMessageSquareQuote: u5,
  LucideMessageSquareReply: p5,
  LucideMessageSquareShare: k5,
  LucideMessageSquareText: M5,
  LucideMessageSquareWarning: f5,
  LucideMessageSquareX: g5,
  LucideMessagesSquare: v5,
  LucideMic: I5,
  LucideMic2: jt,
  LucideMicOff: x5,
  LucideMicVocal: jt,
  LucideMicrochip: w5,
  LucideMicroscope: C5,
  LucideMicrowave: L5,
  LucideMilestone: b5,
  LucideMilk: q5,
  LucideMilkOff: S5,
  LucideMinimize: A5,
  LucideMinimize2: z5,
  LucideMinus: H5,
  LucideMinusCircle: $1,
  LucideMinusSquare: $a,
  LucideMonitor: Z5,
  LucideMonitorCheck: P5,
  LucideMonitorCog: B5,
  LucideMonitorDot: V5,
  LucideMonitorDown: F5,
  LucideMonitorOff: j5,
  LucideMonitorPause: D5,
  LucideMonitorPlay: T5,
  LucideMonitorSmartphone: R5,
  LucideMonitorSpeaker: O5,
  LucideMonitorStop: $5,
  LucideMonitorUp: E5,
  LucideMonitorX: U5,
  LucideMoon: W5,
  LucideMoonStar: N5,
  LucideMoreHorizontal: ht,
  LucideMoreVertical: lt,
  LucideMountain: X5,
  LucideMountainSnow: G5,
  LucideMouse: e3,
  LucideMouseOff: K5,
  LucideMousePointer: _5,
  LucideMousePointer2: J5,
  LucideMousePointerBan: Q5,
  LucideMousePointerClick: Y5,
  LucideMousePointerSquareDashed: Ha,
  LucideMove: u3,
  LucideMove3D: Dt,
  LucideMove3d: Dt,
  LucideMoveDiagonal: a3,
  LucideMoveDiagonal2: t3,
  LucideMoveDown: n3,
  LucideMoveDownLeft: o3,
  LucideMoveDownRight: c3,
  LucideMoveHorizontal: i3,
  LucideMoveLeft: r3,
  LucideMoveRight: d3,
  LucideMoveUp: h3,
  LucideMoveUpLeft: s3,
  LucideMoveUpRight: l3,
  LucideMoveVertical: y3,
  LucideMusic: f3,
  LucideMusic2: p3,
  LucideMusic3: k3,
  LucideMusic4: M3,
  LucideNavigation: x3,
  LucideNavigation2: m3,
  LucideNavigation2Off: g3,
  LucideNavigationOff: v3,
  LucideNetwork: I3,
  LucideNewspaper: w3,
  LucideNfc: C3,
  LucideNotebook: q3,
  LucideNotebookPen: L3,
  LucideNotebookTabs: b3,
  LucideNotebookText: S3,
  LucideNotepadText: A3,
  LucideNotepadTextDashed: z3,
  LucideNut: P3,
  LucideNutOff: H3,
  LucideOctagon: V3,
  LucideOctagonAlert: Tt,
  LucideOctagonMinus: B3,
  LucideOctagonPause: Rt,
  LucideOctagonX: Ot,
  LucideOmega: F3,
  LucideOption: j3,
  LucideOrbit: D3,
  LucideOrigami: T3,
  LucideOutdent: zt,
  LucidePackage: W3,
  LucidePackage2: R3,
  LucidePackageCheck: O3,
  LucidePackageMinus: $3,
  LucidePackageOpen: E3,
  LucidePackagePlus: U3,
  LucidePackageSearch: Z3,
  LucidePackageX: N3,
  LucidePaintBucket: G3,
  LucidePaintRoller: X3,
  LucidePaintbrush: K3,
  LucidePaintbrush2: $t,
  LucidePaintbrushVertical: $t,
  LucidePalette: J3,
  LucidePalmtree: s2,
  LucidePanelBottom: _3,
  LucidePanelBottomClose: Q3,
  LucidePanelBottomDashed: Et,
  LucidePanelBottomInactive: Et,
  LucidePanelBottomOpen: Y3,
  LucidePanelLeft: Wt,
  LucidePanelLeftClose: Ut,
  LucidePanelLeftDashed: Zt,
  LucidePanelLeftInactive: Zt,
  LucidePanelLeftOpen: Nt,
  LucidePanelRight: a6,
  LucidePanelRightClose: e6,
  LucidePanelRightDashed: Gt,
  LucidePanelRightInactive: Gt,
  LucidePanelRightOpen: t6,
  LucidePanelTop: n6,
  LucidePanelTopClose: o6,
  LucidePanelTopDashed: Xt,
  LucidePanelTopInactive: Xt,
  LucidePanelTopOpen: c6,
  LucidePanelsLeftBottom: i6,
  LucidePanelsLeftRight: it,
  LucidePanelsRightBottom: r6,
  LucidePanelsTopBottom: aa,
  LucidePanelsTopLeft: Kt,
  LucidePaperclip: d6,
  LucideParentheses: s6,
  LucideParkingCircle: U1,
  LucideParkingCircleOff: E1,
  LucideParkingMeter: l6,
  LucideParkingSquare: Za,
  LucideParkingSquareOff: Ua,
  LucidePartyPopper: h6,
  LucidePause: y6,
  LucidePauseCircle: Z1,
  LucidePauseOctagon: Rt,
  LucidePawPrint: u6,
  LucidePcCase: p6,
  LucidePen: Qt,
  LucidePenBox: ke,
  LucidePenLine: Jt,
  LucidePenOff: k6,
  LucidePenSquare: ke,
  LucidePenTool: M6,
  LucidePencil: v6,
  LucidePencilLine: f6,
  LucidePencilOff: g6,
  LucidePencilRuler: m6,
  LucidePentagon: x6,
  LucidePercent: I6,
  LucidePercentCircle: N1,
  LucidePercentDiamond: dt,
  LucidePercentSquare: Na,
  LucidePersonStanding: w6,
  LucidePhilippinePeso: C6,
  LucidePhone: H6,
  LucidePhoneCall: L6,
  LucidePhoneForwarded: b6,
  LucidePhoneIncoming: S6,
  LucidePhoneMissed: q6,
  LucidePhoneOff: z6,
  LucidePhoneOutgoing: A6,
  LucidePi: P6,
  LucidePiSquare: Wa,
  LucidePiano: B6,
  LucidePickaxe: V6,
  LucidePictureInPicture: j6,
  LucidePictureInPicture2: F6,
  LucidePieChart: x1,
  LucidePiggyBank: D6,
  LucidePilcrow: O6,
  LucidePilcrowLeft: T6,
  LucidePilcrowRight: R6,
  LucidePilcrowSquare: Ga,
  LucidePill: E6,
  LucidePillBottle: $6,
  LucidePin: Z6,
  LucidePinOff: U6,
  LucidePipette: N6,
  LucidePizza: W6,
  LucidePlane: K6,
  LucidePlaneLanding: G6,
  LucidePlaneTakeoff: X6,
  LucidePlay: J6,
  LucidePlayCircle: W1,
  LucidePlaySquare: Xa,
  LucidePlug: Y6,
  LucidePlug2: Q6,
  LucidePlugZap: Yt,
  LucidePlugZap2: Yt,
  LucidePlus: _6,
  LucidePlusCircle: G1,
  LucidePlusSquare: Ka,
  LucidePocket: t8,
  LucidePocketKnife: e8,
  LucidePodcast: a8,
  LucidePointer: c8,
  LucidePointerOff: o8,
  LucidePopcorn: n8,
  LucidePopsicle: i8,
  LucidePoundSterling: r8,
  LucidePower: s8,
  LucidePowerCircle: X1,
  LucidePowerOff: d8,
  LucidePowerSquare: Ja,
  LucidePresentation: l8,
  LucidePrinter: y8,
  LucidePrinterCheck: h8,
  LucideProjector: u8,
  LucideProportions: p8,
  LucidePuzzle: k8,
  LucidePyramid: M8,
  LucideQrCode: f8,
  LucideQuote: g8,
  LucideRabbit: m8,
  LucideRadar: v8,
  LucideRadiation: x8,
  LucideRadical: I8,
  LucideRadio: L8,
  LucideRadioReceiver: w8,
  LucideRadioTower: C8,
  LucideRadius: b8,
  LucideRailSymbol: S8,
  LucideRainbow: q8,
  LucideRat: z8,
  LucideRatio: A8,
  LucideReceipt: R8,
  LucideReceiptCent: H8,
  LucideReceiptEuro: P8,
  LucideReceiptIndianRupee: B8,
  LucideReceiptJapaneseYen: V8,
  LucideReceiptPoundSterling: F8,
  LucideReceiptRussianRuble: j8,
  LucideReceiptSwissFranc: D8,
  LucideReceiptText: T8,
  LucideRectangleEllipsis: _t,
  LucideRectangleHorizontal: O8,
  LucideRectangleVertical: $8,
  LucideRecycle: E8,
  LucideRedo: N8,
  LucideRedo2: U8,
  LucideRedoDot: Z8,
  LucideRefreshCcw: G8,
  LucideRefreshCcwDot: W8,
  LucideRefreshCw: K8,
  LucideRefreshCwOff: X8,
  LucideRefrigerator: J8,
  LucideRegex: Q8,
  LucideRemoveFormatting: Y8,
  LucideRepeat: t7,
  LucideRepeat1: _8,
  LucideRepeat2: e7,
  LucideReplace: o7,
  LucideReplaceAll: a7,
  LucideReply: n7,
  LucideReplyAll: c7,
  LucideRewind: i7,
  LucideRibbon: r7,
  LucideRocket: d7,
  LucideRockingChair: s7,
  LucideRollerCoaster: l7,
  LucideRotate3D: ea,
  LucideRotate3d: ea,
  LucideRotateCcw: y7,
  LucideRotateCcwSquare: h7,
  LucideRotateCw: p7,
  LucideRotateCwSquare: u7,
  LucideRoute: M7,
  LucideRouteOff: k7,
  LucideRouter: f7,
  LucideRows: ta,
  LucideRows2: ta,
  LucideRows3: aa,
  LucideRows4: g7,
  LucideRss: m7,
  LucideRuler: v7,
  LucideRussianRuble: x7,
  LucideSailboat: I7,
  LucideSalad: w7,
  LucideSandwich: C7,
  LucideSatellite: b7,
  LucideSatelliteDish: L7,
  LucideSave: z7,
  LucideSaveAll: S7,
  LucideSaveOff: q7,
  LucideScale: A7,
  LucideScale3D: oa,
  LucideScale3d: oa,
  LucideScaling: H7,
  LucideScan: O7,
  LucideScanBarcode: P7,
  LucideScanEye: B7,
  LucideScanFace: V7,
  LucideScanHeart: F7,
  LucideScanLine: j7,
  LucideScanQrCode: D7,
  LucideScanSearch: T7,
  LucideScanText: R7,
  LucideScatterChart: I1,
  LucideSchool: $7,
  LucideSchool2: y2,
  LucideScissors: U7,
  LucideScissorsLineDashed: E7,
  LucideScissorsSquare: Qa,
  LucideScissorsSquareDashedBottom: Ia,
  LucideScreenShare: N7,
  LucideScreenShareOff: Z7,
  LucideScroll: G7,
  LucideScrollText: W7,
  LucideSearch: Y7,
  LucideSearchCheck: X7,
  LucideSearchCode: K7,
  LucideSearchSlash: J7,
  LucideSearchX: Q7,
  LucideSection: _7,
  LucideSend: t9,
  LucideSendHorizonal: ca,
  LucideSendHorizontal: ca,
  LucideSendToBack: e9,
  LucideSeparatorHorizontal: a9,
  LucideSeparatorVertical: o9,
  LucideServer: r9,
  LucideServerCog: c9,
  LucideServerCrash: n9,
  LucideServerOff: i9,
  LucideSettings: s9,
  LucideSettings2: d9,
  LucideShapes: l9,
  LucideShare: y9,
  LucideShare2: h9,
  LucideSheet: u9,
  LucideShell: p9,
  LucideShield: C9,
  LucideShieldAlert: k9,
  LucideShieldBan: M9,
  LucideShieldCheck: f9,
  LucideShieldClose: na,
  LucideShieldEllipsis: g9,
  LucideShieldHalf: m9,
  LucideShieldMinus: v9,
  LucideShieldOff: x9,
  LucideShieldPlus: I9,
  LucideShieldQuestion: w9,
  LucideShieldX: na,
  LucideShip: b9,
  LucideShipWheel: L9,
  LucideShirt: S9,
  LucideShoppingBag: q9,
  LucideShoppingBasket: z9,
  LucideShoppingCart: A9,
  LucideShovel: H9,
  LucideShowerHead: P9,
  LucideShrink: B9,
  LucideShrub: V9,
  LucideShuffle: F9,
  LucideSidebar: Wt,
  LucideSidebarClose: Ut,
  LucideSidebarOpen: Nt,
  LucideSigma: j9,
  LucideSigmaSquare: Ya,
  LucideSignal: $9,
  LucideSignalHigh: D9,
  LucideSignalLow: T9,
  LucideSignalMedium: R9,
  LucideSignalZero: O9,
  LucideSignature: E9,
  LucideSignpost: Z9,
  LucideSignpostBig: U9,
  LucideSiren: N9,
  LucideSkipBack: W9,
  LucideSkipForward: G9,
  LucideSkull: X9,
  LucideSlack: K9,
  LucideSlash: J9,
  LucideSlashSquare: _a,
  LucideSlice: Q9,
  LucideSliders: ia,
  LucideSlidersHorizontal: Y9,
  LucideSlidersVertical: ia,
  LucideSmartphone: tM,
  LucideSmartphoneCharging: _9,
  LucideSmartphoneNfc: eM,
  LucideSmile: oM,
  LucideSmilePlus: aM,
  LucideSnail: cM,
  LucideSnowflake: nM,
  LucideSofa: iM,
  LucideSortAsc: t1,
  LucideSortDesc: Ye,
  LucideSoup: rM,
  LucideSpace: dM,
  LucideSpade: sM,
  LucideSparkle: lM,
  LucideSparkles: ra,
  LucideSpeaker: hM,
  LucideSpeech: yM,
  LucideSpellCheck: pM,
  LucideSpellCheck2: uM,
  LucideSpline: kM,
  LucideSplit: MM,
  LucideSplitSquareHorizontal: e2,
  LucideSplitSquareVertical: t2,
  LucideSprayCan: fM,
  LucideSprout: gM,
  LucideSquare: CM,
  LucideSquareActivity: da,
  LucideSquareArrowDown: ha,
  LucideSquareArrowDownLeft: sa,
  LucideSquareArrowDownRight: la,
  LucideSquareArrowLeft: ya,
  LucideSquareArrowOutDownLeft: ua,
  LucideSquareArrowOutDownRight: pa,
  LucideSquareArrowOutUpLeft: ka,
  LucideSquareArrowOutUpRight: Ma,
  LucideSquareArrowRight: fa,
  LucideSquareArrowUp: va,
  LucideSquareArrowUpLeft: ga,
  LucideSquareArrowUpRight: ma,
  LucideSquareAsterisk: xa,
  LucideSquareBottomDashedScissors: Ia,
  LucideSquareChartGantt: qe,
  LucideSquareCheck: Ca,
  LucideSquareCheckBig: wa,
  LucideSquareChevronDown: La,
  LucideSquareChevronLeft: ba,
  LucideSquareChevronRight: Sa,
  LucideSquareChevronUp: qa,
  LucideSquareCode: za,
  LucideSquareDashed: Pa,
  LucideSquareDashedBottom: vM,
  LucideSquareDashedBottomCode: mM,
  LucideSquareDashedKanban: Aa,
  LucideSquareDashedMousePointer: Ha,
  LucideSquareDivide: Ba,
  LucideSquareDot: Va,
  LucideSquareEqual: Fa,
  LucideSquareFunction: ja,
  LucideSquareGanttChart: qe,
  LucideSquareKanban: Da,
  LucideSquareLibrary: Ta,
  LucideSquareM: Ra,
  LucideSquareMenu: Oa,
  LucideSquareMinus: $a,
  LucideSquareMousePointer: Ea,
  LucideSquareParking: Za,
  LucideSquareParkingOff: Ua,
  LucideSquarePen: ke,
  LucideSquarePercent: Na,
  LucideSquarePi: Wa,
  LucideSquarePilcrow: Ga,
  LucideSquarePlay: Xa,
  LucideSquarePlus: Ka,
  LucideSquarePower: Ja,
  LucideSquareRadical: xM,
  LucideSquareScissors: Qa,
  LucideSquareSigma: Ya,
  LucideSquareSlash: _a,
  LucideSquareSplitHorizontal: e2,
  LucideSquareSplitVertical: t2,
  LucideSquareSquare: IM,
  LucideSquareStack: wM,
  LucideSquareTerminal: a2,
  LucideSquareUser: c2,
  LucideSquareUserRound: o2,
  LucideSquareX: n2,
  LucideSquircle: LM,
  LucideSquirrel: bM,
  LucideStamp: SM,
  LucideStar: AM,
  LucideStarHalf: qM,
  LucideStarOff: zM,
  LucideStars: ra,
  LucideStepBack: HM,
  LucideStepForward: PM,
  LucideStethoscope: BM,
  LucideSticker: VM,
  LucideStickyNote: FM,
  LucideStopCircle: J1,
  LucideStore: jM,
  LucideStretchHorizontal: DM,
  LucideStretchVertical: TM,
  LucideStrikethrough: RM,
  LucideSubscript: OM,
  LucideSubtitles: s1,
  LucideSun: NM,
  LucideSunDim: $M,
  LucideSunMedium: EM,
  LucideSunMoon: UM,
  LucideSunSnow: ZM,
  LucideSunrise: WM,
  LucideSunset: GM,
  LucideSuperscript: XM,
  LucideSwatchBook: KM,
  LucideSwissFranc: JM,
  LucideSwitchCamera: QM,
  LucideSword: YM,
  LucideSwords: _M,
  LucideSyringe: ef,
  LucideTable: sf,
  LucideTable2: tf,
  LucideTableCellsMerge: af,
  LucideTableCellsSplit: of,
  LucideTableColumnsSplit: cf,
  LucideTableOfContents: nf,
  LucideTableProperties: rf,
  LucideTableRowsSplit: df,
  LucideTablet: hf,
  LucideTabletSmartphone: lf,
  LucideTablets: yf,
  LucideTag: uf,
  LucideTags: pf,
  LucideTally1: kf,
  LucideTally2: Mf,
  LucideTally3: ff,
  LucideTally4: gf,
  LucideTally5: mf,
  LucideTangent: vf,
  LucideTarget: xf,
  LucideTelescope: If,
  LucideTent: Cf,
  LucideTentTree: wf,
  LucideTerminal: Lf,
  LucideTerminalSquare: a2,
  LucideTestTube: bf,
  LucideTestTube2: i2,
  LucideTestTubeDiagonal: i2,
  LucideTestTubes: Sf,
  LucideText: Pf,
  LucideTextCursor: zf,
  LucideTextCursorInput: qf,
  LucideTextQuote: Af,
  LucideTextSearch: Hf,
  LucideTextSelect: r2,
  LucideTextSelection: r2,
  LucideTheater: Bf,
  LucideThermometer: jf,
  LucideThermometerSnowflake: Vf,
  LucideThermometerSun: Ff,
  LucideThumbsDown: Df,
  LucideThumbsUp: Tf,
  LucideTicket: Nf,
  LucideTicketCheck: Rf,
  LucideTicketMinus: Of,
  LucideTicketPercent: $f,
  LucideTicketPlus: Ef,
  LucideTicketSlash: Uf,
  LucideTicketX: Zf,
  LucideTickets: Gf,
  LucideTicketsPlane: Wf,
  LucideTimer: Jf,
  LucideTimerOff: Xf,
  LucideTimerReset: Kf,
  LucideToggleLeft: Qf,
  LucideToggleRight: Yf,
  LucideToilet: _f,
  LucideTornado: eg,
  LucideTorus: tg,
  LucideTouchpad: og,
  LucideTouchpadOff: ag,
  LucideTowerControl: cg,
  LucideToyBrick: ng,
  LucideTractor: ig,
  LucideTrafficCone: rg,
  LucideTrain: d2,
  LucideTrainFront: sg,
  LucideTrainFrontTunnel: dg,
  LucideTrainTrack: lg,
  LucideTramFront: d2,
  LucideTrash: yg,
  LucideTrash2: hg,
  LucideTreeDeciduous: ug,
  LucideTreePalm: s2,
  LucideTreePine: pg,
  LucideTrees: kg,
  LucideTrello: Mg,
  LucideTrendingDown: fg,
  LucideTrendingUp: mg,
  LucideTrendingUpDown: gg,
  LucideTriangle: xg,
  LucideTriangleAlert: l2,
  LucideTriangleRight: vg,
  LucideTrophy: Ig,
  LucideTruck: wg,
  LucideTurtle: Cg,
  LucideTv: bg,
  LucideTv2: h2,
  LucideTvMinimal: h2,
  LucideTvMinimalPlay: Lg,
  LucideTwitch: Sg,
  LucideTwitter: qg,
  LucideType: Ag,
  LucideTypeOutline: zg,
  LucideUmbrella: Pg,
  LucideUmbrellaOff: Hg,
  LucideUnderline: Bg,
  LucideUndo: jg,
  LucideUndo2: Vg,
  LucideUndoDot: Fg,
  LucideUnfoldHorizontal: Dg,
  LucideUnfoldVertical: Tg,
  LucideUngroup: Rg,
  LucideUniversity: y2,
  LucideUnlink: $g,
  LucideUnlink2: Og,
  LucideUnlock: Ft,
  LucideUnlockKeyhole: Vt,
  LucideUnplug: Eg,
  LucideUpload: Ug,
  LucideUploadCloud: ot,
  LucideUsb: Zg,
  LucideUser: em,
  LucideUser2: g2,
  LucideUserCheck: Ng,
  LucideUserCheck2: u2,
  LucideUserCircle: Y1,
  LucideUserCircle2: Q1,
  LucideUserCog: Wg,
  LucideUserCog2: p2,
  LucideUserMinus: Gg,
  LucideUserMinus2: k2,
  LucideUserPen: Xg,
  LucideUserPlus: Kg,
  LucideUserPlus2: M2,
  LucideUserRound: g2,
  LucideUserRoundCheck: u2,
  LucideUserRoundCog: p2,
  LucideUserRoundMinus: k2,
  LucideUserRoundPen: Jg,
  LucideUserRoundPlus: M2,
  LucideUserRoundSearch: Qg,
  LucideUserRoundX: f2,
  LucideUserSearch: Yg,
  LucideUserSquare: c2,
  LucideUserSquare2: o2,
  LucideUserX: _g,
  LucideUserX2: f2,
  LucideUsers: tm,
  LucideUsers2: m2,
  LucideUsersRound: m2,
  LucideUtensils: x2,
  LucideUtensilsCrossed: v2,
  LucideUtilityPole: am,
  LucideVariable: om,
  LucideVault: cm,
  LucideVegan: nm,
  LucideVenetianMask: im,
  LucideVerified: c1,
  LucideVibrate: dm,
  LucideVibrateOff: rm,
  LucideVideo: lm,
  LucideVideoOff: sm,
  LucideVideotape: hm,
  LucideView: ym,
  LucideVoicemail: um,
  LucideVolleyball: pm,
  LucideVolume: mm,
  LucideVolume1: km,
  LucideVolume2: Mm,
  LucideVolumeOff: fm,
  LucideVolumeX: gm,
  LucideVote: vm,
  LucideWallet: Im,
  LucideWallet2: I2,
  LucideWalletCards: xm,
  LucideWalletMinimal: I2,
  LucideWallpaper: wm,
  LucideWand: Cm,
  LucideWand2: w2,
  LucideWandSparkles: w2,
  LucideWarehouse: Lm,
  LucideWashingMachine: bm,
  LucideWatch: Sm,
  LucideWaves: zm,
  LucideWavesLadder: qm,
  LucideWaypoints: Am,
  LucideWebcam: Hm,
  LucideWebhook: Bm,
  LucideWebhookOff: Pm,
  LucideWeight: Vm,
  LucideWheat: jm,
  LucideWheatOff: Fm,
  LucideWholeWord: Dm,
  LucideWifi: Em,
  LucideWifiHigh: Tm,
  LucideWifiLow: Rm,
  LucideWifiOff: Om,
  LucideWifiZero: $m,
  LucideWind: Zm,
  LucideWindArrowDown: Um,
  LucideWine: Wm,
  LucideWineOff: Nm,
  LucideWorkflow: Gm,
  LucideWorm: Xm,
  LucideWrapText: Km,
  LucideWrench: Jm,
  LucideX: Qm,
  LucideXCircle: _1,
  LucideXOctagon: Ot,
  LucideXSquare: n2,
  LucideYoutube: Ym,
  LucideZap: ev,
  LucideZapOff: _m,
  LucideZoomIn: tv,
  LucideZoomOut: av,
  Luggage: hk,
  LuggageIcon: hk,
  MSquare: Ra,
  MSquareIcon: Ra,
  Magnet: yk,
  MagnetIcon: yk,
  Mail: xk,
  MailCheck: uk,
  MailCheckIcon: uk,
  MailIcon: xk,
  MailMinus: pk,
  MailMinusIcon: pk,
  MailOpen: kk,
  MailOpenIcon: kk,
  MailPlus: Mk,
  MailPlusIcon: Mk,
  MailQuestion: fk,
  MailQuestionIcon: fk,
  MailSearch: gk,
  MailSearchIcon: gk,
  MailWarning: mk,
  MailWarningIcon: mk,
  MailX: vk,
  MailXIcon: vk,
  Mailbox: Ik,
  MailboxIcon: Ik,
  Mails: wk,
  MailsIcon: wk,
  Map: jk,
  MapIcon: jk,
  MapPin: Vk,
  MapPinCheck: Lk,
  MapPinCheckIcon: Lk,
  MapPinCheckInside: Ck,
  MapPinCheckInsideIcon: Ck,
  MapPinHouse: bk,
  MapPinHouseIcon: bk,
  MapPinIcon: Vk,
  MapPinMinus: qk,
  MapPinMinusIcon: qk,
  MapPinMinusInside: Sk,
  MapPinMinusInsideIcon: Sk,
  MapPinOff: zk,
  MapPinOffIcon: zk,
  MapPinPlus: Hk,
  MapPinPlusIcon: Hk,
  MapPinPlusInside: Ak,
  MapPinPlusInsideIcon: Ak,
  MapPinX: Bk,
  MapPinXIcon: Bk,
  MapPinXInside: Pk,
  MapPinXInsideIcon: Pk,
  MapPinned: Fk,
  MapPinnedIcon: Fk,
  Martini: Dk,
  MartiniIcon: Dk,
  Maximize: Rk,
  Maximize2: Tk,
  Maximize2Icon: Tk,
  MaximizeIcon: Rk,
  Medal: Ok,
  MedalIcon: Ok,
  Megaphone: Ek,
  MegaphoneIcon: Ek,
  MegaphoneOff: $k,
  MegaphoneOffIcon: $k,
  Meh: Uk,
  MehIcon: Uk,
  MemoryStick: Zk,
  MemoryStickIcon: Zk,
  Menu: Nk,
  MenuIcon: Nk,
  MenuSquare: Oa,
  MenuSquareIcon: Oa,
  Merge: Wk,
  MergeIcon: Wk,
  MessageCircle: o5,
  MessageCircleCode: Gk,
  MessageCircleCodeIcon: Gk,
  MessageCircleDashed: Xk,
  MessageCircleDashedIcon: Xk,
  MessageCircleHeart: Kk,
  MessageCircleHeartIcon: Kk,
  MessageCircleIcon: o5,
  MessageCircleMore: Jk,
  MessageCircleMoreIcon: Jk,
  MessageCircleOff: Qk,
  MessageCircleOffIcon: Qk,
  MessageCirclePlus: Yk,
  MessageCirclePlusIcon: Yk,
  MessageCircleQuestion: _k,
  MessageCircleQuestionIcon: _k,
  MessageCircleReply: e5,
  MessageCircleReplyIcon: e5,
  MessageCircleWarning: t5,
  MessageCircleWarningIcon: t5,
  MessageCircleX: a5,
  MessageCircleXIcon: a5,
  MessageSquare: m5,
  MessageSquareCode: c5,
  MessageSquareCodeIcon: c5,
  MessageSquareDashed: n5,
  MessageSquareDashedIcon: n5,
  MessageSquareDiff: i5,
  MessageSquareDiffIcon: i5,
  MessageSquareDot: r5,
  MessageSquareDotIcon: r5,
  MessageSquareHeart: d5,
  MessageSquareHeartIcon: d5,
  MessageSquareIcon: m5,
  MessageSquareLock: s5,
  MessageSquareLockIcon: s5,
  MessageSquareMore: l5,
  MessageSquareMoreIcon: l5,
  MessageSquareOff: h5,
  MessageSquareOffIcon: h5,
  MessageSquarePlus: y5,
  MessageSquarePlusIcon: y5,
  MessageSquareQuote: u5,
  MessageSquareQuoteIcon: u5,
  MessageSquareReply: p5,
  MessageSquareReplyIcon: p5,
  MessageSquareShare: k5,
  MessageSquareShareIcon: k5,
  MessageSquareText: M5,
  MessageSquareTextIcon: M5,
  MessageSquareWarning: f5,
  MessageSquareWarningIcon: f5,
  MessageSquareX: g5,
  MessageSquareXIcon: g5,
  MessagesSquare: v5,
  MessagesSquareIcon: v5,
  Mic: I5,
  Mic2: jt,
  Mic2Icon: jt,
  MicIcon: I5,
  MicOff: x5,
  MicOffIcon: x5,
  MicVocal: jt,
  MicVocalIcon: jt,
  Microchip: w5,
  MicrochipIcon: w5,
  Microscope: C5,
  MicroscopeIcon: C5,
  Microwave: L5,
  MicrowaveIcon: L5,
  Milestone: b5,
  MilestoneIcon: b5,
  Milk: q5,
  MilkIcon: q5,
  MilkOff: S5,
  MilkOffIcon: S5,
  Minimize: A5,
  Minimize2: z5,
  Minimize2Icon: z5,
  MinimizeIcon: A5,
  Minus: H5,
  MinusCircle: $1,
  MinusCircleIcon: $1,
  MinusIcon: H5,
  MinusSquare: $a,
  MinusSquareIcon: $a,
  Monitor: Z5,
  MonitorCheck: P5,
  MonitorCheckIcon: P5,
  MonitorCog: B5,
  MonitorCogIcon: B5,
  MonitorDot: V5,
  MonitorDotIcon: V5,
  MonitorDown: F5,
  MonitorDownIcon: F5,
  MonitorIcon: Z5,
  MonitorOff: j5,
  MonitorOffIcon: j5,
  MonitorPause: D5,
  MonitorPauseIcon: D5,
  MonitorPlay: T5,
  MonitorPlayIcon: T5,
  MonitorSmartphone: R5,
  MonitorSmartphoneIcon: R5,
  MonitorSpeaker: O5,
  MonitorSpeakerIcon: O5,
  MonitorStop: $5,
  MonitorStopIcon: $5,
  MonitorUp: E5,
  MonitorUpIcon: E5,
  MonitorX: U5,
  MonitorXIcon: U5,
  Moon: W5,
  MoonIcon: W5,
  MoonStar: N5,
  MoonStarIcon: N5,
  MoreHorizontal: ht,
  MoreHorizontalIcon: ht,
  MoreVertical: lt,
  MoreVerticalIcon: lt,
  Mountain: X5,
  MountainIcon: X5,
  MountainSnow: G5,
  MountainSnowIcon: G5,
  Mouse: e3,
  MouseIcon: e3,
  MouseOff: K5,
  MouseOffIcon: K5,
  MousePointer: _5,
  MousePointer2: J5,
  MousePointer2Icon: J5,
  MousePointerBan: Q5,
  MousePointerBanIcon: Q5,
  MousePointerClick: Y5,
  MousePointerClickIcon: Y5,
  MousePointerIcon: _5,
  MousePointerSquareDashed: Ha,
  MousePointerSquareDashedIcon: Ha,
  Move: u3,
  Move3D: Dt,
  Move3DIcon: Dt,
  Move3d: Dt,
  Move3dIcon: Dt,
  MoveDiagonal: a3,
  MoveDiagonal2: t3,
  MoveDiagonal2Icon: t3,
  MoveDiagonalIcon: a3,
  MoveDown: n3,
  MoveDownIcon: n3,
  MoveDownLeft: o3,
  MoveDownLeftIcon: o3,
  MoveDownRight: c3,
  MoveDownRightIcon: c3,
  MoveHorizontal: i3,
  MoveHorizontalIcon: i3,
  MoveIcon: u3,
  MoveLeft: r3,
  MoveLeftIcon: r3,
  MoveRight: d3,
  MoveRightIcon: d3,
  MoveUp: h3,
  MoveUpIcon: h3,
  MoveUpLeft: s3,
  MoveUpLeftIcon: s3,
  MoveUpRight: l3,
  MoveUpRightIcon: l3,
  MoveVertical: y3,
  MoveVerticalIcon: y3,
  Music: f3,
  Music2: p3,
  Music2Icon: p3,
  Music3: k3,
  Music3Icon: k3,
  Music4: M3,
  Music4Icon: M3,
  MusicIcon: f3,
  Navigation: x3,
  Navigation2: m3,
  Navigation2Icon: m3,
  Navigation2Off: g3,
  Navigation2OffIcon: g3,
  NavigationIcon: x3,
  NavigationOff: v3,
  NavigationOffIcon: v3,
  Network: I3,
  NetworkIcon: I3,
  Newspaper: w3,
  NewspaperIcon: w3,
  Nfc: C3,
  NfcIcon: C3,
  Notebook: q3,
  NotebookIcon: q3,
  NotebookPen: L3,
  NotebookPenIcon: L3,
  NotebookTabs: b3,
  NotebookTabsIcon: b3,
  NotebookText: S3,
  NotebookTextIcon: S3,
  NotepadText: A3,
  NotepadTextDashed: z3,
  NotepadTextDashedIcon: z3,
  NotepadTextIcon: A3,
  Nut: P3,
  NutIcon: P3,
  NutOff: H3,
  NutOffIcon: H3,
  Octagon: V3,
  OctagonAlert: Tt,
  OctagonAlertIcon: Tt,
  OctagonIcon: V3,
  OctagonMinus: B3,
  OctagonMinusIcon: B3,
  OctagonPause: Rt,
  OctagonPauseIcon: Rt,
  OctagonX: Ot,
  OctagonXIcon: Ot,
  Omega: F3,
  OmegaIcon: F3,
  Option: j3,
  OptionIcon: j3,
  Orbit: D3,
  OrbitIcon: D3,
  Origami: T3,
  OrigamiIcon: T3,
  Outdent: zt,
  OutdentIcon: zt,
  Package: W3,
  Package2: R3,
  Package2Icon: R3,
  PackageCheck: O3,
  PackageCheckIcon: O3,
  PackageIcon: W3,
  PackageMinus: $3,
  PackageMinusIcon: $3,
  PackageOpen: E3,
  PackageOpenIcon: E3,
  PackagePlus: U3,
  PackagePlusIcon: U3,
  PackageSearch: Z3,
  PackageSearchIcon: Z3,
  PackageX: N3,
  PackageXIcon: N3,
  PaintBucket: G3,
  PaintBucketIcon: G3,
  PaintRoller: X3,
  PaintRollerIcon: X3,
  Paintbrush: K3,
  Paintbrush2: $t,
  Paintbrush2Icon: $t,
  PaintbrushIcon: K3,
  PaintbrushVertical: $t,
  PaintbrushVerticalIcon: $t,
  Palette: J3,
  PaletteIcon: J3,
  Palmtree: s2,
  PalmtreeIcon: s2,
  PanelBottom: _3,
  PanelBottomClose: Q3,
  PanelBottomCloseIcon: Q3,
  PanelBottomDashed: Et,
  PanelBottomDashedIcon: Et,
  PanelBottomIcon: _3,
  PanelBottomInactive: Et,
  PanelBottomInactiveIcon: Et,
  PanelBottomOpen: Y3,
  PanelBottomOpenIcon: Y3,
  PanelLeft: Wt,
  PanelLeftClose: Ut,
  PanelLeftCloseIcon: Ut,
  PanelLeftDashed: Zt,
  PanelLeftDashedIcon: Zt,
  PanelLeftIcon: Wt,
  PanelLeftInactive: Zt,
  PanelLeftInactiveIcon: Zt,
  PanelLeftOpen: Nt,
  PanelLeftOpenIcon: Nt,
  PanelRight: a6,
  PanelRightClose: e6,
  PanelRightCloseIcon: e6,
  PanelRightDashed: Gt,
  PanelRightDashedIcon: Gt,
  PanelRightIcon: a6,
  PanelRightInactive: Gt,
  PanelRightInactiveIcon: Gt,
  PanelRightOpen: t6,
  PanelRightOpenIcon: t6,
  PanelTop: n6,
  PanelTopClose: o6,
  PanelTopCloseIcon: o6,
  PanelTopDashed: Xt,
  PanelTopDashedIcon: Xt,
  PanelTopIcon: n6,
  PanelTopInactive: Xt,
  PanelTopInactiveIcon: Xt,
  PanelTopOpen: c6,
  PanelTopOpenIcon: c6,
  PanelsLeftBottom: i6,
  PanelsLeftBottomIcon: i6,
  PanelsLeftRight: it,
  PanelsLeftRightIcon: it,
  PanelsRightBottom: r6,
  PanelsRightBottomIcon: r6,
  PanelsTopBottom: aa,
  PanelsTopBottomIcon: aa,
  PanelsTopLeft: Kt,
  PanelsTopLeftIcon: Kt,
  Paperclip: d6,
  PaperclipIcon: d6,
  Parentheses: s6,
  ParenthesesIcon: s6,
  ParkingCircle: U1,
  ParkingCircleIcon: U1,
  ParkingCircleOff: E1,
  ParkingCircleOffIcon: E1,
  ParkingMeter: l6,
  ParkingMeterIcon: l6,
  ParkingSquare: Za,
  ParkingSquareIcon: Za,
  ParkingSquareOff: Ua,
  ParkingSquareOffIcon: Ua,
  PartyPopper: h6,
  PartyPopperIcon: h6,
  Pause: y6,
  PauseCircle: Z1,
  PauseCircleIcon: Z1,
  PauseIcon: y6,
  PauseOctagon: Rt,
  PauseOctagonIcon: Rt,
  PawPrint: u6,
  PawPrintIcon: u6,
  PcCase: p6,
  PcCaseIcon: p6,
  Pen: Qt,
  PenBox: ke,
  PenBoxIcon: ke,
  PenIcon: Qt,
  PenLine: Jt,
  PenLineIcon: Jt,
  PenOff: k6,
  PenOffIcon: k6,
  PenSquare: ke,
  PenSquareIcon: ke,
  PenTool: M6,
  PenToolIcon: M6,
  Pencil: v6,
  PencilIcon: v6,
  PencilLine: f6,
  PencilLineIcon: f6,
  PencilOff: g6,
  PencilOffIcon: g6,
  PencilRuler: m6,
  PencilRulerIcon: m6,
  Pentagon: x6,
  PentagonIcon: x6,
  Percent: I6,
  PercentCircle: N1,
  PercentCircleIcon: N1,
  PercentDiamond: dt,
  PercentDiamondIcon: dt,
  PercentIcon: I6,
  PercentSquare: Na,
  PercentSquareIcon: Na,
  PersonStanding: w6,
  PersonStandingIcon: w6,
  PhilippinePeso: C6,
  PhilippinePesoIcon: C6,
  Phone: H6,
  PhoneCall: L6,
  PhoneCallIcon: L6,
  PhoneForwarded: b6,
  PhoneForwardedIcon: b6,
  PhoneIcon: H6,
  PhoneIncoming: S6,
  PhoneIncomingIcon: S6,
  PhoneMissed: q6,
  PhoneMissedIcon: q6,
  PhoneOff: z6,
  PhoneOffIcon: z6,
  PhoneOutgoing: A6,
  PhoneOutgoingIcon: A6,
  Pi: P6,
  PiIcon: P6,
  PiSquare: Wa,
  PiSquareIcon: Wa,
  Piano: B6,
  PianoIcon: B6,
  Pickaxe: V6,
  PickaxeIcon: V6,
  PictureInPicture: j6,
  PictureInPicture2: F6,
  PictureInPicture2Icon: F6,
  PictureInPictureIcon: j6,
  PieChart: x1,
  PieChartIcon: x1,
  PiggyBank: D6,
  PiggyBankIcon: D6,
  Pilcrow: O6,
  PilcrowIcon: O6,
  PilcrowLeft: T6,
  PilcrowLeftIcon: T6,
  PilcrowRight: R6,
  PilcrowRightIcon: R6,
  PilcrowSquare: Ga,
  PilcrowSquareIcon: Ga,
  Pill: E6,
  PillBottle: $6,
  PillBottleIcon: $6,
  PillIcon: E6,
  Pin: Z6,
  PinIcon: Z6,
  PinOff: U6,
  PinOffIcon: U6,
  Pipette: N6,
  PipetteIcon: N6,
  Pizza: W6,
  PizzaIcon: W6,
  Plane: K6,
  PlaneIcon: K6,
  PlaneLanding: G6,
  PlaneLandingIcon: G6,
  PlaneTakeoff: X6,
  PlaneTakeoffIcon: X6,
  Play: J6,
  PlayCircle: W1,
  PlayCircleIcon: W1,
  PlayIcon: J6,
  PlaySquare: Xa,
  PlaySquareIcon: Xa,
  Plug: Y6,
  Plug2: Q6,
  Plug2Icon: Q6,
  PlugIcon: Y6,
  PlugZap: Yt,
  PlugZap2: Yt,
  PlugZap2Icon: Yt,
  PlugZapIcon: Yt,
  Plus: _6,
  PlusCircle: G1,
  PlusCircleIcon: G1,
  PlusIcon: _6,
  PlusSquare: Ka,
  PlusSquareIcon: Ka,
  Pocket: t8,
  PocketIcon: t8,
  PocketKnife: e8,
  PocketKnifeIcon: e8,
  Podcast: a8,
  PodcastIcon: a8,
  Pointer: c8,
  PointerIcon: c8,
  PointerOff: o8,
  PointerOffIcon: o8,
  Popcorn: n8,
  PopcornIcon: n8,
  Popsicle: i8,
  PopsicleIcon: i8,
  PoundSterling: r8,
  PoundSterlingIcon: r8,
  Power: s8,
  PowerCircle: X1,
  PowerCircleIcon: X1,
  PowerIcon: s8,
  PowerOff: d8,
  PowerOffIcon: d8,
  PowerSquare: Ja,
  PowerSquareIcon: Ja,
  Presentation: l8,
  PresentationIcon: l8,
  Printer: y8,
  PrinterCheck: h8,
  PrinterCheckIcon: h8,
  PrinterIcon: y8,
  Projector: u8,
  ProjectorIcon: u8,
  Proportions: p8,
  ProportionsIcon: p8,
  Puzzle: k8,
  PuzzleIcon: k8,
  Pyramid: M8,
  PyramidIcon: M8,
  QrCode: f8,
  QrCodeIcon: f8,
  Quote: g8,
  QuoteIcon: g8,
  Rabbit: m8,
  RabbitIcon: m8,
  Radar: v8,
  RadarIcon: v8,
  Radiation: x8,
  RadiationIcon: x8,
  Radical: I8,
  RadicalIcon: I8,
  Radio: L8,
  RadioIcon: L8,
  RadioReceiver: w8,
  RadioReceiverIcon: w8,
  RadioTower: C8,
  RadioTowerIcon: C8,
  Radius: b8,
  RadiusIcon: b8,
  RailSymbol: S8,
  RailSymbolIcon: S8,
  Rainbow: q8,
  RainbowIcon: q8,
  Rat: z8,
  RatIcon: z8,
  Ratio: A8,
  RatioIcon: A8,
  Receipt: R8,
  ReceiptCent: H8,
  ReceiptCentIcon: H8,
  ReceiptEuro: P8,
  ReceiptEuroIcon: P8,
  ReceiptIcon: R8,
  ReceiptIndianRupee: B8,
  ReceiptIndianRupeeIcon: B8,
  ReceiptJapaneseYen: V8,
  ReceiptJapaneseYenIcon: V8,
  ReceiptPoundSterling: F8,
  ReceiptPoundSterlingIcon: F8,
  ReceiptRussianRuble: j8,
  ReceiptRussianRubleIcon: j8,
  ReceiptSwissFranc: D8,
  ReceiptSwissFrancIcon: D8,
  ReceiptText: T8,
  ReceiptTextIcon: T8,
  RectangleEllipsis: _t,
  RectangleEllipsisIcon: _t,
  RectangleHorizontal: O8,
  RectangleHorizontalIcon: O8,
  RectangleVertical: $8,
  RectangleVerticalIcon: $8,
  Recycle: E8,
  RecycleIcon: E8,
  Redo: N8,
  Redo2: U8,
  Redo2Icon: U8,
  RedoDot: Z8,
  RedoDotIcon: Z8,
  RedoIcon: N8,
  RefreshCcw: G8,
  RefreshCcwDot: W8,
  RefreshCcwDotIcon: W8,
  RefreshCcwIcon: G8,
  RefreshCw: K8,
  RefreshCwIcon: K8,
  RefreshCwOff: X8,
  RefreshCwOffIcon: X8,
  Refrigerator: J8,
  RefrigeratorIcon: J8,
  Regex: Q8,
  RegexIcon: Q8,
  RemoveFormatting: Y8,
  RemoveFormattingIcon: Y8,
  Repeat: t7,
  Repeat1: _8,
  Repeat1Icon: _8,
  Repeat2: e7,
  Repeat2Icon: e7,
  RepeatIcon: t7,
  Replace: o7,
  ReplaceAll: a7,
  ReplaceAllIcon: a7,
  ReplaceIcon: o7,
  Reply: n7,
  ReplyAll: c7,
  ReplyAllIcon: c7,
  ReplyIcon: n7,
  Rewind: i7,
  RewindIcon: i7,
  Ribbon: r7,
  RibbonIcon: r7,
  Rocket: d7,
  RocketIcon: d7,
  RockingChair: s7,
  RockingChairIcon: s7,
  RollerCoaster: l7,
  RollerCoasterIcon: l7,
  Rotate3D: ea,
  Rotate3DIcon: ea,
  Rotate3d: ea,
  Rotate3dIcon: ea,
  RotateCcw: y7,
  RotateCcwIcon: y7,
  RotateCcwSquare: h7,
  RotateCcwSquareIcon: h7,
  RotateCw: p7,
  RotateCwIcon: p7,
  RotateCwSquare: u7,
  RotateCwSquareIcon: u7,
  Route: M7,
  RouteIcon: M7,
  RouteOff: k7,
  RouteOffIcon: k7,
  Router: f7,
  RouterIcon: f7,
  Rows: ta,
  Rows2: ta,
  Rows2Icon: ta,
  Rows3: aa,
  Rows3Icon: aa,
  Rows4: g7,
  Rows4Icon: g7,
  RowsIcon: ta,
  Rss: m7,
  RssIcon: m7,
  Ruler: v7,
  RulerIcon: v7,
  RussianRuble: x7,
  RussianRubleIcon: x7,
  Sailboat: I7,
  SailboatIcon: I7,
  Salad: w7,
  SaladIcon: w7,
  Sandwich: C7,
  SandwichIcon: C7,
  Satellite: b7,
  SatelliteDish: L7,
  SatelliteDishIcon: L7,
  SatelliteIcon: b7,
  Save: z7,
  SaveAll: S7,
  SaveAllIcon: S7,
  SaveIcon: z7,
  SaveOff: q7,
  SaveOffIcon: q7,
  Scale: A7,
  Scale3D: oa,
  Scale3DIcon: oa,
  Scale3d: oa,
  Scale3dIcon: oa,
  ScaleIcon: A7,
  Scaling: H7,
  ScalingIcon: H7,
  Scan: O7,
  ScanBarcode: P7,
  ScanBarcodeIcon: P7,
  ScanEye: B7,
  ScanEyeIcon: B7,
  ScanFace: V7,
  ScanFaceIcon: V7,
  ScanHeart: F7,
  ScanHeartIcon: F7,
  ScanIcon: O7,
  ScanLine: j7,
  ScanLineIcon: j7,
  ScanQrCode: D7,
  ScanQrCodeIcon: D7,
  ScanSearch: T7,
  ScanSearchIcon: T7,
  ScanText: R7,
  ScanTextIcon: R7,
  ScatterChart: I1,
  ScatterChartIcon: I1,
  School: $7,
  School2: y2,
  School2Icon: y2,
  SchoolIcon: $7,
  Scissors: U7,
  ScissorsIcon: U7,
  ScissorsLineDashed: E7,
  ScissorsLineDashedIcon: E7,
  ScissorsSquare: Qa,
  ScissorsSquareDashedBottom: Ia,
  ScissorsSquareDashedBottomIcon: Ia,
  ScissorsSquareIcon: Qa,
  ScreenShare: N7,
  ScreenShareIcon: N7,
  ScreenShareOff: Z7,
  ScreenShareOffIcon: Z7,
  Scroll: G7,
  ScrollIcon: G7,
  ScrollText: W7,
  ScrollTextIcon: W7,
  Search: Y7,
  SearchCheck: X7,
  SearchCheckIcon: X7,
  SearchCode: K7,
  SearchCodeIcon: K7,
  SearchIcon: Y7,
  SearchSlash: J7,
  SearchSlashIcon: J7,
  SearchX: Q7,
  SearchXIcon: Q7,
  Section: _7,
  SectionIcon: _7,
  Send: t9,
  SendHorizonal: ca,
  SendHorizonalIcon: ca,
  SendHorizontal: ca,
  SendHorizontalIcon: ca,
  SendIcon: t9,
  SendToBack: e9,
  SendToBackIcon: e9,
  SeparatorHorizontal: a9,
  SeparatorHorizontalIcon: a9,
  SeparatorVertical: o9,
  SeparatorVerticalIcon: o9,
  Server: r9,
  ServerCog: c9,
  ServerCogIcon: c9,
  ServerCrash: n9,
  ServerCrashIcon: n9,
  ServerIcon: r9,
  ServerOff: i9,
  ServerOffIcon: i9,
  Settings: s9,
  Settings2: d9,
  Settings2Icon: d9,
  SettingsIcon: s9,
  Shapes: l9,
  ShapesIcon: l9,
  Share: y9,
  Share2: h9,
  Share2Icon: h9,
  ShareIcon: y9,
  Sheet: u9,
  SheetIcon: u9,
  Shell: p9,
  ShellIcon: p9,
  Shield: C9,
  ShieldAlert: k9,
  ShieldAlertIcon: k9,
  ShieldBan: M9,
  ShieldBanIcon: M9,
  ShieldCheck: f9,
  ShieldCheckIcon: f9,
  ShieldClose: na,
  ShieldCloseIcon: na,
  ShieldEllipsis: g9,
  ShieldEllipsisIcon: g9,
  ShieldHalf: m9,
  ShieldHalfIcon: m9,
  ShieldIcon: C9,
  ShieldMinus: v9,
  ShieldMinusIcon: v9,
  ShieldOff: x9,
  ShieldOffIcon: x9,
  ShieldPlus: I9,
  ShieldPlusIcon: I9,
  ShieldQuestion: w9,
  ShieldQuestionIcon: w9,
  ShieldX: na,
  ShieldXIcon: na,
  Ship: b9,
  ShipIcon: b9,
  ShipWheel: L9,
  ShipWheelIcon: L9,
  Shirt: S9,
  ShirtIcon: S9,
  ShoppingBag: q9,
  ShoppingBagIcon: q9,
  ShoppingBasket: z9,
  ShoppingBasketIcon: z9,
  ShoppingCart: A9,
  ShoppingCartIcon: A9,
  Shovel: H9,
  ShovelIcon: H9,
  ShowerHead: P9,
  ShowerHeadIcon: P9,
  Shrink: B9,
  ShrinkIcon: B9,
  Shrub: V9,
  ShrubIcon: V9,
  Shuffle: F9,
  ShuffleIcon: F9,
  Sidebar: Wt,
  SidebarClose: Ut,
  SidebarCloseIcon: Ut,
  SidebarIcon: Wt,
  SidebarOpen: Nt,
  SidebarOpenIcon: Nt,
  Sigma: j9,
  SigmaIcon: j9,
  SigmaSquare: Ya,
  SigmaSquareIcon: Ya,
  Signal: $9,
  SignalHigh: D9,
  SignalHighIcon: D9,
  SignalIcon: $9,
  SignalLow: T9,
  SignalLowIcon: T9,
  SignalMedium: R9,
  SignalMediumIcon: R9,
  SignalZero: O9,
  SignalZeroIcon: O9,
  Signature: E9,
  SignatureIcon: E9,
  Signpost: Z9,
  SignpostBig: U9,
  SignpostBigIcon: U9,
  SignpostIcon: Z9,
  Siren: N9,
  SirenIcon: N9,
  SkipBack: W9,
  SkipBackIcon: W9,
  SkipForward: G9,
  SkipForwardIcon: G9,
  Skull: X9,
  SkullIcon: X9,
  Slack: K9,
  SlackIcon: K9,
  Slash: J9,
  SlashIcon: J9,
  SlashSquare: _a,
  SlashSquareIcon: _a,
  Slice: Q9,
  SliceIcon: Q9,
  Sliders: ia,
  SlidersHorizontal: Y9,
  SlidersHorizontalIcon: Y9,
  SlidersIcon: ia,
  SlidersVertical: ia,
  SlidersVerticalIcon: ia,
  Smartphone: tM,
  SmartphoneCharging: _9,
  SmartphoneChargingIcon: _9,
  SmartphoneIcon: tM,
  SmartphoneNfc: eM,
  SmartphoneNfcIcon: eM,
  Smile: oM,
  SmileIcon: oM,
  SmilePlus: aM,
  SmilePlusIcon: aM,
  Snail: cM,
  SnailIcon: cM,
  Snowflake: nM,
  SnowflakeIcon: nM,
  Sofa: iM,
  SofaIcon: iM,
  SortAsc: t1,
  SortAscIcon: t1,
  SortDesc: Ye,
  SortDescIcon: Ye,
  Soup: rM,
  SoupIcon: rM,
  Space: dM,
  SpaceIcon: dM,
  Spade: sM,
  SpadeIcon: sM,
  Sparkle: lM,
  SparkleIcon: lM,
  Sparkles: ra,
  SparklesIcon: ra,
  Speaker: hM,
  SpeakerIcon: hM,
  Speech: yM,
  SpeechIcon: yM,
  SpellCheck: pM,
  SpellCheck2: uM,
  SpellCheck2Icon: uM,
  SpellCheckIcon: pM,
  Spline: kM,
  SplineIcon: kM,
  Split: MM,
  SplitIcon: MM,
  SplitSquareHorizontal: e2,
  SplitSquareHorizontalIcon: e2,
  SplitSquareVertical: t2,
  SplitSquareVerticalIcon: t2,
  SprayCan: fM,
  SprayCanIcon: fM,
  Sprout: gM,
  SproutIcon: gM,
  Square: CM,
  SquareActivity: da,
  SquareActivityIcon: da,
  SquareArrowDown: ha,
  SquareArrowDownIcon: ha,
  SquareArrowDownLeft: sa,
  SquareArrowDownLeftIcon: sa,
  SquareArrowDownRight: la,
  SquareArrowDownRightIcon: la,
  SquareArrowLeft: ya,
  SquareArrowLeftIcon: ya,
  SquareArrowOutDownLeft: ua,
  SquareArrowOutDownLeftIcon: ua,
  SquareArrowOutDownRight: pa,
  SquareArrowOutDownRightIcon: pa,
  SquareArrowOutUpLeft: ka,
  SquareArrowOutUpLeftIcon: ka,
  SquareArrowOutUpRight: Ma,
  SquareArrowOutUpRightIcon: Ma,
  SquareArrowRight: fa,
  SquareArrowRightIcon: fa,
  SquareArrowUp: va,
  SquareArrowUpIcon: va,
  SquareArrowUpLeft: ga,
  SquareArrowUpLeftIcon: ga,
  SquareArrowUpRight: ma,
  SquareArrowUpRightIcon: ma,
  SquareAsterisk: xa,
  SquareAsteriskIcon: xa,
  SquareBottomDashedScissors: Ia,
  SquareBottomDashedScissorsIcon: Ia,
  SquareChartGantt: qe,
  SquareChartGanttIcon: qe,
  SquareCheck: Ca,
  SquareCheckBig: wa,
  SquareCheckBigIcon: wa,
  SquareCheckIcon: Ca,
  SquareChevronDown: La,
  SquareChevronDownIcon: La,
  SquareChevronLeft: ba,
  SquareChevronLeftIcon: ba,
  SquareChevronRight: Sa,
  SquareChevronRightIcon: Sa,
  SquareChevronUp: qa,
  SquareChevronUpIcon: qa,
  SquareCode: za,
  SquareCodeIcon: za,
  SquareDashed: Pa,
  SquareDashedBottom: vM,
  SquareDashedBottomCode: mM,
  SquareDashedBottomCodeIcon: mM,
  SquareDashedBottomIcon: vM,
  SquareDashedIcon: Pa,
  SquareDashedKanban: Aa,
  SquareDashedKanbanIcon: Aa,
  SquareDashedMousePointer: Ha,
  SquareDashedMousePointerIcon: Ha,
  SquareDivide: Ba,
  SquareDivideIcon: Ba,
  SquareDot: Va,
  SquareDotIcon: Va,
  SquareEqual: Fa,
  SquareEqualIcon: Fa,
  SquareFunction: ja,
  SquareFunctionIcon: ja,
  SquareGanttChart: qe,
  SquareGanttChartIcon: qe,
  SquareIcon: CM,
  SquareKanban: Da,
  SquareKanbanIcon: Da,
  SquareLibrary: Ta,
  SquareLibraryIcon: Ta,
  SquareM: Ra,
  SquareMIcon: Ra,
  SquareMenu: Oa,
  SquareMenuIcon: Oa,
  SquareMinus: $a,
  SquareMinusIcon: $a,
  SquareMousePointer: Ea,
  SquareMousePointerIcon: Ea,
  SquareParking: Za,
  SquareParkingIcon: Za,
  SquareParkingOff: Ua,
  SquareParkingOffIcon: Ua,
  SquarePen: ke,
  SquarePenIcon: ke,
  SquarePercent: Na,
  SquarePercentIcon: Na,
  SquarePi: Wa,
  SquarePiIcon: Wa,
  SquarePilcrow: Ga,
  SquarePilcrowIcon: Ga,
  SquarePlay: Xa,
  SquarePlayIcon: Xa,
  SquarePlus: Ka,
  SquarePlusIcon: Ka,
  SquarePower: Ja,
  SquarePowerIcon: Ja,
  SquareRadical: xM,
  SquareRadicalIcon: xM,
  SquareScissors: Qa,
  SquareScissorsIcon: Qa,
  SquareSigma: Ya,
  SquareSigmaIcon: Ya,
  SquareSlash: _a,
  SquareSlashIcon: _a,
  SquareSplitHorizontal: e2,
  SquareSplitHorizontalIcon: e2,
  SquareSplitVertical: t2,
  SquareSplitVerticalIcon: t2,
  SquareSquare: IM,
  SquareSquareIcon: IM,
  SquareStack: wM,
  SquareStackIcon: wM,
  SquareTerminal: a2,
  SquareTerminalIcon: a2,
  SquareUser: c2,
  SquareUserIcon: c2,
  SquareUserRound: o2,
  SquareUserRoundIcon: o2,
  SquareX: n2,
  SquareXIcon: n2,
  Squircle: LM,
  SquircleIcon: LM,
  Squirrel: bM,
  SquirrelIcon: bM,
  Stamp: SM,
  StampIcon: SM,
  Star: AM,
  StarHalf: qM,
  StarHalfIcon: qM,
  StarIcon: AM,
  StarOff: zM,
  StarOffIcon: zM,
  Stars: ra,
  StarsIcon: ra,
  StepBack: HM,
  StepBackIcon: HM,
  StepForward: PM,
  StepForwardIcon: PM,
  Stethoscope: BM,
  StethoscopeIcon: BM,
  Sticker: VM,
  StickerIcon: VM,
  StickyNote: FM,
  StickyNoteIcon: FM,
  StopCircle: J1,
  StopCircleIcon: J1,
  Store: jM,
  StoreIcon: jM,
  StretchHorizontal: DM,
  StretchHorizontalIcon: DM,
  StretchVertical: TM,
  StretchVerticalIcon: TM,
  Strikethrough: RM,
  StrikethroughIcon: RM,
  Subscript: OM,
  SubscriptIcon: OM,
  Subtitles: s1,
  SubtitlesIcon: s1,
  Sun: NM,
  SunDim: $M,
  SunDimIcon: $M,
  SunIcon: NM,
  SunMedium: EM,
  SunMediumIcon: EM,
  SunMoon: UM,
  SunMoonIcon: UM,
  SunSnow: ZM,
  SunSnowIcon: ZM,
  Sunrise: WM,
  SunriseIcon: WM,
  Sunset: GM,
  SunsetIcon: GM,
  Superscript: XM,
  SuperscriptIcon: XM,
  SwatchBook: KM,
  SwatchBookIcon: KM,
  SwissFranc: JM,
  SwissFrancIcon: JM,
  SwitchCamera: QM,
  SwitchCameraIcon: QM,
  Sword: YM,
  SwordIcon: YM,
  Swords: _M,
  SwordsIcon: _M,
  Syringe: ef,
  SyringeIcon: ef,
  Table: sf,
  Table2: tf,
  Table2Icon: tf,
  TableCellsMerge: af,
  TableCellsMergeIcon: af,
  TableCellsSplit: of,
  TableCellsSplitIcon: of,
  TableColumnsSplit: cf,
  TableColumnsSplitIcon: cf,
  TableIcon: sf,
  TableOfContents: nf,
  TableOfContentsIcon: nf,
  TableProperties: rf,
  TablePropertiesIcon: rf,
  TableRowsSplit: df,
  TableRowsSplitIcon: df,
  Tablet: hf,
  TabletIcon: hf,
  TabletSmartphone: lf,
  TabletSmartphoneIcon: lf,
  Tablets: yf,
  TabletsIcon: yf,
  Tag: uf,
  TagIcon: uf,
  Tags: pf,
  TagsIcon: pf,
  Tally1: kf,
  Tally1Icon: kf,
  Tally2: Mf,
  Tally2Icon: Mf,
  Tally3: ff,
  Tally3Icon: ff,
  Tally4: gf,
  Tally4Icon: gf,
  Tally5: mf,
  Tally5Icon: mf,
  Tangent: vf,
  TangentIcon: vf,
  Target: xf,
  TargetIcon: xf,
  Telescope: If,
  TelescopeIcon: If,
  Tent: Cf,
  TentIcon: Cf,
  TentTree: wf,
  TentTreeIcon: wf,
  Terminal: Lf,
  TerminalIcon: Lf,
  TerminalSquare: a2,
  TerminalSquareIcon: a2,
  TestTube: bf,
  TestTube2: i2,
  TestTube2Icon: i2,
  TestTubeDiagonal: i2,
  TestTubeDiagonalIcon: i2,
  TestTubeIcon: bf,
  TestTubes: Sf,
  TestTubesIcon: Sf,
  Text: Pf,
  TextCursor: zf,
  TextCursorIcon: zf,
  TextCursorInput: qf,
  TextCursorInputIcon: qf,
  TextIcon: Pf,
  TextQuote: Af,
  TextQuoteIcon: Af,
  TextSearch: Hf,
  TextSearchIcon: Hf,
  TextSelect: r2,
  TextSelectIcon: r2,
  TextSelection: r2,
  TextSelectionIcon: r2,
  Theater: Bf,
  TheaterIcon: Bf,
  Thermometer: jf,
  ThermometerIcon: jf,
  ThermometerSnowflake: Vf,
  ThermometerSnowflakeIcon: Vf,
  ThermometerSun: Ff,
  ThermometerSunIcon: Ff,
  ThumbsDown: Df,
  ThumbsDownIcon: Df,
  ThumbsUp: Tf,
  ThumbsUpIcon: Tf,
  Ticket: Nf,
  TicketCheck: Rf,
  TicketCheckIcon: Rf,
  TicketIcon: Nf,
  TicketMinus: Of,
  TicketMinusIcon: Of,
  TicketPercent: $f,
  TicketPercentIcon: $f,
  TicketPlus: Ef,
  TicketPlusIcon: Ef,
  TicketSlash: Uf,
  TicketSlashIcon: Uf,
  TicketX: Zf,
  TicketXIcon: Zf,
  Tickets: Gf,
  TicketsIcon: Gf,
  TicketsPlane: Wf,
  TicketsPlaneIcon: Wf,
  Timer: Jf,
  TimerIcon: Jf,
  TimerOff: Xf,
  TimerOffIcon: Xf,
  TimerReset: Kf,
  TimerResetIcon: Kf,
  ToggleLeft: Qf,
  ToggleLeftIcon: Qf,
  ToggleRight: Yf,
  ToggleRightIcon: Yf,
  Toilet: _f,
  ToiletIcon: _f,
  Tornado: eg,
  TornadoIcon: eg,
  Torus: tg,
  TorusIcon: tg,
  Touchpad: og,
  TouchpadIcon: og,
  TouchpadOff: ag,
  TouchpadOffIcon: ag,
  TowerControl: cg,
  TowerControlIcon: cg,
  ToyBrick: ng,
  ToyBrickIcon: ng,
  Tractor: ig,
  TractorIcon: ig,
  TrafficCone: rg,
  TrafficConeIcon: rg,
  Train: d2,
  TrainFront: sg,
  TrainFrontIcon: sg,
  TrainFrontTunnel: dg,
  TrainFrontTunnelIcon: dg,
  TrainIcon: d2,
  TrainTrack: lg,
  TrainTrackIcon: lg,
  TramFront: d2,
  TramFrontIcon: d2,
  Trash: yg,
  Trash2: hg,
  Trash2Icon: hg,
  TrashIcon: yg,
  TreeDeciduous: ug,
  TreeDeciduousIcon: ug,
  TreePalm: s2,
  TreePalmIcon: s2,
  TreePine: pg,
  TreePineIcon: pg,
  Trees: kg,
  TreesIcon: kg,
  Trello: Mg,
  TrelloIcon: Mg,
  TrendingDown: fg,
  TrendingDownIcon: fg,
  TrendingUp: mg,
  TrendingUpDown: gg,
  TrendingUpDownIcon: gg,
  TrendingUpIcon: mg,
  Triangle: xg,
  TriangleAlert: l2,
  TriangleAlertIcon: l2,
  TriangleIcon: xg,
  TriangleRight: vg,
  TriangleRightIcon: vg,
  Trophy: Ig,
  TrophyIcon: Ig,
  Truck: wg,
  TruckIcon: wg,
  Turtle: Cg,
  TurtleIcon: Cg,
  Tv: bg,
  Tv2: h2,
  Tv2Icon: h2,
  TvIcon: bg,
  TvMinimal: h2,
  TvMinimalIcon: h2,
  TvMinimalPlay: Lg,
  TvMinimalPlayIcon: Lg,
  Twitch: Sg,
  TwitchIcon: Sg,
  Twitter: qg,
  TwitterIcon: qg,
  Type: Ag,
  TypeIcon: Ag,
  TypeOutline: zg,
  TypeOutlineIcon: zg,
  Umbrella: Pg,
  UmbrellaIcon: Pg,
  UmbrellaOff: Hg,
  UmbrellaOffIcon: Hg,
  Underline: Bg,
  UnderlineIcon: Bg,
  Undo: jg,
  Undo2: Vg,
  Undo2Icon: Vg,
  UndoDot: Fg,
  UndoDotIcon: Fg,
  UndoIcon: jg,
  UnfoldHorizontal: Dg,
  UnfoldHorizontalIcon: Dg,
  UnfoldVertical: Tg,
  UnfoldVerticalIcon: Tg,
  Ungroup: Rg,
  UngroupIcon: Rg,
  University: y2,
  UniversityIcon: y2,
  Unlink: $g,
  Unlink2: Og,
  Unlink2Icon: Og,
  UnlinkIcon: $g,
  Unlock: Ft,
  UnlockIcon: Ft,
  UnlockKeyhole: Vt,
  UnlockKeyholeIcon: Vt,
  Unplug: Eg,
  UnplugIcon: Eg,
  Upload: Ug,
  UploadCloud: ot,
  UploadCloudIcon: ot,
  UploadIcon: Ug,
  Usb: Zg,
  UsbIcon: Zg,
  User: em,
  User2: g2,
  User2Icon: g2,
  UserCheck: Ng,
  UserCheck2: u2,
  UserCheck2Icon: u2,
  UserCheckIcon: Ng,
  UserCircle: Y1,
  UserCircle2: Q1,
  UserCircle2Icon: Q1,
  UserCircleIcon: Y1,
  UserCog: Wg,
  UserCog2: p2,
  UserCog2Icon: p2,
  UserCogIcon: Wg,
  UserIcon: em,
  UserMinus: Gg,
  UserMinus2: k2,
  UserMinus2Icon: k2,
  UserMinusIcon: Gg,
  UserPen: Xg,
  UserPenIcon: Xg,
  UserPlus: Kg,
  UserPlus2: M2,
  UserPlus2Icon: M2,
  UserPlusIcon: Kg,
  UserRound: g2,
  UserRoundCheck: u2,
  UserRoundCheckIcon: u2,
  UserRoundCog: p2,
  UserRoundCogIcon: p2,
  UserRoundIcon: g2,
  UserRoundMinus: k2,
  UserRoundMinusIcon: k2,
  UserRoundPen: Jg,
  UserRoundPenIcon: Jg,
  UserRoundPlus: M2,
  UserRoundPlusIcon: M2,
  UserRoundSearch: Qg,
  UserRoundSearchIcon: Qg,
  UserRoundX: f2,
  UserRoundXIcon: f2,
  UserSearch: Yg,
  UserSearchIcon: Yg,
  UserSquare: c2,
  UserSquare2: o2,
  UserSquare2Icon: o2,
  UserSquareIcon: c2,
  UserX: _g,
  UserX2: f2,
  UserX2Icon: f2,
  UserXIcon: _g,
  Users: tm,
  Users2: m2,
  Users2Icon: m2,
  UsersIcon: tm,
  UsersRound: m2,
  UsersRoundIcon: m2,
  Utensils: x2,
  UtensilsCrossed: v2,
  UtensilsCrossedIcon: v2,
  UtensilsIcon: x2,
  UtilityPole: am,
  UtilityPoleIcon: am,
  Variable: om,
  VariableIcon: om,
  Vault: cm,
  VaultIcon: cm,
  Vegan: nm,
  VeganIcon: nm,
  VenetianMask: im,
  VenetianMaskIcon: im,
  Verified: c1,
  VerifiedIcon: c1,
  Vibrate: dm,
  VibrateIcon: dm,
  VibrateOff: rm,
  VibrateOffIcon: rm,
  Video: lm,
  VideoIcon: lm,
  VideoOff: sm,
  VideoOffIcon: sm,
  Videotape: hm,
  VideotapeIcon: hm,
  View: ym,
  ViewIcon: ym,
  Voicemail: um,
  VoicemailIcon: um,
  Volleyball: pm,
  VolleyballIcon: pm,
  Volume: mm,
  Volume1: km,
  Volume1Icon: km,
  Volume2: Mm,
  Volume2Icon: Mm,
  VolumeIcon: mm,
  VolumeOff: fm,
  VolumeOffIcon: fm,
  VolumeX: gm,
  VolumeXIcon: gm,
  Vote: vm,
  VoteIcon: vm,
  Wallet: Im,
  Wallet2: I2,
  Wallet2Icon: I2,
  WalletCards: xm,
  WalletCardsIcon: xm,
  WalletIcon: Im,
  WalletMinimal: I2,
  WalletMinimalIcon: I2,
  Wallpaper: wm,
  WallpaperIcon: wm,
  Wand: Cm,
  Wand2: w2,
  Wand2Icon: w2,
  WandIcon: Cm,
  WandSparkles: w2,
  WandSparklesIcon: w2,
  Warehouse: Lm,
  WarehouseIcon: Lm,
  WashingMachine: bm,
  WashingMachineIcon: bm,
  Watch: Sm,
  WatchIcon: Sm,
  Waves: zm,
  WavesIcon: zm,
  WavesLadder: qm,
  WavesLadderIcon: qm,
  Waypoints: Am,
  WaypointsIcon: Am,
  Webcam: Hm,
  WebcamIcon: Hm,
  Webhook: Bm,
  WebhookIcon: Bm,
  WebhookOff: Pm,
  WebhookOffIcon: Pm,
  Weight: Vm,
  WeightIcon: Vm,
  Wheat: jm,
  WheatIcon: jm,
  WheatOff: Fm,
  WheatOffIcon: Fm,
  WholeWord: Dm,
  WholeWordIcon: Dm,
  Wifi: Em,
  WifiHigh: Tm,
  WifiHighIcon: Tm,
  WifiIcon: Em,
  WifiLow: Rm,
  WifiLowIcon: Rm,
  WifiOff: Om,
  WifiOffIcon: Om,
  WifiZero: $m,
  WifiZeroIcon: $m,
  Wind: Zm,
  WindArrowDown: Um,
  WindArrowDownIcon: Um,
  WindIcon: Zm,
  Wine: Wm,
  WineIcon: Wm,
  WineOff: Nm,
  WineOffIcon: Nm,
  Workflow: Gm,
  WorkflowIcon: Gm,
  Worm: Xm,
  WormIcon: Xm,
  WrapText: Km,
  WrapTextIcon: Km,
  Wrench: Jm,
  WrenchIcon: Jm,
  X: Qm,
  XCircle: _1,
  XCircleIcon: _1,
  XIcon: Qm,
  XOctagon: Ot,
  XOctagonIcon: Ot,
  XSquare: n2,
  XSquareIcon: n2,
  Youtube: Ym,
  YoutubeIcon: Ym,
  Zap: ev,
  ZapIcon: ev,
  ZapOff: _m,
  ZapOffIcon: _m,
  ZoomIn: tv,
  ZoomInIcon: tv,
  ZoomOut: av,
  ZoomOutIcon: av,
  createLucideIcon: e,
  icons: iL
}, Symbol.toStringTag, { value: "Module" })), dL = {
  __name: "Icon",
  props: {
    name: {
      type: String,
      required: !0
    },
    size: Number,
    color: String,
    strokeWidth: {
      type: Number,
      default: 2
    },
    defaultClass: String
  },
  setup(t) {
    const a = t, o = u(() => rL[a.name]);
    return (c, n) => (k(), J(ve(l(o)), {
      size: t.size,
      color: t.color,
      "stroke-width": t.strokeWidth,
      "default-class": t.defaultClass
    }, null, 8, ["size", "color", "stroke-width", "default-class"]));
  }
}, sL = ["disabled", "data-disabled"], SS = /* @__PURE__ */ O({
  __name: "ActionIcon",
  props: {
    loading: { type: Boolean, default: !1 },
    loaderProps: null,
    size: { default: "md" },
    color: { default: "primary" },
    radius: { default: "md" },
    gradient: null,
    disabled: { type: Boolean, default: !1 },
    iconName: null,
    variant: { default: "filled" },
    class: null,
    onClick: null
  },
  emits: ["click"],
  setup(t, { emit: a }) {
    const o = t, c = (y) => {
      !o.disabled && !o.loading && a("click", y);
    }, n = u(() => ({
      xs: 13,
      sm: 15,
      md: 17,
      lg: 19,
      xl: 21
    })[o.size]), i = (y) => {
      if (!y)
        return "cstu-bg-gradient-to-r";
      const p = (y % 360 + 360) % 360;
      return p >= 337.5 || p < 22.5 ? "cstu-bg-gradient-to-r" : p >= 22.5 && p < 67.5 ? "cstu-bg-gradient-to-tr" : p >= 67.5 && p < 112.5 ? "cstu-bg-gradient-to-t" : p >= 112.5 && p < 157.5 ? "cstu-bg-gradient-to-tl" : p >= 157.5 && p < 202.5 ? "cstu-bg-gradient-to-l" : p >= 202.5 && p < 247.5 ? "cstu-bg-gradient-to-bl" : p >= 247.5 && p < 292.5 ? "cstu-bg-gradient-to-b" : "cstu-bg-gradient-to-br";
    }, d = (y) => ({
      none: "cstu-rounded-none",
      xs: "cstu-rounded",
      sm: "cstu-rounded-md",
      md: "cstu-rounded-lg",
      lg: "cstu-rounded-xl",
      xl: "cstu-rounded-2xl",
      full: "cstu-rounded-full"
    })[y] || "cstu-rounded-lg", r = u(() => {
      const y = "cstu-inline-flex cstu-items-center cstu-justify-center cstu-transition-all cstu-duration-200";
      if (o.variant === "gradient" && o.gradient) {
        const x = `${i(o.gradient.deg)} cstu-from-${o.gradient.from}-500 cstu-to-${o.gradient.to || o.gradient.from}-600 hover:cstu-from-${o.gradient.from}-600 hover:cstu-to-${o.gradient.to || o.gradient.from}-700 cstu-text-white`;
        return [
          y,
          x,
          Ie(o.size, "button"),
          d(o.radius),
          S2({
            disabled: o.disabled,
            loading: o.loading
          }),
          {
            "cstu-cursor-pointer": !o.disabled && !o.loading,
            relative: o.loading
          },
          o.class
        ];
      }
      const p = ee(o.color, o.variant, {
        hover: !0,
        active: !0,
        focus: !0
      }), m = Ie(o.size, "button"), C = S2({
        disabled: o.disabled,
        loading: o.loading
      }), z = Tv(o.size, "button"), w = d(o.radius);
      return [
        y,
        p,
        m,
        z,
        C,
        w,
        {
          relative: o.loading,
          "cstu-cursor-pointer": !o.disabled && !o.loading
        },
        o.class
      ];
    }), h = u(() => ({
      xs: "xs",
      sm: "sm",
      md: "sm",
      lg: "md",
      xl: "md"
    })[o.size]), s = u(() => o.variant === "filled" || o.variant === "gradient" ? "white" : o.color), M = u(() => o.variant === "filled" || o.variant === "gradient" ? "bg-opacity-0" : "bg-white");
    return (y, p) => (k(), g("button", {
      class: I(l(r)),
      disabled: t.disabled || t.loading,
      "data-disabled": t.disabled,
      onClick: c
    }, [
      E(se, { name: "fade" }, {
        default: N(() => [
          t.loading ? (k(), g("div", {
            key: 0,
            class: I(["absolute inset-0 flex items-center justify-center bg-opacity-50", l(M)])
          }, [
            E(cw, ce(t.loaderProps, {
              size: l(h),
              color: l(s)
            }), null, 16, ["size", "color"])
          ], 2)) : L("", !0)
        ]),
        _: 1
      }),
      f("span", {
        class: I(["flex items-center justify-center", { "opacity-0": t.loading }])
      }, [
        t.iconName ? (k(), J(l(dL), {
          key: 0,
          name: t.iconName,
          size: l(n)
        }, null, 8, ["name", "size"])) : H(y.$slots, "default", { key: 1 })
      ], 2)
    ], 10, sL));
  }
});
const lL = /* @__PURE__ */ aI('<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><g clip-path="url(#clip0_33663_12905)"><path d="M6 8.95312C5.91113 8.95312 5.82739 8.93604 5.74878 8.90186C5.67017 8.86768 5.6001 8.81982 5.53857 8.7583L0.93457 4.1543C0.886719 4.09961 0.845703 4.03467 0.811523 3.95947C0.777344 3.88428 0.760254 3.80225 0.760254 3.71338C0.760254 3.53564 0.823486 3.38354 0.949951 3.25708C1.07642 3.13062 1.23193 3.06738 1.4165 3.06738C1.49854 3.06738 1.57715 3.08276 1.65234 3.11353C1.72754 3.14429 1.7959 3.18701 1.85742 3.2417L6 7.40479L10.1426 3.2417C10.2041 3.18701 10.2725 3.14429 10.3477 3.11353C10.4229 3.08276 10.5015 3.06738 10.5835 3.06738C10.7681 3.06738 10.9236 3.13062 11.05 3.25708C11.1765 3.38354 11.2397 3.53564 11.2397 3.71338C11.2397 3.80225 11.2227 3.88428 11.1885 3.95947C11.1543 4.03467 11.1133 4.09961 11.0654 4.1543L6.46143 8.7583C6.3999 8.81982 6.32983 8.86768 6.25122 8.90186C6.17261 8.93604 6.08887 8.95312 6 8.95312Z" fill="#99A3A9"></path></g><defs><clipPath id="clip0_33663_12905"><rect width="10.5" height="11" fill="white" transform="matrix(1 0 0 -1 0.75 11.5)"></rect></clipPath></defs></svg>', 1), hL = ["data-active"], qS = /* @__PURE__ */ O({
  __name: "Dropdown",
  props: {
    size: { default: "md" },
    radius: { default: "md" },
    open: { type: Boolean, default: !1 },
    buttonClasses: { default: "" },
    dropdownClasses: { default: "" },
    placement: { default: "auto" },
    disabled: { type: Boolean, default: !1 },
    containerClasses: { default: "" },
    showArrow: { type: Boolean, default: !0 },
    disabledText: { default: "" },
    parentPositionRelative: { type: Boolean, default: !0 },
    offsetDistance: { default: 8 },
    unstyled: { type: Boolean, default: !1 },
    matchWidth: { type: Boolean, default: !1 },
    zIndex: { default: 50 }
  },
  emits: ["close", "update:open"],
  setup(t, { emit: a }) {
    const o = t, c = j(o.open), n = j(0), i = j(null), d = j(null);
    xe(() => {
      ne(c, (x) => {
        x && me(() => {
          var S;
          const v = (S = i.value) == null ? void 0 : S.querySelectorAll("input");
          v && v.length && v.forEach((V) => {
            V.addEventListener("click", r, { capture: !0 }), V.addEventListener("mousedown", r, { capture: !0 }), V.addEventListener("focus", r, { capture: !0 });
          });
        });
      });
    });
    function r(x) {
      x.stopPropagation();
      const v = x.target;
      setTimeout(() => {
        v.focus();
      }, 0);
    }
    const h = u(() => {
      switch (o.placement) {
        case "top":
          return "top";
        case "bottom":
          return "bottom";
        case "left":
          return "left";
        case "right":
          return "right";
        case "auto":
          return;
        case "top-start":
          return "top-start";
        case "bottom-start":
          return "bottom-start";
        case "top-end":
          return "top-end";
        case "bottom-end":
          return "bottom-end";
        case "left-start":
          return "left-start";
        case "right-start":
          return "right-start";
        default:
          return "bottom-start";
      }
    }), s = u(() => {
      const x = [
        Mv(o.offsetDistance),
        fv({ padding: 8 })
      ];
      return o.placement === "auto" ? x.push(Sx({ padding: 8 })) : x.push(gv({
        fallbackPlacements: ["top-start", "bottom-start", "left-start", "right-start"],
        padding: 8
      })), x;
    }), { floatingStyles: M, update: y } = mv(d, i, {
      placement: h.value,
      middleware: s.value,
      whileElementsMounted: bx,
      strategy: "fixed"
    }), p = fe("parentDropdownOpen", null);
    Ee("parentDropdownOpen", c), ne(() => o.open, (x) => {
      x !== c.value && (c.value = x);
    }), ne(() => p == null ? void 0 : p.value, (x) => {
      x === !1 && (c.value = !1);
    }, { immediate: !0 }), ne(c, (x) => {
      x && me(() => {
        y();
      });
    });
    const m = u(() => Ie(o.size, "dropdown")), C = u(() => De(o.radius));
    function z(x) {
      var Z;
      if (!c.value)
        return;
      if (!x) {
        b();
        return;
      }
      const v = x.target, S = v.closest(".cstu-dropdown-menu"), V = (Z = d.value) == null ? void 0 : Z.contains(v);
      S || V || o.disabled || b();
    }
    Ee("dropdownClose", z);
    function w() {
      o.disabled || (c.value ? (c.value = !1, a("close"), a("update:open", !1)) : (c.value = !0, a("update:open", !0), setTimeout(() => {
        var v, S;
        (v = i.value) == null || v.focus();
        const x = (S = i.value) == null ? void 0 : S.querySelector(".active");
        x == null || x.scrollIntoView({ behavior: "smooth" });
      }, 100)));
    }
    function A(x) {
      i.value && (x.key === "ArrowUp" && n.value > 0 ? (x.preventDefault(), n.value--) : x.key === "ArrowDown" && n.value < i.value.children.length - 1 && (x.preventDefault(), n.value++));
    }
    function b(x = !1) {
      c.value = !1, !x && (a("close"), a("update:open", !1));
    }
    return (x, v) => F2((k(), g("div", {
      class: I(["cstu-inline-block cstu-text-left cstu-dropdown-container", [
        { "cstu-relative": t.parentPositionRelative },
        { "cstu-grayscale cstu-filter cstu-cursor-not-allowed cstu-opacity-70": t.disabled },
        t.containerClasses
      ]])
    }, [
      f("button", {
        ref_key: "buttonRef",
        ref: d,
        type: "button",
        class: I([
          !t.unstyled && "cstu-text-gray-500 cstu-inline-flex cstu-overflow-hidden cstu-text-ellipsis cstu-whitespace-pre cstu-justify-between cstu-items-center cstu-w-full focus:cstu-outline-none",
          !t.unstyled && l(C),
          !t.unstyled && l(m),
          { "cstu-pointer-events-none": t.disabled },
          t.buttonClasses,
          !t.unstyled && "cstu-border cstu-border-gray-400/20 hover:cstu-bg-gray-100/50 hover:cstu-border-gray-400/25"
        ]),
        "aria-expanded": "true",
        "aria-haspopup": "true",
        onClick: w
      }, [
        H(x.$slots, "icon", { closeDropdown: b }),
        H(x.$slots, "selected", { closeDropdown: b }, () => [
          ae("Select")
        ]),
        t.showArrow ? (k(), g("span", {
          key: 0,
          class: I(["cstu-transition cstu-leading-none", { "cstu-rotate-180": c.value }])
        }, [
          H(x.$slots, "arrow", { closeDropdown: b }, () => [
            lL
          ])
        ], 2)) : L("", !0)
      ], 2),
      E(se, {
        "enter-active-class": "cstu-transition cstu-ease-out cstu-duration-100",
        "enter-from-class": "cstu-transform cstu-opacity-0 cstu-scale-95",
        "enter-to-class": "cstu-transform cstu-opacity-100 cstu-scale-100",
        "leave-active-class": "cstu-transition cstu-ease-in cstu-duration-75",
        "leave-from-class": "cstu-transform cstu-opacity-100 cstu-scale-100",
        "leave-to-class": "cstu-transform cstu-opacity-0 cstu-scale-95"
      }, {
        default: N(() => {
          var S;
          return [
            (k(), J($2, { to: "body" }, [
              F2(f("div", {
                ref_key: "dropdownList",
                ref: i,
                style: W([l(M), o.matchWidth ? { width: ((S = d.value) == null ? void 0 : S.offsetWidth) + "px" } : {}, { zIndex: o.zIndex }]),
                class: I(["cstu-dropdown-menu cstu-max-h-72 cstu-px-[12px] cstu-py-[13px] cstu-overflow-y-auto cstu-origin-top-left cstu-rounded-lg cstu-shadow-dropdown cstu-bg-white focus:cstu-outline-none", [
                  l(C),
                  t.dropdownClasses,
                  { "cstu-min-w-[225px]": !o.matchWidth }
                ]]),
                onClick: v[0] || (v[0] = Pe(() => {
                }, ["stop"])),
                onMousedown: v[1] || (v[1] = Pe(() => {
                }, ["stop"]))
              }, [
                f("div", {
                  class: "cstu-flex cstu-flex-col cstu-gap-[11px]",
                  role: "menu",
                  "aria-orientation": "vertical",
                  "aria-labelledby": "menu-button",
                  "data-active": n.value,
                  tabindex: "-1",
                  onKeydown: A
                }, [
                  H(x.$slots, "default", { closeDropdown: b })
                ], 40, hL)
              ], 38), [
                [yv, c.value]
              ])
            ]))
          ];
        }),
        _: 3
      })
    ], 2)), [
      [l(Bx), z]
    ]);
  }
}), zS = /* @__PURE__ */ O({
  __name: "DropdownItem",
  props: {
    disabled: { type: Boolean, default: !1 },
    closeOnClick: { type: Boolean, default: !0 },
    class: { default: "" },
    selected: { type: Boolean, default: !1 },
    size: { default: "md" }
  },
  emits: ["click"],
  setup(t, { emit: a }) {
    const o = t, c = fe("dropdownClose", () => {
    }), n = u(() => o.class);
    function i() {
      o.disabled || (o.closeOnClick && c(), a("click"));
    }
    return (d, r) => (k(), g("div", {
      role: "menuitem",
      tabindex: "-1",
      class: I([
        "cstu-cursor-pointer hover:cstu-bg-blue-50 active:cstu-bg-blue-50 cstu-rounded-lg cstu-min-h-9 cstu-flex cstu-items-center",
        l(C2)(o.size),
        "cstu-py-[5.5px] cstu-pr-[13.5px] cstu-pl-[10.5px]",
        { "cstu-cursor-not-allowed cstu-bg-gray-100": t.disabled },
        { "cstu-bg-blue-50": t.selected },
        l(n)
      ]),
      onClick: i
    }, [
      H(d.$slots, "default", { selected: t.selected })
    ], 2));
  }
}), yL = { class: "cstu-inline-flex cstu-relative" }, uL = ["disabled"], pL = {
  key: 0,
  class: "cstu-mr-2"
}, kL = /* @__PURE__ */ f("svg", {
  class: "cstu-animate-spin cstu-h-4 cstu-w-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ f("circle", {
    class: "cstu-opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /* @__PURE__ */ f("path", {
    class: "cstu-opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1), ML = ["disabled"], fL = {
  class: "cstu-flex cstu-flex-col cstu-gap-[11px]",
  role: "menu",
  "aria-orientation": "vertical",
  tabindex: "-1"
}, AS = /* @__PURE__ */ O({
  __name: "SplitButton",
  props: {
    variant: { default: "filled" },
    color: { default: "primary" },
    size: { default: "md" },
    radius: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    dropdownIcon: null,
    showDivider: { type: Boolean, default: !0 }
  },
  emits: ["click", "dropdown-click", "open", "close"],
  setup(t, { emit: a }) {
    const o = t, c = j(!1), n = j(null), i = j(null), {
      x: d,
      y: r,
      strategy: h,
      update: s
    } = mv(n, i, {
      placement: "bottom-end",
      middleware: [
        Mv(4),
        gv(),
        fv({ padding: 8 })
      ]
    }), M = (x) => {
      c.value && n.value && !n.value.contains(x.target) && i.value && !i.value.contains(x.target) && m();
    }, y = () => {
      o.disabled || o.loading || (c.value ? m() : p(), a("dropdown-click"));
    }, p = async () => {
      c.value = !0, a("open"), s();
    }, m = () => {
      c.value = !1, a("close");
    };
    xe(() => {
      document.addEventListener("click", M);
    }), K2(() => {
      document.removeEventListener("click", M);
    });
    function C(x, v, S = {}) {
      if (ue(x))
        return {};
      switch (v) {
        case "filled":
          return {
            backgroundColor: x,
            color: "white",
            borderColor: x
          };
        case "light":
          return {
            backgroundColor: `${x}20`,
            // 20% opacity
            color: x,
            borderColor: "transparent"
          };
        case "outline":
          return {
            backgroundColor: "transparent",
            color: x,
            borderColor: x
          };
        case "subtle":
          return {
            backgroundColor: "transparent",
            color: x,
            borderColor: "transparent"
          };
        case "text":
          return {
            backgroundColor: "transparent",
            color: x,
            borderColor: "transparent"
          };
        default:
          return {};
      }
    }
    const z = u(() => ue(o.color) || o.disabled ? {} : C(o.color, o.variant, {
      hover: !0,
      active: !0,
      focus: !0
    })), w = u(() => {
      const x = "cstu-inline-flex cstu-items-center cstu-justify-center cstu-font-medium cstu-transition-all cstu-duration-200", v = ue(o.color) ? ee(o.color, o.variant, {
        hover: !0,
        active: !0,
        focus: !0
      }) : "", S = Ie(o.size, "button"), V = S2({
        disabled: o.disabled,
        loading: o.loading
      });
      return [
        x,
        v,
        S,
        V
      ];
    }), A = u(() => ({
      none: "cstu-rounded-none",
      xs: "cstu-rounded-s",
      sm: "cstu-rounded-s-md",
      md: "cstu-rounded-s-lg",
      lg: "cstu-rounded-s-xl",
      xl: "cstu-rounded-s-2xl",
      full: "cstu-rounded-s-full"
    })[o.radius] || "cstu-rounded-s-lg"), b = u(() => ({
      none: "cstu-rounded-none",
      xs: "cstu-rounded-e",
      sm: "cstu-rounded-e-md",
      md: "cstu-rounded-e-lg",
      lg: "cstu-rounded-e-xl",
      xl: "cstu-rounded-e-2xl",
      full: "cstu-rounded-e-full"
    })[o.radius] || "cstu-rounded-e-lg");
    return (x, v) => (k(), g("div", yL, [
      f("button", {
        class: I([
          l(w),
          "cstu-border-r-0",
          { "cstu-pointer-events-none": t.disabled || t.loading },
          l(A)
        ]),
        style: W(l(z)),
        disabled: t.disabled || t.loading,
        onClick: v[0] || (v[0] = (S) => x.$emit("click"))
      }, [
        t.loading ? (k(), g("span", pL, [
          H(x.$slots, "loader", {}, () => [
            kL
          ])
        ])) : L("", !0),
        H(x.$slots, "default")
      ], 14, uL),
      t.showDivider ? (k(), g("div", {
        key: 0,
        class: I(["cstu-relative", {
          "cstu-pointer-events-none": t.disabled || t.loading
        }])
      }, [
        f("div", {
          class: I(["cstu-absolute cstu-inset-y-1 cstu-w-px", [
            {
              "cstu-opacity-50": t.disabled || t.loading
            },
            t.variant === "outline" ? l(ue)(o.color) ? `cstu-bg-${l(b2)[o.color].base}-400/50` : "cstu-bg-gray-400/50" : "cstu-bg-white/20"
          ]])
        }, null, 2)
      ], 2)) : L("", !0),
      f("button", {
        ref_key: "triggerRef",
        ref: n,
        class: I([
          l(w),
          "cstu-px-2 cstu-border-l-0",
          { "cstu-pointer-events-none": t.disabled || t.loading },
          l(b)
        ]),
        style: W(l(z)),
        disabled: t.disabled || t.loading,
        onClick: y
      }, [
        H(x.$slots, "dropdown-icon", {}, () => [
          E(l(N2), {
            class: I(["cstu-h-4 cstu-w-4", {
              "cstu-opacity-50": t.disabled || t.loading,
              "cstu-rotate-180 cstu-transform": c.value
            }])
          }, null, 8, ["class"])
        ])
      ], 14, ML),
      (k(), J($2, { to: "body" }, [
        E(se, {
          "enter-active-class": "cstu-transition cstu-duration-200 cstu-ease-out",
          "enter-from-class": "cstu-transform cstu-scale-95 cstu-opacity-0",
          "enter-to-class": "cstu-transform cstu-scale-100 cstu-opacity-100",
          "leave-active-class": "cstu-transition cstu-duration-75 cstu-ease-in",
          "leave-from-class": "cstu-transform cstu-scale-100 cstu-opacity-100",
          "leave-to-class": "cstu-transform cstu-scale-95 cstu-opacity-0"
        }, {
          default: N(() => [
            c.value ? (k(), g("div", {
              key: 0,
              ref_key: "floatingRef",
              ref: i,
              class: "cstu-dropdown-menu cstu-max-h-72 cstu-px-[12px] cstu-py-[13px] cstu-min-w-[225px] cstu-overflow-y-auto cstu-origin-top-left cstu-rounded-lg cstu-shadow-dropdown cstu-bg-white focus:cstu-outline-none",
              style: W({
                position: l(h),
                top: `${l(r) ?? 0}px`,
                left: `${l(d) ?? 0}px`,
                zIndex: 50
              }),
              onClick: v[1] || (v[1] = Pe(() => {
              }, ["stop"])),
              onMousedown: v[2] || (v[2] = Pe(() => {
              }, ["stop"]))
            }, [
              f("div", fL, [
                H(x.$slots, "menu")
              ])
            ], 36)) : L("", !0)
          ]),
          _: 3
        })
      ]))
    ]));
  }
}), Lv = {
  none: "rounded-none",
  xs: "rounded",
  sm: "rounded-md",
  md: "rounded-lg",
  lg: "rounded-xl",
  xl: "rounded-2xl",
  full: "rounded-full"
}, gL = ["onClick", "data-value"], HS = /* @__PURE__ */ O({
  __name: "SegmentedControl",
  props: {
    modelValue: { default: "" },
    data: null,
    size: { default: "md" },
    radius: { default: "md" },
    color: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    transitionDuration: { default: 200 },
    withItemsBorders: { type: Boolean, default: !1 },
    orientation: { default: "horizontal" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: a }) {
    const o = t, c = j({}), n = j(null), i = u(() => o.data.map((s) => typeof s == "string" ? { value: s, label: s } : s)), d = u(() => o.orientation === "horizontal" ? "cstu-flex-row" : "cstu-flex-col"), r = async () => {
      if (!o.modelValue)
        return;
      await me();
      const s = c.value[o.modelValue];
      if (!s)
        return;
      const M = s.getBoundingClientRect(), y = s.parentElement.getBoundingClientRect();
      n.value = {
        left: M.left - y.left,
        top: M.top - y.top,
        width: M.width,
        height: M.height
      };
    }, h = (s) => {
      a("update:modelValue", s);
    };
    return ne(() => o.modelValue, r), ne(() => o.orientation, r), xe(() => {
      r(), window.addEventListener("resize", r);
    }), Dv(() => {
      window.removeEventListener("resize", r);
    }), (s, M) => (k(), g("div", {
      class: I([
        "cstu-relative cstu-inline-flex",
        l(d),
        {
          "cstu-w-full": t.fullWidth,
          "cstu-opacity-50 cstu-pointer-events-none": t.disabled
        }
      ]),
      role: "radiogroup"
    }, [
      n.value ? (k(), g("div", {
        key: 0,
        class: I(["cstu-absolute cstu-bg-white cstu-rounded-[inherit]", l(Lv)[t.radius]]),
        style: W({
          transform: `translate(${n.value.left}px, ${n.value.top}px)`,
          width: `${n.value.width}px`,
          height: `${n.value.height}px`,
          transition: `transform ${t.transitionDuration}ms ease`,
          boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)"
        })
      }, null, 6)) : L("", !0),
      f("div", {
        class: I([
          "cstu-relative cstu-flex",
          l(d),
          l(Lv)[t.radius],
          {
            "cstu-w-full": t.fullWidth,
            "cstu-divide-x cstu-divide-gray-200": t.withItemsBorders && t.orientation === "horizontal",
            "cstu-divide-y cstu-divide-gray-200": t.withItemsBorders && t.orientation === "vertical"
          },
          l(Ie)(t.size, "segmentedControlContainer"),
          "cstu-bg-gray-100"
        ])
      }, [
        (k(!0), g(re, null, O2(l(i), (y) => (k(), g("div", {
          key: y.value,
          class: I([
            "cstu-relative cstu-flex-1",
            "cstu-transition-all cstu-duration-200",
            l(kx)(!!y.disabled),
            o.modelValue === y.value ? "cstu-bg-white cstu-border-gray-500/15" : "cstu-border-transparent",
            l(Ie)(t.size, "segmentedControl"),
            "cstu-cursor-pointer",
            "cstu-flex cstu-items-center cstu-justify-center hover:cstu-border-gray-500/15 cstu-border",
            l(Lv)[t.radius]
          ]),
          onClick: () => !y.disabled && h(y.value),
          "data-value": y.value,
          ref_for: !0,
          ref: "el => segmentRefs[option.value] = el"
        }, [
          f("span", {
            class: I([
              l(Mx)({ size: t.size, disabled: y.disabled }),
              o.modelValue === y.value ? "cstu-text-gray-500" : "cstu-text-gray-600",
              "cstu-select-none !cstu-mb-0 !cstu-font-normal cstu-capitalize cstu-whitespace-nowrap cstu-flex cstu-items-center cstu-gap-2"
            ])
          }, [
            y.icon ? (k(), g("span", {
              key: 0,
              class: I(y.icon)
            }, null, 2)) : L("", !0),
            o.modelValue === y.value ? H(s.$slots, "leftSection", { key: 1 }) : L("", !0),
            o.modelValue === y.value ? H(s.$slots, "default", { key: 2 }, () => [
              ae(U(y.label), 1)
            ]) : (k(), g(re, { key: 3 }, [
              ae(U(y.label), 1)
            ], 64)),
            o.modelValue === y.value ? H(s.$slots, "rightSection", { key: 4 }) : L("", !0)
          ], 2)
        ], 10, gL))), 128))
      ], 2)
    ], 2));
  }
}), mL = {
  key: 0,
  class: "cstu-flex cstu-flex-col"
}, vL = ["for"], xL = ["id", "name", "checked", "disabled"], PS = /* @__PURE__ */ O({
  __name: "Switch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: null,
    offLabel: null,
    onLabel: null,
    color: { default: "primary" },
    size: { default: "md" },
    radius: null,
    thumbIcon: null,
    labelPosition: { default: "right" },
    description: null,
    error: null,
    disabled: { type: Boolean, default: !1 },
    name: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: a }) {
    const o = u(() => `switch-${Math.random().toString(36).slice(2, 11)}`), c = (r) => {
      const h = r.target;
      a("update:modelValue", h.checked);
    }, n = u(() => ({
      size: r,
      disabled: h
    }) => [
      C2(r || "md"),
      h ? "cstu-text-gray-400" : "cstu-text-gray-700"
    ].filter(Boolean).join(" ")), i = (r) => {
      switch (r) {
        case "xs":
          return "cstu-text-xs";
        case "sm":
          return "cstu-text-xs";
        case "md":
          return "cstu-text-xs";
        case "lg":
          return "cstu-text-sm";
        case "xl":
          return "cstu-text-sm";
        default:
          return "cstu-text-xs";
      }
    }, d = (r) => {
      switch (r) {
        case "xs":
          return "cstu-text-xs";
        case "sm":
          return "cstu-text-xs";
        case "md":
          return "cstu-text-xs";
        case "lg":
          return "cstu-text-sm";
        case "xl":
          return "cstu-text-sm";
        default:
          return "cstu-text-xs";
      }
    };
    return (r, h) => (k(), g("div", {
      class: I([
        "cstu-inline-flex",
        t.labelPosition === "left" ? "cstu-flex-row-reverse" : "cstu-flex-row",
        "cstu-items-center cstu-gap-2"
      ])
    }, [
      t.label || t.description ? (k(), g("div", mL, [
        t.label ? (k(), g("label", {
          key: 0,
          for: l(o),
          class: I([
            "cstu-select-none cstu-font-medium",
            l(n)({
              size: t.size,
              color: t.error ? "danger" : t.color,
              disabled: t.disabled
            })
          ])
        }, U(t.label), 11, vL)) : L("", !0),
        t.description ? (k(), g("span", {
          key: 1,
          class: I([
            i(t.size),
            t.error ? "cstu-text-red-600" : "cstu-text-gray-500"
          ])
        }, U(t.description), 3)) : L("", !0),
        t.error ? (k(), g("span", {
          key: 2,
          class: I([
            d(t.size),
            "cstu-text-red-600 cstu-mt-1"
          ])
        }, U(t.error), 3)) : L("", !0)
      ])) : L("", !0),
      f("label", {
        class: I([
          "cstu-relative cstu-inline-flex cstu-shrink-0 cstu-cursor-pointer",
          l(kx)(t.disabled),
          {
            "cstu-h-4 cstu-w-6": t.size === "xs",
            "cstu-h-5 cstu-w-7": t.size === "sm",
            "cstu-h-5 cstu-w-8": t.size === "md",
            "cstu-h-6 cstu-w-9": t.size === "lg",
            "cstu-h-7 cstu-w-11": t.size === "xl"
          }
        ])
      }, [
        f("input", {
          id: l(o),
          type: "checkbox",
          role: "switch",
          name: t.name,
          checked: t.modelValue,
          disabled: t.disabled,
          class: "sr-only peer",
          onChange: c
        }, null, 40, xL),
        f("div", {
          class: I([
            "absolute inset-0 rounded-full transition-all duration-200",
            "peer-focus:ring-2 peer-focus:ring-offset-1 peer-focus:ring-opacity-50",
            t.modelValue ? [
              t.color === "primary" ? "bg-[#709FFD]" : l(ee)(t.color, "filled"),
              t.disabled ? "opacity-40" : l(rI)(t.color)
            ] : [
              "bg-[#E3E8EB]",
              !t.disabled && "peer-focus:ring-gray-400"
            ]
          ])
        }, [
          f("span", {
            class: I([
              "absolute top-1/2 -translate-y-1/2 box-border",
              "cstu-flex cstu-items-center cstu-justify-center",
              "cstu-rounded-full cstu-bg-white",
              "cstu-transition-all cstu-duration-200",
              {
                "cstu-h-2.5 cstu-w-2.5": t.size === "xs" || t.size === "sm",
                "cstu-h-3 cstu-w-3": t.size === "md",
                "cstu-h-4 cstu-w-4": t.size === "lg",
                "cstu-h-5 cstu-w-5": t.size === "xl"
              },
              t.size === "xs" || t.size === "sm" ? "bg-[rgba(255,255,255,0.002)] border-[4px] border-white" : "bg-[rgba(255,255,255,0.002)] border-[6px] border-white",
              "shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-1px_rgba(0,0,0,0.06)]",
              t.modelValue ? {
                "cstu-left-[11px]": t.size === "xs",
                "cstu-left-[12.5px]": t.size === "sm",
                "cstu-left-[14.75px]": t.size === "md",
                "cstu-left-[16px]": t.size === "lg",
                "cstu-left-[18px]": t.size === "xl"
              } : {
                "cstu-left-[2.5px]": t.size === "xs",
                "cstu-left-[3.5px]": t.size === "sm" || t.size === "lg",
                "cstu-left-[3.75px]": t.size === "md",
                "cstu-left-[4px]": t.size === "xl"
              }
            ])
          }, [
            t.thumbIcon && typeof t.thumbIcon == "string" ? (k(), g("span", {
              key: 0,
              class: I([
                "cstu-flex cstu-items-center cstu-justify-center",
                {
                  "cstu-text-[8px]": t.size === "xs" || t.size === "sm",
                  "cstu-text-[10px]": t.size === "md",
                  "cstu-text-xs": t.size === "lg",
                  "cstu-text-sm": t.size === "xl"
                }
              ])
            }, U(t.thumbIcon), 3)) : L("", !0),
            r.$slots.thumbIcon ? H(r.$slots, "thumbIcon", {
              key: 1,
              checked: t.modelValue,
              size: t.size
            }) : r.$slots.default ? H(r.$slots, "default", {
              key: 2,
              checked: t.modelValue,
              size: t.size
            }) : L("", !0)
          ], 2)
        ], 2)
      ], 2)
    ], 2));
  }
}), IL = {
  key: 0,
  class: "badge-section mr-2"
}, wL = {
  key: 1,
  class: "badge-section ml-2"
}, BS = /* @__PURE__ */ O({
  __name: "Badge",
  props: {
    variant: { default: "filled" },
    color: { default: "primary" },
    textClass: null,
    size: { default: "md" },
    radius: { default: "xl" },
    circle: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    autoContrast: { type: Boolean, default: !0 },
    gradient: null,
    leftSection: null,
    rightSection: null,
    component: null
  },
  setup(t) {
    const a = t, o = (s) => s ? ["primary", "secondary", "success", "warning", "danger", "info", "dark", "light"].includes(s) : !0, c = (s) => {
      if (!s)
        return "cstu-bg-gradient-to-r";
      const M = (s % 360 + 360) % 360;
      return M >= 337.5 || M < 22.5 ? "cstu-bg-gradient-to-r" : M >= 22.5 && M < 67.5 ? "cstu-bg-gradient-to-tr" : M >= 67.5 && M < 112.5 ? "cstu-bg-gradient-to-t" : M >= 112.5 && M < 157.5 ? "cstu-bg-gradient-to-tl" : M >= 157.5 && M < 202.5 ? "cstu-bg-gradient-to-l" : M >= 202.5 && M < 247.5 ? "cstu-bg-gradient-to-bl" : M >= 247.5 && M < 292.5 ? "cstu-bg-gradient-to-b" : M >= 292.5 && M < 337.5 ? "cstu-bg-gradient-to-br" : "cstu-bg-gradient-to-r";
    }, n = u(() => {
      const s = {
        xs: "h-5 w-5 flex items-center justify-center p-0 overflow-hidden text-center",
        sm: "h-6 w-6 flex items-center justify-center p-0 overflow-hidden text-center",
        md: "h-7 w-7 flex items-center justify-center p-0 overflow-hidden text-center",
        lg: "h-8 w-8 flex items-center justify-center p-0 overflow-hidden text-center",
        xl: "h-9 w-9 flex items-center justify-center p-0 overflow-hidden text-center"
      };
      return s[a.size] || s.md;
    }), i = u(() => {
      if (a.variant !== "gradient" || !a.gradient)
        return "";
      const s = c(a.gradient.deg), M = a.gradient.from || "blue", y = a.gradient.to || M;
      return `${s} cstu-from-${M}-500 cstu-to-${y}-600 text-white`;
    }), d = u(() => {
      const s = {
        filled: `${ee(a.color, "filled")} ${a.autoContrast ? "text-white dark:text-white" : ""}`,
        light: `${ee(a.color, "light")}`,
        outline: `${ee(a.color, "outline")}`,
        transparent: `${ee(a.color, "text")}`,
        gradient: i.value
      };
      return s[a.variant] || s.filled;
    }), r = u(() => {
      const s = "inline-flex items-center justify-center font-medium";
      if (a.variant === "gradient" && a.gradient) {
        const m = c(a.gradient.deg), C = a.gradient.from || "blue", z = a.gradient.to || C, w = `${m} cstu-from-${C}-500 cstu-to-${z}-600 ${a.autoContrast ? "text-white" : ""}`;
        return [
          s,
          w,
          a.circle ? n.value : Ie(a.size, "badge"),
          a.circle ? "rounded-full" : De(a.radius),
          a.fullWidth ? "w-full" : ""
        ].filter(Boolean).join(" ");
      }
      const M = a.circle ? n.value : Ie(a.size, "badge"), y = a.circle ? "rounded-full" : De(a.radius), p = a.fullWidth ? "w-full" : "";
      return [
        s,
        d.value,
        M,
        y,
        p
      ].filter(Boolean).join(" ");
    }), h = u(() => {
      const s = {};
      if (!o(a.color))
        switch (a.variant) {
          case "filled":
            s.backgroundColor = a.color, s.color = "cstu-bg-white";
            break;
          case "light":
            s.backgroundColor = `${a.color}20`, s.color = a.color;
            break;
          case "outline":
            s.backgroundColor = "transparent", s.color = a.color, s.border = `1px solid ${a.color}`;
            break;
        }
      return s;
    });
    return (s, M) => (k(), J(ve(t.component || "div"), ce({
      class: l(r),
      style: l(h)
    }, s.$attrs), {
      default: N(() => [
        t.leftSection ? (k(), g("span", IL, [
          typeof t.leftSection == "string" ? (k(), g(re, { key: 0 }, [
            ae(U(t.leftSection), 1)
          ], 64)) : (k(), J(ve(t.leftSection), { key: 1 }))
        ])) : L("", !0),
        f("span", {
          class: I([[{ "overflow-hidden max-w-full": t.circle }, t.textClass], "badge-label"])
        }, [
          H(s.$slots, "default")
        ], 2),
        t.rightSection ? (k(), g("span", wL, [
          typeof t.rightSection == "string" ? (k(), g(re, { key: 0 }, [
            ae(U(t.rightSection), 1)
          ], 64)) : (k(), J(ve(t.rightSection), { key: 1 }))
        ])) : L("", !0)
      ]),
      _: 3
    }, 16, ["class", "style"]));
  }
});
function CL(t) {
  return {
    none: "",
    sm: "cstu-shadow-sm",
    md: "cstu-shadow",
    lg: "cstu-shadow-lg",
    xl: "cstu-shadow-xl"
  }[t] || "";
}
const Fx = /* @__PURE__ */ O({
  __name: "CardSection",
  props: {
    withBorder: { type: Boolean, default: !1 },
    inheritPadding: { type: Boolean, default: !1 },
    component: { default: "div" },
    class: null
  },
  setup(t) {
    const a = t, o = fe("card-padding", "md"), c = u(() => a.withBorder ? "cstu-border-b cstu-border-gray-200" : ""), n = u(() => a.inheritPadding ? {
      xs: "cstu-px-2",
      sm: "cstu-px-3",
      md: "cstu-px-4",
      lg: "cstu-px-5",
      xl: "cstu-px-6"
    }[o] || "cstu-px-4" : "");
    return (i, d) => (k(), J(ve(t.component), {
      class: I([
        l(c),
        l(n),
        a.class
      ])
    }, {
      default: N(() => [
        H(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), LL = /* @__PURE__ */ O({
  __name: "Card",
  props: {
    radius: { default: "md" },
    withBorder: { type: Boolean, default: !1 },
    shadow: { default: "none" },
    padding: { default: "md" },
    component: { default: "div" },
    class: null
  },
  setup(t, { expose: a }) {
    const o = t;
    Ee("card-padding", o.padding);
    const c = u(() => ({
      none: "cstu-rounded-none",
      xs: "cstu-rounded",
      sm: "cstu-rounded-md",
      md: "cstu-rounded-lg",
      lg: "cstu-rounded-xl",
      xl: "cstu-rounded-2xl",
      full: "cstu-rounded-full"
    })[o.radius] || "cstu-rounded-lg"), n = u(() => o.shadow === "none" ? "" : CL(o.shadow)), i = u(() => o.withBorder ? "cstu-border cstu-border-gray-200" : ""), d = u(() => ({
      xs: "cstu-p-2",
      sm: "cstu-p-3",
      md: "cstu-p-4",
      lg: "cstu-p-5",
      xl: "cstu-p-6"
    })[o.padding] || "cstu-p-4");
    return a({
      Section: Fx
    }), (r, h) => (k(), J(ve(t.component), {
      class: I([
        "cstu-overflow-hidden cstu-bg-white",
        l(c),
        l(n),
        l(i),
        l(d),
        o.class
      ])
    }, {
      default: N(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
LL.Section = Fx;
var bL = Object.defineProperty, SL = Object.defineProperties, qL = Object.getOwnPropertyDescriptors, sv = Object.getOwnPropertySymbols, jx = Object.prototype.hasOwnProperty, Dx = Object.prototype.propertyIsEnumerable, rx = (t, a, o) => a in t ? bL(t, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[a] = o, te = (t, a) => {
  for (var o in a || (a = {}))
    jx.call(a, o) && rx(t, o, a[o]);
  if (sv)
    for (var o of sv(a))
      Dx.call(a, o) && rx(t, o, a[o]);
  return t;
}, Ze = (t, a) => SL(t, qL(a)), zL = (t, a) => {
  var o = {};
  for (var c in t)
    jx.call(t, c) && a.indexOf(c) < 0 && (o[c] = t[c]);
  if (t != null && sv)
    for (var c of sv(t))
      a.indexOf(c) < 0 && Dx.call(t, c) && (o[c] = t[c]);
  return o;
}, Q2 = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
}, R2 = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored",
  AUTO: "auto"
}, Le = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
}, AL = {
  BOUNCE: "bounce",
  SLIDE: "slide",
  FLIP: "flip",
  ZOOM: "zoom"
}, Tx = {
  dangerouslyHTMLString: !1,
  multiple: !0,
  position: Q2.TOP_RIGHT,
  autoClose: 5e3,
  transition: "bounce",
  hideProgressBar: !1,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  closeOnClick: !0,
  className: "",
  bodyClassName: "",
  style: {},
  progressClassName: "",
  progressStyle: {},
  role: "alert",
  theme: "light"
}, HL = {
  rtl: !1,
  newestOnTop: !1,
  toastClassName: ""
}, Rx = te(te({}, Tx), HL);
Ze(te({}, Tx), {
  data: {},
  type: Le.DEFAULT,
  icon: !1
});
var T;
(function(t) {
  t[t.COLLAPSE_DURATION = 300] = "COLLAPSE_DURATION", t[t.DEBOUNCE_DURATION = 50] = "DEBOUNCE_DURATION", t.CSS_NAMESPACE = "Toastify";
})(T || (T = {}));
var lv;
(function(t) {
  t.ENTRANCE_ANIMATION_END = "d";
})(lv || (lv = {}));
var PL = {
  enter: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__bounce-enter`,
  exit: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__bounce-exit`,
  appendPosition: !0
}, BL = {
  enter: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__slide-enter`,
  exit: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__slide-exit`,
  appendPosition: !0
}, VL = {
  enter: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__zoom-enter`,
  exit: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__zoom-exit`
}, FL = {
  enter: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__flip-enter`,
  exit: `${T.CSS_NAMESPACE}--animate ${T.CSS_NAMESPACE}__flip-exit`
};
function Ox(t) {
  let a = PL;
  if (!t || typeof t == "string")
    switch (t) {
      case "flip":
        a = FL;
        break;
      case "zoom":
        a = VL;
        break;
      case "slide":
        a = BL;
        break;
    }
  else
    a = t;
  return a;
}
function jL(t) {
  return t.containerId || String(t.position);
}
var vv = "will-unmount";
function DL() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Q2.TOP_RIGHT;
  return !!document.querySelector(`.${T.CSS_NAMESPACE}__toast-container--${t}`);
}
function TL() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Q2.TOP_RIGHT;
  return `${T.CSS_NAMESPACE}__toast-container--${t}`;
}
function RL(t, a) {
  let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  const c = [`${T.CSS_NAMESPACE}__toast-container`, `${T.CSS_NAMESPACE}__toast-container--${t}`, o ? `${T.CSS_NAMESPACE}__toast-container--rtl` : null].filter(Boolean).join(" ");
  return V2(a) ? a({
    position: t,
    rtl: o,
    defaultClassName: c
  }) : `${c} ${a || ""}`;
}
function OL(t) {
  var a;
  const {
    position: o,
    containerClassName: c,
    rtl: n = !1,
    style: i = {}
  } = t, d = T.CSS_NAMESPACE, r = TL(o), h = document.querySelector(`.${d}`), s = document.querySelector(`.${r}`), M = !!s && !((a = s.className) != null && a.includes(vv)), y = h || document.createElement("div"), p = document.createElement("div");
  p.className = RL(o, c, n), p.dataset.testid = `${T.CSS_NAMESPACE}__toast-container--${o}`, p.id = jL(t);
  for (const m in i)
    if (Object.prototype.hasOwnProperty.call(i, m)) {
      const C = i[m];
      p.style[m] = C;
    }
  return h || (y.className = T.CSS_NAMESPACE, document.body.appendChild(y)), M || y.appendChild(p), p;
}
function Hv(t) {
  var a, o, c;
  const n = typeof t == "string" ? t : ((a = t.currentTarget) == null ? void 0 : a.id) || ((o = t.target) == null ? void 0 : o.id), i = document.getElementById(n);
  i && i.removeEventListener("animationend", Hv, !1);
  try {
    X2[n].unmount(), (c = document.getElementById(n)) == null || c.remove(), delete X2[n], delete ie[n];
  } catch {
  }
}
var X2 = E2({});
function $L(t, a) {
  const o = document.getElementById(String(a));
  o && (X2[o.id] = t);
}
function Pv(t) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const o = String(t);
  if (!X2[o])
    return;
  const c = document.getElementById(o);
  c && c.classList.add(vv), a ? (UL(t), c && c.addEventListener("animationend", Hv, !1)) : Hv(o), Ve.items = Ve.items.filter((n) => n.containerId !== t);
}
function EL(t) {
  for (const a in X2)
    Pv(a, t);
  Ve.items = [];
}
function $x(t, a) {
  const o = document.getElementById(t.toastId);
  if (o) {
    let c = t;
    c = te(te({}, c), Ox(c.transition));
    const n = c.appendPosition ? `${c.exit}--${c.position}` : c.exit;
    o.className += ` ${n}`, a && a(o);
  }
}
function UL(t) {
  for (const a in ie)
    if (a === t)
      for (const o of ie[a] || [])
        $x(o);
}
function ZL(t) {
  const o = Y2().find((c) => c.toastId === t);
  return o == null ? void 0 : o.containerId;
}
function Kv(t) {
  return document.getElementById(t);
}
function NL(t) {
  const a = Kv(t.containerId);
  return a && a.classList.contains(vv);
}
function dx(t) {
  var a;
  const o = yx(t.content) ? ze(t.content.props) : null;
  return o ?? ze((a = t.data) != null ? a : {});
}
function WL(t) {
  return t ? Ve.items.filter((o) => o.containerId === t).length > 0 : Ve.items.length > 0;
}
function GL() {
  if (Ve.items.length > 0) {
    const t = Ve.items.shift();
    Bv(t == null ? void 0 : t.toastContent, t == null ? void 0 : t.toastProps);
  }
}
var ie = E2({}), Ve = E2({
  items: []
});
function Y2() {
  const t = ze(ie);
  return Object.values(t).reduce((a, o) => [...a, ...o], []);
}
function XL(t) {
  return Y2().find((o) => o.toastId === t);
}
function Bv(t) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (NL(a)) {
    const o = Kv(a.containerId);
    o && o.addEventListener("animationend", Vv.bind(null, t, a), !1);
  } else
    Vv(t, a);
}
function Vv(t) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const o = Kv(a.containerId);
  o && o.removeEventListener("animationend", Vv.bind(null, t, a), !1);
  const c = ie[a.containerId] || [], n = c.length > 0;
  if (!n && !DL(a.position)) {
    const i = OL(a), d = Sv(fb, a);
    d.mount(i), $L(d, i.id);
  }
  n && (a.position = c[0].position), me(() => {
    a.updateId ? je.update(a) : je.add(t, a);
  });
}
var je = {
  /**
   * add a toast
   * @param _ ..
   * @param opts toast props
   */
  add(t, a) {
    const {
      containerId: o = ""
    } = a;
    o && (ie[o] = ie[o] || [], ie[o].find((c) => c.toastId === a.toastId) || setTimeout(() => {
      var c, n;
      a.newestOnTop ? (c = ie[o]) == null || c.unshift(a) : (n = ie[o]) == null || n.push(a), a.onOpen && a.onOpen(dx(a));
    }, a.delay || 0));
  },
  /**
   * remove a toast
   * @param id toastId
   */
  remove(t) {
    if (t) {
      const a = ZL(t);
      if (a) {
        const o = ie[a];
        let c = o.find((n) => n.toastId === t);
        ie[a] = o.filter((n) => n.toastId !== t), !ie[a].length && !WL(a) && Pv(a, !1), GL(), me(() => {
          c != null && c.onClose && (c.onClose(dx(c)), c = void 0);
        });
      }
    }
  },
  /**
   * update the toast
   * @param opts toast props
   */
  update() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      containerId: a = ""
    } = t;
    if (a && t.updateId) {
      ie[a] = ie[a] || [];
      const o = ie[a].find((c) => c.toastId === t.toastId);
      o && setTimeout(() => {
        for (const c in t)
          if (Object.prototype.hasOwnProperty.call(t, c)) {
            const n = t[c];
            o[c] = n;
          }
      }, t.delay || 0);
    }
  },
  /**
   * clear all toasts in container.
   * @param containerId container id
   */
  clear(t) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    t ? Pv(t, a) : EL(a);
  },
  dismissCallback(t) {
    var a;
    const o = (a = t.currentTarget) == null ? void 0 : a.id, c = document.getElementById(o);
    c && (c.removeEventListener("animationend", je.dismissCallback, !1), setTimeout(() => {
      je.remove(o);
    }));
  },
  dismiss(t) {
    if (t) {
      const a = Y2();
      for (const o of a)
        if (o.toastId === t) {
          $x(o, (c) => {
            c.addEventListener("animationend", je.dismissCallback, !1);
          });
          break;
        }
    }
  }
}, Ex = E2({});
function Ux() {
  return Math.random().toString(36).substring(2, 9);
}
function KL(t) {
  return typeof t == "number" && !isNaN(t);
}
function Fv(t) {
  return typeof t == "string";
}
function V2(t) {
  return typeof t == "function";
}
function xv() {
  for (var t = arguments.length, a = new Array(t), o = 0; o < t; o++)
    a[o] = arguments[o];
  return ce(...a);
}
function ov(t) {
  return typeof t == "object" && (!!(t != null && t.render) || !!(t != null && t.setup) || typeof (t == null ? void 0 : t.type) == "object");
}
function JL() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Ex[`${T.CSS_NAMESPACE}-default-options`] = t;
}
function QL() {
  return Ex[`${T.CSS_NAMESPACE}-default-options`] || Rx;
}
function YL() {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}
var W2;
(function(t) {
  t[t.Enter = 0] = "Enter", t[t.Exit = 1] = "Exit";
})(W2 || (W2 = {}));
var _L = {
  containerId: {
    type: [String, Number],
    required: !1,
    default: ""
  },
  dangerouslyHTMLString: {
    type: Boolean,
    required: !1,
    default: !1
  },
  multiple: {
    type: Boolean,
    required: !1,
    default: !0
  },
  limit: {
    type: Number,
    required: !1,
    default: void 0
  },
  position: {
    type: String,
    required: !1,
    default: Q2.TOP_LEFT
  },
  bodyClassName: {
    type: String,
    required: !1,
    default: ""
  },
  autoClose: {
    type: [Number, Boolean],
    required: !1,
    default: !1
  },
  closeButton: {
    type: [Boolean, Function, Object],
    required: !1,
    default: void 0
  },
  transition: {
    type: [String, Object],
    required: !1,
    default: "bounce"
  },
  hideProgressBar: {
    type: Boolean,
    required: !1,
    default: !1
  },
  pauseOnHover: {
    type: Boolean,
    required: !1,
    default: !0
  },
  pauseOnFocusLoss: {
    type: Boolean,
    required: !1,
    default: !0
  },
  closeOnClick: {
    type: Boolean,
    required: !1,
    default: !0
  },
  progress: {
    type: Number,
    required: !1,
    default: void 0
  },
  progressClassName: {
    type: String,
    required: !1,
    default: ""
  },
  toastStyle: {
    type: Object,
    required: !1,
    default() {
      return {};
    }
  },
  progressStyle: {
    type: Object,
    required: !1,
    default() {
      return {};
    }
  },
  role: {
    type: String,
    required: !1,
    default: "alert"
  },
  theme: {
    type: String,
    required: !1,
    default: R2.AUTO
  },
  content: {
    type: [String, Object, Function],
    required: !1,
    default: ""
  },
  toastId: {
    type: [String, Number],
    required: !1,
    default: ""
  },
  data: {
    type: [Object, String],
    required: !1,
    default() {
      return {};
    }
  },
  type: {
    type: String,
    required: !1,
    default: Le.DEFAULT
  },
  icon: {
    type: [Boolean, String, Number, Object, Function],
    required: !1,
    default: void 0
  },
  delay: {
    type: Number,
    required: !1,
    default: void 0
  },
  onOpen: {
    type: Function,
    required: !1,
    default: void 0
  },
  onClose: {
    type: Function,
    required: !1,
    default: void 0
  },
  onClick: {
    type: Function,
    required: !1,
    default: void 0
  },
  isLoading: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  rtl: {
    type: Boolean,
    required: !1,
    default: !1
  },
  toastClassName: {
    type: String,
    required: !1,
    default: ""
  },
  updateId: {
    type: [String, Number],
    required: !1,
    default: ""
  }
}, Zx = _L, eb = {
  autoClose: {
    type: [Number, Boolean],
    required: !0
  },
  isRunning: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  type: {
    type: String,
    required: !1,
    default: Le.DEFAULT
  },
  theme: {
    type: String,
    required: !1,
    default: R2.AUTO
  },
  hide: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  className: {
    type: [String, Function],
    required: !1,
    default: ""
  },
  controlledProgress: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  rtl: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  isIn: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  progress: {
    type: Number,
    required: !1,
    default: void 0
  },
  closeToast: {
    type: Function,
    required: !1,
    default: void 0
  }
}, tb = O({
  name: "ProgressBar",
  props: eb,
  // @ts-ignore
  setup(t, a) {
    let {
      attrs: o
    } = a;
    const c = j(), n = u(() => t.hide ? "true" : "false"), i = u(() => Ze(te({}, o.style || {}), {
      animationDuration: `${t.autoClose === !0 ? 5e3 : t.autoClose}ms`,
      animationPlayState: t.isRunning ? "running" : "paused",
      opacity: t.hide ? 0 : 1,
      transform: t.controlledProgress ? `scaleX(${t.progress})` : "none"
    })), d = u(() => [`${T.CSS_NAMESPACE}__progress-bar`, t.controlledProgress ? `${T.CSS_NAMESPACE}__progress-bar--controlled` : `${T.CSS_NAMESPACE}__progress-bar--animated`, `${T.CSS_NAMESPACE}__progress-bar-theme--${t.theme}`, `${T.CSS_NAMESPACE}__progress-bar--${t.type}`, t.rtl ? `${T.CSS_NAMESPACE}__progress-bar--rtl` : null].filter(Boolean).join(" ")), r = u(() => `${d.value} ${(o == null ? void 0 : o.class) || ""}`), h = () => {
      c.value && (c.value.onanimationend = null, c.value.ontransitionend = null);
    }, s = () => {
      t.isIn && t.closeToast && t.autoClose !== !1 && (t.closeToast(), h());
    }, M = u(() => t.controlledProgress ? null : s), y = u(() => t.controlledProgress ? s : null);
    return to(() => {
      c.value && (h(), c.value.onanimationend = M.value, c.value.ontransitionend = y.value);
    }), () => E("div", {
      ref: c,
      role: "progressbar",
      "aria-hidden": n.value,
      "aria-label": "notification timer",
      class: r.value,
      style: i.value
    }, null);
  }
}), ab = tb, ob = O({
  name: "CloseButton",
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      required: !1,
      default: R2.AUTO
    },
    type: {
      type: String,
      required: !1,
      default: R2.LIGHT
    },
    ariaLabel: {
      type: String,
      required: !1,
      default: "close"
    },
    closeToast: {
      type: Function,
      required: !1,
      default: void 0
    }
  },
  setup(t) {
    return () => E("button", {
      class: `${T.CSS_NAMESPACE}__close-button ${T.CSS_NAMESPACE}__close-button--${t.theme}`,
      type: "button",
      onClick: (a) => {
        a.stopPropagation(), t.closeToast && t.closeToast(a);
      },
      "aria-label": t.ariaLabel
    }, [E("svg", {
      "aria-hidden": "true",
      viewBox: "0 0 14 16"
    }, [E("path", {
      "fill-rule": "evenodd",
      d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    }, null)])]);
  }
}), Iv = (t) => {
  let a = t, {
    theme: o,
    type: c,
    path: n
  } = a, i = zL(a, [
    "theme",
    "type",
    "path"
  ]);
  return E("svg", ce({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: o === "colored" ? "currentColor" : `var(--toastify-icon-color-${c})`
  }, i), [E("path", {
    d: n
  }, null)]);
};
function cb(t) {
  return E(Iv, ce(t, {
    path: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }), null);
}
function nb(t) {
  return E(Iv, ce(t, {
    path: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }), null);
}
function ib(t) {
  return E(Iv, ce(t, {
    path: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }), null);
}
function rb(t) {
  return E(Iv, ce(t, {
    path: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }), null);
}
function db() {
  return E("div", {
    class: `${T.CSS_NAMESPACE}__spinner`
  }, null);
}
var jv = {
  info: nb,
  warning: cb,
  success: ib,
  error: rb,
  spinner: db
}, sb = (t) => t in jv;
function lb(t) {
  let {
    theme: a,
    type: o,
    isLoading: c,
    icon: n
  } = t, i;
  const d = {
    theme: a,
    type: o
  };
  return c ? i = jv.spinner() : n === !1 ? i = void 0 : ov(n) ? i = ze(n) : V2(n) ? i = n(d) : yx(n) ? i = oI(n, d) : Fv(n) || KL(n) ? i = n : sb(o) && (i = jv[o](d)), i;
}
var hb = () => {
};
function yb(t, a) {
  let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : T.COLLAPSE_DURATION;
  const {
    scrollHeight: c,
    style: n
  } = t, i = o;
  requestAnimationFrame(() => {
    n.minHeight = "initial", n.height = c + "px", n.transition = `all ${i}ms`, requestAnimationFrame(() => {
      n.height = "0", n.padding = "0", n.margin = "0", setTimeout(a, i);
    });
  });
}
function ub(t) {
  const a = j(!1), o = j(!1), c = j(!1), n = j(W2.Enter), i = E2(Ze(te({}, t), {
    appendPosition: t.appendPosition || !1,
    collapse: typeof t.collapse > "u" ? !0 : t.collapse,
    collapseDuration: t.collapseDuration || T.COLLAPSE_DURATION
  })), d = i.done || hb, r = u(() => i.appendPosition ? `${i.enter}--${i.position}` : i.enter), h = u(() => i.appendPosition ? `${i.exit}--${i.position}` : i.exit), s = u(() => t.pauseOnHover ? {
    onMouseenter: w,
    onMouseleave: z
  } : {});
  function M() {
    const b = r.value.split(" ");
    p().addEventListener(lv.ENTRANCE_ANIMATION_END, z, {
      once: !0
    });
    const x = (S) => {
      const V = p();
      S.target === V && (V.dispatchEvent(new Event(lv.ENTRANCE_ANIMATION_END)), V.removeEventListener("animationend", x), V.removeEventListener("animationcancel", x), n.value === W2.Enter && S.type !== "animationcancel" && V.classList.remove(...b));
    }, v = () => {
      const S = p();
      S.classList.add(...b), S.addEventListener("animationend", x), S.addEventListener("animationcancel", x);
    };
    t.pauseOnFocusLoss && m(), v();
  }
  function y() {
    if (!p())
      return;
    const b = () => {
      const v = p();
      v.removeEventListener("animationend", b), i.collapse ? yb(v, d, i.collapseDuration) : d();
    }, x = () => {
      const v = p();
      n.value = W2.Exit, v && (v.className += ` ${h.value}`, v.addEventListener("animationend", b));
    };
    o.value || (c.value ? b() : setTimeout(x));
  }
  function p() {
    return t.toastRef.value;
  }
  function m() {
    document.hasFocus() || w(), window.addEventListener("focus", z), window.addEventListener("blur", w);
  }
  function C() {
    window.removeEventListener("focus", z), window.removeEventListener("blur", w);
  }
  function z() {
    (!t.loading.value || t.isLoading === void 0) && (a.value = !0);
  }
  function w() {
    a.value = !1;
  }
  function A(b) {
    b && (b.stopPropagation(), b.preventDefault()), o.value = !1;
  }
  return to(y), to(() => {
    const b = Y2();
    o.value = b.findIndex((x) => x.toastId === i.toastId) > -1;
  }), to(() => {
    t.isLoading !== void 0 && (t.loading.value ? w() : z());
  }), xe(M), Dv(() => {
    t.pauseOnFocusLoss && C();
  }), {
    isIn: o,
    isRunning: a,
    hideToast: A,
    eventHandlers: s
  };
}
var pb = O({
  name: "ToastItem",
  inheritAttrs: !1,
  props: Zx,
  // @ts-ignore
  setup(t) {
    const a = j(), o = u(() => !!t.isLoading), c = u(() => t.progress !== void 0 && t.progress !== null), n = u(() => lb(t)), i = u(() => [`${T.CSS_NAMESPACE}__toast`, `${T.CSS_NAMESPACE}__toast-theme--${t.theme}`, `${T.CSS_NAMESPACE}__toast--${t.type}`, t.rtl ? `${T.CSS_NAMESPACE}__toast--rtl` : void 0, t.toastClassName || ""].filter(Boolean).join(" ")), {
      isRunning: d,
      isIn: r,
      hideToast: h,
      eventHandlers: s
    } = ub(te(te({
      toastRef: a,
      loading: o,
      done: () => {
        je.remove(t.toastId);
      }
    }, Ox(t.transition)), t));
    return () => E("div", ce({
      id: t.toastId,
      class: i.value,
      style: t.toastStyle || {},
      ref: a,
      "data-testid": `toast-item-${t.toastId}`,
      onClick: (M) => {
        t.closeOnClick && h(), t.onClick && t.onClick(M);
      }
    }, s.value), [E("div", {
      role: t.role,
      "data-testid": "toast-body",
      class: `${T.CSS_NAMESPACE}__toast-body ${t.bodyClassName || ""}`
    }, [n.value != null && E("div", {
      "data-testid": `toast-icon-${t.type}`,
      class: [`${T.CSS_NAMESPACE}__toast-icon`, t.isLoading ? "" : `${T.CSS_NAMESPACE}--animate-icon ${T.CSS_NAMESPACE}__zoom-enter`].join(" ")
    }, [ov(n.value) ? Ue(ze(n.value), {
      theme: t.theme,
      type: t.type
    }) : V2(n.value) ? n.value({
      theme: t.theme,
      type: t.type
    }) : n.value]), E("div", {
      "data-testid": "toast-content"
    }, [ov(t.content) ? Ue(ze(t.content), {
      toastProps: ze(t),
      closeToast: h,
      data: t.data
    }) : V2(t.content) ? t.content({
      toastProps: ze(t),
      closeToast: h,
      data: t.data
    }) : t.dangerouslyHTMLString ? Ue("div", {
      innerHTML: t.content
    }) : t.content])]), (t.closeButton === void 0 || t.closeButton === !0) && E(ob, {
      theme: t.theme,
      closeToast: (M) => {
        M.stopPropagation(), M.preventDefault(), h();
      }
    }, null), ov(t.closeButton) ? Ue(ze(t.closeButton), {
      closeToast: h,
      type: t.type,
      theme: t.theme
    }) : V2(t.closeButton) ? t.closeButton({
      closeToast: h,
      type: t.type,
      theme: t.theme
    }) : null, E(ab, {
      className: t.progressClassName,
      style: t.progressStyle,
      rtl: t.rtl,
      theme: t.theme,
      isIn: r.value,
      type: t.type,
      hide: t.hideProgressBar,
      isRunning: d.value,
      autoClose: t.autoClose,
      controlledProgress: c.value,
      progress: t.progress,
      closeToast: t.isLoading ? void 0 : h
    }, null)]);
  }
}), kb = pb, Mb = O({
  name: "ToastifyContainer",
  inheritAttrs: !1,
  props: Zx,
  // @ts-ignore
  setup(t) {
    const a = u(() => t.containerId), o = u(() => ie[a.value] || []), c = u(() => o.value.filter((n) => n.position === t.position));
    return () => E(re, null, [c.value.map((n) => {
      const {
        toastId: i = ""
      } = n;
      return E(kb, ce({
        key: i
      }, n), null);
    })]);
  }
}), fb = Mb, bv = !1;
function Nx() {
  const t = [];
  return Y2().forEach((o) => {
    const c = document.getElementById(o.containerId);
    c && !c.classList.contains(vv) && t.push(o);
  }), t;
}
function gb(t) {
  const a = Nx().length, o = t ?? 0;
  return o > 0 && a + Ve.items.length >= o;
}
function mb(t) {
  gb(t.limit) && !t.updateId && Ve.items.push({
    toastId: t.toastId,
    containerId: t.containerId,
    toastContent: t.content,
    toastProps: t
  });
}
function We(t, a) {
  let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (bv)
    return;
  o = xv(QL(), {
    type: a
  }, o), (!o.toastId || typeof o.toastId != "string" && typeof o.toastId != "number") && (o.toastId = Ux()), o = Ze(te({}, o), {
    content: t,
    containerId: o.containerId || String(o.position)
  });
  const c = Number(o == null ? void 0 : o.progress);
  return c < 0 && (o.progress = 0), c > 1 && (o.progress = 1), o.theme === "auto" && (o.theme = YL()), mb(o), o.multiple ? Ve.items.length || Bv(t, o) : (bv = !0, Q.clearAll(void 0, !1), setTimeout(() => {
    Bv(t, o);
  }, 0), setTimeout(() => {
    bv = !1;
  }, 390)), o.toastId;
}
var Q = (t, a) => We(t, Le.DEFAULT, a);
Q.info = (t, a) => We(t, Le.INFO, a);
Q.error = (t, a) => We(t, Le.ERROR, a);
Q.warning = (t, a) => We(t, Le.WARNING, a);
Q.warn = Q.warning;
Q.success = (t, a) => We(t, Le.SUCCESS, a);
Q.loading = (t, a) => We(t, Le.DEFAULT, xv(a, {
  isLoading: !0,
  autoClose: !1,
  closeOnClick: !1,
  closeButton: !1,
  draggable: !1
}));
Q.dark = (t, a) => We(t, Le.DEFAULT, xv(a, {
  theme: R2.DARK
}));
Q.remove = (t) => {
  t ? je.dismiss(t) : je.clear();
};
Q.clearAll = (t, a) => {
  je.clear(t, a);
};
Q.isActive = (t) => {
  let a = !1;
  return a = Nx().findIndex((c) => c.toastId === t) > -1, a;
};
Q.update = function(t) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  setTimeout(() => {
    const o = XL(t);
    if (o) {
      const c = ze(o), {
        content: n
      } = c, i = Ze(te(te({}, c), a), {
        toastId: a.toastId || t,
        updateId: Ux()
      }), d = i.render || n;
      delete i.render, We(d, i.type, i);
    }
  }, 0);
};
Q.done = (t) => {
  Q.update(t, {
    isLoading: !1,
    progress: 1
  });
};
Q.promise = vb;
function vb(t, a, o) {
  let {
    pending: c,
    error: n,
    success: i
  } = a, d;
  c && (d = Fv(c) ? Q.loading(c, o) : Q.loading(c.render, te(te({}, o), c)));
  const r = {
    isLoading: void 0,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null,
    delay: 100
  }, h = (M, y, p) => {
    if (y == null) {
      Q.remove(d);
      return;
    }
    const m = Ze(te(te({
      type: M
    }, r), o), {
      data: p
    }), C = Fv(y) ? {
      render: y
    } : y;
    return d ? Q.update(d, Ze(te(te({}, m), C), {
      isLoading: !1,
      autoClose: !0
    })) : Q(C.render, Ze(te(te({}, m), C), {
      isLoading: !1,
      autoClose: !0
    })), p;
  }, s = V2(t) ? t() : t;
  return s.then((M) => h("success", i, M)).catch((M) => h("error", n, M)), s;
}
Q.POSITION = Q2;
Q.THEME = R2;
Q.TYPE = Le;
Q.TRANSITIONS = AL;
var ye = Q, Wx = {
  install(t) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Gx(a);
  }
};
typeof window < "u" && (window.Vue3Toastify = Wx);
function Gx() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const a = xv(Rx, t);
  JL(a);
}
var xb = Wx;
const Ib = (t) => (cI("data-v-e05db311"), t = t(), nI(), t), wb = { class: "cstu-toast__icon-wrapper" }, Cb = { class: "cstu-toast__icon" }, Lb = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bb = ["stroke"], Sb = ["stroke"], qb = ["stroke"], zb = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ab = ["stroke"], Hb = ["stroke"], Pb = ["stroke"], Bb = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vb = { "clip-path": "url(#clip0_success)" }, Fb = ["stroke"], jb = ["stroke"], Db = /* @__PURE__ */ Ib(() => /* @__PURE__ */ f("defs", null, [
  /* @__PURE__ */ f("clipPath", { id: "clip0_success" }, [
    /* @__PURE__ */ f("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1)), Tb = {
  key: 3,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rb = ["stroke"], Ob = ["stroke"], $b = ["stroke"], Eb = {
  key: 4,
  class: "animate-spin",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ub = ["stroke"], Zb = {
  key: 5,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nb = ["stroke"], Wb = ["stroke"], Gb = ["stroke"], Xb = { class: "cstu-toast__content" }, Kb = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jb = ["stroke"], Qb = ["stroke"], Yb = /* @__PURE__ */ O({
  __name: "CustomToast",
  props: {
    message: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "info"
      // Default to info
    },
    // closeToast is automatically passed by vue3-toastify when content is a component
    closeToast: {
      type: Function,
      required: !1
    },
    // Add prop to explicitly control custom close button visibility
    closeButton: {
      type: Boolean,
      default: !0
      // Default to showing the button
    },
    // Add theme prop back
    theme: {
      type: String,
      default: "light"
    }
  },
  setup(t) {
    const a = t, o = j(!1), c = () => {
      typeof window < "u" && (o.value = window.matchMedia("(prefers-color-scheme: dark)").matches);
    };
    xe(() => {
      c(), typeof window < "u" && window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", c);
    });
    const n = {
      info: { bg: "#F0F7FF", border: "#BDD3FE", icon: "#2294FF" },
      warning: { bg: "#FFF4EA", border: "#FFDDBD", icon: "#FF922B" },
      success: { bg: "#EEF9F3", border: "#CBECDA", icon: "#4EB17C" },
      error: { bg: "#FEE8ED", border: "#FCB6C8", icon: "#F5144C" },
      loading: { bg: "#FFFFFF", border: "#86868630", icon: "#2294FF" },
      // Added loading
      dark: { bg: "#3A4557", border: "#5A6A80", icon: "#FFFFFF" },
      // Added dark
      default: { bg: "#F0F7FF", border: "#BDD3FE", icon: "#2294FF" }
      // Default matches info
    }, i = u(() => a.theme === "colored" ? "#FFFFFF" : n[a.type].icon), d = u(() => {
      if (a.theme === "dark")
        return a.type === "default" ? {
          backgroundColor: "#4a4a4a !important",
          borderColor: "#86868630",
          color: "#FFFFFF"
        } : {
          backgroundColor: "#4a4a4a !important",
          borderColor: "#5A6A80",
          color: "#FFFFFF"
        };
      if (a.theme === "colored") {
        if (a.type === "default")
          return {
            backgroundColor: "#4a4a4a !important",
            borderColor: "#86868630",
            color: "#FFFFFF"
          };
        if (a.type === "info")
          return {
            backgroundColor: "#2294FF",
            borderColor: "#2294FF",
            color: "#FFFFFF"
          };
        if (a.type === "warning")
          return {
            backgroundColor: "#ff922b",
            borderColor: "#ff922b",
            color: "#FFFFFF"
          };
        if (a.type === "success")
          return {
            backgroundColor: "#4eb17c",
            borderColor: "#4eb17c",
            color: "#FFFFFF"
          };
        if (a.type === "error")
          return {
            backgroundColor: "#f74370",
            borderColor: "#f74370",
            color: "#FFFFFF"
          };
        {
          const h = n[a.type];
          return {
            backgroundColor: h.bg,
            borderColor: h.border
          };
        }
      }
      if (a.theme === "auto") {
        if (o.value)
          return a.type === "default" ? {
            backgroundColor: "#4a4a4a !important",
            borderColor: "#86868630",
            color: "#FFFFFF"
          } : {
            backgroundColor: "#4a4a4a !important",
            borderColor: "#5A6A80",
            color: "#FFFFFF"
          };
        {
          const h = n[a.type];
          return {
            backgroundColor: h.bg,
            borderColor: h.border
          };
        }
      }
      const r = n[a.type];
      return {
        backgroundColor: r.bg,
        borderColor: r.border
      };
    });
    return (r, h) => (k(), g("div", {
      class: I(["cstu-toast", `cstu-toast--${t.type}`]),
      style: W(l(d))
    }, [
      f("div", wb, [
        f("div", Cb, [
          t.type === "info" ? (k(), g("svg", Lb, [
            f("circle", {
              cx: "9.16667",
              cy: "9.16667",
              r: "9.16667",
              transform: "matrix(1 0 0 -1 0.833496 19.1665)",
              stroke: l(i),
              "stroke-width": "1.66667"
            }, null, 8, bb),
            f("path", {
              d: "M10 14.1665V9.99984",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Sb),
            f("path", {
              d: "M10 6.6665V6.24984",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, qb)
          ])) : t.type === "warning" ? (k(), g("svg", zb, [
            f("path", {
              d: "M18.108 15.0004L11.4414 3.33368C11.296 3.07719 11.0852 2.86384 10.8305 2.71541C10.5757 2.56697 10.2862 2.48877 9.99136 2.48877C9.69654 2.48877 9.40699 2.56697 9.15226 2.71541C8.89753 2.86384 8.68673 3.07719 8.54136 3.33368L1.8747 15.0004C1.72777 15.2548 1.65072 15.5436 1.65137 15.8374C1.65202 16.1313 1.73035 16.4197 1.8784 16.6735C2.02646 16.9273 2.23899 17.1375 2.49444 17.2827C2.7499 17.4279 3.0392 17.503 3.33303 17.5003H16.6664C16.9588 17.5001 17.246 17.4228 17.4991 17.2764C17.7522 17.13 17.9624 16.9196 18.1085 16.6663C18.2545 16.413 18.3314 16.1257 18.3313 15.8333C18.3312 15.5408 18.2542 15.2536 18.108 15.0004Z",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Ab),
            f("path", {
              d: "M10 7.5V10.8333",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Hb),
            f("path", {
              d: "M10 14.1665H10.0083",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Pb)
          ])) : t.type === "success" ? (k(), g("svg", Bb, [
            f("g", Vb, [
              f("path", {
                d: "M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z",
                stroke: l(i),
                "stroke-width": "1.66667",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, 8, Fb),
              f("path", {
                d: "M6.6665 10.4168L8.88873 12.5002L13.3332 8.3335",
                stroke: l(i),
                "stroke-width": "1.66667",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, 8, jb)
            ]),
            Db
          ])) : t.type === "error" ? (k(), g("svg", Tb, [
            f("circle", {
              cx: "10.0002",
              cy: "10.0002",
              r: "9.16667",
              stroke: l(i),
              "stroke-width": "1.66667"
            }, null, 8, Rb),
            f("path", {
              d: "M10 5.8335V10.0002",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Ob),
            f("path", {
              d: "M10 13.3335V13.7502",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, $b)
          ])) : t.type === "loading" ? (k(), g("svg", Eb, [
            f("path", {
              d: "M10.0002 18.3332C8.35199 18.3332 6.74082 17.8444 5.37041 16.9288C4 16.0131 2.9319 14.7116 2.30117 13.1889C1.67044 11.6661 1.50541 9.99059 1.82695 8.37408C2.1485 6.75758 2.94217 5.27272 4.10761 4.10728C5.27304 2.94184 6.7579 2.14817 8.37441 1.82663C9.99092 1.50508 11.6665 1.67011 13.1892 2.30084C14.7119 2.93157 16.0134 3.99967 16.9291 5.37008C17.8448 6.74049 18.3335 8.35166 18.3335 9.99984",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Ub)
          ])) : (k(), g("svg", Zb, [
            f("circle", {
              cx: "9.16667",
              cy: "9.16667",
              r: "9.16667",
              transform: "matrix(1 0 0 -1 0.833496 19.1665)",
              stroke: l(i),
              "stroke-width": "1.66667"
            }, null, 8, Nb),
            f("path", {
              d: "M10 14.1665V9.99984",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Wb),
            f("path", {
              d: "M10 6.6665V6.24984",
              stroke: l(i),
              "stroke-width": "1.66667",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Gb)
          ]))
        ])
      ]),
      f("div", Xb, [
        f("p", null, U(t.message), 1)
      ]),
      t.closeButton ? (k(), g("button", {
        key: 0,
        onClick: h[0] || (h[0] = //@ts-ignore
        (...s) => t.closeToast && t.closeToast(...s)),
        class: "cstu-toast__close-button"
      }, [
        (k(), g("svg", Kb, [
          f("path", {
            d: "M5 5L15.6452 15.6452",
            stroke: a.theme === "dark" ? "#FFFFFF" : "#4A4A4A",
            "stroke-width": "1.66667",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Jb),
          f("path", {
            d: "M5 15.6455L15.6452 5.00035",
            stroke: a.theme === "dark" ? "#FFFFFF" : "#4A4A4A",
            "stroke-width": "1.66667",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Qb)
        ]))
      ])) : L("", !0)
    ], 6));
  }
});
const _b = /* @__PURE__ */ Rv(Yb, [["__scopeId", "data-v-e05db311"]]), hv = {
  autoClose: 3e3,
  position: ye.POSITION.BOTTOM_RIGHT,
  hideProgressBar: !0,
  closeOnClick: !0,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  theme: "light",
  icon: !1,
  closeButton: !1,
  toastClassName: "cstu-toast-wrapper",
  bodyClassName: "cstu-toast-body"
}, $e = (t, a, o) => {
  const c = { ...hv, ...o }, n = Ue(_b, {
    message: t,
    type: a,
    theme: c.theme,
    // Pass the theme prop
    // Use !! on userIntentOptions.closeButton to pass the correct boolean to our component
    closeButton: !!c.closeButton
  }), i = {
    ...c,
    // Start with user intent
    closeButton: !1
    // FORCE the library's button to be hidden
  };
  return ye(n, i);
}, eS = {
  // Basic toast function (defaults to 'info' type)
  show(t, a) {
    return $e(t, (a == null ? void 0 : a.type) || "info", a);
  },
  // Type-specific toast functions
  success(t, a) {
    return $e(t, "success", a);
  },
  info(t, a) {
    return $e(t, "info", a);
  },
  warning(t, a) {
    return $e(t, "warning", a);
  },
  error(t, a) {
    return $e(t, "error", a);
  },
  loading(t, a) {
    const o = { autoClose: !1, closeOnClick: !1, ...a };
    return $e(t, "loading", o);
  },
  dark(t, a) {
    return $e(t, "dark", a);
  },
  // Show toast based on type - Keep this for flexibility if needed
  showByType(t, a, o) {
    return $e(t, a, o);
  },
  // Promise toast
  promise(t, a, o) {
    return ye.promise(
      t,
      a,
      { ...hv, ...o }
    );
  },
  // Update an existing toast
  update(t, a) {
    ye.update(t, a);
  },
  // Remove all toasts or a specific one
  remove(t) {
    t ? ye.dismiss(t) : ye.dismiss();
  },
  // Remove all toasts
  clear() {
    ye.clearAll();
  },
  // Check if a toast is active
  isActive(t) {
    return ye.isActive(t);
  },
  // Mark a loading toast as done
  done(t) {
    ye.done(t);
  },
  // Constants
  POSITION: ye.POSITION,
  TYPE: ye.TYPE,
  TRANSITIONS: ye.TRANSITIONS
}, VS = {
  install: (t, a) => {
    Gx(hv), t.use(xb, {
      ...hv,
      ...a
    });
  }
}, FS = ye.POSITION, jS = ye.TYPE, DS = ye.TRANSITIONS, tS = { class: "cstu-toast-wrapper" }, TS = /* @__PURE__ */ O({
  __name: "Toast",
  props: {
    message: null,
    type: { default: "default" },
    autoClose: { type: [Number, Boolean], default: 3e3 },
    position: { default: "bottom-right" },
    hideProgressBar: { type: Boolean, default: !1 },
    pauseOnHover: { type: Boolean, default: !0 },
    pauseOnFocusLoss: { type: Boolean, default: !0 },
    closeOnClick: { type: Boolean, default: !0 },
    toastClassName: null,
    bodyClassName: null,
    style: null,
    progressClassName: null,
    progressStyle: null,
    role: null,
    theme: { default: "light" },
    closeButton: { type: Boolean, default: !0 },
    dangerouslyHTMLString: { type: Boolean, default: !1 },
    rtl: { type: Boolean, default: !1 },
    containerId: null,
    showOnMount: { type: Boolean, default: !0 }
  },
  setup(t) {
    const a = t;
    return xe(() => {
      if (a.showOnMount && a.message) {
        const o = {
          autoClose: a.autoClose,
          position: a.position,
          hideProgressBar: a.hideProgressBar,
          pauseOnHover: a.pauseOnHover,
          pauseOnFocusLoss: a.pauseOnFocusLoss,
          closeOnClick: a.closeOnClick,
          toastClassName: a.toastClassName,
          bodyClassName: a.bodyClassName,
          style: a.style,
          progressClassName: a.progressClassName,
          progressStyle: a.progressStyle,
          role: a.role,
          theme: a.theme,
          closeButton: a.closeButton,
          dangerouslyHTMLString: a.dangerouslyHTMLString,
          rtl: a.rtl,
          containerId: a.containerId
        };
        eS.showByType(a.message, a.type, o);
      }
    }), (o, c) => (k(), g("div", tS, [
      H(o.$slots, "default")
    ]));
  }
});
const aS = {
  key: 0,
  class: "cstu-border-b cstu-border-gray-200 cstu-p-4 cstu-flex cstu-items-center cstu-justify-between"
}, oS = {
  key: 0,
  class: "cstu-text-lg cstu-font-medium"
}, cS = /* @__PURE__ */ f("svg", {
  class: "cstu-w-5 cstu-h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ f("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1), nS = [
  cS
], iS = { class: "cstu-flex-1 cstu-overflow-auto cstu-p-4" }, RS = /* @__PURE__ */ O({
  __name: "Drawer",
  props: {
    opened: { type: Boolean },
    onClose: null,
    title: null,
    position: { default: "right" },
    size: { default: "md" },
    width: null,
    height: null,
    radius: { default: "md" },
    withCloseButton: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    trapFocus: { type: Boolean, default: !0 },
    returnFocus: { type: Boolean, default: !0 },
    offset: { default: 0 },
    overlayOpacity: { default: 0.15 },
    overlayBlur: { default: 0 },
    scrollAreaComponent: { default: void 0 },
    overlayProps: { default: () => ({}) },
    closeButtonProps: { default: () => ({}) },
    transitionProps: { default: () => ({}) },
    onEnterTransitionEnd: { type: Function, default: () => {
    } },
    onExitTransitionEnd: { type: Function, default: () => {
    } }
  },
  setup(t) {
    const a = t, o = u(() => {
      const s = [];
      switch (a.position) {
        case "left":
          s.push("cstu-left-0 cstu-top-0 cstu-bottom-0");
          break;
        case "right":
          s.push("cstu-right-0 cstu-top-0 cstu-bottom-0");
          break;
        case "top":
          s.push("cstu-top-0 cstu-left-0 cstu-right-0");
          break;
        case "bottom":
          s.push("cstu-bottom-0 cstu-left-0 cstu-right-0");
          break;
      }
      return s.join(" ");
    }), c = u(() => !a.radius || a.radius === "none" ? "" : {
      xs: "cstu-rounded",
      sm: "cstu-rounded-md",
      md: "cstu-rounded-lg",
      lg: "cstu-rounded-xl",
      xl: "cstu-rounded-2xl",
      full: "cstu-rounded-full"
    }[a.radius]), n = u(() => {
      const s = {};
      if (a.width !== void 0)
        s.width = typeof a.width == "number" ? `${a.width}px` : a.width;
      else if (["left", "right"].includes(a.position))
        if (typeof a.size == "string" && ["xs", "sm", "md", "lg", "xl"].includes(a.size)) {
          const M = {
            xs: "16rem",
            // 64
            sm: "20rem",
            // 80
            md: "24rem",
            // 96
            lg: "32rem",
            xl: "40rem"
          };
          s.width = M[a.size];
        } else
          typeof a.size == "string" ? s.width = a.size : typeof a.size == "number" && (s.width = `${a.size}px`);
      if (a.height !== void 0)
        s.height = typeof a.height == "number" ? `${a.height}px` : a.height;
      else if (["top", "bottom"].includes(a.position))
        if (typeof a.size == "string" && ["xs", "sm", "md", "lg", "xl"].includes(a.size)) {
          const M = {
            xs: "16rem",
            // 64
            sm: "20rem",
            // 80
            md: "24rem",
            // 96
            lg: "32rem",
            xl: "40rem"
          };
          s.height = M[a.size];
        } else
          typeof a.size == "string" ? s.height = a.size : typeof a.size == "number" && (s.height = `${a.size}px`);
      if (a.offset > 0)
        switch (a.position) {
          case "left":
            s.transform = `translateX(${a.offset}px)`;
            break;
          case "right":
            s.transform = `translateX(-${a.offset}px)`;
            break;
          case "top":
            s.transform = `translateY(${a.offset}px)`;
            break;
          case "bottom":
            s.transform = `translateY(-${a.offset}px)`;
            break;
        }
      return s;
    }), i = u(() => {
      var M;
      const s = {
        left: "drawer-left",
        right: "drawer-right",
        top: "drawer-top",
        bottom: "drawer-bottom"
      };
      return ((M = a.transitionProps) == null ? void 0 : M.transition) || s[a.position];
    }), d = () => {
      a.closeOnClickOutside && a.onClose();
    }, r = () => {
      a.onClose();
    }, h = (s) => {
      s.key === "Escape" && a.opened && a.closeOnEscape && a.onClose();
    };
    return xe(() => {
      document.addEventListener("keydown", h);
    }), Dv(() => {
      document.removeEventListener("keydown", h), document.body.style.overflow === "hidden" && (document.body.style.overflow = "");
    }), ne(() => a.opened, (s) => {
      a.overlayOpacity > 0 && (s ? document.body.style.overflow = "hidden" : document.body.style.overflow = ""), setTimeout(s ? () => {
        typeof a.onEnterTransitionEnd == "function" && a.onEnterTransitionEnd();
      } : () => {
        typeof a.onExitTransitionEnd == "function" && a.onExitTransitionEnd();
      }, 300);
    }), (s, M) => (k(), g("div", null, [
      E(se, { name: "drawer-backdrop" }, {
        default: N(() => [
          t.opened ? (k(), g("div", ce({
            key: 0,
            class: "fixed inset-0 z-[999]",
            style: {
              backgroundColor: `rgba(0, 0, 0, ${t.overlayOpacity})`,
              backdropFilter: t.overlayBlur > 0 ? `blur(${t.overlayBlur}px)` : "none"
            },
            onClick: d
          }, t.overlayProps), null, 16)) : L("", !0)
        ]),
        _: 1
      }),
      E(se, { name: l(i) }, {
        default: N(() => [
          t.opened ? (k(), g("div", ce({
            key: 0,
            class: ["cstu-fixed cstu-z-[1000] cstu-bg-white cstu-shadow-lg cstu-flex cstu-flex-col", [l(o), l(c)]],
            style: l(n),
            role: "dialog",
            "aria-modal": "true"
          }, s.$attrs), [
            s.$slots.header || t.title || t.withCloseButton ? (k(), g("div", aS, [
              H(s.$slots, "header", {}, () => [
                t.title ? (k(), g("div", oS, U(t.title), 1)) : L("", !0)
              ]),
              t.withCloseButton ? (k(), g("button", ce({
                key: 0,
                class: "cstu-ml-auto cstu-flex cstu-items-center cstu-justify-center cstu-w-8 cstu-h-8 cstu-rounded-full cstu-text-gray-500 hover:cstu-bg-gray-100 focus:cstu-outline-none",
                "aria-label": "Close",
                onClick: r
              }, t.closeButtonProps), nS, 16)) : L("", !0)
            ])) : L("", !0),
            f("div", iS, [
              H(s.$slots, "default")
            ])
          ], 16)) : L("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
});
const OS = {}, rS = /* @__PURE__ */ O({
  __name: "ListItem",
  props: {
    disabled: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    class: { default: "" },
    selectedClass: { default: "" },
    noColorOnSelected: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: a }) {
    const o = t, c = u(() => o.class);
    function n() {
      o.disabled || a("click");
    }
    return (i, d) => (k(), g("div", {
      role: "listitem",
      tabindex: "-1",
      class: I([
        "cstu-cursor-pointer cstu-rounded-lg cstu-min-h-9 cstu-flex cstu-items-center",
        "cstu-py-[5.5px] cstu-pr-[13.5px] cstu-pl-[10.5px]",
        { "hover:cstu-bg-blue-50 active:cstu-bg-blue-50": !t.disabled },
        { "cstu-cursor-not-allowed cstu-bg-gray-100 ": t.disabled },
        { [t.selectedClass]: t.selected && !t.disabled },
        { "cstu-bg-blue-50": t.selected && !t.noColorOnSelected && !t.disabled },
        l(c)
      ]),
      onClick: n
    }, [
      H(i.$slots, "default", { selected: t.selected })
    ], 2));
  }
}), dS = /* @__PURE__ */ f("path", {
  d: "M5.64844 0.919922L9.81641 5.08789C9.91667 5.18815 9.9668 5.3099 9.9668 5.45312C9.9668 5.59635 9.91667 5.7181 9.81641 5.81836L9.34375 6.29102C9.24349 6.39128 9.12174 6.44499 8.97852 6.45215C8.83529 6.45931 8.71354 6.41276 8.61328 6.3125L5.2832 2.98242L1.95312 6.3125C1.85286 6.41276 1.73112 6.45931 1.58789 6.45215C1.44466 6.44499 1.32292 6.39128 1.22266 6.29102L0.75 5.81836C0.649739 5.7181 0.599609 5.59635 0.599609 5.45312C0.599609 5.3099 0.649739 5.18815 0.75 5.08789L4.91797 0.919922C5.01823 0.805339 5.13997 0.748047 5.2832 0.748047C5.42643 0.748047 5.54818 0.805339 5.64844 0.919922Z",
  fill: "#75797C"
}, null, -1), sS = [
  dS
], $S = /* @__PURE__ */ O({
  __name: "Collapsible",
  props: {
    modelValue: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    class: { default: "" },
    hideArrow: { type: Boolean, default: !1 },
    buttonClass: { default: "" },
    selectedClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: a }) {
    const o = t, c = u(() => o.modelValue !== void 0), n = u({
      get: () => c.value ? o.modelValue ?? !1 : i.value,
      set: (h) => {
        c.value ? a("update:modelValue", h) : i.value = h;
      }
    }), i = j(o.defaultOpen), d = u(() => o.class);
    function r() {
      o.disabled || (n.value = !n.value);
    }
    return (h, s) => (k(), g("div", {
      class: I(["space-y-1 cstu-select-none", l(d)])
    }, [
      E(rS, {
        role: "button",
        disabled: t.disabled,
        class: I(["cstu-flex cstu-items-center cstu-justify-between", t.buttonClass].join(" ")),
        "selected-class": t.selectedClass,
        selected: l(n),
        "no-color-on-selected": !0,
        onClick: r
      }, {
        default: N(() => [
          H(h.$slots, "trigger", { open: l(n) }),
          t.hideArrow ? L("", !0) : (k(), g("svg", {
            key: 0,
            xmlns: "http://www.w3.org/2000/svg",
            width: "10",
            height: "7",
            viewBox: "0 0 10 7",
            fill: "none",
            class: I(["cstu-transform cstu-transition-transform cstu-duration-200", { "cstu-rotate-180": !l(n) }])
          }, sS, 2))
        ]),
        _: 3
      }, 8, ["disabled", "class", "selected-class", "selected"]),
      E(se, {
        "enter-active-class": "cstu-transition cstu-duration-100 cstu-ease-out",
        "enter-from-class": "cstu-transform cstu-scale-95 cstu-opacity-0",
        "enter-to-class": "cstu-transform cstu-scale-100 cstu-opacity-100",
        "leave-active-class": "cstu-transition cstu-duration-75 cstu-ease-in",
        "leave-from-class": "cstu-transform cstu-scale-100 cstu-opacity-100",
        "leave-to-class": "cstu-transform cstu-scale-95 cstu-opacity-0"
      }, {
        default: N(() => [
          F2(f("div", null, [
            H(h.$slots, "default")
          ], 512), [
            [yv, l(n)]
          ])
        ]),
        _: 3
      })
    ], 2));
  }
});
export {
  SS as ActionIcon,
  fS as Alert,
  BC as Avatar,
  FC as AvatarGroup,
  BS as Badge,
  LS as Breadcrumbs,
  Me as Button,
  LL as Card,
  Fx as CardSection,
  yS as Checkbox,
  pS as Chip,
  $S as Collapsible,
  _b as CustomToast,
  gS as Dialog,
  RS as Drawer,
  qS as Dropdown,
  zS as DropdownItem,
  Yw as HoverCard,
  Hx as HoverCardTarget,
  kS as Indicator,
  rS as ListItem,
  cw as Loader,
  xS as Modal,
  IS as ModalDirective,
  vS as ModalPlugin,
  FS as POSITION,
  wS as Pagination,
  CS as Popover,
  MS as Progress,
  HS as SegmentedControl,
  AS as SplitButton,
  PS as Switch,
  DS as TRANSITIONS,
  jS as TYPE,
  Xv as Tabs,
  jC as TabsList,
  TC as TabsPanel,
  DC as TabsTab,
  uS as TextInput,
  bS as Textarea,
  TS as Toast,
  VS as ToastPlugin,
  OS as composables,
  eS as cstuToast,
  SC as getInitials,
  bC as getInitialsColor,
  Ax as hoverCardInjectionKey,
  ye as toast,
  Jw as useHoverCard,
  mS as useModal
};
